module.exports = {
	"contractName": "WorldGame",
	"abi": [
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint32"
				}
			],
			"name": "blockHash32Map",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0x5d156e7c"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "regionRewards",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0x73f9c314"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "regionNeighbors",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0xc5554f6c"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "gameDataArray",
			"outputs": [
				{
					"name": "turnTeamId",
					"type": "uint32"
				},
				{
					"name": "turnNum",
					"type": "uint32"
				},
				{
					"name": "maxBlocksPerTurn",
					"type": "uint32"
				},
				{
					"name": "playerCount",
					"type": "uint32"
				},
				{
					"name": "undeployedSoldiers",
					"type": "uint256"
				},
				{
					"name": "regionOwners",
					"type": "uint256"
				},
				{
					"name": "actionCount",
					"type": "uint32"
				},
				{
					"name": "fromRegionList",
					"type": "uint256"
				},
				{
					"name": "toRegionList",
					"type": "uint256"
				},
				{
					"name": "moveSoldierCountList",
					"type": "uint256"
				},
				{
					"name": "submitBlockList",
					"type": "uint256"
				},
				{
					"name": "teamAvatars",
					"type": "bytes8"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0xdfecc3da"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor",
			"signature": "constructor"
		},
		{
			"payable": true,
			"stateMutability": "payable",
			"type": "fallback"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "gameId",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "turnNum",
					"type": "uint32"
				},
				{
					"indexed": false,
					"name": "teamAvatars",
					"type": "bytes8"
				}
			],
			"name": "NewGame",
			"type": "event",
			"signature": "0x7b500020844755355aa28dffd1c18d8b8e19f27484cf8e3678b3715b2a84f119"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "gameId",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "turnNum",
					"type": "uint32"
				},
				{
					"indexed": false,
					"name": "nextTeamId",
					"type": "uint32"
				}
			],
			"name": "NextTurn",
			"type": "event",
			"signature": "0xaf26d387915e958f9e0527ca62daeba4f1dbedcfa353788bc92cb1d168eafa4e"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "gameId",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "winningTeamId",
					"type": "uint32"
				}
			],
			"name": "Winner",
			"type": "event",
			"signature": "0xf3576487e22fe2d358509a56b99d4924c4fc146200d92b58ab61bf8b82fcdec3"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "stop",
					"type": "bool"
				}
			],
			"name": "stopNewGames",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function",
			"signature": "0x20d636da"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "playerCount",
					"type": "uint32"
				},
				{
					"name": "maxBlocksPerTurn",
					"type": "uint32"
				},
				{
					"name": "playerAddresses",
					"type": "address[8]"
				},
				{
					"name": "teamAvatars",
					"type": "bytes8"
				}
			],
			"name": "newGame",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function",
			"signature": "0x11d17981"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				},
				{
					"name": "turnNum",
					"type": "uint32"
				},
				{
					"name": "regionFrom",
					"type": "uint32"
				},
				{
					"name": "regionTo",
					"type": "uint32"
				},
				{
					"name": "moveSoldierCount",
					"type": "uint32"
				}
			],
			"name": "attackOrMove",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function",
			"signature": "0x1e710c1b"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				},
				{
					"name": "turnNum",
					"type": "uint32"
				},
				{
					"name": "regionDeploy",
					"type": "uint32"
				},
				{
					"name": "deploySoldierCount",
					"type": "uint32"
				}
			],
			"name": "deploySoldiersAndEndTurn",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function",
			"signature": "0xb14580ff"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				},
				{
					"name": "turnNum",
					"type": "uint32"
				}
			],
			"name": "forceEndOfTurn",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function",
			"signature": "0x13e9c3a0"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				},
				{
					"name": "teamId",
					"type": "uint32"
				}
			],
			"name": "declareWinner",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function",
			"signature": "0x63e8360d"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "blockNum",
					"type": "uint32"
				}
			],
			"name": "cacheBlockHash32",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function",
			"signature": "0xd76a606c"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "blockNum",
					"type": "uint32"
				}
			],
			"name": "readBlockHash32",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0x69b0e1db"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "numberOfGames",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0xf6928070"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "offset",
					"type": "uint256"
				}
			],
			"name": "listGamesForAddress",
			"outputs": [
				{
					"name": "",
					"type": "uint256[10]"
				},
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0xa19d8df9"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				}
			],
			"name": "soldiersByRegion",
			"outputs": [
				{
					"name": "",
					"type": "uint32[25]"
				},
				{
					"name": "",
					"type": "uint32[25]"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0xe97b9249"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				}
			],
			"name": "turnAndPlayerInfo",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "address[8]"
				},
				{
					"name": "",
					"type": "bytes8"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0x7c83e731"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				}
			],
			"name": "undeployedSoldiers",
			"outputs": [
				{
					"name": "",
					"type": "uint32[8]"
				},
				{
					"name": "",
					"type": "uint32[8]"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0x8935185f"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				}
			],
			"name": "pendingActions",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "uint32[8]"
				},
				{
					"name": "",
					"type": "uint32[8]"
				},
				{
					"name": "",
					"type": "uint32[8]"
				},
				{
					"name": "",
					"type": "uint32[8]"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0x03117ba2"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "gameId",
					"type": "uint256"
				}
			],
			"name": "pendingActionOutcomes",
			"outputs": [
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "uint32"
				},
				{
					"name": "",
					"type": "uint32[8]"
				},
				{
					"name": "",
					"type": "uint32[8]"
				},
				{
					"name": "",
					"type": "uint32[8]"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function",
			"signature": "0xbf29233f"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "104:47830:2:-;;;7132:116;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;7163:5:2;:18;;-1:-1:-1;;;;;;7163:18:2;7171:10;7163:18;;;7191:21;:19;;;;:21;:::i;:::-;7222:19;:17;;;;:19;:::i;:::-;104:47830;;32234:10560;32283:15;:72;;-1:-1:-1;;;;32283:72:2;;;32335:19;32283:72;32365:65;;;;;295:3;;32306:14;32440:39;:54;;;;;;;;;-1:-1:-1;;;;;;32440:54:2;;;;;;;;;295:3;32480:1;-1:-1:-1;32504:39:2;:54;;;;;;;;;-1:-1:-1;;;;;;32504:54:2;;;;;;;;;295:3;32568:15;-1:-1:-1;32568:39:2;:54;;;;;;;;;-1:-1:-1;;;;;;32568:54:2;;;;;;;;;32693:19;32633:80;;32816:83;32723;-1:-1:-1;;32633:80:2;;;;;-1:-1:-1;;32723:83:2;;;;;-1:-1:-1;;;;;;32816:83:2;;;;295:3;32633:15;-1:-1:-1;32909:47:2;:62;;;;;;;;;-1:-1:-1;;;;;;32909:62:2;;;;;;;;;295:3;32981:15;-1:-1:-1;32981:47:2;:62;;;;;;;;;-1:-1:-1;;;;;;32981:62:2;;;;;;;;;33054:47;:83;;33235:80;33147:78;-1:-1:-1;;33054:83:2;;;-1:-1:-1;33054:83:2;-1:-1:-1;;33147:78:2;;;;;-1:-1:-1;;;;;;33235:80:2;;;;295:3;33054:15;;33325:47;:62;;;;;;;;;-1:-1:-1;;;;;;33325:62:2;;;;;;;;;295:3;33397:15;;:47;:62;;-1:-1:-1;;;;;;33397:62:2;;;;;;;;;;;;;;;;;33470:44;:72;;-1:-1:-1;;;;;;;;;;;;;;33552:80:2;;;;;33642:77;;;;;;33729:88;;;;;295:3;33470:15;33493:19;33827:44;:59;;-1:-1:-1;;;;;;33827:59:2;;;;;;;;;;;;;;;;;33897:44;:77;;-1:-1:-1;;;;;;;;;;33897:77:2;;;33954:19;33897:77;33984:80;;;;;;34074:88;;;;;295:3;33897:15;33920:19;34172:44;:59;;;;;;;;;-1:-1:-1;;;;;;34172:59:2;;;;;;;;;295:3;34241:15;34172:47;34241:44;:59;;;;;;;;;-1:-1:-1;;;;;;34241:59:2;;;;;;;;;34311:42;:78;;34399;34366:22;-1:-1:-1;;34311:78:2;;;;;-1:-1:-1;;34399:78:2;;;;;295:3;;34334:17;34487:42;:57;;;;;;;;;-1:-1:-1;;;;;;34487:57:2;;;;;;;;;295:3;34530:1;34577:17;34554:42;:57;;;;;;;;;-1:-1:-1;;;;;;34554:57:2;;;;;;;;;295:3;34621:15;34644:17;34621:42;:57;;-1:-1:-1;;;;;;34621:57:2;;;;;;;;;;;;;;;;;34689:55;:88;;-1:-1:-1;;;;;;;;;;34689:88:2;;;34757:19;34689:88;34787;;;;;;34885:99;;;;;295:3;34689:15;34712:30;34994:55;:70;;;;;;;;;-1:-1:-1;;;;;;34994:70:2;;;;;;;;;295:3;35074:15;35097:30;35074:55;:70;;-1:-1:-1;;;;;;35074:70:2;;;;;;;;;;;;;;;;;35155:55;:99;;-1:-1:-1;;;;35155:99:2;;;35223:30;35155:99;35264:92;;;;;295:3;35155:15;35178:30;35366:55;:70;;;;;;;;;-1:-1:-1;;;;;;35366:70:2;;;;;;;;;295:3;35422:1;35469:30;35446:55;:70;;;;;;;;;-1:-1:-1;;;;;;35446:70:2;;;;;;;;;295:3;35526:15;35549:30;35526:55;:70;;-1:-1:-1;;;;;;35526:70:2;;;;;;;;;;;;;;;;;35607:48;:92;;-1:-1:-1;;;;35607:92:2;;;35668:30;35607:92;35709:85;;;;;295:3;35607:15;35630:23;35804:48;:63;;;;;;;;;-1:-1:-1;;;;;;35804:63:2;;;;;;;;;295:3;35853:1;35804:51;35877:48;:63;;;;;;;;;-1:-1:-1;;;;;;35877:63:2;;;;;;;;;295:3;35950:15;35877:51;35950:48;:63;;-1:-1:-1;;;;;;35950:63:2;;;;;;;;;;;;;;;;;36024:48;:85;;-1:-1:-1;;;;36024:85:2;;;35950:51;36024:85;36119:81;;;;;295:3;36024:15;36047:23;36210:48;:63;;;;;;;;;-1:-1:-1;;;;;;36210:63:2;;;;;;;;;295:3;36259:1;36306:23;36283:48;:63;;;;;;;;;-1:-1:-1;;;;;;36283:63:2;;;;;;;;;295:3;36356:15;36379:23;36356:48;:63;;-1:-1:-1;;;;;;36356:63:2;;;;;;;;;;;;;;;;;36430:47;:78;;-1:-1:-1;;;;;;;;;;36430:78:2;;;36490:17;36430:78;36518:83;;;;;;36611:80;;;;;295:3;36430:15;36453:22;36701:47;:62;;;;;;;;;-1:-1:-1;;;;;;36701:62:2;;;;;;;;;295:3;36773:15;36796:22;36773:47;:62;;-1:-1:-1;;;;;;36773:62:2;;;;;;;;;;;;;;;;;36846:47;:83;;-1:-1:-1;;;;;;;;;;;;;;;;36846:83:2;;;36906:22;36846:83;36939:80;;;;;;37029;;;;;;37119:83;;;;;295:3;36846:15;36869:22;37212:47;:62;;-1:-1:-1;;;;;;37212:62:2;;;;;;;;;;;;;;;;;;;37285:47;:83;;-1:-1:-1;;;;;;;;;;;;;;;;37285:83:2;;;37345:22;37285:83;37378:80;;;;37468:74;;;;37552:82;;;;;;37644:83;;;;;;;;37438:19;37738:82;;;;;37612:21;37738:82;37830:83;;;;;37923;;;37468:74;37923:83;;;295:3;37285:15;37704:22;38016:47;:62;;;;;;;;;-1:-1:-1;;;;;;38016:62:2;;;;;;;;;295:3;38088:15;38111:22;38088:47;:62;;-1:-1:-1;;;;;;38088:62:2;;;;;;;;;;;;;;;;;;;38161:44;:80;;-1:-1:-1;;;;;;;;;;;;;;;;38161:80:2;;;38218:22;38161:80;38251;;;;38341:77;;;;;;38428;;;;;;38515:78;;;;;;38572:20;38604:80;;;;38308:22;38604:80;38694;;;;38784:71;;;;38865:77;;;;;38952;;;;;;;;38841:13;39040:77;;;;;38184:19;39040:77;39127:78;;;39215:77;;;;39302:71;;;;;;;;295:3;;38161:15;39383:44;:59;;-1:-1:-1;;;;;;39383:59:2;;;;;;;;;;;;;;;;;39453:45;:78;;-1:-1:-1;;;;39453:78:2;;;39511:19;39453:78;39541;;;;;295:3;39453:15;39476:20;39629:45;:60;;;;;;;;;-1:-1:-1;;;;;;39629:60:2;;;;;;;;;295:3;39675:1;39722:20;39699:45;:60;;;;;;;;;-1:-1:-1;;;;;;39699:60:2;;;;;;;;;295:3;39769:15;39792:20;39769:45;:60;;-1:-1:-1;;;;;;39769:60:2;;;;;;;;;;;;;;;;;;;39840:38;:71;;-1:-1:-1;;;;;;;;;;;;;;;;39840:71:2;;;39769:48;39840:71;39921;;;;40002:74;;;;40086:73;;;;40169:74;;;;;;;;40254:46;:73;;;;;39863:13;40254:73;40337:82;;;;;40429;;;;;40521;;;;;;;295:3;39840:15;40137:21;40613:46;:61;;-1:-1:-1;;;;;;40613:61:2;;;;;;;;;;;;;;;;;;;40685:47;:74;;-1:-1:-1;;;;;;;;;;;;;;;;40685:74:2;;;40745:13;40685:74;40769:82;;;;40861:86;;;;;;40957;;;;;;41053:73;;;;;;;41137:50;:89;;;;;;;;41236:86;;;;;;;295:3;40685:15;40921:25;41332:50;:65;;;;;;;;;-1:-1:-1;;;;;;41332:65:2;;;;;;;;;295:3;41383:1;41430:25;41407:50;:65;;;;;;;;;-1:-1:-1;;;;;;41407:65:2;;;;;;;;;295:3;41482:15;41505:25;41482:50;:65;;-1:-1:-1;;;;;;41482:65:2;;;;;;;;;;;;;;;;;41558:50;:89;;-1:-1:-1;;;;;;;;;;;;;;;;41558:89:2;;;41621:25;41558:89;41657:86;;;;;;41753:76;;;;;;41839:83;;;;;295:3;41558:15;41581:25;41932:50;:65;;-1:-1:-1;;;;;;41932:65:2;;;;;;;;;;;;;;;;;42008:44;:83;;-1:-1:-1;;;;;;;;;;42008:83:2;;;42065:25;42008:83;42101:70;;;;;;42181:81;;;;;295:3;42008:15;42031:19;42272:44;:59;;;;;;;;;-1:-1:-1;;;;;;42272:59:2;;;;;;;;;295:3;42341:15;42364:19;42341:44;:59;;;;;;;;;-1:-1:-1;;;;;;42341:59:2;;;;;;;;;42411:37;:70;;42577:73;42491:76;42461:19;-1:-1:-1;;42411:70:2;;;;;;;-1:-1:-1;;42491:76:2;;;;;-1:-1:-1;;;;;;42577:73:2;;-1:-1:-1;;;;;;42660:65:2;;;295:3;42411:15;42434:12;42735:37;42773:1;42735:40;;;;;;;;;;;;:52;;;;;;;;;;;;;;;;;;32234:10560::o;42921:1493::-;42968:13;:41;;-1:-1:-1;;42968:41:2;43008:1;42968:41;-1:-1:-1;;43019:49:2;;;;;43126:1;;43099:22;43078:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43182:2;43137:13;43158:19;43151:27;;;;;;;;43137:42;;;;;;;;;;;;;;;;;;;;:47;;;;;;;;;;;;;;;;;;43239:1;43194:13;43215:19;43208:27;;;;;;;;43194:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;43293:1;43250:13;43271:17;43264:25;;;;;;;;43250:40;;;;;;;;;;;;;;;;;;;;:44;;;;;;;;;;;;;;;;;;43360:1;43304:13;43325:30;43318:38;;;;;;;;43304:53;;;;;;;;;;;;;;;;;;;;:57;;;;;;;;;;;;;;;;;;43427:1;43371:13;43392:30;43385:38;;;;;;;;43371:53;;;;;;;;;;;;;;;;;;;;:57;;;;;;;;;;;;;;;;;;43487:1;43438:13;43459:23;43452:31;;;;;;;;43438:46;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;43547:1;43498:13;43519:23;43512:31;;;;;;;;43498:46;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;43606:2;43558:13;43579:22;43572:30;;;;;;;;43558:45;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;43666:1;43618:13;43639:22;43632:30;;;;;;;;43618:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43725:1;43677:13;43698:22;43691:30;;;;;;;;43677:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43784:1;43736:13;43757:22;43750:30;;;;;;;;43736:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43840:1;43795:13;43816:19;43809:27;;;;;;;;43795:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;43896:1;43851:13;43872:19;43865:27;;;;;;;;43851:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;43952:1;43907:13;43928:19;43921:27;;;;;;;;43907:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;44009:1;43963:13;43984:20;43977:28;;;;;;;;43963:43;;;;;;;;;;;;;;;;;;;;:47;;;;;;;;;;;;;;;;;;44059:1;44020:13;44041;44034:21;;;;;;;;44020:36;;;;;;;;;;;;;;;;;;;;:40;;;;;;;;;;;;;;;;;;44117:2;44070:13;44091:21;44084:29;;;;;;;;44070:44;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;44177:1;44129:13;44150:22;44143:30;;;;;;;;44129:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;44239:1;44188:13;44209:25;44202:33;;;;;;;;44188:48;;;;;;;;;;;;;;;;;;;;:52;;;;;;;;;;;;;;;;;;44301:1;44250:13;44271:25;44264:33;;;;;;;;44250:48;;;;;;;;;;;;;;;;;;;;:52;;;;;;;;;;;;;;;;;;44357:1;44312:13;44333:19;44326:27;;;;;;;;44312:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;44406:1;44368:13;44389:12;44382:20;;;;;;;;44368:35;;;;;;;;104:47830;;;;;;;",
	"deployedSourceMap": "104:47830:2:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7369:40;;;-1:-1:-1;;;;;7369:40:2;;;;;;;;;;;;;;;;;;;;;;;;;;;21039:1120;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;21039:1120:2;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;;;;;;;;7844:2072;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;7844:2072:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;7844:2072:2;;-1:-1:-1;;;7844:2072:2;;-1:-1:-1;;7844:2072:2;;-1:-1:-1;7844:2072:2;;-1:-1:-1;;7844:2072:2;;;;;;;;;;;;;;;;;14294:867;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;14294:867:2;;;;;;;;;;;10289:1619;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;10289:1619:2;;;;;;;;;;;;;;;;;;;;;;;;7497:102;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;7497:102:2;;;;;;;1891:48;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1891:48:2;;;;;;;;;;;;;;;;;;;;;;;;;;15303:505;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;15303:505:2;;;;;;;;;16513:259;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;16513:259:2;;;;;;;2201:41;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;2201:41:2;;;;;19418:434;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;19418:434:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;-1:-1;;;;;19418:434:2;;;;;;;;-1:-1:-1;19418:434:2;;;;;;;;;-1:-1:-1;19418:434:2;-1:-1:-1;;;;;;19418:434:2;20075:583;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;20075:583:2;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;20075:583:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;20075:583:2;;;;;;;;;;;;;;;;;17205:1246;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;17205:1246:2;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;17205:1246:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;12259:1863;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;12259:1863:2;;;;;;;;;;;;;;;;;;;22513:1775;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;22513:1775:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;2055:58:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;2055:58:2;;;;;;;16005:327;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;16005:327:2;;;;;;;2332:31;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;2332:31:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;2332:31:2;;;;;;;;;;;;;;;;;18702:440;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;18702:440:2;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;-1:-1;;84:18;;18702:440:2;;;;64:39:-1;;;-1:-1;18702:440:2;-1:-1:-1;18702:440:2;;-1:-1:-1;18702:440:2;;;;52:2:-1;8:100;;16848:98:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;16848:98:2;;;;21039:1120;21139:6;21159:28;;:::i;:::-;21202;;:::i;:::-;21245;;:::i;:::-;21288;;:::i;:::-;21333:21;21389:50;;:::i;:::-;21449:48;;:::i;:::-;21507:56;;:::i;:::-;21573:51;;:::i;:::-;21640:8;21357:13;21371:6;21357:21;;;;;;;;;;;;;;;;;;;;21333:45;;21651:1;21640:12;;21635:339;641:1;21654:24;;;;21635:339;;;21719:33;21729:4;:19;;;21750:1;21719:9;:33::i;:::-;21699:14;:17;;;;;;;;;;:53;;;;:17;;;;;;:53;21794:17;;;;21784:31;;21813:1;21784:9;:31::i;:::-;21766:12;:15;;;;;;;;;;:49;;;;:15;;;;;;:49;21865:25;;;;21855:39;;21892:1;21855:9;:39::i;:::-;21829:20;:23;;;;;;;;;;:65;;;;:23;;;;;;:65;21939:20;;;;21929:34;;21961:1;21929:9;:34::i;:::-;21908:15;:18;;;;;;;;;;:55;;;;:18;;;;;;:55;21680:3;;21635:339;;;-1:-1:-1;22005:16:2;;;;;;;;;22036:14;;-1:-1:-1;22065:12:2;;-1:-1:-1;22092:20:2;-1:-1:-1;22065:12:2;;-1:-1:-1;21039:1120:2;-1:-1:-1;;21039:1120:2:o;7844:2072::-;8063:7;7000;;8063;;7000;;;;;:16;6992:54;;;;;-1:-1:-1;;;;;6992:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;1038:2;8160:40;;;;;8152:108;;;;;-1:-1:-1;;;;;8152:108:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8462:1353;;;;;;;;;-1:-1:-1;8462:1353:2;;;8584:12;8462:1353;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1619:66;8462:1353;;;;;;;;-1:-1:-1;;8462:1353:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;8462:1353:2;;;;;;;;;8443:13;27:10:-1;;9819:1:2;23:18:-1;;;45:23;;;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;8443:1373:2;;;;;-1:-1:-1;;8443:1373:2;;;;;-1:-1:-1;;8443:1373:2;;;;-1:-1:-1;;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9819:1;;23:18:-1;8462:1353:2;8443:1373;;;;;;;;;:::i;:::-;-1:-1:-1;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;8443:1373:2;;;;;;;;;-1:-1:-1;;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;8443:1373:2;;;;;;;;;;;9836:50;;;8443:1377;;;;9836:50;;;9859:12;9836:50;;;;;;;-1:-1:-1;;9836:50:2;;;;;;;;8443:1377;;-1:-1:-1;9836:50:2;;;;;;;;;;9903:6;7844:2072;-1:-1:-1;;;;;7844:2072:2:o;14294:867::-;14431:21;14409:6;5334:21;5358:13;5372:6;5358:21;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;5478:20:2;;;:23;;-1:-1:-1;;;;;5478:23:2;5464:10;:37;;:91;;-1:-1:-1;5532:20:2;;;;:23;;-1:-1:-1;;;;;5532:23:2;5518:10;:37;5464:91;:145;;;-1:-1:-1;5586:20:2;;;5607:1;5586:23;;-1:-1:-1;;;;;5586:23:2;5572:10;:37;5464:145;:199;;;-1:-1:-1;5640:20:2;;;5661:1;5640:23;;-1:-1:-1;;;;;5640:23:2;5626:10;:37;5464:199;:253;;;-1:-1:-1;5694:20:2;;;5715:1;5694:23;;-1:-1:-1;;;;;5694:23:2;5680:10;:37;5464:253;:307;;;-1:-1:-1;5748:20:2;;;5769:1;5748:23;;-1:-1:-1;;;;;5748:23:2;5734:10;:37;5464:307;:361;;;-1:-1:-1;5802:20:2;;;5823:1;5802:23;;-1:-1:-1;;;;;5802:23:2;5788:10;:37;5464:361;:415;;;-1:-1:-1;5856:20:2;;;5877:1;5856:23;;-1:-1:-1;;;;;5856:23:2;5842:10;:37;5464:415;5443:485;;;;;;;-1:-1:-1;;;;;5443:485:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;14455:13;:21;;14469:6;;14455:21;;;;;;;;;;;;;;;;;;;14494:12;;14455:21;;-1:-1:-1;14494:23:2;;;;:12;;;;;:23;14486:54;;;;;-1:-1:-1;;;;;14486:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;14581:12;;14573:44;;14581:12;;;;;;;14595:21;;;;14573:7;:44::i;:::-;14558:59;;:12;:59;14550:109;;;;;-1:-1:-1;;;;;14550:109:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14756:16;;;;14775:1;14756:16;;;;:20;14752:80;;;14792:29;14814:6;14792:21;:29::i;:::-;14902:25;14920:6;14902:17;:25::i;:::-;14884:43;;-1:-1:-1;;14884:43:2;;;;;;-1:-1:-1;;14937:35:2;;14959:12;14937:35;;;;;;;;;;;15066:25;15084:6;15066:17;:25::i;:::-;15124:12;;15107:47;;;;;;15124:12;;;;;;15107:47;;;;15138:15;;;15107:47;;;;;;;;;;;;;;14294:867;;;;;:::o;10289:1619::-;10573:21;10628:8;10496:6;10504:7;4847:21;4871:13;4885:6;4871:21;;;;;;;;;;;;;;;;;;;;;;;5008:15;;4871:21;;-1:-1:-1;4987:20:2;;;;5008:15;;4987:37;;;;;;;;;-1:-1:-1;;;;;4987:37:2;4973:10;:51;4952:121;;;;;-1:-1:-1;;;;;4952:121:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;5149:12;;:23;;;;:12;;;;;:23;5141:54;;;;;-1:-1:-1;;;;;5141:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;10536:10;10548:8;364:2;6153:25;;;;:52;;;;-1:-1:-1;364:2:2;6182:23;;;;6153:52;6145:86;;;;;;;-1:-1:-1;;;;;6145:86:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;6364:8;6330:42;;:15;6346:10;6330:27;;;;;;;;;;;;:30;;;:42;;:101;;;6423:8;6389:42;;:15;6405:10;6389:27;;;;;;;;;;;;:30;;;;;;:42;6330:101;:160;;;;6482:8;6448:42;;:15;6464:10;6448:27;;;;;;;;;;;;:30;;;;;;:42;6330:160;:219;;;;6541:8;6507:42;;:15;6523:10;6507:27;;;;;;;;;;;;:30;;;;;;:42;6330:219;:278;;;;6600:8;6566:42;;:15;6582:10;6566:27;;;;;;;;;;;;:30;;;;;;:42;6330:278;6309:380;;;;;;;-1:-1:-1;;;;;6309:380:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10597:13;:21;;10611:6;;10597:21;;;;;;;;;;;;;;;;10573:45;;10703:1;10699:5;;10694:270;10710:16;;;;;;;;10706:20;;;;10694:270;;;10854:31;10864:4;:17;;;10883:1;10854:9;:31::i;:::-;10842:43;;;;;;;;10817:136;;;;;-1:-1:-1;;;;;10817:136:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10728:3;;;;;10694:270;;;10981:16;;;;641:1;10981:39;:16;;;:39;10973:87;;;;;-1:-1:-1;;;;;10973:87:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11112:16;11078:50;;:4;:19;;11098:10;11078:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:50;11070:92;;;;;-1:-1:-1;;;;;11070:92:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;11199:39;11208:4;:17;;;11227:10;11199:8;:39::i;:::-;11180:15;;:58;:15;;;:58;;;11172:98;;;;;-1:-1:-1;;;;;11172:98:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;11338:16;;;;;;;;;-1:-1:-1;11442:16:2;;11407:19;;;;:31;;;;;;;;;;;;;;;;;;;;:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11538:45;11548:4;:19;;;11569:1;11572:10;11538:9;:45::i;:::-;11516:19;;;:67;11623:17;;;;11613:41;;11642:1;11645:8;11613:9;:41::i;:::-;11593:17;;;:61;11702:25;;;;11692:57;;11729:1;11732:16;11692:9;:57::i;:::-;11664:25;;;:85;11792:20;;;;11782:56;;11814:1;11824:12;11782:9;:56::i;:::-;11759:20;;;:79;-1:-1:-1;;;11883:16:2;;;;:18;;;;;;;;;-1:-1:-1;;11883:18:2;;;;;;-1:-1:-1;;;;;;;;10289:1619:2:o;7497:102::-;6825:5;;-1:-1:-1;;;;;6825:5:2;6811:10;:19;6803:66;;;;;-1:-1:-1;;;;;6803:66:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7578:7;:14;;;;;;;-1:-1:-1;;7578:14:2;;;;;;;;;7497:102::o;1891:48::-;;;;;;;;;;;;;;;:::o;15303:505::-;15416:21;15480:13;15515:8;15394:6;5334:21;5358:13;5372:6;5358:21;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;5478:20:2;;;:23;;-1:-1:-1;;;;;5478:23:2;5464:10;:37;;:91;;-1:-1:-1;5532:20:2;;;;:23;;-1:-1:-1;;;;;5532:23:2;5518:10;:37;5464:91;:145;;;-1:-1:-1;5586:20:2;;;5607:1;5586:23;;-1:-1:-1;;;;;5586:23:2;5572:10;:37;5464:145;:199;;;-1:-1:-1;5640:20:2;;;5661:1;5640:23;;-1:-1:-1;;;;;5640:23:2;5626:10;:37;5464:199;:253;;;-1:-1:-1;5694:20:2;;;5715:1;5694:23;;-1:-1:-1;;;;;5694:23:2;5680:10;:37;5464:253;:307;;;-1:-1:-1;5748:20:2;;;5769:1;5748:23;;-1:-1:-1;;;;;5748:23:2;5734:10;:37;5464:307;:361;;;-1:-1:-1;5802:20:2;;;5823:1;5802:23;;-1:-1:-1;;;;;5802:23:2;5788:10;:37;5464:361;:415;;;-1:-1:-1;5856:20:2;;;5877:1;5856:23;;-1:-1:-1;;;;;5856:23:2;5842:10;:37;5464:415;5443:485;;;;;;;-1:-1:-1;;;;;5443:485:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;15440:13;:21;;15454:6;;15440:21;;;;;;;;;;;;;;;;15416:45;;15496:4;15480:20;;15526:1;15515:12;;15510:161;364:2;15529:16;;;;15510:161;;;15604:6;15570:40;;:30;15579:4;:17;;;15598:1;15570:8;:30::i;:::-;:40;;;15566:95;;15641:5;15630:16;;15566:95;15547:3;;;;;15510:161;;;15689:8;15681:44;;;;;;;-1:-1:-1;;;;;15681:44:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;15740:8;15736:66;;;15769:22;;;;;;;;;;;;;;;;;;;;;;;;;;15736:66;15303:505;;;;;;;:::o;16513:259::-;16575:6;16621:19;;;;;;16656:16;;;16652:85;;;-1:-1:-1;16702:24:2;;;;;;;;:14;:24;;;;;;;16652:85;16754:11;16513:259;-1:-1:-1;;16513:259:2:o;2201:41::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;19418:434::-;19508:6;19516;19524;19532;19540:20;;:::i;:::-;19562:6;19585:21;19609:13;19623:6;19609:21;;;;;;;;;;;;;;;;;;;;;;;19661:15;;19819:16;;;;19640:205;;;19661:15;19640:205;;;;;;19609:21;;-1:-1:-1;19661:15:2;;;;;19691:12;;;;;;19718:21;;;;;;19754:16;;;;;;;;19661:15;19785:20;;;19819:16;;;19640:205;19785:20;;19718:21;;19785:20;19640:205;;;;-1:-1:-1;;;;;19640:205:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;19418:434;;;;;;;;:::o;20075:583::-;20166:19;;:::i;:::-;20187;;:::i;:::-;20223:21;20279:49;;:::i;:::-;20338:43;;:::i;:::-;20396:8;20247:13;20261:6;20247:21;;;;;;;;;;;;;;;;;;;;20223:45;;20407:1;20396:12;;20391:201;538:1;20410:15;;;;20391:201;;;20474:37;20484:4;:23;;;20509:1;20474:9;:37::i;:::-;20446:22;:25;;;;;;;;;;:65;;;;:25;;;;;;:65;20547:33;20570:6;20578:1;20547:22;:33::i;:::-;20525:16;:19;;;;;;;;;;:55;;;;:19;;;;;;:55;20427:3;;20391:201;;;-1:-1:-1;20610:22:2;;20634:16;;-1:-1:-1;20075:583:2;-1:-1:-1;;;20075:583:2:o;17205:1246::-;17297:11;;:::i;:::-;17310:6;17318:7;17342:29;;:::i;:::-;17381:18;17409:14;17553:21;17824:9;17918:21;17986:8;17460:1;17437:13;:20;;;;:24;17433:961;;;17577:13;:20;-1:-1:-1;;17577:24:2;;-1:-1:-1;17628:1:2;17619:10;;:36;;;;;17642:13;17633:6;:22;17619:36;17615:97;;;17691:6;17675:22;;17615:97;17836:13;17852:1;17836:17;17824:29;;17819:565;17859:1;17855;:5;17819:565;;;17942:13;:21;;-1:-1:-1;;17894:5:2;;;-1:-1:-1;17894:5:2;;17942:21;;;;;;;;;;;;;;;;17918:45;;17997:1;17986:12;;17981:280;18004:16;;;;;;;;;18000:20;;;;17981:280;;;18080:10;18053:20;;;:23;;;;;;;;;;;;-1:-1:-1;;;;;18053:23:2;:37;18049:194;;;18144:6;18118:10;:23;;;;;;;;;;;;;:32;18176:13;;;;;18215:5;;18049:194;18022:3;;17981:280;;;18283:11;:17;;18298:2;18283:17;:39;;;;18316:6;18304:9;:18;18283:39;18279:91;;;18346:5;;18279:91;-1:-1:-1;;17862:3:2;;;;17819:565;;;-1:-1:-1;18412:10:2;;18424:11;;-1:-1:-1;18437:6:2;;-1:-1:-1;17205:1246:2;;-1:-1:-1;;;;;17205:1246:2:o;12259:1863::-;12488:21;12543:29;12456:6;12464:7;4847:21;4871:13;4885:6;4871:21;;;;;;;;;;;;;;;;;;;;;;;5008:15;;4871:21;;-1:-1:-1;4987:20:2;;;;5008:15;;4987:37;;;;;;;;;-1:-1:-1;;;;;4987:37:2;4973:10;:51;4952:121;;;;;-1:-1:-1;;;;;4952:121:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;5149:12;;:23;;;;:12;;;;;:23;5141:54;;;;;-1:-1:-1;;;;;5141:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;12512:13;:21;;12526:6;;12512:21;;;;;;;;;;;;;;;;;;;12585:23;;;;12610:15;;12512:21;;-1:-1:-1;12575:51:2;;12610:15;;12575:9;:51::i;:::-;12543:83;-1:-1:-1;12645:44:2;;;;;;;;;12637:87;;;;;-1:-1:-1;;;;;12637:87:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;12756:25;;;295:3;12756:25;:52;;;;-1:-1:-1;12785:23:2;;;;12756:52;12755:131;;;-1:-1:-1;12871:15:2;;12835:17;;;;12871:15;;;;;12826:41;;12854:12;12826:8;:41::i;:::-;:60;;;12755:131;:202;;;;216:3;12903:54;;:41;12912:4;:17;;;12931:12;12903:8;:41::i;:::-;:54;;;12755:202;12734:321;;;;;;;-1:-1:-1;;;;;12734:321:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13152:16;;;;13171:1;13152:16;;;;:20;13148:80;;;13188:29;13210:6;13188:21;:29::i;:::-;13297:25;;;295:3;13297:25;13293:500;;13367:17;;;;13400:15;;13358:58;;13367:17;13386:12;;13400:15;;13358:8;:58::i;:::-;13338:17;;;:78;13483:23;;;;13525:15;;13456:168;;13483:23;13525:15;;13559:51;13567:22;13591:18;13559:7;:51::i;:::-;13456:9;:168::i;:::-;13430:23;;;:194;13674:108;13699:19;;;:33;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13750:18;13674:7;:108::i;:::-;13638:19;;;:33;;;;;;;;;;;;;;;;;;;;;:144;;;;;;;;;;;;;;;;;;13293:500;13863:25;13881:6;13863:17;:25::i;:::-;13845:43;;-1:-1:-1;;13845:43:2;;;;;;-1:-1:-1;;13898:35:2;;13920:12;13898:35;;;;;;;;;;;14027:25;14045:6;14027:17;:25::i;:::-;14085:12;;14068:47;;;;;;14085:12;;;;;;14068:47;;;;14099:15;;;14068:47;;;;;;;;;;;;;;12259:1863;;;;;;;;;:::o;22513:1775::-;22620:6;22640;22660:28;;:::i;:::-;22703;;:::i;:::-;22746;;:::i;:::-;22791:21;22847:51;;:::i;:::-;22908:57;;:::i;:::-;22975;;:::i;:::-;23048:8;23107:15;23240:13;23472:25;23499;22815:13;22829:6;22815:21;;;;;;;;;;;;;;;;;;;;22791:45;;23059:1;23048:12;;23043:1045;641:1;23062:24;;;;23043:1045;;;23125:31;23135:4;:17;;;23154:1;23125:9;:31::i;:::-;23107:49;;23191:34;23201:4;:20;;;23223:1;23191:9;:34::i;:::-;23170:15;:18;;;;;;;;;;:55;;;;:18;;;;;;;;;:55;23297:15;;23265:17;;;;23297:15;;;23256:37;;23284:8;23256;:37::i;:::-;:56;;;:127;;;;216:3;23333:50;;:37;23342:4;:17;;;23361:8;23333;:37::i;:::-;:50;;;23256:127;23240:143;;23402:8;:49;;;-1:-1:-1;23429:15:2;:18;;;;;;;;;;;;;;23450:1;23429:22;23414:37;;:12;:37;23402:49;23398:680;;;23528:408;23617:15;:18;;;;;;;;;;;;;;23708:39;23718:4;:25;;;23745:1;23708:9;:39::i;:::-;23818:19;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23910:8;23528:22;:408::i;:::-;23471:465;;-1:-1:-1;23471:465:2;-1:-1:-1;23471:465:2;23955:21;:24;;;;;;;;;;:45;;;;:24;;;;;;;;;:45;24045:18;;24018:21;;:24;;;;;;;;;:45;;;;:24;;;;;;:45;23398:680;23088:3;;;;;23043:1045;;;-1:-1:-1;;;24154:16:2;;;;;24126:12;;24154:16;;;;;-1:-1:-1;24185:15:2;;-1:-1:-1;24215:21:2;;-1:-1:-1;24250:21:2;-1:-1:-1;22513:1775:2;;-1:-1:-1;;;;22513:1775:2:o;2055:58::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;16005:327::-;16106:24;;;;16063:6;16106:24;;;:14;:24;;;;;;16063:6;;16106:24;16145:20;;16141:152;;;-1:-1:-1;;16206:19:2;;;;16240:24;;;;16199:27;16240:24;;;;;:42;;-1:-1:-1;;16240:42:2;16206:19;;16240:42;;;;;;;;;16206:19;16005:327::o;2332:31::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;2332:31:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;18702:440::-;18791:20;;:::i;:::-;18813;;:::i;:::-;18850:21;18906:44;;:::i;:::-;18965:8;18874:13;18888:6;18874:21;;;;;;;;;;;;;;;;;;;;18850:45;;18976:1;18965:12;;18960:119;364:2;18979:16;;;;18960:119;;;19038:30;19047:4;:17;;;19066:1;19038:8;:30::i;:::-;19016:16;:19;;;;;;;;;;:52;;;;:19;;;;;;:52;18997:3;;18960:119;;;19089:46;;;;;;;;;;19097:16;;19115:19;;;;19089:46;19115:19;;19089:46;;19115:19;-1:-1:-1;19089:46:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;18702:440;;;;;;:::o;16848:98::-;16919:13;:20;16848:98;;:::o;44653:192::-;44772:2;44764:10;;1127;44799:22;;;;;;;44798:39;;44653:192;;;;;;:::o;47219:188::-;47281:6;47310:7;;;47331;;;;;;;;47327:46;;47361:1;47354:8;;;;47327:46;-1:-1:-1;1289:10:2;;47219:188;-1:-1:-1;;;47219:188:2:o;24397:1968::-;24490:21;24625:8;24680:17;24747:15;24810:13;25167:25;25194;24514:13;24528:6;24514:21;;;;;;;;;;;;;;;;;;;;24490:45;;24636:1;24625:12;;24620:1669;24643:16;;;;;;;;24639:20;;;;24620:1669;;;24700:33;24710:4;:19;;;24731:1;24700:9;:33::i;:::-;24680:53;;24765:31;24775:4;:17;;;24794:1;24765:9;:31::i;:::-;24867:15;;24835:17;;;;24747:49;;-1:-1:-1;24867:15:2;;;24826:37;;24747:49;24826:8;:37::i;:::-;:56;;;:126;;;;216:3;24902:50;;:37;24911:4;:17;;;24930:8;24902;:37::i;:::-;:50;;;24826:126;24810:142;;25223:388;25304:34;25314:4;:20;;;25336:1;25304:9;:34::i;:::-;25403:39;25413:4;:25;;;25440:1;25403:9;:39::i;:::-;25505:19;;;:29;;;;;;;;;25223:388;25166:445;;;;25630:18;:23;;25652:1;25630:23;25626:653;;;25806:18;25774:19;;;:29;;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;25862:54;25871:4;:17;;;25890:8;25900:4;:15;;;;;;;;;;;;25862:8;:54::i;:::-;25842:17;;;:74;25626:653;;;26077:119;26106:19;;;:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;26160:18;26077:7;:119::i;:::-;26043:19;;;:31;;;;;;;;;;;;;;;;;;;;;:153;;;;;;;;;;;;;;;;;;26246:18;26214:4;:19;;26234:8;26214:29;;;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;25626:653;24661:3;;;;;24620:1669;;;-1:-1:-1;;;26338:16:2;;;;:20;;-1:-1:-1;;26338:20:2;;;-1:-1:-1;;;;24397:1968:2:o;26483:888::-;26588:6;26611:21;26666:41;;:::i;:::-;26717:16;26751:8;26827:18;27080:17;26635:13;26649:6;26635:21;;;;;;;;;;;;;;;;;;;;26611:45;;26736:5;26717:24;;26787:1;26783:5;;26778:292;364:2;26790:16;;;;26778:292;;;26848:30;26857:4;:17;;;26876:1;26848:8;:30::i;:::-;26827:51;-1:-1:-1;26896:24:2;;;216:3;26896:24;26892:168;;;26954:4;26940:18;;26892:168;;;27041:4;27009:16;:29;;;;;;;;;;:36;;;:29;;;;;:36;26892:168;26808:3;;;;;26778:292;;;-1:-1:-1;27100:15:2;;;;-1:-1:-1;27100:15:2;;27125:212;27141:16;;;;;;;;;27137:20;;;;27125:212;;;27210:16;;;;;;;;;;27205:1;27192:14;;27191:35;;;;;;;;;27178:48;;27244:11;:43;;;-1:-1:-1;27259:16:2;:28;;;;;;;;;;;;;;27244:43;27240:87;;;27307:5;;27240:87;27159:3;;;;;27125:212;;;27354:10;26483:888;-1:-1:-1;;;;;;;26483:888:2:o;31443:663::-;31504:21;31618:13;31726:19;31852:29;31528:13;31542:6;31528:21;;;;;;;;;;;;;;;;;;;;;;;31634:15;;31528:21;;-1:-1:-1;31634:15:2;;;-1:-1:-1;31748:38:2;31771:6;31634:15;31748:22;:38::i;:::-;31726:60;;31884:42;31894:4;:23;;;31919:6;31884:9;:42::i;:::-;31852:74;;31962:137;31985:4;:23;;;32023:6;32044:45;32052:22;32076:12;32044:7;:45::i;31962:137::-;31936:4;:23;;:163;;;;31443:663;;;;;:::o;45675:189::-;45819:22;45793:1;45785:9;;;;45819:22;;;;;1222:4;45818:38;;45675:189::o;45168:268::-;45335:22;45404:14;;;45302:2;45294:10;;;;45335:22;;;;45404:24;;;45335:22;;45333:25;45376:23;;;;45375:54;;45168:268::o;30606:720::-;30717:6;30740:21;30862:18;30973:17;31041:8;30764:13;30778:6;30764:21;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;30764:21:2;-1:-1:-1;30993:33:2;;-1:-1:-1;30764:21:2;;-1:-1:-1;31036:206:2;364:2;31055:16;;;;31036:206;;;31130:6;31096:40;;:30;31105:4;:17;;;31124:1;31096:8;:30::i;:::-;:40;;;31092:140;;;31171:13;:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;31156:31;;;;31205:12;;;;;;;31092:140;31073:3;;31036:206;;;-1:-1:-1;945:2:2;31261:24;;31260:58;;;;;-1:-1:-1;;;;30606:720:2:o;46188:329::-;46278:7;;;46313:3;46305:11;;;;46297:54;;;;;-1:-1:-1;;;;;46297:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;1222:4:2;46385:1;46377:9;;;;46417:21;;;;;;;;;46415:24;46457:23;;;;46485:14;;:24;46456:54;;46188:329::o;46775:184::-;46837:6;;46859:8;;;;;;;;46855:79;;-1:-1:-1;;46894:7:2;;;;46915:8;;46855:79;-1:-1:-1;46951:1:2;;46775:184;-1:-1:-1;;;46775:184:2:o;27859:2521::-;28062:6;28070;28719:18;28786:20;28824;29251:12;29309;29840:25;30156;28101:8;:42;;;;28128:11;28142:1;28128:15;28113:30;;:12;:30;28101:42;28093:93;;;;;;;-1:-1:-1;;;;;28093:93:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;28201:8;28197:2177;;;28306:40;28314:16;28332:13;28306:7;:40::i;:::-;28298:52;-1:-1:-1;28348:1:2;;-1:-1:-1;28298:52:2;;28197:2177;28740:32;28756:11;28770:1;28756:15;28740;:32::i;:::-;28719:53;-1:-1:-1;28809:1:2;;-1:-1:-1;28809:1:2;;-1:-1:-1;28955:16:2;;;;28951:796;;;29007:1;;-1:-1:-1;842:1:2;29042:46;29050:13;739:1;29042:7;:46::i;:::-;:73;;;;;;;;;;29026:89;;28951:796;;;29273:17;;;;;-1:-1:-1;29287:3:2;29273:17;;;29332:16;;;29331:24;;;;-1:-1:-1;29448:32:2;29456:16;29273:17;29448:7;:32::i;:::-;:38;;;;;;;;;;;-1:-1:-1;29701:30:2;29622:54;29630:13;739:1;29645:30;;29622:7;:54::i;:::-;:110;;;;;;;;;;29606:126;;28951:796;29888:13;29869:32;;:16;:32;;;29868:92;;29959:1;29868:92;;;29942:13;29923:16;:32;29868:92;29840:120;;30201:13;30185:29;;:13;:29;;;30184:117;;30291:1;30270:18;:22;;;:30;;30299:1;30270:30;;;30295:1;30270:30;30184:117;;;;;30252:13;30236;:29;30184:117;30156:145;;30324:18;30344;30316:47;;;;28197:2177;27859:2521;;;;;;;;;;;;;;:::o;47683:249::-;47745:6;;47767:7;;;;47763:46;;;47797:1;47790:8;;;;47763:46;47835:2;47830;:7;47819:18;;47861:2;47851:12;;47855:2;47851:6;;:1;:6;;;;;;;;;;:12;;;47847:51;;;47886:1;47879:8;;;;104:47830;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;104:47830:2;;;-1:-1:-1;;104:47830:2:o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;104:47830:2;-1:-1:-1;;;;;104:47830:2;;;;;;;;;;;-1:-1:-1;104:47830:2;;;;;;;-1:-1:-1;104:47830:2;;;-1:-1:-1;104:47830:2;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;104:47830:2;;;-1:-1:-1;104:47830:2;:::i;:::-;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;104:47830:2;;;-1:-1:-1;;104:47830:2:o;:::-;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;104:47830:2;;;-1:-1:-1;;104:47830:2:o;:::-;;;;;;;;;;;;;-1:-1:-1;;104:47830:2;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;104:47830:2;;;;;;",
	"source": "pragma solidity ^0.4.0;\n\n/** @title World game. Battle to control territory and take over the world. */\ncontract WorldGame {\n\n    /* Constant to indicate that a region has no owner */\n    uint32 constant NOT_OWNED = 255;\n\n    /* Constant to indicate no region */\n    uint32 constant NO_REGION = 255;\n\n    /* Number of regions */\n    uint32 constant REGION_COUNT = 25;\n\n    /* Maxmimum number of neighbors per region */\n    uint32 constant MAX_NEIGHBORS = 5;\n\n    /* Maximum number of players per game */\n    uint32 constant MAX_PLAYERS = 8;\n\n    /* Maximum number for actions per turn in a game */\n    uint32 constant MAX_ACTIONS_PER_TURN = 8;\n\n    /* Defender advantage in battle numerator */\n    uint32 constant DEFENDER_ADVANTAGE_NUM = 5;\n\n    /* Defender advantage in battle denominator  */\n    uint32 constant DEFENDER_ADVANTAGE_DENOM = 4;\n\n    /* Reward bonus multiplier denominator  */\n    uint32 constant REWARD_BONUS_MULTIPLIER_DENOM = 20;\n\n    /* Minimum value for maxBlocksPerTurn */\n    uint32 constant MAX_BLOCKS_THRESHOLD = 20;\n\n    /* 32 bit mask used for helper functions */\n    uint256 constant MASK_32_BITS = 0xffffffff;\n\n    /* 8 bit mask used for helper functions */\n    uint256 constant MASK_8_BITS = 0xff;\n\n    /* Max uint32 value */\n    uint32 constant MAX_UINT32 = 0xffffffff;\n\n    /* Constant to indicate that all regions have no owner */\n    uint256 constant ALL_REGIONS_NOT_OWNED = 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff;\n\n    /* Initial number of soldier each player starts with. Each play begins with 20 soldiers. */\n    uint256 constant BEGIN_SOLDIERS_COUNTS = 0x0000001400000014000000140000001400000014000000140000001400000014;\n    \n    /* Contract owner used for circuit breaker. */\n    address private owner;\n\n    /* Whether circuit breaker is active. */\n    bool private stopped;\n\n    /* Historical cache of block hashes. */\n    mapping (uint32 => uint32) public blockHash32Map;\n\n    /* Describes which adjacent neighbors each region has. E.g. EASTERN_EUROPE is next to WESTERN_EUROPE. */\n    uint32[MAX_NEIGHBORS][REGION_COUNT] public regionNeighbors;\n\n    /* Describes the reward amount given each round for controlling a region. */\n    uint32[REGION_COUNT] public regionRewards;\n\n    /* Array of game data.  Each entry in the area represents a different game. */\n    GameData[] public gameDataArray;\n\n    /* Enum with all the regions of the game */\n    enum Regions {\n        HAWAII,\n        WESTERN_CANADA,\n        EASTERN_CANADA,\n        WESTERN_USA,\n        EASTERN_USA,\n        GREENLAND,\n        NORTHERN_SOUTH_AMERICA,\n        SOUTHERN_SOUTH_AMERICA,\n        WEST_ANTARCTICA,\n        EAST_ANTARCTICA,\n        WESTERN_EUROPE,\n        EASTERN_EUROPE,\n        CENTRAL_RUSSIA,\n        EASTERN_RUSSIA,\n        WEST_AFRICA,\n        MIDDLE_EAST,\n        EAST_AFRICA,\n        SOUTH_AFRICA,\n        INDIA,\n        EASTERN_CHINA,\n        SOUTHEAST_ASIA,\n        WESTERN_AUSTRALIA,\n        EASTERN_AUSTRALIA,\n        NEW_ZEALAND,\n        FIJI\n    }\n\n    /* Data for an individual game. */\n    struct GameData {\n\n        /* Team ID for who's turn it is. */\n        uint32 turnTeamId;\n\n        /* A unique ID to identify this turn. */\n        uint32 turnNum;\n\n        /* Maxmimum number of blocks per turn. */\n        uint32 maxBlocksPerTurn;\n\n        /* Number of players in this game. */\n        uint32 playerCount;\n\n        /* Address of each player. */\n        address[MAX_PLAYERS] playerAddresses;\n\n        /* Soldiers held by a player in reserve, but not deployed to a region. */\n        uint256 undeployedSoldiers;\n\n        /* Which player controls each region. */\n        uint256 regionOwners;\n\n        /* Number of soldiers deployed to each region. */\n        uint32[REGION_COUNT] regionSoldiers;\n\n        /* Number of actions taken this turn. */\n        uint32 actionCount;\n\n        /* Region user is moving soldiers from. Listed by action ID. */\n        uint256 fromRegionList;\n\n        /* Region user is moving soldiers to. Listed by action ID.  */\n        uint256 toRegionList;\n\n        /* Number of soldiers to move. Listed by action ID. */\n        uint256 moveSoldierCountList;\n\n        /* Block number when action was submitted. Listed by action ID. */\n        uint256 submitBlockList;\n\n        /* Avatars to use for each team. */\n        bytes8 teamAvatars;\n    }\n    \n    /* Event indicating that a new game has started. */\n    event NewGame(uint256 gameId, uint32 turnNum, bytes8 teamAvatars);\n\n    /* Event when it's the next player's turn. */\n    event NextTurn(uint256 gameId, uint32 turnNum, uint32 nextTeamId);\n\n    /* Event when a player wins the game! */\n    event Winner(uint256 gameId, uint32 winningTeamId);\n\n    /* Modifier that only allows player to take action if it's their turn. */\n    modifier onlyIfPlayersTurn(uint256 gameId, uint32 turnNum) {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Ensure it's message sender's turn. */\n        require(\n            msg.sender == game.playerAddresses[game.turnTeamId], \n            \"Sender not authorized.\"\n        );\n\n        /* Don't allow action to occur on wrong turn. */\n        require(game.turnNum == turnNum, \"Wrong turn number.\");\n\n        _;\n    }\n\n    /* Modifier that checks if sender is a player in this game. */\n    modifier onlyPlayers(uint256 gameId) {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Ensure sender in a player in the game. */\n        require(\n            msg.sender == game.playerAddresses[0] || \n            msg.sender == game.playerAddresses[1] || \n            msg.sender == game.playerAddresses[2] || \n            msg.sender == game.playerAddresses[3] || \n            msg.sender == game.playerAddresses[4] || \n            msg.sender == game.playerAddresses[5] || \n            msg.sender == game.playerAddresses[6] || \n            msg.sender == game.playerAddresses[7], \n            \"Sender not authorized.\"\n        );\n\n        _;\n    }\n\n    /* Modifier to only allow moving soldiers between adjacent regions that exist. */\n    modifier onlyNeighbors(uint32 regionFrom, uint32 regionTo) {\n\n        /* Ensure regions exist. */\n        require(regionFrom < REGION_COUNT && regionTo < REGION_COUNT, \"Must be valid regions\");\n\n        /* Only allow moving soldiers between adjacent regions. */\n        require(\n            regionNeighbors[regionFrom][0] == regionTo || \n            regionNeighbors[regionFrom][1] == regionTo || \n            regionNeighbors[regionFrom][2] == regionTo || \n            regionNeighbors[regionFrom][3] == regionTo || \n            regionNeighbors[regionFrom][4] == regionTo,\n            \"Regions must be neighbors in order to move between them\"\n        );\n\n        _;\n    }\n\n    /* Modifier that only allows owner to call function. */\n    modifier isOwner() {\n        require(msg.sender == owner, \"Only owner can call this function.\");\n\n        _;\n    }\n\n    /* Modifier that stops function in case of emergency. */\n    modifier stopInEmergency() {\n        require(stopped == false, \"Stopped due to emergency.\");\n\n        _;\n    }\n\n    /* Constructor initializes common data about regions. */\n    constructor() public {\n        owner = msg.sender;\n        initRegionNeighbors();\n        initRegionRewards();\n    }\n\n    /* Fallback function. Added so ether sent to this contract is reverted. */\n    function() public payable {\n        revert(\"Invalid call to game contract.\");\n    }\n\n    /* Trigger circuit breaker to prevent new games from being created. */\n    function stopNewGames(bool stop)\n        public \n        isOwner()\n    {\n        stopped = stop;\n    }\n\n    /// @notice Create a new game instance\n    /// @param playerCount number of players\n    /// @param playerAddresses address of each player\n    /// @param teamAvatars avatar to use for each player\n    /// @return Id of the game instance\n    function newGame(\n        uint32 playerCount, \n        uint32 maxBlocksPerTurn, \n        address[MAX_PLAYERS] playerAddresses, \n        bytes8 teamAvatars\n    )\n        public\n        stopInEmergency() \n        returns(uint256) \n    {\n        /* Ensure maxBlocksPerTurn isn't set maliciously low. */\n        require(maxBlocksPerTurn >= MAX_BLOCKS_THRESHOLD, \"Users must be given enough time to complete their turn.\");\n\n        /* \n            Initialize a new game with some default values.\n            Push returns array length so subtract 1 to get array index.\n        */\n        uint256 gameId = gameDataArray.push(GameData(\n            /* uint32 turnTeamId */\n            uint32(0), \n            /* uint32 turnNum */\n            uint32(block.number), \n            /* uint32 maxBlocksPerTurn */\n            maxBlocksPerTurn,\n            /* uint32 playerCount */\n            playerCount,\n            /* address[MAX_PLAYERS] playerAddresses */\n            playerAddresses, \n            /* uint256 undeployedSoldiers */\n            BEGIN_SOLDIERS_COUNTS, \n            /* uint256 regionOwners */\n            ALL_REGIONS_NOT_OWNED, \n            /* uint32[REGION_COUNT] regionSoldiers */\n            [\n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0)\n            ], \n            /* uint32 actionCount */\n            uint32(0),\n            /* uint256 fromRegionList */\n            uint256(0), \n            /* uint256 toRegionList */\n            uint256(0), \n            /* uint256 moveSoldierCountList */\n            uint256(0), \n            /* uint256 submitBlockList */\n            uint256(0),\n            /* bytes8 teamAvatars */\n            teamAvatars\n        )) - 1;\n\n        emit NewGame(gameId, uint32(block.number), teamAvatars);\n        return gameId;\n    }\n\n    /// @notice Move soldiers from one region to an adjacent region.  Attack if moving to enemy territory. \n    /// @param gameId Id of game \n    /// @param turnNum Turn action should occur during \n    /// @param regionFrom Move soldiers from this region\n    /// @param regionTo Move soldiers to this region\n    /// @param moveSoldierCount Number of soldiers to move\n    function attackOrMove(\n        uint256 gameId, \n        uint32 turnNum, \n        uint32 regionFrom, \n        uint32 regionTo, \n        uint32 moveSoldierCount\n    )\n        public \n        onlyIfPlayersTurn(gameId, turnNum) \n        onlyNeighbors(regionFrom, regionTo) \n    {\n        GameData storage game = gameDataArray[gameId];\n        uint32 i;\n\n        /* Loop through all queued actions. */\n        for (i = 0; i < game.actionCount; i++) {\n            /* Ensure region doesn't already have a queued action. */\n            require(\n                regionTo != getData32(game.toRegionList, i), \n                \"Region already has queued action.\"\n            );\n        }\n        require(game.actionCount < MAX_ACTIONS_PER_TURN, \"Only 8 actions are allowed per turn\");\n        require(game.regionSoldiers[regionFrom] > moveSoldierCount, \"Must have sufficient soldiers\");\n        require(game.turnTeamId == getData8(game.regionOwners, regionFrom), \"Must own region moving from\");\n\n        /* Index to use for creating a new action */\n        i = game.actionCount;\n\n        /* Remove soldiers from region */\n        game.regionSoldiers[regionFrom] -= moveSoldierCount;\n\n        /* Queue a new action for this turn */\n        game.fromRegionList = setData32(game.fromRegionList, i, regionFrom);\n        game.toRegionList = setData32(game.toRegionList, i, regionTo);\n        game.moveSoldierCountList = setData32(game.moveSoldierCountList, i, moveSoldierCount);\n        game.submitBlockList = setData32(game.submitBlockList, i, uint32(block.number));\n\n        /* Update action count */\n        game.actionCount++;\n    }\n\n    /// @notice Execute actions that have been queued for this turn.\n    /// @param gameId Id of game \n    /// @param turnNum Turn deploySoldiersAndEndTurn should occur during \n    /// @param regionDeploy Region where you'd like to deploy soldiers to\n    /// @param deploySoldierCount Number of soldiers you'd like to deploy at end of your turn\n    function deploySoldiersAndEndTurn(\n        uint256 gameId, \n        uint32 turnNum, \n        uint32 regionDeploy, \n        uint32 deploySoldierCount\n    )\n        public \n        onlyIfPlayersTurn(gameId, turnNum) \n    {\n        GameData storage game = gameDataArray[gameId];\n        uint32 undeployedSoldierCount = getData32(game.undeployedSoldiers, game.turnTeamId);\n\n        require(undeployedSoldierCount >= deploySoldierCount, \"Must have sufficient soldiers.\");\n        require(\n            (regionDeploy == NO_REGION && deploySoldierCount == 0) || \n            getData8(game.regionOwners, regionDeploy) == game.turnTeamId || \n            getData8(game.regionOwners, regionDeploy) == NOT_OWNED,\n            \"You can only deploy soldiers to a region you own, or that is unoccupied.\"\n        );\n\n        /* If there's any queued actions then execute them before ending turn. */\n        if (game.actionCount > 0) {\n            executePendingActions(gameId);\n        }\n\n        /* Deploy soldiers if a region is specified */\n        if (regionDeploy != NO_REGION) {\n            game.regionOwners = setData8(game.regionOwners, regionDeploy, game.turnTeamId);\n            game.undeployedSoldiers = setData32(\n                game.undeployedSoldiers, \n                game.turnTeamId, \n                subSafe(undeployedSoldierCount, deploySoldierCount)\n            );\n            game.regionSoldiers[regionDeploy] = addSafe(\n                game.regionSoldiers[regionDeploy],\n                deploySoldierCount\n            );\n        }\n\n        /* It's the next player's turn */\n        game.turnTeamId = getNextTurnTeamId(gameId);\n        game.turnNum = uint32(block.number);\n\n        /* Give bonus soldiers to next team based on what regions they control. */\n        giveRegionRewards(gameId);\n\n        emit NextTurn(gameId, game.turnNum, game.turnTeamId);\n    }\n\n    /// @notice Force turn to end for player who's taking too long.\n    /// @param gameId Id of game \n    /// @param turnNum Turn forceEndOfTurn should occur during \n    function forceEndOfTurn(\n        uint256 gameId, \n        uint32 turnNum\n    )\n        public \n        onlyPlayers(gameId)\n    {\n        GameData storage game = gameDataArray[gameId];\n        require(game.turnNum == turnNum, \"Wrong turn number.\");\n        require(block.number > addSafe(game.turnNum, game.maxBlocksPerTurn), \"Player still has time to finish turn.\");\n\n        /* If there's any queued actions then execute them before ending turn. */\n        if (game.actionCount > 0) {\n            executePendingActions(gameId);\n        }\n\n        /* It's the next player's turn */\n        game.turnTeamId = getNextTurnTeamId(gameId);\n        game.turnNum = uint32(block.number);\n\n        /* Give bonus soldiers to next team based on what regions they control. */\n        giveRegionRewards(gameId);\n\n        emit NextTurn(gameId, game.turnNum, game.turnTeamId);\n    }\n\n    /// @notice Declare victory for a team.\n    /// @param gameId Id of game\n    /// @param teamId Team you'd like to declare as winner\n    function declareWinner(uint256 gameId, uint32 teamId) \n        public \n        onlyPlayers(gameId)\n    {\n        GameData storage game = gameDataArray[gameId];\n        \n        bool isWinner = true;\n        for (uint32 i = 0; i < REGION_COUNT; i++) {\n            if (getData8(game.regionOwners, i) != teamId) {\n                isWinner = false;\n            }\n        }\n\n        require(isWinner, \"We don't have a winner.\");\n\n        if (isWinner) {\n            emit Winner(gameId, teamId);\n        }\n    }\n\n    /// @notice Caches the hash for a specific block in a map.  Only uses last 32 bits.\n    /// @param blockNum Block number\n    /// @return Last 32 bits of block hash, or 0 if not available\n    function cacheBlockHash32(uint32 blockNum) public returns(uint32) {\n        uint32 cachedBlockHash = blockHash32Map[blockNum];\n\n        if (cachedBlockHash == 0) {\n            cachedBlockHash = uint32(blockhash(blockNum));\n            blockHash32Map[blockNum] = cachedBlockHash;\n        }\n\n        return cachedBlockHash;\n    }\n\n    /// @notice Get hash for a specific block.  Only uses last 32 bits.\n    /// @param blockNum Block number\n    /// @return Last 32 bits of block hash, or 0 if not available\n    function readBlockHash32(uint32 blockNum) public view returns(uint32) {\n        uint32 blockHash32 = uint32(blockhash(blockNum));\n\n        if (blockHash32 == 0) {\n            blockHash32 = blockHash32Map[blockNum];\n        }\n\n        return blockHash32;\n    }\n\n    /// @notice Returns total number of games that have been created.\n    function numberOfGames() public view returns(uint256) {\n        return gameDataArray.length;\n    }\n\n    /// @notice Returns recent game ids where msg.sender is a player.\n    /// @param offset Position in game data array to start search from\n    /// @return List of game ids\n    /// @return Number of game ids\n    /// @return Position in loop when ended\n    function listGamesForAddress(uint256 offset) \n        public \n        view \n        returns(uint256[10], uint32, uint256) \n    {\n        uint256[10] memory gameIdList;\n        uint32 gameIdCount;\n        uint256 gameId;\n        if (gameDataArray.length > 0) {\n\n            /* Start position to search backwards through gameDataArray */\n            uint256 startPosition = gameDataArray.length - 1;\n            if (offset > 0 && offset < startPosition) {\n                startPosition = offset;\n            }\n\n            /* Add one to \"i\" to prevent underflow.  Then sub one from \"i\" to get gameId. */\n            for (uint256 i = startPosition + 1; i > 0; i--) {\n                gameId = i - 1;\n\n                GameData storage game = gameDataArray[gameId];\n                for (uint32 j = 0; j < game.playerCount; j++) {\n                    if (game.playerAddresses[j] == msg.sender) {\n                        gameIdList[gameIdCount] = gameId;\n                        gameIdCount++;\n                        break;\n                    }\n                }\n\n                if (gameIdCount == 10 || gasleft() < 100000) {\n                    break;\n                }\n            }\n        }\n\n        return (gameIdList, gameIdCount, gameId);\n    }\n\n    /// @notice Returns the number of soldiers deployed to each region and region owners.\n    /// @param gameId Id of game \n    /// @return List of which player owns each region\n    /// @return List of number of soldiers deployed to each region\n    function soldiersByRegion(uint256 gameId) \n        public \n        view \n        returns(uint32[REGION_COUNT], uint32[REGION_COUNT]) \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[REGION_COUNT] memory regionOwnersList;\n        for (uint32 i = 0; i < REGION_COUNT; i++) {\n            regionOwnersList[i] = getData8(game.regionOwners, i);\n        }\n\n        return (regionOwnersList, game.regionSoldiers);\n    }\n\n    /// @notice Returns information about current turn and players.\n    /// @param gameId Id of game \n    /// @return Id of current player\n    /// @return Turn number\n    /// @return Max blocks per turn\n    /// @return Number of players\n    /// @return Player addresses\n    function turnAndPlayerInfo(uint256 gameId) \n        public \n        view \n        returns(uint32, uint32, uint32, uint32, address[MAX_PLAYERS], bytes8) \n    {\n        GameData storage game = gameDataArray[gameId];\n        return (\n            game.turnTeamId, \n            game.turnNum, \n            game.maxBlocksPerTurn, \n            game.playerCount, \n            game.playerAddresses,\n            game.teamAvatars\n        );\n    }\n\n    /// @notice Returns the number of undeployed soldiers for each player.\n    /// @param gameId Id of game \n    /// @return Number of undeployed soldiers for each player\n    /// @return Reward points for each player\n    function undeployedSoldiers(uint256 gameId) \n        public \n        view \n        returns(uint32[MAX_PLAYERS], uint32[MAX_PLAYERS]) \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[MAX_PLAYERS] memory undeployedSoldiersList;\n        uint32[MAX_PLAYERS] memory regionRewardList;\n        for (uint32 i = 0; i < MAX_PLAYERS; i++) {\n            undeployedSoldiersList[i] = getData32(game.undeployedSoldiers, i);\n            regionRewardList[i] = calculateRegionRewards(gameId, i); \n        }\n\n        return (undeployedSoldiersList, regionRewardList);\n    }\n\n    /// @notice Returns pending actions that have been queued for current turn.\n    /// @param gameId Id of game \n    /// @return Number of pending actions\n    /// @return List of regions moving soldiers from\n    /// @return List of regions moving soldiers to\n    /// @return List with number of soldiers to move\n    /// @return List with block number when action was queued\n    function pendingActions(uint256 gameId) \n        public \n        view \n        returns(\n            uint32,\n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN]\n    ) {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[MAX_ACTIONS_PER_TURN] memory fromRegionList;\n        uint32[MAX_ACTIONS_PER_TURN] memory toRegionList;\n        uint32[MAX_ACTIONS_PER_TURN] memory moveSoldierCountList;\n        uint32[MAX_ACTIONS_PER_TURN] memory submitBlockList;\n\n        for (uint32 i = 0; i < MAX_ACTIONS_PER_TURN; i++) {\n            fromRegionList[i] = getData32(game.fromRegionList, i);\n            toRegionList[i] = getData32(game.toRegionList, i);\n            moveSoldierCountList[i] = getData32(game.moveSoldierCountList, i);\n            submitBlockList[i] = getData32(game.submitBlockList, i);\n        }\n\n        return (\n            game.actionCount, \n            fromRegionList, \n            toRegionList, \n            moveSoldierCountList, \n            submitBlockList\n        );\n    }\n\n    /// @notice Returns pending actions that have been queued for current turn.\n    /// @param gameId Id of game \n    /// @return Current block numbber\n    /// @return Number of pending actions\n    /// @return List with block number when action was queued\n    /// @return Number of remaining attackers\n    /// @return Number of remaining defenders\n    function pendingActionOutcomes(uint256 gameId) \n        public \n        view \n        returns(\n            uint32,\n            uint32,\n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN]\n    ) {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[MAX_ACTIONS_PER_TURN] memory submitBlockList;\n        uint32[MAX_ACTIONS_PER_TURN] memory remainingAttackerList;\n        uint32[MAX_ACTIONS_PER_TURN] memory remainingDefenderList;\n\n        for (uint32 i = 0; i < MAX_ACTIONS_PER_TURN; i++) {\n            uint32 toRegion = getData32(game.toRegionList, i);\n            submitBlockList[i] = getData32(game.submitBlockList, i);\n\n            bool friendly = getData8(game.regionOwners, toRegion) == game.turnTeamId || \n                getData8(game.regionOwners, toRegion) == NOT_OWNED;\n\n            if (friendly || block.number > submitBlockList[i] + 1) {\n                (uint32 remainingAttackers, uint32 remainingDefenders) = getOutcomeAttackOrMove(\n                    /* uint32 submitBlock */\n                    submitBlockList[i], \n                    /* uint32 moveSoldierCount */\n                    getData32(game.moveSoldierCountList, i), \n                    /* uint32 defenderCount  */\n                    game.regionSoldiers[toRegion],\n                    /* bool friendly  */\n                    friendly\n                );\n\n                remainingAttackerList[i] = remainingAttackers;\n                remainingDefenderList[i] = remainingDefenders;\n            }\n        }\n\n        return (\n            uint32(block.number), \n            game.actionCount, \n            submitBlockList, \n            remainingAttackerList,\n            remainingDefenderList\n        );\n    }\n\n    /// @notice Execute actions that have been queued for this turn.\n    /// @param gameId Id of game \n    function executePendingActions(\n        uint256 gameId\n    ) \n        private \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Loops through all queued actions executing them one by one. */\n        for (uint32 i = 0; i < game.actionCount; i++) {\n            uint32 regionFrom = getData32(game.fromRegionList, i);\n            uint32 regionTo = getData32(game.toRegionList, i);\n            bool friendly = getData8(game.regionOwners, regionTo) == game.turnTeamId ||\n                getData8(game.regionOwners, regionTo) == NOT_OWNED;\n\n            /* \n                If attacking enemy territory, then uses randomness to determine outcome.\n                If moving to friendly territory then just moves the soldiers. \n            */\n            (uint32 remainingAttackers, uint32 remainingDefenders) = getOutcomeAttackOrMove(\n                /* uint32 submitBlock */\n                getData32(game.submitBlockList, i), \n                /* uint32 moveSoldierCount */\n                getData32(game.moveSoldierCountList, i), \n                /* uint32 defenderCount  */\n                game.regionSoldiers[regionTo],\n                /* bool friendly  */\n                friendly\n            );\n\n            if (remainingDefenders == 0) {\n                /* Attacker wins (or move was friendly).  Remaining attackers move to new region. */\n                game.regionSoldiers[regionTo] = remainingAttackers;\n                game.regionOwners = setData8(game.regionOwners, regionTo, game.turnTeamId);\n            }\n            else {\n                /* Defender wins.  Remaining attackers return back home. */\n                game.regionSoldiers[regionFrom] = addSafe(\n                    game.regionSoldiers[regionFrom], \n                    remainingAttackers\n                );\n                game.regionSoldiers[regionTo] = remainingDefenders;\n            }\n        }\n\n        /* Reset action count to 0. */\n        game.actionCount = 0;\n    }\n\n    /// @notice Player who's turn is next. \n    /// @param gameId Id of game\n    /// @return Next player's turn\n    function getNextTurnTeamId(\n        uint256 gameId\n    ) \n        private \n        view \n        returns(uint32) \n    {\n        GameData storage game = gameDataArray[gameId];\n        bool[MAX_PLAYERS] memory playerOwnsRegion;\n        bool hasNotOwned = false;\n        uint32 i;\n        \n        for (i = 0; i < REGION_COUNT; i++) {\n            uint32 regionOwner = getData8(game.regionOwners, i);\n            if (regionOwner == NOT_OWNED) {\n                hasNotOwned = true;\n            }\n            else {\n                playerOwnsRegion[regionOwner] = true;\n            }\n        }\n\n        uint32 turnTeamId = game.turnTeamId;\n        for (i = 0; i < game.playerCount; i++) {\n            turnTeamId = (turnTeamId + 1) % game.playerCount;\n            if (hasNotOwned || playerOwnsRegion[turnTeamId]) {\n                break;\n            }\n        }\n\n        return turnTeamId;\n    }\n\n    /// @notice Declare victory for a team.\n    /// @param submitBlock Block number when action was submitted to queue\n    /// @param moveSoldierCount Number of soldiers to move or attack\n    /// @param defenderCount Number of soldiers defending destination region\n    /// @param friendly Whether this is an attack, or friendly move\n    /// @return remainingAttackers Number of attacking soldiers remaining \n    /// @return remainingDefenders Number of defending soldiers remaining\n    function getOutcomeAttackOrMove(\n        uint32 submitBlock, \n        uint32 moveSoldierCount, \n        uint32 defenderCount, \n        bool friendly\n    ) \n        private \n        view \n        returns(uint32, uint32) \n    {\n        require(friendly || block.number > submitBlock + 1, \"Attacks must be at least 2 blocks old.\");\n\n        if (friendly) {\n            /* If friendly, just move all soldiers to attacking side. */\n            return (addSafe(moveSoldierCount, defenderCount), 0);\n        }\n        else {\n            /* \n                Determine outcome of attack.\n                Use blockHash of the block after action was submitted as a source of randomness.\n\n                Only most recent 256 blockhashes are available.\n                If too much time has ellapsed, then blockHash will be 0 and attacker loses.\n            */\n            uint32 blockHash32 = readBlockHash32(submitBlock + 1);\n            uint32 deadDefenders = 0;\n            uint32 deadAttackers = 0;\n\n            /* If blockHash32 is no longer available then attacker loses by default. */\n            if (blockHash32 == 0) {\n                deadDefenders = 0;\n                deadAttackers = mulSafe(defenderCount, DEFENDER_ADVANTAGE_NUM) / DEFENDER_ADVANTAGE_DENOM;\n            }\n            /* If blockHash32 is available then use it as a source of randomness. */\n            else {\n                uint32 randA = uint32(blockHash32 % 256);\n                uint32 randB = uint32((blockHash32 >> 8) % 256);\n\n                /* Determine effectiveness of attack. */\n                deadDefenders = mulSafe(moveSoldierCount, randA) / 256;\n\n                /* Determine effectiveness of defence.  Gives slight extra advantage to defender. */\n                deadAttackers = mulSafe(defenderCount, DEFENDER_ADVANTAGE_NUM * randB) / \n                    (256 * DEFENDER_ADVANTAGE_DENOM);\n            }\n\n            /* Determine remaining attackers by subtracting dead attackers. */\n            uint32 remainingAttackers = (moveSoldierCount > deadAttackers) ? \n                (moveSoldierCount - deadAttackers) : 0;\n\n            /* \n                Determine remaining defenders by subtracting dead defenders.\n                If all attackers are dead then keep at least 1 defender.\n            */\n            uint32 remainingDefenders = (defenderCount > deadDefenders) ? \n                (defenderCount - deadDefenders) : (remainingAttackers > 0 ? 0 : 1);\n\n            return (remainingAttackers, remainingDefenders);\n        }\n    }\n\n    /// @notice Calculate a team's reward amount based on what regions they control.\n    /// @param gameId Id of game\n    /// @param teamId Team you'd like to calculate rewards for\n    /// @return Reward amount for team\n    function calculateRegionRewards(uint256 gameId, uint32 teamId) \n        private \n        view \n        returns(uint32) \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Reward total based on what regions player controls. */\n        uint32 rewardTotal = 0;\n\n        /* Bonus multiplier of 5% given per additional region controller.  */\n        uint32 bonusScore = REWARD_BONUS_MULTIPLIER_DENOM - 1;\n        for (uint32 i = 0; i < REGION_COUNT; i++) {\n            if (getData8(game.regionOwners, i) == teamId) {\n                rewardTotal += regionRewards[i];\n                bonusScore++;\n            }\n        }\n\n        return ((rewardTotal * bonusScore) / REWARD_BONUS_MULTIPLIER_DENOM);\n    }\n\n    /// @notice Reward team with soldiers based on what regions they control.\n    /// @param gameId Id of game\n    function giveRegionRewards(uint256 gameId) private {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Team who's turn it is that gets the reward. */\n        uint32 teamId = game.turnTeamId;\n\n        /* Reward total based on what regions player controls. */\n        uint32 rewardAmount = calculateRegionRewards(gameId, teamId);\n\n        /* Add reward to undeployed soldiers count. */\n        uint32 undeployedSoldierCount = getData32(game.undeployedSoldiers, teamId);\n        game.undeployedSoldiers = setData32(\n            game.undeployedSoldiers, \n            teamId, \n            addSafe(undeployedSoldierCount, rewardAmount)\n        );\n    }\n\n    /// @notice Initialize neighbor relationships between all regions\n    /// @dev This data shared by all game instances\n    function initRegionNeighbors() private {\n        regionNeighbors[uint32(Regions.HAWAII)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.HAWAII)][1] = uint32(Regions.FIJI);\n        regionNeighbors[uint32(Regions.HAWAII)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.HAWAII)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.HAWAII)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][1] = uint32(Regions.EASTERN_CANADA);\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][2] = uint32(Regions.EASTERN_RUSSIA);\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][0] = uint32(Regions.WESTERN_CANADA);\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][1] = uint32(Regions.GREENLAND);\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][2] = uint32(Regions.EASTERN_USA);\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WESTERN_USA)][0] = uint32(Regions.HAWAII);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][1] = uint32(Regions.WESTERN_CANADA);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][2] = uint32(Regions.EASTERN_USA);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][3] = uint32(Regions.NORTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_USA)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.EASTERN_USA)][1] = uint32(Regions.EASTERN_CANADA);\n        regionNeighbors[uint32(Regions.EASTERN_USA)][2] = uint32(Regions.NORTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.EASTERN_USA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EASTERN_USA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.GREENLAND)][0] = uint32(Regions.EASTERN_CANADA);\n        regionNeighbors[uint32(Regions.GREENLAND)][1] = uint32(Regions.WESTERN_EUROPE);\n        regionNeighbors[uint32(Regions.GREENLAND)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.GREENLAND)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.GREENLAND)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][1] = uint32(Regions.EASTERN_USA);\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][2] = uint32(Regions.SOUTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][0] = uint32(Regions.NORTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][1] = uint32(Regions.WEST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][0] = uint32(Regions.SOUTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][1] = uint32(Regions.EAST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][0] = uint32(Regions.WEST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][1] = uint32(Regions.NEW_ZEALAND);\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][0] = uint32(Regions.GREENLAND);\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][1] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][2] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][0] = uint32(Regions.WESTERN_EUROPE);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][1] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][2] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][3] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][0] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][1] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][2] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][3] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][4] = uint32(Regions.EASTERN_RUSSIA);\n\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][0] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][1] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][2] = uint32(Regions.WESTERN_CANADA);\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][0] = uint32(Regions.WESTERN_EUROPE);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][1] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][2] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][3] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][4] = uint32(Regions.SOUTH_AFRICA);\n\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][0] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][1] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][2] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][3] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][4] = uint32(Regions.WEST_AFRICA);\n\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][0] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][1] = uint32(Regions.SOUTH_AFRICA);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][2] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][3] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][0] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][1] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.INDIA)][0] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.INDIA)][1] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.INDIA)][2] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.INDIA)][3] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.INDIA)][4] = uint32(Regions.SOUTHEAST_ASIA);\n\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][0] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][1] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][2] = uint32(Regions.EASTERN_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][3] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][0] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][1] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][2] = uint32(Regions.WESTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][3] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][4] = uint32(Regions.FIJI);\n\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][0] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][1] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][0] = uint32(Regions.WESTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][1] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][2] = uint32(Regions.FIJI);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][3] = uint32(Regions.NEW_ZEALAND);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][0] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][1] = uint32(Regions.FIJI);\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][2] = uint32(Regions.EAST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.FIJI)][0] = uint32(Regions.NEW_ZEALAND);\n        regionNeighbors[uint32(Regions.FIJI)][1] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.FIJI)][2] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.FIJI)][3] = uint32(Regions.HAWAII);\n        regionNeighbors[uint32(Regions.FIJI)][4] = NO_REGION;\n    }\n\n    /// @notice Initialize rewards given for controlling each region\n    /// @dev This data shared by all game instances\n    function initRegionRewards() private {\n        regionRewards[uint32(Regions.HAWAII)] = 3;\n        regionRewards[uint32(Regions.WESTERN_CANADA)] = 6;\n        regionRewards[uint32(Regions.EASTERN_CANADA)] = 5;\n        regionRewards[uint32(Regions.WESTERN_USA)] = 11;\n        regionRewards[uint32(Regions.EASTERN_USA)] = 8;\n        regionRewards[uint32(Regions.GREENLAND)] = 3;\n        regionRewards[uint32(Regions.NORTHERN_SOUTH_AMERICA)] = 3;\n        regionRewards[uint32(Regions.SOUTHERN_SOUTH_AMERICA)] = 4;\n        regionRewards[uint32(Regions.WEST_ANTARCTICA)] = 2;\n        regionRewards[uint32(Regions.EAST_ANTARCTICA)] = 2;\n        regionRewards[uint32(Regions.WESTERN_EUROPE)] = 10;\n        regionRewards[uint32(Regions.EASTERN_EUROPE)] = 6;\n        regionRewards[uint32(Regions.CENTRAL_RUSSIA)] = 4;\n        regionRewards[uint32(Regions.EASTERN_RUSSIA)] = 3;\n        regionRewards[uint32(Regions.WEST_AFRICA)] = 3;\n        regionRewards[uint32(Regions.MIDDLE_EAST)] = 4;\n        regionRewards[uint32(Regions.EAST_AFRICA)] = 3;\n        regionRewards[uint32(Regions.SOUTH_AFRICA)] = 5;\n        regionRewards[uint32(Regions.INDIA)] = 7;\n        regionRewards[uint32(Regions.EASTERN_CHINA)] = 10;\n        regionRewards[uint32(Regions.SOUTHEAST_ASIA)] = 5;\n        regionRewards[uint32(Regions.WESTERN_AUSTRALIA)] = 4;\n        regionRewards[uint32(Regions.EASTERN_AUSTRALIA)] = 6;\n        regionRewards[uint32(Regions.NEW_ZEALAND)] = 4;\n        regionRewards[uint32(Regions.FIJI)] = 2;\n    }\n\n    /// @notice Reads data using a uint256 to store an array of 8 uint32s\n    /// @param combinedData A uint256 which contains data for 8 uint32s\n    /// @param index Position in array to read\n    /// @return Value at position index\n    function getData32(uint256 combinedData, uint32 index) internal pure returns(uint32) {\n        uint32 offset = index * 32;\n        return uint32((combinedData >> offset) & MASK_32_BITS);\n    }\n\n    /// @notice Writes data using a uint256 to store an array of 8 uint32s\n    /// @param combinedData A uint256 which contains data for 8 uint32s\n    /// @param index Position in array to write\n    /// @param value Value to write at position index.  Value must fit in a uint32.\n    /// @return Updated combined data\n    function setData32(uint256 combinedData, uint32 index, uint32 value) internal pure returns(uint256) {\n        uint32 offset = index * 32;\n        uint256 zeromask = ~(MASK_32_BITS << offset);\n        return (combinedData & zeromask) | (uint256(value) << offset);\n    }\n\n    /// @notice Reads data using a uint256 to store an array of 32 uint8s\n    /// @param combinedData A uint256 which contains data for 32 uint8s\n    /// @param index Position in array to read\n    /// @return Value at position index\n    function getData8(uint256 combinedData, uint32 index) internal pure returns(uint32) {\n        uint32 offset = index * 8;\n        return uint32((combinedData >> offset) & MASK_8_BITS);\n    }\n\n    /// @notice Writes data using a uint256 to store an array of 32 uint8s\n    /// @param combinedData A uint256 which contains data for 32 uint8s\n    /// @param index Position in array to write\n    /// @param value Value to write at position index.  Value must be less than 256.\n    /// @return Updated combined data\n    function setData8(uint256 combinedData, uint32 index, uint32 value) internal pure returns(uint256) {\n        require(value < 256, \"Only 8 bits allowed for value.\");\n        uint32 offset = index * 8;\n        uint256 zeromask = ~(MASK_8_BITS << offset);\n        return (combinedData & zeromask) | (uint256(value) << offset);\n    }\n\n    /// @notice Safe subtraction that returns 0 on underflow.\n    /// @dev We intentially don't assert so as to not block program execution.\n    /// @param _a Value to subtract from\n    /// @param _b Value to subtract\n    /// @return Result of _a - _b\n    function subSafe(uint32 _a, uint32 _b) internal pure returns (uint32) {\n        if (_b <= _a) {\n            uint32 c = _a - _b;\n            return c;\n        }\n\n        return 0;\n    }\n\n    /// @notice Safe addition that returns MAX_UINT32 on overflow\n    /// @dev We intentially don't assert so as to not block program execution.\n    /// @param _a First value to add\n    /// @param _b Second value to add\n    /// @return Result of _a + _b\n    function addSafe(uint32 _a, uint32 _b) internal pure returns (uint32) {\n        uint32 c = _a + _b;\n        if (c >= _a) {\n            return c;\n        }\n\n        return MAX_UINT32;\n    }\n\n    /// @notice Safe multiplication that returns MAX_UINT32 on overflow\n    /// @dev We intentially don't assert so as to not block program execution.\n    /// @param _a First value to multiply\n    /// @param _b Second value to multiply\n    /// @return Result of _a * _b\n    function mulSafe(uint32 _a, uint32 _b) internal pure returns (uint32) {\n        if (_a == 0) {\n            return 0;\n        }\n\n        uint32 c = _a * _b;\n        if (c / _a == _b) {\n            return c;\n        }\n\n        return MAX_UINT32;\n    }\n}\n",
	"sourcePath": "/Users/justinhamilton/ethereum/worldgame/contracts/WorldGame.sol",
	"ast": {
		"absolutePath": "/Users/justinhamilton/ethereum/worldgame/contracts/WorldGame.sol",
		"exportedSymbols": {
			"WorldGame": [
				4288
			]
		},
		"id": 4289,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 120,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".0"
				],
				"nodeType": "PragmaDirective",
				"src": "0:23:2"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": "@title World game. Battle to control territory and take over the world. ",
				"fullyImplemented": true,
				"id": 4288,
				"linearizedBaseContracts": [
					4288
				],
				"name": "WorldGame",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": true,
						"id": 123,
						"name": "NOT_OWNED",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "188:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 121,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "188:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "323535",
							"id": 122,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "216:3:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_255_by_1",
								"typeString": "int_const 255"
							},
							"value": "255"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 126,
						"name": "NO_REGION",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "267:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 124,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "267:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "323535",
							"id": 125,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "295:3:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_255_by_1",
								"typeString": "int_const 255"
							},
							"value": "255"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 129,
						"name": "REGION_COUNT",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "333:33:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 127,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "333:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3235",
							"id": 128,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "364:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_25_by_1",
								"typeString": "int_const 25"
							},
							"value": "25"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 132,
						"name": "MAX_NEIGHBORS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "423:33:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 130,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "423:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "35",
							"id": 131,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "455:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_5_by_1",
								"typeString": "int_const 5"
							},
							"value": "5"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 135,
						"name": "MAX_PLAYERS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "508:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 133,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "508:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "38",
							"id": 134,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "538:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_8_by_1",
								"typeString": "int_const 8"
							},
							"value": "8"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 138,
						"name": "MAX_ACTIONS_PER_TURN",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "602:40:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 136,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "602:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "38",
							"id": 137,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "641:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_8_by_1",
								"typeString": "int_const 8"
							},
							"value": "8"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 141,
						"name": "DEFENDER_ADVANTAGE_NUM",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "698:42:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 139,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "698:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "35",
							"id": 140,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "739:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_5_by_1",
								"typeString": "int_const 5"
							},
							"value": "5"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 144,
						"name": "DEFENDER_ADVANTAGE_DENOM",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "799:44:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 142,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "799:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "34",
							"id": 143,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "842:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_4_by_1",
								"typeString": "int_const 4"
							},
							"value": "4"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 147,
						"name": "REWARD_BONUS_MULTIPLIER_DENOM",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "897:50:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 145,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "897:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3230",
							"id": 146,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "945:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_20_by_1",
								"typeString": "int_const 20"
							},
							"value": "20"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 150,
						"name": "MAX_BLOCKS_THRESHOLD",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "999:41:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 148,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "999:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3230",
							"id": 149,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1038:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_20_by_1",
								"typeString": "int_const 20"
							},
							"value": "20"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 153,
						"name": "MASK_32_BITS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1095:42:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 151,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1095:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30786666666666666666",
							"id": 152,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1127:10:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_4294967295_by_1",
								"typeString": "int_const 4294967295"
							},
							"value": "0xffffffff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 156,
						"name": "MASK_8_BITS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1191:35:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 154,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1191:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30786666",
							"id": 155,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1222:4:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_255_by_1",
								"typeString": "int_const 255"
							},
							"value": "0xff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 159,
						"name": "MAX_UINT32",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1260:39:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 157,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "1260:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30786666666666666666",
							"id": 158,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1289:10:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_4294967295_by_1",
								"typeString": "int_const 4294967295"
							},
							"value": "0xffffffff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 162,
						"name": "ALL_REGIONS_NOT_OWNED",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1368:107:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 160,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1368:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "307866666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666",
							"id": 161,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1409:66:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_115792089237316195423570985008687907853269984665640564039457584007913129639935_by_1",
								"typeString": "int_const 1157...(70 digits omitted)...9935"
							},
							"value": "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 165,
						"name": "BEGIN_SOLDIERS_COUNTS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1578:107:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 163,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1578:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "307830303030303031343030303030303134303030303030313430303030303031343030303030303134303030303030313430303030303031343030303030303134",
							"id": 164,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1619:66:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_539198933468554830630303949770532107640973245947105932686537879715860_by_1",
								"typeString": "int_const 5391...(61 digits omitted)...5860"
							},
							"value": "0x0000001400000014000000140000001400000014000000140000001400000014"
						},
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 167,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1747:21:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 166,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "1747:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "private"
					},
					{
						"constant": false,
						"id": 169,
						"name": "stopped",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1820:20:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 168,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "1820:4:2",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "private"
					},
					{
						"constant": false,
						"id": 173,
						"name": "blockHash32Map",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1891:48:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
							"typeString": "mapping(uint32 => uint32)"
						},
						"typeName": {
							"id": 172,
							"keyType": {
								"id": 170,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "1900:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"nodeType": "Mapping",
							"src": "1891:26:2",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
								"typeString": "mapping(uint32 => uint32)"
							},
							"valueType": {
								"id": 171,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "1910:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 179,
						"name": "regionNeighbors",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "2055:58:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
							"typeString": "uint32[5][25]"
						},
						"typeName": {
							"baseType": {
								"baseType": {
									"id": 174,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "2055:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"id": 176,
								"length": {
									"argumentTypes": null,
									"id": 175,
									"name": "MAX_NEIGHBORS",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 132,
									"src": "2062:13:2",
									"typeDescriptions": {
										"typeIdentifier": null,
										"typeString": null
									}
								},
								"nodeType": "ArrayTypeName",
								"src": "2055:21:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_uint32_$5_storage_ptr",
									"typeString": "uint32[5]"
								}
							},
							"id": 178,
							"length": {
								"argumentTypes": null,
								"id": 177,
								"name": "REGION_COUNT",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 129,
								"src": "2077:12:2",
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								}
							},
							"nodeType": "ArrayTypeName",
							"src": "2055:35:2",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage_ptr",
								"typeString": "uint32[5][25]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 183,
						"name": "regionRewards",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "2201:41:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_uint32_$25_storage",
							"typeString": "uint32[25]"
						},
						"typeName": {
							"baseType": {
								"id": 180,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "2201:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"id": 182,
							"length": {
								"argumentTypes": null,
								"id": 181,
								"name": "REGION_COUNT",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 129,
								"src": "2208:12:2",
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								}
							},
							"nodeType": "ArrayTypeName",
							"src": "2201:20:2",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
								"typeString": "uint32[25]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 186,
						"name": "gameDataArray",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "2332:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
							"typeString": "struct WorldGame.GameData[]"
						},
						"typeName": {
							"baseType": {
								"contractScope": null,
								"id": 184,
								"name": "GameData",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 245,
								"src": "2332:8:2",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
									"typeString": "struct WorldGame.GameData"
								}
							},
							"id": 185,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "2332:10:2",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage_ptr",
								"typeString": "struct WorldGame.GameData[]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"canonicalName": "WorldGame.Regions",
						"id": 212,
						"members": [
							{
								"id": 187,
								"name": "HAWAII",
								"nodeType": "EnumValue",
								"src": "2441:6:2"
							},
							{
								"id": 188,
								"name": "WESTERN_CANADA",
								"nodeType": "EnumValue",
								"src": "2457:14:2"
							},
							{
								"id": 189,
								"name": "EASTERN_CANADA",
								"nodeType": "EnumValue",
								"src": "2481:14:2"
							},
							{
								"id": 190,
								"name": "WESTERN_USA",
								"nodeType": "EnumValue",
								"src": "2505:11:2"
							},
							{
								"id": 191,
								"name": "EASTERN_USA",
								"nodeType": "EnumValue",
								"src": "2526:11:2"
							},
							{
								"id": 192,
								"name": "GREENLAND",
								"nodeType": "EnumValue",
								"src": "2547:9:2"
							},
							{
								"id": 193,
								"name": "NORTHERN_SOUTH_AMERICA",
								"nodeType": "EnumValue",
								"src": "2566:22:2"
							},
							{
								"id": 194,
								"name": "SOUTHERN_SOUTH_AMERICA",
								"nodeType": "EnumValue",
								"src": "2598:22:2"
							},
							{
								"id": 195,
								"name": "WEST_ANTARCTICA",
								"nodeType": "EnumValue",
								"src": "2630:15:2"
							},
							{
								"id": 196,
								"name": "EAST_ANTARCTICA",
								"nodeType": "EnumValue",
								"src": "2655:15:2"
							},
							{
								"id": 197,
								"name": "WESTERN_EUROPE",
								"nodeType": "EnumValue",
								"src": "2680:14:2"
							},
							{
								"id": 198,
								"name": "EASTERN_EUROPE",
								"nodeType": "EnumValue",
								"src": "2704:14:2"
							},
							{
								"id": 199,
								"name": "CENTRAL_RUSSIA",
								"nodeType": "EnumValue",
								"src": "2728:14:2"
							},
							{
								"id": 200,
								"name": "EASTERN_RUSSIA",
								"nodeType": "EnumValue",
								"src": "2752:14:2"
							},
							{
								"id": 201,
								"name": "WEST_AFRICA",
								"nodeType": "EnumValue",
								"src": "2776:11:2"
							},
							{
								"id": 202,
								"name": "MIDDLE_EAST",
								"nodeType": "EnumValue",
								"src": "2797:11:2"
							},
							{
								"id": 203,
								"name": "EAST_AFRICA",
								"nodeType": "EnumValue",
								"src": "2818:11:2"
							},
							{
								"id": 204,
								"name": "SOUTH_AFRICA",
								"nodeType": "EnumValue",
								"src": "2839:12:2"
							},
							{
								"id": 205,
								"name": "INDIA",
								"nodeType": "EnumValue",
								"src": "2861:5:2"
							},
							{
								"id": 206,
								"name": "EASTERN_CHINA",
								"nodeType": "EnumValue",
								"src": "2876:13:2"
							},
							{
								"id": 207,
								"name": "SOUTHEAST_ASIA",
								"nodeType": "EnumValue",
								"src": "2899:14:2"
							},
							{
								"id": 208,
								"name": "WESTERN_AUSTRALIA",
								"nodeType": "EnumValue",
								"src": "2923:17:2"
							},
							{
								"id": 209,
								"name": "EASTERN_AUSTRALIA",
								"nodeType": "EnumValue",
								"src": "2950:17:2"
							},
							{
								"id": 210,
								"name": "NEW_ZEALAND",
								"nodeType": "EnumValue",
								"src": "2977:11:2"
							},
							{
								"id": 211,
								"name": "FIJI",
								"nodeType": "EnumValue",
								"src": "2998:4:2"
							}
						],
						"name": "Regions",
						"nodeType": "EnumDefinition",
						"src": "2418:590:2"
					},
					{
						"canonicalName": "WorldGame.GameData",
						"id": 245,
						"members": [
							{
								"constant": false,
								"id": 214,
								"name": "turnTeamId",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3124:17:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 213,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3124:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 216,
								"name": "turnNum",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3201:14:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 215,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3201:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 218,
								"name": "maxBlocksPerTurn",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3276:23:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 217,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3276:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 220,
								"name": "playerCount",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3356:18:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 219,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3356:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 224,
								"name": "playerAddresses",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3423:36:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
									"typeString": "address[8]"
								},
								"typeName": {
									"baseType": {
										"id": 221,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3423:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 223,
									"length": {
										"argumentTypes": null,
										"id": 222,
										"name": "MAX_PLAYERS",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 135,
										"src": "3431:11:2",
										"typeDescriptions": {
											"typeIdentifier": null,
											"typeString": null
										}
									},
									"nodeType": "ArrayTypeName",
									"src": "3423:20:2",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
										"typeString": "address[8]"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 226,
								"name": "undeployedSoldiers",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3552:26:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 225,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "3552:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 228,
								"name": "regionOwners",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3638:20:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 227,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "3638:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 232,
								"name": "regionSoldiers",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3727:35:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
									"typeString": "uint32[25]"
								},
								"typeName": {
									"baseType": {
										"id": 229,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3727:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 231,
									"length": {
										"argumentTypes": null,
										"id": 230,
										"name": "REGION_COUNT",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 129,
										"src": "3734:12:2",
										"typeDescriptions": {
											"typeIdentifier": null,
											"typeString": null
										}
									},
									"nodeType": "ArrayTypeName",
									"src": "3727:20:2",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
										"typeString": "uint32[25]"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 234,
								"name": "actionCount",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3822:18:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 233,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3822:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 236,
								"name": "fromRegionList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3923:22:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 235,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "3923:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 238,
								"name": "toRegionList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4027:20:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 237,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "4027:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 240,
								"name": "moveSoldierCountList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4121:28:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 239,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "4121:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 242,
								"name": "submitBlockList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4235:23:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 241,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "4235:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 244,
								"name": "teamAvatars",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4313:18:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes8",
									"typeString": "bytes8"
								},
								"typeName": {
									"id": 243,
									"name": "bytes8",
									"nodeType": "ElementaryTypeName",
									"src": "4313:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "GameData",
						"nodeType": "StructDefinition",
						"scope": 4288,
						"src": "3053:1285:2",
						"visibility": "public"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 253,
						"name": "NewGame",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 252,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 247,
									"indexed": false,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 253,
									"src": "4418:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 246,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4418:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 249,
									"indexed": false,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 253,
									"src": "4434:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 248,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4434:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 251,
									"indexed": false,
									"name": "teamAvatars",
									"nodeType": "VariableDeclaration",
									"scope": 253,
									"src": "4450:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 250,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "4450:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4417:52:2"
						},
						"src": "4404:66:2"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 261,
						"name": "NextTurn",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 260,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 255,
									"indexed": false,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 261,
									"src": "4541:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 254,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4541:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 257,
									"indexed": false,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 261,
									"src": "4557:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 256,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4557:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 259,
									"indexed": false,
									"name": "nextTeamId",
									"nodeType": "VariableDeclaration",
									"scope": 261,
									"src": "4573:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 258,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4573:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4540:51:2"
						},
						"src": "4526:66:2"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 267,
						"name": "Winner",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 266,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 263,
									"indexed": false,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 267,
									"src": "4656:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 262,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4656:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 265,
									"indexed": false,
									"name": "winningTeamId",
									"nodeType": "VariableDeclaration",
									"scope": 267,
									"src": "4672:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 264,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4672:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4655:38:2"
						},
						"src": "4643:51:2"
					},
					{
						"body": {
							"id": 300,
							"nodeType": "Block",
							"src": "4837:377:2",
							"statements": [
								{
									"assignments": [
										274
									],
									"declarations": [
										{
											"constant": false,
											"id": 274,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 301,
											"src": "4847:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 273,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "4847:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 278,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 275,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "4871:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 277,
										"indexExpression": {
											"argumentTypes": null,
											"id": 276,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 269,
											"src": "4885:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "4871:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "4847:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 287,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 280,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4372,
														"src": "4973:3:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 281,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "4973:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 282,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 274,
															"src": "4987:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 283,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "playerAddresses",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 224,
														"src": "4987:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_address_$8_storage",
															"typeString": "address[8] storage ref"
														}
													},
													"id": 286,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 284,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 274,
															"src": "5008:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 285,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnTeamId",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 214,
														"src": "5008:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4987:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4973:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
												"id": 288,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "5039:24:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												},
												"value": "Sender not authorized."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												}
											],
											"id": 279,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "4952:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 289,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4952:121:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 290,
									"nodeType": "ExpressionStatement",
									"src": "4952:121:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 295,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 292,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 274,
														"src": "5149:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 293,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "5149:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 294,
													"name": "turnNum",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 271,
													"src": "5165:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "5149:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "57726f6e67207475726e206e756d6265722e",
												"id": 296,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "5174:20:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												},
												"value": "Wrong turn number."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												}
											],
											"id": 291,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "5141:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 297,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5141:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 298,
									"nodeType": "ExpressionStatement",
									"src": "5141:54:2"
								},
								{
									"id": 299,
									"nodeType": "PlaceholderStatement",
									"src": "5206:1:2"
								}
							]
						},
						"documentation": null,
						"id": 301,
						"name": "onlyIfPlayersTurn",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 272,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 269,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 301,
									"src": "4805:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 268,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4805:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 271,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 301,
									"src": "4821:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 270,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4821:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4804:32:2"
						},
						"src": "4778:436:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 379,
							"nodeType": "Block",
							"src": "5324:623:2",
							"statements": [
								{
									"assignments": [
										306
									],
									"declarations": [
										{
											"constant": false,
											"id": 306,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 380,
											"src": "5334:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 305,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "5334:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 310,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 307,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "5358:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 309,
										"indexExpression": {
											"argumentTypes": null,
											"id": 308,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 303,
											"src": "5372:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "5358:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "5334:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 374,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 366,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 358,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 350,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 342,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 334,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"id": 326,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 318,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 312,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "5464:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 313,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "5464:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 314,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 306,
																						"src": "5478:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 315,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "5478:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 317,
																				"indexExpression": {
																					"argumentTypes": null,
																					"hexValue": "30",
																					"id": 316,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "5499:1:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_0_by_1",
																						"typeString": "int_const 0"
																					},
																					"value": "0"
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "5478:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "5464:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "||",
																		"rightExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 325,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 319,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "5518:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 320,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "5518:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 321,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 306,
																						"src": "5532:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 322,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "5532:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 324,
																				"indexExpression": {
																					"argumentTypes": null,
																					"hexValue": "31",
																					"id": 323,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "5553:1:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_1_by_1",
																						"typeString": "int_const 1"
																					},
																					"value": "1"
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "5532:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "5518:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"src": "5464:91:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "||",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		},
																		"id": 333,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 327,
																				"name": "msg",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4372,
																				"src": "5572:3:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_magic_message",
																					"typeString": "msg"
																				}
																			},
																			"id": 328,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "sender",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": null,
																			"src": "5572:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 329,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 306,
																					"src": "5586:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 330,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "playerAddresses",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 224,
																				"src": "5586:20:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_address_$8_storage",
																					"typeString": "address[8] storage ref"
																				}
																			},
																			"id": 332,
																			"indexExpression": {
																				"argumentTypes": null,
																				"hexValue": "32",
																				"id": 331,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "5607:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_2_by_1",
																					"typeString": "int_const 2"
																				},
																				"value": "2"
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "5586:23:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"src": "5572:37:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "5464:145:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"id": 341,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 335,
																			"name": "msg",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4372,
																			"src": "5626:3:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_message",
																				"typeString": "msg"
																			}
																		},
																		"id": 336,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "sender",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "5626:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 337,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 306,
																				"src": "5640:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 338,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "playerAddresses",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 224,
																			"src": "5640:20:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_address_$8_storage",
																				"typeString": "address[8] storage ref"
																			}
																		},
																		"id": 340,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "33",
																			"id": 339,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "5661:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_3_by_1",
																				"typeString": "int_const 3"
																			},
																			"value": "3"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "5640:23:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"src": "5626:37:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "5464:199:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																"id": 349,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 343,
																		"name": "msg",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4372,
																		"src": "5680:3:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_message",
																			"typeString": "msg"
																		}
																	},
																	"id": 344,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "sender",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "5680:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 345,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 306,
																			"src": "5694:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 346,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "playerAddresses",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 224,
																		"src": "5694:20:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_address_$8_storage",
																			"typeString": "address[8] storage ref"
																		}
																	},
																	"id": 348,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "34",
																		"id": 347,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "5715:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_4_by_1",
																			"typeString": "int_const 4"
																		},
																		"value": "4"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "5694:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"src": "5680:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "5464:253:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"id": 357,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 351,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4372,
																	"src": "5734:3:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 352,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "sender",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "5734:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 353,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 306,
																		"src": "5748:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 354,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "playerAddresses",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 224,
																	"src": "5748:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_address_$8_storage",
																		"typeString": "address[8] storage ref"
																	}
																},
																"id": 356,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "35",
																	"id": 355,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "5769:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_5_by_1",
																		"typeString": "int_const 5"
																	},
																	"value": "5"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "5748:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"src": "5734:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "5464:307:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														},
														"id": 365,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 359,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4372,
																"src": "5788:3:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 360,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "5788:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 361,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 306,
																	"src": "5802:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 362,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "playerAddresses",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 224,
																"src": "5802:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_address_$8_storage",
																	"typeString": "address[8] storage ref"
																}
															},
															"id": 364,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "36",
																"id": 363,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "5823:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_6_by_1",
																	"typeString": "int_const 6"
																},
																"value": "6"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "5802:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"src": "5788:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "5464:361:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 373,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 367,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4372,
															"src": "5842:3:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 368,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "5842:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 369,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 306,
																"src": "5856:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 370,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "playerAddresses",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 224,
															"src": "5856:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_address_$8_storage",
																"typeString": "address[8] storage ref"
															}
														},
														"id": 372,
														"indexExpression": {
															"argumentTypes": null,
															"hexValue": "37",
															"id": 371,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "5877:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_7_by_1",
																"typeString": "int_const 7"
															},
															"value": "7"
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "5856:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "5842:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "5464:415:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
												"id": 375,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "5894:24:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												},
												"value": "Sender not authorized."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												}
											],
											"id": 311,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "5443:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 376,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5443:485:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 377,
									"nodeType": "ExpressionStatement",
									"src": "5443:485:2"
								},
								{
									"id": 378,
									"nodeType": "PlaceholderStatement",
									"src": "5939:1:2"
								}
							]
						},
						"documentation": null,
						"id": 380,
						"name": "onlyPlayers",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 304,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 303,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 380,
									"src": "5308:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 302,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "5308:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5307:16:2"
						},
						"src": "5287:660:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 441,
							"nodeType": "Block",
							"src": "6098:610:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 393,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 389,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 387,
														"name": "regionFrom",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 382,
														"src": "6153:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 388,
														"name": "REGION_COUNT",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 129,
														"src": "6166:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "6153:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 392,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 390,
														"name": "regionTo",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 384,
														"src": "6182:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 391,
														"name": "REGION_COUNT",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 129,
														"src": "6193:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "6182:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "6153:52:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d7573742062652076616c696420726567696f6e73",
												"id": 394,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "6207:23:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
													"typeString": "literal_string \"Must be valid regions\""
												},
												"value": "Must be valid regions"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
													"typeString": "literal_string \"Must be valid regions\""
												}
											],
											"id": 386,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6145:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 395,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6145:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 396,
									"nodeType": "ExpressionStatement",
									"src": "6145:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 436,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 428,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 420,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 412,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 404,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 398,
																			"name": "regionNeighbors",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 179,
																			"src": "6330:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																				"typeString": "uint32[5] storage ref[25] storage ref"
																			}
																		},
																		"id": 400,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 399,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 382,
																			"src": "6346:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6330:27:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$5_storage",
																			"typeString": "uint32[5] storage ref"
																		}
																	},
																	"id": 402,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 401,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "6358:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6330:30:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 403,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 384,
																	"src": "6364:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "6330:42:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 411,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 405,
																			"name": "regionNeighbors",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 179,
																			"src": "6389:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																				"typeString": "uint32[5] storage ref[25] storage ref"
																			}
																		},
																		"id": 407,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 406,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 382,
																			"src": "6405:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6389:27:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$5_storage",
																			"typeString": "uint32[5] storage ref"
																		}
																	},
																	"id": 409,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 408,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "6417:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6389:30:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 410,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 384,
																	"src": "6423:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "6389:42:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "6330:101:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 419,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 413,
																		"name": "regionNeighbors",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 179,
																		"src": "6448:15:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																			"typeString": "uint32[5] storage ref[25] storage ref"
																		}
																	},
																	"id": 415,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 414,
																		"name": "regionFrom",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 382,
																		"src": "6464:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6448:27:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$5_storage",
																		"typeString": "uint32[5] storage ref"
																	}
																},
																"id": 417,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "32",
																	"id": 416,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "6476:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_2_by_1",
																		"typeString": "int_const 2"
																	},
																	"value": "2"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6448:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 418,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 384,
																"src": "6482:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "6448:42:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "6330:160:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 427,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 421,
																	"name": "regionNeighbors",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 179,
																	"src": "6507:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																		"typeString": "uint32[5] storage ref[25] storage ref"
																	}
																},
																"id": 423,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 422,
																	"name": "regionFrom",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 382,
																	"src": "6523:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6507:27:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$5_storage",
																	"typeString": "uint32[5] storage ref"
																}
															},
															"id": 425,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "33",
																"id": 424,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "6535:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_3_by_1",
																	"typeString": "int_const 3"
																},
																"value": "3"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "6507:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 426,
															"name": "regionTo",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 384,
															"src": "6541:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6507:42:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "6330:219:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 435,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 429,
																"name": "regionNeighbors",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 179,
																"src": "6566:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																	"typeString": "uint32[5] storage ref[25] storage ref"
																}
															},
															"id": 431,
															"indexExpression": {
																"argumentTypes": null,
																"id": 430,
																"name": "regionFrom",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 382,
																"src": "6582:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "6566:27:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$5_storage",
																"typeString": "uint32[5] storage ref"
															}
														},
														"id": 433,
														"indexExpression": {
															"argumentTypes": null,
															"hexValue": "34",
															"id": 432,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "6594:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_4_by_1",
																"typeString": "int_const 4"
															},
															"value": "4"
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6566:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 434,
														"name": "regionTo",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 384,
														"src": "6600:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "6566:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "6330:278:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "526567696f6e73206d757374206265206e65696768626f727320696e206f7264657220746f206d6f7665206265747765656e207468656d",
												"id": 437,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "6622:57:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
													"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
												},
												"value": "Regions must be neighbors in order to move between them"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
													"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
												}
											],
											"id": 397,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6309:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 438,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6309:380:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 439,
									"nodeType": "ExpressionStatement",
									"src": "6309:380:2"
								},
								{
									"id": 440,
									"nodeType": "PlaceholderStatement",
									"src": "6700:1:2"
								}
							]
						},
						"documentation": null,
						"id": 442,
						"name": "onlyNeighbors",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 385,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 382,
									"name": "regionFrom",
									"nodeType": "VariableDeclaration",
									"scope": 442,
									"src": "6062:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 381,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "6062:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 384,
									"name": "regionTo",
									"nodeType": "VariableDeclaration",
									"scope": 442,
									"src": "6081:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 383,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "6081:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6061:36:2"
						},
						"src": "6039:669:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 453,
							"nodeType": "Block",
							"src": "6793:95:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 448,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 445,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4372,
														"src": "6811:3:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 446,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "6811:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 447,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 167,
													"src": "6825:5:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "6811:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f6e6c79206f776e65722063616e2063616c6c20746869732066756e6374696f6e2e",
												"id": 449,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "6832:36:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
													"typeString": "literal_string \"Only owner can call this function.\""
												},
												"value": "Only owner can call this function."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
													"typeString": "literal_string \"Only owner can call this function.\""
												}
											],
											"id": 444,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6803:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 450,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6803:66:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 451,
									"nodeType": "ExpressionStatement",
									"src": "6803:66:2"
								},
								{
									"id": 452,
									"nodeType": "PlaceholderStatement",
									"src": "6880:1:2"
								}
							]
						},
						"documentation": null,
						"id": 454,
						"name": "isOwner",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 443,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "6790:2:2"
						},
						"src": "6774:114:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 464,
							"nodeType": "Block",
							"src": "6982:83:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 459,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 457,
													"name": "stopped",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 169,
													"src": "7000:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 458,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7011:5:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "7000:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53746f707065642064756520746f20656d657267656e63792e",
												"id": 460,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "7018:27:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
													"typeString": "literal_string \"Stopped due to emergency.\""
												},
												"value": "Stopped due to emergency."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
													"typeString": "literal_string \"Stopped due to emergency.\""
												}
											],
											"id": 456,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6992:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 461,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6992:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 462,
									"nodeType": "ExpressionStatement",
									"src": "6992:54:2"
								},
								{
									"id": 463,
									"nodeType": "PlaceholderStatement",
									"src": "7057:1:2"
								}
							]
						},
						"documentation": null,
						"id": 465,
						"name": "stopInEmergency",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 455,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "6979:2:2"
						},
						"src": "6955:110:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 479,
							"nodeType": "Block",
							"src": "7153:95:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 471,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 468,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 167,
											"src": "7163:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 469,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4372,
												"src": "7171:3:2",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 470,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "7171:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "7163:18:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 472,
									"nodeType": "ExpressionStatement",
									"src": "7163:18:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 473,
											"name": "initRegionNeighbors",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 3841,
											"src": "7191:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
												"typeString": "function ()"
											}
										},
										"id": 474,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7191:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 475,
									"nodeType": "ExpressionStatement",
									"src": "7191:21:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 476,
											"name": "initRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4070,
											"src": "7222:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
												"typeString": "function ()"
											}
										},
										"id": 477,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7222:19:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 478,
									"nodeType": "ExpressionStatement",
									"src": "7222:19:2"
								}
							]
						},
						"documentation": null,
						"id": 480,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 466,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7143:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 467,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7153:0:2"
						},
						"scope": 4288,
						"src": "7132:116:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 487,
							"nodeType": "Block",
							"src": "7359:57:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "496e76616c69642063616c6c20746f2067616d6520636f6e74726163742e",
												"id": 484,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "7376:32:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
													"typeString": "literal_string \"Invalid call to game contract.\""
												},
												"value": "Invalid call to game contract."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
													"typeString": "literal_string \"Invalid call to game contract.\""
												}
											],
											"id": 483,
											"name": "revert",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4377,
												4378
											],
											"referencedDeclaration": 4378,
											"src": "7369:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (string memory) pure"
											}
										},
										"id": 485,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7369:40:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 486,
									"nodeType": "ExpressionStatement",
									"src": "7369:40:2"
								}
							]
						},
						"documentation": null,
						"id": 488,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 481,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7341:2:2"
						},
						"payable": true,
						"returnParameters": {
							"id": 482,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7359:0:2"
						},
						"scope": 4288,
						"src": "7333:83:2",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 499,
							"nodeType": "Block",
							"src": "7568:31:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 497,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 495,
											"name": "stopped",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 169,
											"src": "7578:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 496,
											"name": "stop",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 490,
											"src": "7588:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "7578:14:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 498,
									"nodeType": "ExpressionStatement",
									"src": "7578:14:2"
								}
							]
						},
						"documentation": null,
						"id": 500,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [],
								"id": 493,
								"modifierName": {
									"argumentTypes": null,
									"id": 492,
									"name": "isOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 454,
									"src": "7554:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "7554:9:2"
							}
						],
						"name": "stopNewGames",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 491,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 490,
									"name": "stop",
									"nodeType": "VariableDeclaration",
									"scope": 500,
									"src": "7519:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 489,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "7519:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7518:11:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 494,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7568:0:2"
						},
						"scope": 4288,
						"src": "7497:102:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 649,
							"nodeType": "Block",
							"src": "8077:1839:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 520,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 518,
													"name": "maxBlocksPerTurn",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 504,
													"src": "8160:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 519,
													"name": "MAX_BLOCKS_THRESHOLD",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 150,
													"src": "8180:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "8160:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "5573657273206d75737420626520676976656e20656e6f7567682074696d6520746f20636f6d706c657465207468656972207475726e2e",
												"id": 521,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "8202:57:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
													"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
												},
												"value": "Users must be given enough time to complete their turn."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
													"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
												}
											],
											"id": 517,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "8152:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 522,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8152:108:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 523,
									"nodeType": "ExpressionStatement",
									"src": "8152:108:2"
								},
								{
									"assignments": [
										525
									],
									"declarations": [
										{
											"constant": false,
											"id": 525,
											"name": "gameId",
											"nodeType": "VariableDeclaration",
											"scope": 650,
											"src": "8426:14:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 524,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "8426:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 637,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 636,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 530,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "8527:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 529,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "8520:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 531,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "8520:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 533,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4362,
																		"src": "8584:5:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 534,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "number",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "8584:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																],
																"id": 532,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "8577:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 535,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "8577:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 536,
															"name": "maxBlocksPerTurn",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 504,
															"src": "8654:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 537,
															"name": "playerCount",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 502,
															"src": "8721:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 538,
															"name": "playerAddresses",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 508,
															"src": "8801:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																"typeString": "address[8] memory"
															}
														},
														{
															"argumentTypes": null,
															"id": 539,
															"name": "BEGIN_SOLDIERS_COUNTS",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 165,
															"src": "8876:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 540,
															"name": "ALL_REGIONS_NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 162,
															"src": "8951:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 542,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9066:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 541,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9059:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 543,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9059:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 545,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9077:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 544,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9070:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 546,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9070:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 548,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9088:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 547,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9081:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 549,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9081:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 551,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9099:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 550,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9092:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 552,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9092:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 554,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9110:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 553,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9103:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 555,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9103:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 557,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9121:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 556,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9114:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 558,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9114:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 560,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9149:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 559,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9142:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 561,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9142:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 563,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9160:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 562,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9153:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 564,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9153:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 566,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9171:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 565,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9164:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 567,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9164:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 569,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9182:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 568,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9175:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 570,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9175:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 572,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9193:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 571,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9186:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 573,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9186:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 575,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9204:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 574,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9197:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 576,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9197:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 578,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9232:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 577,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9225:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 579,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9225:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 581,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9243:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 580,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9236:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 582,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9236:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 584,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9254:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 583,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9247:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 585,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9247:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 587,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9265:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 586,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9258:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 588,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9258:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 590,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9276:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 589,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9269:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 591,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9269:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 593,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9287:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 592,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9280:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 594,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9280:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 596,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9315:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 595,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9308:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 597,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9308:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 599,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9326:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 598,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9319:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 600,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9319:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 602,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9337:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 601,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9330:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 603,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9330:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 605,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9348:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 604,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9341:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 606,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9341:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 608,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9359:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 607,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9352:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 609,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9352:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 611,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9370:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 610,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9363:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 612,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9363:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 614,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9398:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 613,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9391:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 615,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9391:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 616,
															"isConstant": false,
															"isInlineArray": true,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "9041:373:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																"typeString": "uint32[25] memory"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 618,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9473:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 617,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9466:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 619,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9466:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 621,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9538:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 620,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9530:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 622,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9530:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 624,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9602:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 623,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9594:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 625,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9594:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 627,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9674:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 626,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9666:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 628,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9666:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 630,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9741:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 629,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9733:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 631,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9733:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 632,
															"name": "teamAvatars",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 510,
															"src": "9794:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes8",
																"typeString": "bytes8"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																"typeString": "address[8] memory"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																"typeString": "uint32[25] memory"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_bytes8",
																"typeString": "bytes8"
															}
														],
														"id": 528,
														"name": "GameData",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 245,
														"src": "8462:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_struct$_GameData_$245_storage_ptr_$",
															"typeString": "type(struct WorldGame.GameData storage pointer)"
														}
													},
													"id": 633,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "structConstructorCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "8462:1353:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_memory",
														"typeString": "struct WorldGame.GameData memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_struct$_GameData_$245_memory",
														"typeString": "struct WorldGame.GameData memory"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 526,
													"name": "gameDataArray",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 186,
													"src": "8443:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
														"typeString": "struct WorldGame.GameData storage ref[] storage ref"
													}
												},
												"id": 527,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "push",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "8443:18:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_arraypush_nonpayable$_t_struct$_GameData_$245_storage_$returns$_t_uint256_$",
													"typeString": "function (struct WorldGame.GameData storage ref) returns (uint256)"
												}
											},
											"id": 634,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "8443:1373:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "-",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 635,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "9819:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "8443:1377:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "8426:1394:2"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 639,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 525,
												"src": "9844:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 641,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "9859:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 642,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "9859:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 640,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "9852:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 643,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "9852:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 644,
												"name": "teamAvatars",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 510,
												"src": "9874:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes8",
													"typeString": "bytes8"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												{
													"typeIdentifier": "t_bytes8",
													"typeString": "bytes8"
												}
											],
											"id": 638,
											"name": "NewGame",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 253,
											"src": "9836:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_bytes8_$returns$__$",
												"typeString": "function (uint256,uint32,bytes8)"
											}
										},
										"id": 645,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9836:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 646,
									"nodeType": "EmitStatement",
									"src": "9831:55:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 647,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 525,
										"src": "9903:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 516,
									"id": 648,
									"nodeType": "Return",
									"src": "9896:13:2"
								}
							]
						},
						"documentation": "@notice Create a new game instance\n @param playerCount number of players\n @param playerAddresses address of each player\n @param teamAvatars avatar to use for each player\n @return Id of the game instance",
						"id": 650,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [],
								"id": 513,
								"modifierName": {
									"argumentTypes": null,
									"id": 512,
									"name": "stopInEmergency",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 465,
									"src": "8028:15:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "8028:17:2"
							}
						],
						"name": "newGame",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 511,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 502,
									"name": "playerCount",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7870:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 501,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "7870:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 504,
									"name": "maxBlocksPerTurn",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7899:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 503,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "7899:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 508,
									"name": "playerAddresses",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7933:36:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
										"typeString": "address[8]"
									},
									"typeName": {
										"baseType": {
											"id": 505,
											"name": "address",
											"nodeType": "ElementaryTypeName",
											"src": "7933:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 507,
										"length": {
											"argumentTypes": null,
											"id": 506,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "7941:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "7933:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
											"typeString": "address[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 510,
									"name": "teamAvatars",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7980:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 509,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "7980:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7860:144:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 516,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 515,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "8063:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 514,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "8063:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8062:9:2"
						},
						"scope": 4288,
						"src": "7844:2072:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 799,
							"nodeType": "Block",
							"src": "10563:1345:2",
							"statements": [
								{
									"assignments": [
										672
									],
									"declarations": [
										{
											"constant": false,
											"id": 672,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 800,
											"src": "10573:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 671,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "10573:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 676,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 673,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "10597:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 675,
										"indexExpression": {
											"argumentTypes": null,
											"id": 674,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 652,
											"src": "10611:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "10597:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10573:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 678,
											"name": "i",
											"nodeType": "VariableDeclaration",
											"scope": 800,
											"src": "10628:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 677,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "10628:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 679,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "10628:8:2"
								},
								{
									"body": {
										"id": 702,
										"nodeType": "Block",
										"src": "10733:231:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 698,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 692,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 658,
																"src": "10842:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "!=",
															"rightExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 694,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 672,
																			"src": "10864:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 695,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "toRegionList",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 238,
																		"src": "10864:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 696,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 678,
																		"src": "10883:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 693,
																	"name": "getData32",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4095,
																	"src": "10854:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 697,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "10854:31:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "10842:43:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														{
															"argumentTypes": null,
															"hexValue": "526567696f6e20616c7265616479206861732071756575656420616374696f6e2e",
															"id": 699,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "string",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "10904:35:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																"typeString": "literal_string \"Region already has queued action.\""
															},
															"value": "Region already has queued action."
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															{
																"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																"typeString": "literal_string \"Region already has queued action.\""
															}
														],
														"id": 691,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															4375,
															4376
														],
														"referencedDeclaration": 4376,
														"src": "10817:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
															"typeString": "function (bool,string memory) pure"
														}
													},
													"id": 700,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "10817:136:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 701,
												"nodeType": "ExpressionStatement",
												"src": "10817:136:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 687,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 684,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 678,
											"src": "10706:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 685,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "10710:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 686,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "10710:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "10706:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 703,
									"initializationExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 682,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 680,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "10699:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 681,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "10703:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "10699:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 683,
										"nodeType": "ExpressionStatement",
										"src": "10699:5:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 689,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "10728:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 688,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "10728:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 690,
										"nodeType": "ExpressionStatement",
										"src": "10728:3:2"
									},
									"nodeType": "ForStatement",
									"src": "10694:270:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 708,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 705,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "10981:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 706,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "actionCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 234,
													"src": "10981:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "<",
												"rightExpression": {
													"argumentTypes": null,
													"id": 707,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "11000:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "10981:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f6e6c79203820616374696f6e732061726520616c6c6f77656420706572207475726e",
												"id": 709,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11022:37:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
													"typeString": "literal_string \"Only 8 actions are allowed per turn\""
												},
												"value": "Only 8 actions are allowed per turn"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
													"typeString": "literal_string \"Only 8 actions are allowed per turn\""
												}
											],
											"id": 704,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "10973:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 710,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10973:87:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 711,
									"nodeType": "ExpressionStatement",
									"src": "10973:87:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 718,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 713,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11078:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 714,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "regionSoldiers",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 232,
														"src": "11078:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_uint32_$25_storage",
															"typeString": "uint32[25] storage ref"
														}
													},
													"id": 716,
													"indexExpression": {
														"argumentTypes": null,
														"id": 715,
														"name": "regionFrom",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 656,
														"src": "11098:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "11078:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"id": 717,
													"name": "moveSoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 660,
													"src": "11112:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "11078:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d75737420686176652073756666696369656e7420736f6c6469657273",
												"id": 719,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11130:31:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
													"typeString": "literal_string \"Must have sufficient soldiers\""
												},
												"value": "Must have sufficient soldiers"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
													"typeString": "literal_string \"Must have sufficient soldiers\""
												}
											],
											"id": 712,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "11070:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 720,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "11070:92:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 721,
									"nodeType": "ExpressionStatement",
									"src": "11070:92:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 730,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 723,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11180:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 724,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "11180:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 726,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "11208:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 727,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionOwners",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 228,
															"src": "11208:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 728,
															"name": "regionFrom",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 656,
															"src": "11227:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 725,
														"name": "getData8",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4158,
														"src": "11199:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 729,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "11199:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "11180:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d757374206f776e20726567696f6e206d6f76696e672066726f6d",
												"id": 731,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11240:29:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
													"typeString": "literal_string \"Must own region moving from\""
												},
												"value": "Must own region moving from"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
													"typeString": "literal_string \"Must own region moving from\""
												}
											],
											"id": 722,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "11172:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 732,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "11172:98:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 733,
									"nodeType": "ExpressionStatement",
									"src": "11172:98:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 737,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 734,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 678,
											"src": "11334:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 735,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11338:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 736,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "11338:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "11334:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 738,
									"nodeType": "ExpressionStatement",
									"src": "11334:20:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 745,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 739,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11407:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 742,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "regionSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 232,
												"src": "11407:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 743,
											"indexExpression": {
												"argumentTypes": null,
												"id": 741,
												"name": "regionFrom",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 656,
												"src": "11427:10:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "11407:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "-=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 744,
											"name": "moveSoldierCount",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 660,
											"src": "11442:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "11407:51:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 746,
									"nodeType": "ExpressionStatement",
									"src": "11407:51:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 756,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 747,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11516:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 749,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "fromRegionList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 236,
											"src": "11516:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 751,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11548:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 752,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "fromRegionList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 236,
													"src": "11548:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 753,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11569:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 754,
													"name": "regionFrom",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 656,
													"src": "11572:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 750,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11538:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 755,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11538:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11516:67:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 757,
									"nodeType": "ExpressionStatement",
									"src": "11516:67:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 767,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 758,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11593:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 760,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "toRegionList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 238,
											"src": "11593:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 762,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11623:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 763,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "toRegionList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 238,
													"src": "11623:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 764,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11642:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 765,
													"name": "regionTo",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 658,
													"src": "11645:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 761,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11613:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 766,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11613:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11593:61:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 768,
									"nodeType": "ExpressionStatement",
									"src": "11593:61:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 778,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 769,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11664:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 771,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "moveSoldierCountList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 240,
											"src": "11664:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 773,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11702:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 774,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "moveSoldierCountList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 240,
													"src": "11702:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 775,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11729:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 776,
													"name": "moveSoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 660,
													"src": "11732:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 772,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11692:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 777,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11692:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11664:85:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 779,
									"nodeType": "ExpressionStatement",
									"src": "11664:85:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 792,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 780,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11759:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 782,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "submitBlockList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 242,
											"src": "11759:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 784,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11792:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 785,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "submitBlockList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 242,
													"src": "11792:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 786,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11814:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 788,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "11824:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 789,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "11824:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 787,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "11817:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 790,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "11817:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 783,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11782:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 791,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11782:56:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11759:79:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 793,
									"nodeType": "ExpressionStatement",
									"src": "11759:79:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 797,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "UnaryOperation",
										"operator": "++",
										"prefix": false,
										"src": "11883:18:2",
										"subExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 794,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11883:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 796,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "11883:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 798,
									"nodeType": "ExpressionStatement",
									"src": "11883:18:2"
								}
							]
						},
						"documentation": "@notice Move soldiers from one region to an adjacent region.  Attack if moving to enemy territory. \n @param gameId Id of game \n @param turnNum Turn action should occur during \n @param regionFrom Move soldiers from this region\n @param regionTo Move soldiers to this region\n @param moveSoldierCount Number of soldiers to move",
						"id": 800,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 663,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 652,
										"src": "10496:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									{
										"argumentTypes": null,
										"id": 664,
										"name": "turnNum",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 654,
										"src": "10504:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									}
								],
								"id": 665,
								"modifierName": {
									"argumentTypes": null,
									"id": 662,
									"name": "onlyIfPlayersTurn",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 301,
									"src": "10478:17:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
										"typeString": "modifier (uint256,uint32)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "10478:34:2"
							},
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 667,
										"name": "regionFrom",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 656,
										"src": "10536:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									{
										"argumentTypes": null,
										"id": 668,
										"name": "regionTo",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 658,
										"src": "10548:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									}
								],
								"id": 669,
								"modifierName": {
									"argumentTypes": null,
									"id": 666,
									"name": "onlyNeighbors",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 442,
									"src": "10522:13:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint32_$_t_uint32_$",
										"typeString": "modifier (uint32,uint32)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "10522:35:2"
							}
						],
						"name": "attackOrMove",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 661,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 652,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10320:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 651,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "10320:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 654,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10345:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 653,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10345:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 656,
									"name": "regionFrom",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10370:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 655,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10370:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 658,
									"name": "regionTo",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10398:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 657,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10398:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 660,
									"name": "moveSoldierCount",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10424:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 659,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10424:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10310:143:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 670,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10563:0:2"
						},
						"scope": 4288,
						"src": "10289:1619:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 951,
							"nodeType": "Block",
							"src": "12478:1644:2",
							"statements": [
								{
									"assignments": [
										816
									],
									"declarations": [
										{
											"constant": false,
											"id": 816,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 952,
											"src": "12488:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 815,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "12488:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 820,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 817,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "12512:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 819,
										"indexExpression": {
											"argumentTypes": null,
											"id": 818,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 802,
											"src": "12526:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "12512:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "12488:45:2"
								},
								{
									"assignments": [
										822
									],
									"declarations": [
										{
											"constant": false,
											"id": 822,
											"name": "undeployedSoldierCount",
											"nodeType": "VariableDeclaration",
											"scope": 952,
											"src": "12543:29:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 821,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "12543:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 829,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 824,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "12585:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 825,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "undeployedSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 226,
												"src": "12585:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 826,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "12610:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 827,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "12610:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 823,
											"name": "getData32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4095,
											"src": "12575:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
												"typeString": "function (uint256,uint32) pure returns (uint32)"
											}
										},
										"id": 828,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "12575:51:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "12543:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 833,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 831,
													"name": "undeployedSoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 822,
													"src": "12645:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 832,
													"name": "deploySoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 808,
													"src": "12671:18:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "12645:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d75737420686176652073756666696369656e7420736f6c64696572732e",
												"id": 834,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "12691:32:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
													"typeString": "literal_string \"Must have sufficient soldiers.\""
												},
												"value": "Must have sufficient soldiers."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
													"typeString": "literal_string \"Must have sufficient soldiers.\""
												}
											],
											"id": 830,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "12637:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 835,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "12637:87:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 836,
									"nodeType": "ExpressionStatement",
									"src": "12637:87:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 862,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 854,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 844,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 840,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 838,
																		"name": "regionDeploy",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 806,
																		"src": "12756:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 839,
																		"name": "NO_REGION",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 126,
																		"src": "12772:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "12756:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "&&",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 843,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 841,
																		"name": "deploySoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 808,
																		"src": "12785:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 842,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "12807:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"src": "12785:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "12756:52:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 845,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "12755:54:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 853,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 847,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "12835:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 848,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "12835:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 849,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "12854:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 846,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "12826:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 850,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "12826:41:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 851,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "12871:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 852,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "12871:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "12826:60:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "12755:131:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 861,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 856,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "12912:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 857,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "12912:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 858,
																"name": "regionDeploy",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 806,
																"src": "12931:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 855,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "12903:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 859,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "12903:41:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 860,
														"name": "NOT_OWNED",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 123,
														"src": "12948:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "12903:54:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "12755:202:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "596f752063616e206f6e6c79206465706c6f7920736f6c646965727320746f206120726567696f6e20796f75206f776e2c206f72207468617420697320756e6f636375706965642e",
												"id": 863,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "12971:74:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
													"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
												},
												"value": "You can only deploy soldiers to a region you own, or that is unoccupied."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
													"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
												}
											],
											"id": 837,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "12734:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 864,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "12734:321:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 865,
									"nodeType": "ExpressionStatement",
									"src": "12734:321:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 869,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 866,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 816,
												"src": "13152:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 867,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "13152:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 868,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "13171:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "13152:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 875,
									"nodeType": "IfStatement",
									"src": "13148:80:2",
									"trueBody": {
										"id": 874,
										"nodeType": "Block",
										"src": "13174:54:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 871,
															"name": "gameId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 802,
															"src": "13210:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 870,
														"name": "executePendingActions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1847,
														"src": "13188:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 872,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "13188:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 873,
												"nodeType": "ExpressionStatement",
												"src": "13188:29:2"
											}
										]
									}
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 878,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 876,
											"name": "regionDeploy",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 806,
											"src": "13297:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"id": 877,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "13313:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "13297:25:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 921,
									"nodeType": "IfStatement",
									"src": "13293:500:2",
									"trueBody": {
										"id": 920,
										"nodeType": "Block",
										"src": "13324:469:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 889,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 879,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 816,
															"src": "13338:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 881,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "regionOwners",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 228,
														"src": "13338:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 883,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13367:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 884,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "13367:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 885,
																"name": "regionDeploy",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 806,
																"src": "13386:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 886,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13400:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 887,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "13400:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 882,
															"name": "setData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4203,
															"src": "13358:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
															}
														},
														"id": 888,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13358:58:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "13338:78:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 890,
												"nodeType": "ExpressionStatement",
												"src": "13338:78:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 904,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 891,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 816,
															"src": "13430:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 893,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "undeployedSoldiers",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 226,
														"src": "13430:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 895,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13483:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 896,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "undeployedSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 226,
																"src": "13483:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 897,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13525:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 898,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "13525:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"id": 900,
																		"name": "undeployedSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 822,
																		"src": "13567:22:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 901,
																		"name": "deploySoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 808,
																		"src": "13591:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 899,
																	"name": "subSafe",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4228,
																	"src": "13559:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint32,uint32) pure returns (uint32)"
																	}
																},
																"id": 902,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "13559:51:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 894,
															"name": "setData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4133,
															"src": "13456:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
															}
														},
														"id": 903,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13456:168:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "13430:194:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 905,
												"nodeType": "ExpressionStatement",
												"src": "13430:194:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 918,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 906,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "13638:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 909,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionSoldiers",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 232,
															"src": "13638:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_storage",
																"typeString": "uint32[25] storage ref"
															}
														},
														"id": 910,
														"indexExpression": {
															"argumentTypes": null,
															"id": 908,
															"name": "regionDeploy",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 806,
															"src": "13658:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "13638:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 912,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13699:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 913,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 232,
																	"src": "13699:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$25_storage",
																		"typeString": "uint32[25] storage ref"
																	}
																},
																"id": 915,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 914,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "13719:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "13699:33:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 916,
																"name": "deploySoldierCount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 808,
																"src": "13750:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 911,
															"name": "addSafe",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4253,
															"src": "13674:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32,uint32) pure returns (uint32)"
															}
														},
														"id": 917,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13674:108:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "13638:144:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 919,
												"nodeType": "ExpressionStatement",
												"src": "13638:144:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 928,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 922,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 816,
												"src": "13845:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 924,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "13845:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 926,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "13881:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 925,
												"name": "getNextTurnTeamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1948,
												"src": "13863:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
													"typeString": "function (uint256) view returns (uint32)"
												}
											},
											"id": 927,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "13863:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "13845:43:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 929,
									"nodeType": "ExpressionStatement",
									"src": "13845:43:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 937,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 930,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 816,
												"src": "13898:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 932,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnNum",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 216,
											"src": "13898:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 934,
														"name": "block",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4362,
														"src": "13920:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_block",
															"typeString": "block"
														}
													},
													"id": 935,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "number",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "13920:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 933,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "13913:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 936,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "13913:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "13898:35:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 938,
									"nodeType": "ExpressionStatement",
									"src": "13898:35:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 940,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 802,
												"src": "14045:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 939,
											"name": "giveRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2210,
											"src": "14027:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 941,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14027:25:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 942,
									"nodeType": "ExpressionStatement",
									"src": "14027:25:2"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 944,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 802,
												"src": "14077:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 945,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "14085:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 946,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "14085:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 947,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "14099:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 948,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "14099:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 943,
											"name": "NextTurn",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 261,
											"src": "14068:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
												"typeString": "function (uint256,uint32,uint32)"
											}
										},
										"id": 949,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14068:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 950,
									"nodeType": "EmitStatement",
									"src": "14063:52:2"
								}
							]
						},
						"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game \n @param turnNum Turn deploySoldiersAndEndTurn should occur during \n @param regionDeploy Region where you'd like to deploy soldiers to\n @param deploySoldierCount Number of soldiers you'd like to deploy at end of your turn",
						"id": 952,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 811,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 802,
										"src": "12456:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									{
										"argumentTypes": null,
										"id": 812,
										"name": "turnNum",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 804,
										"src": "12464:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									}
								],
								"id": 813,
								"modifierName": {
									"argumentTypes": null,
									"id": 810,
									"name": "onlyIfPlayersTurn",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 301,
									"src": "12438:17:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
										"typeString": "modifier (uint256,uint32)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "12438:34:2"
							}
						],
						"name": "deploySoldiersAndEndTurn",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 809,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 802,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12302:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 801,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "12302:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 804,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12327:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 803,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "12327:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 806,
									"name": "regionDeploy",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12352:19:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 805,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "12352:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 808,
									"name": "deploySoldierCount",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12382:25:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 807,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "12382:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "12292:121:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 814,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "12478:0:2"
						},
						"scope": 4288,
						"src": "12259:1863:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1028,
							"nodeType": "Block",
							"src": "14421:740:2",
							"statements": [
								{
									"assignments": [
										963
									],
									"declarations": [
										{
											"constant": false,
											"id": 963,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1029,
											"src": "14431:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 962,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "14431:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 967,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 964,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "14455:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 966,
										"indexExpression": {
											"argumentTypes": null,
											"id": 965,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 954,
											"src": "14469:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "14455:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "14431:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 972,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 969,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 963,
														"src": "14494:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 970,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "14494:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 971,
													"name": "turnNum",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 956,
													"src": "14510:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "14494:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "57726f6e67207475726e206e756d6265722e",
												"id": 973,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "14519:20:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												},
												"value": "Wrong turn number."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												}
											],
											"id": 968,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "14486:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 974,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14486:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 975,
									"nodeType": "ExpressionStatement",
									"src": "14486:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 985,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 977,
														"name": "block",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4362,
														"src": "14558:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_block",
															"typeString": "block"
														}
													},
													"id": 978,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "number",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "14558:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 980,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 963,
																"src": "14581:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 981,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnNum",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 216,
															"src": "14581:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 982,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 963,
																"src": "14595:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 983,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "maxBlocksPerTurn",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 218,
															"src": "14595:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 979,
														"name": "addSafe",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4253,
														"src": "14573:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint32,uint32) pure returns (uint32)"
														}
													},
													"id": 984,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "14573:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "14558:59:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "506c61796572207374696c6c206861732074696d6520746f2066696e697368207475726e2e",
												"id": 986,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "14619:39:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
													"typeString": "literal_string \"Player still has time to finish turn.\""
												},
												"value": "Player still has time to finish turn."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
													"typeString": "literal_string \"Player still has time to finish turn.\""
												}
											],
											"id": 976,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "14550:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 987,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14550:109:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 988,
									"nodeType": "ExpressionStatement",
									"src": "14550:109:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 992,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 989,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 963,
												"src": "14756:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 990,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "14756:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 991,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "14775:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "14756:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 998,
									"nodeType": "IfStatement",
									"src": "14752:80:2",
									"trueBody": {
										"id": 997,
										"nodeType": "Block",
										"src": "14778:54:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 994,
															"name": "gameId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 954,
															"src": "14814:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 993,
														"name": "executePendingActions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1847,
														"src": "14792:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 995,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "14792:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 996,
												"nodeType": "ExpressionStatement",
												"src": "14792:29:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1005,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 999,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 963,
												"src": "14884:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1001,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "14884:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1003,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 954,
													"src": "14920:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1002,
												"name": "getNextTurnTeamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1948,
												"src": "14902:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
													"typeString": "function (uint256) view returns (uint32)"
												}
											},
											"id": 1004,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14902:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "14884:43:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 1006,
									"nodeType": "ExpressionStatement",
									"src": "14884:43:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1014,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1007,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 963,
												"src": "14937:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1009,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnNum",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 216,
											"src": "14937:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1011,
														"name": "block",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4362,
														"src": "14959:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_block",
															"typeString": "block"
														}
													},
													"id": 1012,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "number",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "14959:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1010,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "14952:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 1013,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14952:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "14937:35:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 1015,
									"nodeType": "ExpressionStatement",
									"src": "14937:35:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1017,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 954,
												"src": "15084:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 1016,
											"name": "giveRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2210,
											"src": "15066:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1018,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "15066:25:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1019,
									"nodeType": "ExpressionStatement",
									"src": "15066:25:2"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1021,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 954,
												"src": "15116:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1022,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "15124:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1023,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "15124:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1024,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "15138:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1025,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "15138:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 1020,
											"name": "NextTurn",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 261,
											"src": "15107:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
												"typeString": "function (uint256,uint32,uint32)"
											}
										},
										"id": 1026,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "15107:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1027,
									"nodeType": "EmitStatement",
									"src": "15102:52:2"
								}
							]
						},
						"documentation": "@notice Force turn to end for player who's taking too long.\n @param gameId Id of game \n @param turnNum Turn forceEndOfTurn should occur during ",
						"id": 1029,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 959,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 954,
										"src": "14409:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									}
								],
								"id": 960,
								"modifierName": {
									"argumentTypes": null,
									"id": 958,
									"name": "onlyPlayers",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 380,
									"src": "14397:11:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$",
										"typeString": "modifier (uint256)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "14397:19:2"
							}
						],
						"name": "forceEndOfTurn",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 957,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 954,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1029,
									"src": "14327:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 953,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "14327:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 956,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 1029,
									"src": "14352:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 955,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "14352:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "14317:55:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 961,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "14421:0:2"
						},
						"scope": 4288,
						"src": "14294:867:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1087,
							"nodeType": "Block",
							"src": "15406:402:2",
							"statements": [
								{
									"assignments": [
										1040
									],
									"declarations": [
										{
											"constant": false,
											"id": 1040,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1088,
											"src": "15416:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1039,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "15416:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1044,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1041,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "15440:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1043,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1042,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1031,
											"src": "15454:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "15440:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "15416:45:2"
								},
								{
									"assignments": [
										1046
									],
									"declarations": [
										{
											"constant": false,
											"id": 1046,
											"name": "isWinner",
											"nodeType": "VariableDeclaration",
											"scope": 1088,
											"src": "15480:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"typeName": {
												"id": 1045,
												"name": "bool",
												"nodeType": "ElementaryTypeName",
												"src": "15480:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1048,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1047,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "15496:4:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "15480:20:2"
								},
								{
									"body": {
										"id": 1072,
										"nodeType": "Block",
										"src": "15552:119:2",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 1065,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1060,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1040,
																	"src": "15579:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1061,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "15579:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1062,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1050,
																"src": "15598:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1059,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "15570:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1063,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "15570:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "!=",
													"rightExpression": {
														"argumentTypes": null,
														"id": 1064,
														"name": "teamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1033,
														"src": "15604:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "15570:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1071,
												"nodeType": "IfStatement",
												"src": "15566:95:2",
												"trueBody": {
													"id": 1070,
													"nodeType": "Block",
													"src": "15612:49:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1068,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1066,
																	"name": "isWinner",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1046,
																	"src": "15630:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "66616c7365",
																	"id": 1067,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "15641:5:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "false"
																},
																"src": "15630:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1069,
															"nodeType": "ExpressionStatement",
															"src": "15630:16:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1055,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1053,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1050,
											"src": "15529:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1054,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "15533:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "15529:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1073,
									"initializationExpression": {
										"assignments": [
											1050
										],
										"declarations": [
											{
												"constant": false,
												"id": 1050,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1088,
												"src": "15515:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1049,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "15515:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1052,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1051,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "15526:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "15515:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1057,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "15547:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1056,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1050,
												"src": "15547:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1058,
										"nodeType": "ExpressionStatement",
										"src": "15547:3:2"
									},
									"nodeType": "ForStatement",
									"src": "15510:161:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1075,
												"name": "isWinner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1046,
												"src": "15689:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "576520646f6e2774206861766520612077696e6e65722e",
												"id": 1076,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "15699:25:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
													"typeString": "literal_string \"We don't have a winner.\""
												},
												"value": "We don't have a winner."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
													"typeString": "literal_string \"We don't have a winner.\""
												}
											],
											"id": 1074,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "15681:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 1077,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "15681:44:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1078,
									"nodeType": "ExpressionStatement",
									"src": "15681:44:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"id": 1079,
										"name": "isWinner",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1046,
										"src": "15740:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1086,
									"nodeType": "IfStatement",
									"src": "15736:66:2",
									"trueBody": {
										"id": 1085,
										"nodeType": "Block",
										"src": "15750:52:2",
										"statements": [
											{
												"eventCall": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 1081,
															"name": "gameId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1031,
															"src": "15776:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1082,
															"name": "teamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1033,
															"src": "15784:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1080,
														"name": "Winner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 267,
														"src": "15769:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$returns$__$",
															"typeString": "function (uint256,uint32)"
														}
													},
													"id": 1083,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "15769:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 1084,
												"nodeType": "EmitStatement",
												"src": "15764:27:2"
											}
										]
									}
								}
							]
						},
						"documentation": "@notice Declare victory for a team.\n @param gameId Id of game\n @param teamId Team you'd like to declare as winner",
						"id": 1088,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 1036,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1031,
										"src": "15394:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									}
								],
								"id": 1037,
								"modifierName": {
									"argumentTypes": null,
									"id": 1035,
									"name": "onlyPlayers",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 380,
									"src": "15382:11:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$",
										"typeString": "modifier (uint256)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "15382:19:2"
							}
						],
						"name": "declareWinner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1034,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1031,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1088,
									"src": "15326:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1030,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "15326:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1033,
									"name": "teamId",
									"nodeType": "VariableDeclaration",
									"scope": 1088,
									"src": "15342:13:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1032,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "15342:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "15325:31:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1038,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "15406:0:2"
						},
						"scope": 4288,
						"src": "15303:505:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1122,
							"nodeType": "Block",
							"src": "16071:261:2",
							"statements": [
								{
									"assignments": [
										1096
									],
									"declarations": [
										{
											"constant": false,
											"id": 1096,
											"name": "cachedBlockHash",
											"nodeType": "VariableDeclaration",
											"scope": 1123,
											"src": "16081:22:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1095,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "16081:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1100,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1097,
											"name": "blockHash32Map",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 173,
											"src": "16106:14:2",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
												"typeString": "mapping(uint32 => uint32)"
											}
										},
										"id": 1099,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1098,
											"name": "blockNum",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1090,
											"src": "16121:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "16106:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "16081:49:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1103,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1101,
											"name": "cachedBlockHash",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1096,
											"src": "16145:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1102,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "16164:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "16145:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1119,
									"nodeType": "IfStatement",
									"src": "16141:152:2",
									"trueBody": {
										"id": 1118,
										"nodeType": "Block",
										"src": "16167:126:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1110,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1104,
														"name": "cachedBlockHash",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1096,
														"src": "16181:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"id": 1107,
																		"name": "blockNum",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1090,
																		"src": "16216:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1106,
																	"name": "blockhash",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4363,
																	"src": "16206:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
																		"typeString": "function (uint256) view returns (bytes32)"
																	}
																},
																"id": 1108,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "16206:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															],
															"id": 1105,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "16199:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 1109,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "16199:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "16181:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1111,
												"nodeType": "ExpressionStatement",
												"src": "16181:45:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1116,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1112,
															"name": "blockHash32Map",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 173,
															"src": "16240:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																"typeString": "mapping(uint32 => uint32)"
															}
														},
														"id": 1114,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1113,
															"name": "blockNum",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1090,
															"src": "16255:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "16240:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 1115,
														"name": "cachedBlockHash",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1096,
														"src": "16267:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "16240:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1117,
												"nodeType": "ExpressionStatement",
												"src": "16240:42:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1120,
										"name": "cachedBlockHash",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1096,
										"src": "16310:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 1094,
									"id": 1121,
									"nodeType": "Return",
									"src": "16303:22:2"
								}
							]
						},
						"documentation": "@notice Caches the hash for a specific block in a map.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
						"id": 1123,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "cacheBlockHash32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1091,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1090,
									"name": "blockNum",
									"nodeType": "VariableDeclaration",
									"scope": 1123,
									"src": "16031:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1089,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16031:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16030:17:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1094,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1093,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1123,
									"src": "16063:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1092,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16063:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16062:8:2"
						},
						"scope": 4288,
						"src": "16005:327:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1151,
							"nodeType": "Block",
							"src": "16583:189:2",
							"statements": [
								{
									"assignments": [
										1131
									],
									"declarations": [
										{
											"constant": false,
											"id": 1131,
											"name": "blockHash32",
											"nodeType": "VariableDeclaration",
											"scope": 1152,
											"src": "16593:18:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1130,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "16593:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1137,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1134,
														"name": "blockNum",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1125,
														"src": "16631:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 1133,
													"name": "blockhash",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4363,
													"src": "16621:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
														"typeString": "function (uint256) view returns (bytes32)"
													}
												},
												"id": 1135,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "16621:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 1132,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "16614:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint32_$",
												"typeString": "type(uint32)"
											},
											"typeName": "uint32"
										},
										"id": 1136,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "16614:27:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "16593:48:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1140,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1138,
											"name": "blockHash32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1131,
											"src": "16656:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1139,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "16671:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "16656:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1148,
									"nodeType": "IfStatement",
									"src": "16652:85:2",
									"trueBody": {
										"id": 1147,
										"nodeType": "Block",
										"src": "16674:63:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1145,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1141,
														"name": "blockHash32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1131,
														"src": "16688:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1142,
															"name": "blockHash32Map",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 173,
															"src": "16702:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																"typeString": "mapping(uint32 => uint32)"
															}
														},
														"id": 1144,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1143,
															"name": "blockNum",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1125,
															"src": "16717:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "16702:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "16688:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1146,
												"nodeType": "ExpressionStatement",
												"src": "16688:38:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1149,
										"name": "blockHash32",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1131,
										"src": "16754:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 1129,
									"id": 1150,
									"nodeType": "Return",
									"src": "16747:18:2"
								}
							]
						},
						"documentation": "@notice Get hash for a specific block.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
						"id": 1152,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "readBlockHash32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1126,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1125,
									"name": "blockNum",
									"nodeType": "VariableDeclaration",
									"scope": 1152,
									"src": "16538:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1124,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16538:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16537:17:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1129,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1128,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1152,
									"src": "16575:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1127,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16575:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16574:8:2"
						},
						"scope": 4288,
						"src": "16513:259:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1160,
							"nodeType": "Block",
							"src": "16902:44:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 1157,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "16919:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1158,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "length",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "16919:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1156,
									"id": 1159,
									"nodeType": "Return",
									"src": "16912:27:2"
								}
							]
						},
						"documentation": "@notice Returns total number of games that have been created.",
						"id": 1161,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "numberOfGames",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1153,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "16870:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1156,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1155,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1161,
									"src": "16893:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1154,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "16893:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16892:9:2"
						},
						"scope": 4288,
						"src": "16848:98:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1286,
							"nodeType": "Block",
							"src": "17332:1119:2",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1178,
											"name": "gameIdList",
											"nodeType": "VariableDeclaration",
											"scope": 1287,
											"src": "17342:29:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
												"typeString": "uint256[10]"
											},
											"typeName": {
												"baseType": {
													"id": 1176,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "17342:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 1177,
												"length": {
													"argumentTypes": null,
													"hexValue": "3130",
													"id": 1175,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "17350:2:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "10"
												},
												"nodeType": "ArrayTypeName",
												"src": "17342:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
													"typeString": "uint256[10]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1179,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "17342:29:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1181,
											"name": "gameIdCount",
											"nodeType": "VariableDeclaration",
											"scope": 1287,
											"src": "17381:18:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1180,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "17381:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1182,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "17381:18:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1184,
											"name": "gameId",
											"nodeType": "VariableDeclaration",
											"scope": 1287,
											"src": "17409:14:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1183,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "17409:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1185,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "17409:14:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1189,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1186,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "17437:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1187,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "17437:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1188,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "17460:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "17437:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1280,
									"nodeType": "IfStatement",
									"src": "17433:961:2",
									"trueBody": {
										"id": 1279,
										"nodeType": "Block",
										"src": "17463:931:2",
										"statements": [
											{
												"assignments": [
													1191
												],
												"declarations": [
													{
														"constant": false,
														"id": 1191,
														"name": "startPosition",
														"nodeType": "VariableDeclaration",
														"scope": 1287,
														"src": "17553:21:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"typeName": {
															"id": 1190,
															"name": "uint256",
															"nodeType": "ElementaryTypeName",
															"src": "17553:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1196,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1195,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1192,
															"name": "gameDataArray",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 186,
															"src": "17577:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																"typeString": "struct WorldGame.GameData storage ref[] storage ref"
															}
														},
														"id": 1193,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "length",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "17577:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "-",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 1194,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "17600:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "17577:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "17553:48:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1203,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1199,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1197,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1163,
															"src": "17619:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1198,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17628:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "17619:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1202,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1200,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1163,
															"src": "17633:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1201,
															"name": "startPosition",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1191,
															"src": "17642:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "17633:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "17619:36:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1209,
												"nodeType": "IfStatement",
												"src": "17615:97:2",
												"trueBody": {
													"id": 1208,
													"nodeType": "Block",
													"src": "17657:55:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1206,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1204,
																	"name": "startPosition",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1191,
																	"src": "17675:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1205,
																	"name": "offset",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1163,
																	"src": "17691:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "17675:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 1207,
															"nodeType": "ExpressionStatement",
															"src": "17675:22:2"
														}
													]
												}
											},
											{
												"body": {
													"id": 1277,
													"nodeType": "Block",
													"src": "17867:517:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1226,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1222,
																	"name": "gameId",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1184,
																	"src": "17885:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 1225,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1223,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1211,
																		"src": "17894:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 1224,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "17898:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"src": "17894:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "17885:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 1227,
															"nodeType": "ExpressionStatement",
															"src": "17885:14:2"
														},
														{
															"assignments": [
																1229
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 1229,
																	"name": "game",
																	"nodeType": "VariableDeclaration",
																	"scope": 1287,
																	"src": "17918:21:2",
																	"stateVariable": false,
																	"storageLocation": "storage",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData"
																	},
																	"typeName": {
																		"contractScope": null,
																		"id": 1228,
																		"name": "GameData",
																		"nodeType": "UserDefinedTypeName",
																		"referencedDeclaration": 245,
																		"src": "17918:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 1233,
															"initialValue": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 1230,
																	"name": "gameDataArray",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 186,
																	"src": "17942:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																		"typeString": "struct WorldGame.GameData storage ref[] storage ref"
																	}
																},
																"id": 1232,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 1231,
																	"name": "gameId",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1184,
																	"src": "17956:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "17942:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage",
																	"typeString": "struct WorldGame.GameData storage ref"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "17918:45:2"
														},
														{
															"body": {
																"id": 1264,
																"nodeType": "Block",
																"src": "18027:234:2",
																"statements": [
																	{
																		"condition": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 1251,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1245,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1229,
																						"src": "18053:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 1246,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "18053:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 1248,
																				"indexExpression": {
																					"argumentTypes": null,
																					"id": 1247,
																					"name": "j",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1235,
																					"src": "18074:1:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "18053:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1249,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "18080:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 1250,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "18080:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "18053:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"falseBody": null,
																		"id": 1263,
																		"nodeType": "IfStatement",
																		"src": "18049:194:2",
																		"trueBody": {
																			"id": 1262,
																			"nodeType": "Block",
																			"src": "18092:151:2",
																			"statements": [
																				{
																					"expression": {
																						"argumentTypes": null,
																						"id": 1256,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"leftHandSide": {
																							"argumentTypes": null,
																							"baseExpression": {
																								"argumentTypes": null,
																								"id": 1252,
																								"name": "gameIdList",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1178,
																								"src": "18118:10:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
																									"typeString": "uint256[10] memory"
																								}
																							},
																							"id": 1254,
																							"indexExpression": {
																								"argumentTypes": null,
																								"id": 1253,
																								"name": "gameIdCount",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1181,
																								"src": "18129:11:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint32",
																									"typeString": "uint32"
																								}
																							},
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": true,
																							"nodeType": "IndexAccess",
																							"src": "18118:23:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"nodeType": "Assignment",
																						"operator": "=",
																						"rightHandSide": {
																							"argumentTypes": null,
																							"id": 1255,
																							"name": "gameId",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1184,
																							"src": "18144:6:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"src": "18118:32:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint256",
																							"typeString": "uint256"
																						}
																					},
																					"id": 1257,
																					"nodeType": "ExpressionStatement",
																					"src": "18118:32:2"
																				},
																				{
																					"expression": {
																						"argumentTypes": null,
																						"id": 1259,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"nodeType": "UnaryOperation",
																						"operator": "++",
																						"prefix": false,
																						"src": "18176:13:2",
																						"subExpression": {
																							"argumentTypes": null,
																							"id": 1258,
																							"name": "gameIdCount",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1181,
																							"src": "18176:11:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint32",
																								"typeString": "uint32"
																							}
																						},
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"id": 1260,
																					"nodeType": "ExpressionStatement",
																					"src": "18176:13:2"
																				},
																				{
																					"id": 1261,
																					"nodeType": "Break",
																					"src": "18215:5:2"
																				}
																			]
																		}
																	}
																]
															},
															"condition": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 1241,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 1238,
																	"name": "j",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1235,
																	"src": "18000:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "<",
																"rightExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1239,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1229,
																		"src": "18004:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1240,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "playerCount",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 220,
																	"src": "18004:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "18000:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1265,
															"initializationExpression": {
																"assignments": [
																	1235
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 1235,
																		"name": "j",
																		"nodeType": "VariableDeclaration",
																		"scope": 1287,
																		"src": "17986:8:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 1234,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "17986:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 1237,
																"initialValue": {
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 1236,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "17997:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "17986:12:2"
															},
															"loopExpression": {
																"expression": {
																	"argumentTypes": null,
																	"id": 1243,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "UnaryOperation",
																	"operator": "++",
																	"prefix": false,
																	"src": "18022:3:2",
																	"subExpression": {
																		"argumentTypes": null,
																		"id": 1242,
																		"name": "j",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1235,
																		"src": "18022:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1244,
																"nodeType": "ExpressionStatement",
																"src": "18022:3:2"
															},
															"nodeType": "ForStatement",
															"src": "17981:280:2"
														},
														{
															"condition": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 1273,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 1268,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1266,
																		"name": "gameIdCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1181,
																		"src": "18283:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "3130",
																		"id": 1267,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "18298:2:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_10_by_1",
																			"typeString": "int_const 10"
																		},
																		"value": "10"
																	},
																	"src": "18283:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 1272,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [],
																		"expression": {
																			"argumentTypes": [],
																			"id": 1269,
																			"name": "gasleft",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4365,
																			"src": "18304:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_gasleft_view$__$returns$_t_uint256_$",
																				"typeString": "function () view returns (uint256)"
																			}
																		},
																		"id": 1270,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "18304:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "<",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "313030303030",
																		"id": 1271,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "18316:6:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_100000_by_1",
																			"typeString": "int_const 100000"
																		},
																		"value": "100000"
																	},
																	"src": "18304:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "18283:39:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"falseBody": null,
															"id": 1276,
															"nodeType": "IfStatement",
															"src": "18279:91:2",
															"trueBody": {
																"id": 1275,
																"nodeType": "Block",
																"src": "18324:46:2",
																"statements": [
																	{
																		"id": 1274,
																		"nodeType": "Break",
																		"src": "18346:5:2"
																	}
																]
															}
														}
													]
												},
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1218,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1216,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1211,
														"src": "17855:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1217,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "17859:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "17855:5:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 1278,
												"initializationExpression": {
													"assignments": [
														1211
													],
													"declarations": [
														{
															"constant": false,
															"id": 1211,
															"name": "i",
															"nodeType": "VariableDeclaration",
															"scope": 1287,
															"src": "17824:9:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"typeName": {
																"id": 1210,
																"name": "uint256",
																"nodeType": "ElementaryTypeName",
																"src": "17824:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1215,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1214,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1212,
															"name": "startPosition",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1191,
															"src": "17836:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "+",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 1213,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17852:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "17836:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "17824:29:2"
												},
												"loopExpression": {
													"expression": {
														"argumentTypes": null,
														"id": 1220,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "UnaryOperation",
														"operator": "--",
														"prefix": false,
														"src": "17862:3:2",
														"subExpression": {
															"argumentTypes": null,
															"id": 1219,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1211,
															"src": "17862:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 1221,
													"nodeType": "ExpressionStatement",
													"src": "17862:3:2"
												},
												"nodeType": "ForStatement",
												"src": "17819:565:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"id": 1281,
												"name": "gameIdList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1178,
												"src": "18412:10:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
													"typeString": "uint256[10] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1282,
												"name": "gameIdCount",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1181,
												"src": "18424:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 1283,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1184,
												"src": "18437:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"id": 1284,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "18411:33:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_array$_t_uint256_$10_memory_ptr_$_t_uint32_$_t_uint256_$",
											"typeString": "tuple(uint256[10] memory,uint32,uint256)"
										}
									},
									"functionReturnParameters": 1173,
									"id": 1285,
									"nodeType": "Return",
									"src": "18404:40:2"
								}
							]
						},
						"documentation": "@notice Returns recent game ids where msg.sender is a player.\n @param offset Position in game data array to start search from\n @return List of game ids\n @return Number of game ids\n @return Position in loop when ended",
						"id": 1287,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "listGamesForAddress",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1164,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1163,
									"name": "offset",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17234:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1162,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "17234:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "17233:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1173,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1168,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17297:11:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
										"typeString": "uint256[10]"
									},
									"typeName": {
										"baseType": {
											"id": 1165,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "17297:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 1167,
										"length": {
											"argumentTypes": null,
											"hexValue": "3130",
											"id": 1166,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "17305:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											},
											"value": "10"
										},
										"nodeType": "ArrayTypeName",
										"src": "17297:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
											"typeString": "uint256[10]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1170,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17310:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1169,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "17310:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1172,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17318:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1171,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "17318:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "17296:30:2"
						},
						"scope": 4288,
						"src": "17205:1246:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1339,
							"nodeType": "Block",
							"src": "18840:302:2",
							"statements": [
								{
									"assignments": [
										1301
									],
									"declarations": [
										{
											"constant": false,
											"id": 1301,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1340,
											"src": "18850:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1300,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "18850:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1305,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1302,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "18874:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1304,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1303,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1289,
											"src": "18888:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "18874:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "18850:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1310,
											"name": "regionOwnersList",
											"nodeType": "VariableDeclaration",
											"scope": 1340,
											"src": "18906:44:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
												"typeString": "uint32[25]"
											},
											"typeName": {
												"baseType": {
													"id": 1308,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "18906:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1309,
												"length": {
													"argumentTypes": null,
													"id": 1307,
													"name": "REGION_COUNT",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 129,
													"src": "18913:12:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "18906:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
													"typeString": "uint32[25]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1311,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "18906:44:2"
								},
								{
									"body": {
										"id": 1332,
										"nodeType": "Block",
										"src": "19002:77:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1330,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1322,
															"name": "regionOwnersList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1310,
															"src": "19016:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																"typeString": "uint32[25] memory"
															}
														},
														"id": 1324,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1323,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1313,
															"src": "19033:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "19016:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1326,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1301,
																	"src": "19047:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1327,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "19047:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1328,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1313,
																"src": "19066:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1325,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "19038:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1329,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "19038:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "19016:52:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1331,
												"nodeType": "ExpressionStatement",
												"src": "19016:52:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1318,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1316,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1313,
											"src": "18979:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1317,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "18983:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "18979:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1333,
									"initializationExpression": {
										"assignments": [
											1313
										],
										"declarations": [
											{
												"constant": false,
												"id": 1313,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1340,
												"src": "18965:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1312,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "18965:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1315,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1314,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "18976:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "18965:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1320,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "18997:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1319,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1313,
												"src": "18997:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1321,
										"nodeType": "ExpressionStatement",
										"src": "18997:3:2"
									},
									"nodeType": "ForStatement",
									"src": "18960:119:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"id": 1334,
												"name": "regionOwnersList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1310,
												"src": "19097:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
													"typeString": "uint32[25] memory"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1335,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1301,
													"src": "19115:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1336,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "regionSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 232,
												"src": "19115:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											}
										],
										"id": 1337,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "19096:39:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_array$_t_uint32_$25_memory_ptr_$_t_array$_t_uint32_$25_storage_$",
											"typeString": "tuple(uint32[25] memory,uint32[25] storage ref)"
										}
									},
									"functionReturnParameters": 1299,
									"id": 1338,
									"nodeType": "Return",
									"src": "19089:46:2"
								}
							]
						},
						"documentation": "@notice Returns the number of soldiers deployed to each region and region owners.\n @param gameId Id of game \n @return List of which player owns each region\n @return List of number of soldiers deployed to each region",
						"id": 1340,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "soldiersByRegion",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1290,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1289,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1340,
									"src": "18728:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1288,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "18728:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "18727:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1299,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1294,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1340,
									"src": "18791:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
										"typeString": "uint32[25]"
									},
									"typeName": {
										"baseType": {
											"id": 1291,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "18791:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1293,
										"length": {
											"argumentTypes": null,
											"id": 1292,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "18798:12:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "18791:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
											"typeString": "uint32[25]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1298,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1340,
									"src": "18813:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
										"typeString": "uint32[25]"
									},
									"typeName": {
										"baseType": {
											"id": 1295,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "18813:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1297,
										"length": {
											"argumentTypes": null,
											"id": 1296,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "18820:12:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "18813:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
											"typeString": "uint32[25]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "18790:44:2"
						},
						"scope": 4288,
						"src": "18702:440:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1379,
							"nodeType": "Block",
							"src": "19575:277:2",
							"statements": [
								{
									"assignments": [
										1360
									],
									"declarations": [
										{
											"constant": false,
											"id": 1360,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1380,
											"src": "19585:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1359,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "19585:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1364,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1361,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "19609:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1363,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1362,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1342,
											"src": "19623:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "19609:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "19585:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1365,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19661:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1366,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "19661:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1367,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19691:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1368,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "19691:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1369,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19718:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1370,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "maxBlocksPerTurn",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 218,
												"src": "19718:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1371,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19754:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1372,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "playerCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 220,
												"src": "19754:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1373,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19785:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1374,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "playerAddresses",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 224,
												"src": "19785:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_address_$8_storage",
													"typeString": "address[8] storage ref"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1375,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19819:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1376,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "teamAvatars",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 244,
												"src": "19819:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes8",
													"typeString": "bytes8"
												}
											}
										],
										"id": 1377,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "19647:198:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_uint32_$_t_uint32_$_t_array$_t_address_$8_storage_$_t_bytes8_$",
											"typeString": "tuple(uint32,uint32,uint32,uint32,address[8] storage ref,bytes8)"
										}
									},
									"functionReturnParameters": 1358,
									"id": 1378,
									"nodeType": "Return",
									"src": "19640:205:2"
								}
							]
						},
						"documentation": "@notice Returns information about current turn and players.\n @param gameId Id of game \n @return Id of current player\n @return Turn number\n @return Max blocks per turn\n @return Number of players\n @return Player addresses",
						"id": 1380,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "turnAndPlayerInfo",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1343,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1342,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19445:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1341,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "19445:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "19444:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1358,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1345,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19508:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1344,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19508:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1347,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19516:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1346,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19516:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1349,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19524:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1348,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19524:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1351,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19532:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1350,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19532:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1355,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19540:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
										"typeString": "address[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1352,
											"name": "address",
											"nodeType": "ElementaryTypeName",
											"src": "19540:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 1354,
										"length": {
											"argumentTypes": null,
											"id": 1353,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "19548:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "19540:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
											"typeString": "address[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1357,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19562:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 1356,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "19562:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "19507:62:2"
						},
						"scope": 4288,
						"src": "19418:434:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1446,
							"nodeType": "Block",
							"src": "20213:445:2",
							"statements": [
								{
									"assignments": [
										1394
									],
									"declarations": [
										{
											"constant": false,
											"id": 1394,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1447,
											"src": "20223:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1393,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "20223:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1398,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1395,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "20247:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1397,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1396,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1382,
											"src": "20261:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "20247:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "20223:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1403,
											"name": "undeployedSoldiersList",
											"nodeType": "VariableDeclaration",
											"scope": 1447,
											"src": "20279:49:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1401,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "20279:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1402,
												"length": {
													"argumentTypes": null,
													"id": 1400,
													"name": "MAX_PLAYERS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 135,
													"src": "20286:11:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "20279:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1404,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "20279:49:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1409,
											"name": "regionRewardList",
											"nodeType": "VariableDeclaration",
											"scope": 1447,
											"src": "20338:43:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1407,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "20338:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1408,
												"length": {
													"argumentTypes": null,
													"id": 1406,
													"name": "MAX_PLAYERS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 135,
													"src": "20345:11:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "20338:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1410,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "20338:43:2"
								},
								{
									"body": {
										"id": 1440,
										"nodeType": "Block",
										"src": "20432:160:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1429,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1421,
															"name": "undeployedSoldiersList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1403,
															"src": "20446:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1423,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1422,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1412,
															"src": "20469:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "20446:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1425,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1394,
																	"src": "20484:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1426,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "undeployedSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 226,
																"src": "20484:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1427,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20509:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1424,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "20474:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1428,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "20474:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "20446:65:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1430,
												"nodeType": "ExpressionStatement",
												"src": "20446:65:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1438,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1431,
															"name": "regionRewardList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1409,
															"src": "20525:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1433,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1432,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1412,
															"src": "20542:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "20525:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 1435,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1382,
																"src": "20570:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1436,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20578:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1434,
															"name": "calculateRegionRewards",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2164,
															"src": "20547:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) view returns (uint32)"
															}
														},
														"id": 1437,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "20547:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "20525:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1439,
												"nodeType": "ExpressionStatement",
												"src": "20525:55:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1417,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1415,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1412,
											"src": "20410:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1416,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "20414:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "20410:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1441,
									"initializationExpression": {
										"assignments": [
											1412
										],
										"declarations": [
											{
												"constant": false,
												"id": 1412,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20396:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1411,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "20396:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1414,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1413,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "20407:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "20396:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1419,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "20427:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1418,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1412,
												"src": "20427:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1420,
										"nodeType": "ExpressionStatement",
										"src": "20427:3:2"
									},
									"nodeType": "ForStatement",
									"src": "20391:201:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"id": 1442,
												"name": "undeployedSoldiersList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1403,
												"src": "20610:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1443,
												"name": "regionRewardList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1409,
												"src": "20634:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											}
										],
										"id": 1444,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "20609:42:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
											"typeString": "tuple(uint32[8] memory,uint32[8] memory)"
										}
									},
									"functionReturnParameters": 1392,
									"id": 1445,
									"nodeType": "Return",
									"src": "20602:49:2"
								}
							]
						},
						"documentation": "@notice Returns the number of undeployed soldiers for each player.\n @param gameId Id of game \n @return Number of undeployed soldiers for each player\n @return Reward points for each player",
						"id": 1447,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "undeployedSoldiers",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1383,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1382,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1447,
									"src": "20103:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1381,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "20103:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "20102:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1392,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1387,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1447,
									"src": "20166:19:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1384,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "20166:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1386,
										"length": {
											"argumentTypes": null,
											"id": 1385,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "20173:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "20166:19:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1391,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1447,
									"src": "20187:19:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1388,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "20187:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1390,
										"length": {
											"argumentTypes": null,
											"id": 1389,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "20194:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "20187:19:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "20165:42:2"
						},
						"scope": 4288,
						"src": "20075:583:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1560,
							"nodeType": "Block",
							"src": "21323:836:2",
							"statements": [
								{
									"assignments": [
										1471
									],
									"declarations": [
										{
											"constant": false,
											"id": 1471,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21333:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1470,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "21333:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1475,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1472,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "21357:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1474,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1473,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1449,
											"src": "21371:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "21357:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "21333:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1480,
											"name": "fromRegionList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21389:50:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1478,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21389:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1479,
												"length": {
													"argumentTypes": null,
													"id": 1477,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21396:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21389:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1481,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21389:50:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1486,
											"name": "toRegionList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21449:48:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1484,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21449:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1485,
												"length": {
													"argumentTypes": null,
													"id": 1483,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21456:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21449:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1487,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21449:48:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1492,
											"name": "moveSoldierCountList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21507:56:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1490,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21507:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1491,
												"length": {
													"argumentTypes": null,
													"id": 1489,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21514:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21507:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1493,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21507:56:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1498,
											"name": "submitBlockList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21573:51:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1496,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21573:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1497,
												"length": {
													"argumentTypes": null,
													"id": 1495,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21580:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21573:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1499,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21573:51:2"
								},
								{
									"body": {
										"id": 1550,
										"nodeType": "Block",
										"src": "21685:289:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1518,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1510,
															"name": "fromRegionList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1480,
															"src": "21699:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1512,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1511,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21714:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21699:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1514,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21729:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1515,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "fromRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 236,
																"src": "21729:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1516,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21750:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1513,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21719:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1517,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21719:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21699:53:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1519,
												"nodeType": "ExpressionStatement",
												"src": "21699:53:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1528,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1520,
															"name": "toRegionList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1486,
															"src": "21766:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1522,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1521,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21779:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21766:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1524,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21794:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1525,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "toRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 238,
																"src": "21794:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1526,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21813:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1523,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21784:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1527,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21784:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21766:49:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1529,
												"nodeType": "ExpressionStatement",
												"src": "21766:49:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1538,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1530,
															"name": "moveSoldierCountList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1492,
															"src": "21829:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1532,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1531,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21850:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21829:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1534,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21865:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1535,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "moveSoldierCountList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 240,
																"src": "21865:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1536,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21892:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1533,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21855:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1537,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21855:39:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21829:65:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1539,
												"nodeType": "ExpressionStatement",
												"src": "21829:65:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1548,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1540,
															"name": "submitBlockList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1498,
															"src": "21908:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1542,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1541,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21924:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21908:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1544,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21939:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1545,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "submitBlockList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 242,
																"src": "21939:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1546,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21961:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1543,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21929:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1547,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21929:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21908:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1549,
												"nodeType": "ExpressionStatement",
												"src": "21908:55:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1506,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1504,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1501,
											"src": "21654:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1505,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21658:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "21654:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1551,
									"initializationExpression": {
										"assignments": [
											1501
										],
										"declarations": [
											{
												"constant": false,
												"id": 1501,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21640:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1500,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21640:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1503,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1502,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "21651:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "21640:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1508,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "21680:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1507,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1501,
												"src": "21680:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1509,
										"nodeType": "ExpressionStatement",
										"src": "21680:3:2"
									},
									"nodeType": "ForStatement",
									"src": "21635:339:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1552,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1471,
													"src": "22005:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1553,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "22005:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 1554,
												"name": "fromRegionList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1480,
												"src": "22036:14:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1555,
												"name": "toRegionList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1486,
												"src": "22065:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1556,
												"name": "moveSoldierCountList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1492,
												"src": "22092:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1557,
												"name": "submitBlockList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1498,
												"src": "22127:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											}
										],
										"id": 1558,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "21991:161:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
											"typeString": "tuple(uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
										}
									},
									"functionReturnParameters": 1469,
									"id": 1559,
									"nodeType": "Return",
									"src": "21984:168:2"
								}
							]
						},
						"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Number of pending actions\n @return List of regions moving soldiers from\n @return List of regions moving soldiers to\n @return List with number of soldiers to move\n @return List with block number when action was queued",
						"id": 1561,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pendingActions",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1450,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1449,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21063:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1448,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "21063:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "21062:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1469,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1452,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21139:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1451,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "21139:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1456,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21159:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1453,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21159:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1455,
										"length": {
											"argumentTypes": null,
											"id": 1454,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21166:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21159:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1460,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21202:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1457,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21202:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1459,
										"length": {
											"argumentTypes": null,
											"id": 1458,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21209:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21202:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1464,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21245:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1461,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21245:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1463,
										"length": {
											"argumentTypes": null,
											"id": 1462,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21252:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21245:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1468,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21288:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1465,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21288:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1467,
										"length": {
											"argumentTypes": null,
											"id": 1466,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21295:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21288:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "21125:197:2"
						},
						"scope": 4288,
						"src": "21039:1120:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1710,
							"nodeType": "Block",
							"src": "22781:1507:2",
							"statements": [
								{
									"assignments": [
										1583
									],
									"declarations": [
										{
											"constant": false,
											"id": 1583,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22791:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1582,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "22791:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1587,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1584,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "22815:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1586,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1585,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1563,
											"src": "22829:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "22815:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "22791:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1592,
											"name": "submitBlockList",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22847:51:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1590,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "22847:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1591,
												"length": {
													"argumentTypes": null,
													"id": 1589,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "22854:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "22847:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1593,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "22847:51:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1598,
											"name": "remainingAttackerList",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22908:57:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1596,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "22908:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1597,
												"length": {
													"argumentTypes": null,
													"id": 1595,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "22915:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "22908:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1599,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "22908:57:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1604,
											"name": "remainingDefenderList",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22975:57:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1602,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "22975:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1603,
												"length": {
													"argumentTypes": null,
													"id": 1601,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "22982:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "22975:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1605,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "22975:57:2"
								},
								{
									"body": {
										"id": 1697,
										"nodeType": "Block",
										"src": "23093:995:2",
										"statements": [
											{
												"assignments": [
													1617
												],
												"declarations": [
													{
														"constant": false,
														"id": 1617,
														"name": "toRegion",
														"nodeType": "VariableDeclaration",
														"scope": 1711,
														"src": "23107:15:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1616,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "23107:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1623,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1619,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1583,
																"src": "23135:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1620,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "toRegionList",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 238,
															"src": "23135:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1621,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1607,
															"src": "23154:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1618,
														"name": "getData32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4095,
														"src": "23125:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1622,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "23125:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "23107:49:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1632,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1624,
															"name": "submitBlockList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1592,
															"src": "23170:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1626,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1625,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1607,
															"src": "23186:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "23170:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1628,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1583,
																	"src": "23201:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1629,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "submitBlockList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 242,
																"src": "23201:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1630,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1607,
																"src": "23223:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1627,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "23191:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1631,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "23191:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "23170:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1633,
												"nodeType": "ExpressionStatement",
												"src": "23170:55:2"
											},
											{
												"assignments": [
													1635
												],
												"declarations": [
													{
														"constant": false,
														"id": 1635,
														"name": "friendly",
														"nodeType": "VariableDeclaration",
														"scope": 1711,
														"src": "23240:13:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"typeName": {
															"id": 1634,
															"name": "bool",
															"nodeType": "ElementaryTypeName",
															"src": "23240:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1652,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1651,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1643,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1637,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1583,
																		"src": "23265:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1638,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "23265:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1639,
																	"name": "toRegion",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1617,
																	"src": "23284:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1636,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "23256:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1640,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "23256:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1641,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1583,
																"src": "23297:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1642,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "23297:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23256:56:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1650,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1645,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1583,
																		"src": "23342:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1646,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "23342:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1647,
																	"name": "toRegion",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1617,
																	"src": "23361:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1644,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "23333:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1648,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "23333:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1649,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "23374:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23333:50:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "23256:127:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "23240:143:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1662,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1653,
														"name": "friendly",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1635,
														"src": "23402:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1661,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1654,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "23414:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 1655,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "23414:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1660,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 1656,
																	"name": "submitBlockList",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1592,
																	"src": "23429:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																		"typeString": "uint32[8] memory"
																	}
																},
																"id": 1658,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 1657,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1607,
																	"src": "23445:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "23429:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1659,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "23450:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "23429:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23414:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "23402:49:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1696,
												"nodeType": "IfStatement",
												"src": "23398:680:2",
												"trueBody": {
													"id": 1695,
													"nodeType": "Block",
													"src": "23453:625:2",
													"statements": [
														{
															"assignments": [
																1664,
																1666
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 1664,
																	"name": "remainingAttackers",
																	"nodeType": "VariableDeclaration",
																	"scope": 1711,
																	"src": "23472:25:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 1663,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "23472:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																},
																{
																	"constant": false,
																	"id": 1666,
																	"name": "remainingDefenders",
																	"nodeType": "VariableDeclaration",
																	"scope": 1711,
																	"src": "23499:25:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 1665,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "23499:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 1682,
															"initialValue": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1668,
																			"name": "submitBlockList",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1592,
																			"src": "23617:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																				"typeString": "uint32[8] memory"
																			}
																		},
																		"id": 1670,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1669,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1607,
																			"src": "23633:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "23617:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1672,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1583,
																					"src": "23718:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1673,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "moveSoldierCountList",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 240,
																				"src": "23718:25:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 1674,
																				"name": "i",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1607,
																				"src": "23745:1:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 1671,
																			"name": "getData32",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4095,
																			"src": "23708:9:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint256,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 1675,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "23708:39:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1676,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1583,
																				"src": "23818:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1677,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "23818:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1679,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1678,
																			"name": "toRegion",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1617,
																			"src": "23838:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "23818:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1680,
																		"name": "friendly",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1635,
																		"src": "23910:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	],
																	"id": 1667,
																	"name": "getOutcomeAttackOrMove",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2100,
																	"src": "23528:22:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
																		"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
																	}
																},
																"id": 1681,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "23528:408:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
																	"typeString": "tuple(uint32,uint32)"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "23471:465:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1687,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1683,
																		"name": "remainingAttackerList",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1598,
																		"src": "23955:21:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																			"typeString": "uint32[8] memory"
																		}
																	},
																	"id": 1685,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1684,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1607,
																		"src": "23977:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "23955:24:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1686,
																	"name": "remainingAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1664,
																	"src": "23982:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "23955:45:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1688,
															"nodeType": "ExpressionStatement",
															"src": "23955:45:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1693,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1689,
																		"name": "remainingDefenderList",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1604,
																		"src": "24018:21:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																			"typeString": "uint32[8] memory"
																		}
																	},
																	"id": 1691,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1690,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1607,
																		"src": "24040:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "24018:24:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1692,
																	"name": "remainingDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1666,
																	"src": "24045:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "24018:45:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1694,
															"nodeType": "ExpressionStatement",
															"src": "24018:45:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1612,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1610,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1607,
											"src": "23062:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1611,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "23066:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "23062:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1698,
									"initializationExpression": {
										"assignments": [
											1607
										],
										"declarations": [
											{
												"constant": false,
												"id": 1607,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "23048:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1606,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "23048:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1609,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1608,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "23059:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "23048:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1614,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "23088:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1613,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1607,
												"src": "23088:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1615,
										"nodeType": "ExpressionStatement",
										"src": "23088:3:2"
									},
									"nodeType": "ForStatement",
									"src": "23043:1045:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1700,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "24126:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 1701,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "24126:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 1699,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "24119:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 1702,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "24119:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1703,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1583,
													"src": "24154:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1704,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "24154:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 1705,
												"name": "submitBlockList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1592,
												"src": "24185:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1706,
												"name": "remainingAttackerList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1598,
												"src": "24215:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1707,
												"name": "remainingDefenderList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1604,
												"src": "24250:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											}
										],
										"id": 1708,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "24105:176:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
											"typeString": "tuple(uint32,uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
										}
									},
									"functionReturnParameters": 1581,
									"id": 1709,
									"nodeType": "Return",
									"src": "24098:183:2"
								}
							]
						},
						"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Current block numbber\n @return Number of pending actions\n @return List with block number when action was queued\n @return Number of remaining attackers\n @return Number of remaining defenders",
						"id": 1711,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pendingActionOutcomes",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1564,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1563,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22544:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1562,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "22544:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "22543:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1581,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1566,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22620:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1565,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "22620:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1568,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22640:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1567,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "22640:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1572,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22660:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1569,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22660:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1571,
										"length": {
											"argumentTypes": null,
											"id": 1570,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "22667:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "22660:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1576,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22703:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1573,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22703:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1575,
										"length": {
											"argumentTypes": null,
											"id": 1574,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "22710:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "22703:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1580,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22746:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1577,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22746:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1579,
										"length": {
											"argumentTypes": null,
											"id": 1578,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "22753:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "22746:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "22606:174:2"
						},
						"scope": 4288,
						"src": "22513:1775:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1846,
							"nodeType": "Block",
							"src": "24480:1885:2",
							"statements": [
								{
									"assignments": [
										1717
									],
									"declarations": [
										{
											"constant": false,
											"id": 1717,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1847,
											"src": "24490:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1716,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "24490:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1721,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1718,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "24514:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1720,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1719,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1713,
											"src": "24528:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "24514:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "24490:45:2"
								},
								{
									"body": {
										"id": 1838,
										"nodeType": "Block",
										"src": "24666:1623:2",
										"statements": [
											{
												"assignments": [
													1734
												],
												"declarations": [
													{
														"constant": false,
														"id": 1734,
														"name": "regionFrom",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "24680:17:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1733,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "24680:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1740,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1736,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1717,
																"src": "24710:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1737,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "fromRegionList",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 236,
															"src": "24710:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1738,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1723,
															"src": "24731:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1735,
														"name": "getData32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4095,
														"src": "24700:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1739,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "24700:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "24680:53:2"
											},
											{
												"assignments": [
													1742
												],
												"declarations": [
													{
														"constant": false,
														"id": 1742,
														"name": "regionTo",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "24747:15:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1741,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "24747:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1748,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1744,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1717,
																"src": "24775:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1745,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "toRegionList",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 238,
															"src": "24775:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1746,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1723,
															"src": "24794:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1743,
														"name": "getData32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4095,
														"src": "24765:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1747,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "24765:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "24747:49:2"
											},
											{
												"assignments": [
													1750
												],
												"declarations": [
													{
														"constant": false,
														"id": 1750,
														"name": "friendly",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "24810:13:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"typeName": {
															"id": 1749,
															"name": "bool",
															"nodeType": "ElementaryTypeName",
															"src": "24810:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1767,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1766,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1758,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1752,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "24835:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1753,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "24835:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1754,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1742,
																	"src": "24854:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1751,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "24826:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1755,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "24826:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1756,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1717,
																"src": "24867:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1757,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "24867:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "24826:56:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1765,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1760,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "24911:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1761,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "24911:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1762,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1742,
																	"src": "24930:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1759,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "24902:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1763,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "24902:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1764,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "24943:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "24902:50:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "24826:126:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "24810:142:2"
											},
											{
												"assignments": [
													1769,
													1771
												],
												"declarations": [
													{
														"constant": false,
														"id": 1769,
														"name": "remainingAttackers",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "25167:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1768,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "25167:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													},
													{
														"constant": false,
														"id": 1771,
														"name": "remainingDefenders",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "25194:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1770,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "25194:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1789,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1774,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25314:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1775,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "submitBlockList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 242,
																	"src": "25314:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1776,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1723,
																	"src": "25336:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1773,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "25304:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1777,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "25304:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1779,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25413:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1780,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "moveSoldierCountList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 240,
																	"src": "25413:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1781,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1723,
																	"src": "25440:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1778,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "25403:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1782,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "25403:39:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1783,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "25505:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1784,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 232,
																"src": "25505:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_storage",
																	"typeString": "uint32[25] storage ref"
																}
															},
															"id": 1786,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1785,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1742,
																"src": "25525:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "25505:29:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 1787,
															"name": "friendly",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1750,
															"src": "25589:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 1772,
														"name": "getOutcomeAttackOrMove",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2100,
														"src": "25223:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
															"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
														}
													},
													"id": 1788,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "25223:388:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
														"typeString": "tuple(uint32,uint32)"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "25166:445:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 1792,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1790,
														"name": "remainingDefenders",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1771,
														"src": "25630:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1791,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "25652:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "25630:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 1836,
													"nodeType": "Block",
													"src": "25949:330:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1826,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1814,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "26043:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1817,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "26043:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 1818,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1816,
																		"name": "regionFrom",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1734,
																		"src": "26063:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "26043:31:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1820,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1717,
																					"src": "26106:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1821,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "regionSoldiers",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 232,
																				"src": "26106:19:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_uint32_$25_storage",
																					"typeString": "uint32[25] storage ref"
																				}
																			},
																			"id": 1823,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 1822,
																				"name": "regionFrom",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1734,
																				"src": "26126:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "26106:31:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 1824,
																			"name": "remainingAttackers",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1769,
																			"src": "26160:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 1819,
																		"name": "addSafe",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4253,
																		"src": "26077:7:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																			"typeString": "function (uint32,uint32) pure returns (uint32)"
																		}
																	},
																	"id": 1825,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "26077:119:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "26043:153:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1827,
															"nodeType": "ExpressionStatement",
															"src": "26043:153:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1834,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1828,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "26214:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1831,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "26214:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 1832,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1830,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "26234:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "26214:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1833,
																	"name": "remainingDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1771,
																	"src": "26246:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "26214:50:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1835,
															"nodeType": "ExpressionStatement",
															"src": "26214:50:2"
														}
													]
												},
												"id": 1837,
												"nodeType": "IfStatement",
												"src": "25626:653:2",
												"trueBody": {
													"id": 1813,
													"nodeType": "Block",
													"src": "25655:276:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1799,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1793,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25774:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1796,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "25774:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 1797,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1795,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "25794:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "25774:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1798,
																	"name": "remainingAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1769,
																	"src": "25806:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "25774:50:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1800,
															"nodeType": "ExpressionStatement",
															"src": "25774:50:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1811,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1801,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25842:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1803,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "25842:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1805,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "25871:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1806,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionOwners",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 228,
																			"src": "25871:17:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 1807,
																			"name": "regionTo",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1742,
																			"src": "25890:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1808,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "25900:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1809,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "turnTeamId",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 214,
																			"src": "25900:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 1804,
																		"name": "setData8",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4203,
																		"src": "25862:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																			"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																		}
																	},
																	"id": 1810,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "25862:54:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "25842:74:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 1812,
															"nodeType": "ExpressionStatement",
															"src": "25842:74:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1729,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1726,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1723,
											"src": "24639:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1727,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1717,
												"src": "24643:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1728,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "24643:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "24639:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1839,
									"initializationExpression": {
										"assignments": [
											1723
										],
										"declarations": [
											{
												"constant": false,
												"id": 1723,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1847,
												"src": "24625:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1722,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "24625:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1725,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1724,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "24636:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "24625:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1731,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "24661:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1730,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1723,
												"src": "24661:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1732,
										"nodeType": "ExpressionStatement",
										"src": "24661:3:2"
									},
									"nodeType": "ForStatement",
									"src": "24620:1669:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1844,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1840,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1717,
												"src": "26338:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1842,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "26338:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1843,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "26357:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "26338:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 1845,
									"nodeType": "ExpressionStatement",
									"src": "26338:20:2"
								}
							]
						},
						"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game ",
						"id": 1847,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "executePendingActions",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1714,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1713,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1847,
									"src": "24437:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1712,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "24437:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "24427:30:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1715,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "24480:0:2"
						},
						"scope": 4288,
						"src": "24397:1968:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 1947,
							"nodeType": "Block",
							"src": "26601:770:2",
							"statements": [
								{
									"assignments": [
										1855
									],
									"declarations": [
										{
											"constant": false,
											"id": 1855,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26611:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1854,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "26611:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1859,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1856,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "26635:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1858,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1857,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1849,
											"src": "26649:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "26635:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "26611:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1864,
											"name": "playerOwnsRegion",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26666:41:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
												"typeString": "bool[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1862,
													"name": "bool",
													"nodeType": "ElementaryTypeName",
													"src": "26666:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 1863,
												"length": {
													"argumentTypes": null,
													"id": 1861,
													"name": "MAX_PLAYERS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 135,
													"src": "26671:11:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "26666:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bool_$8_storage_ptr",
													"typeString": "bool[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1865,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "26666:41:2"
								},
								{
									"assignments": [
										1867
									],
									"declarations": [
										{
											"constant": false,
											"id": 1867,
											"name": "hasNotOwned",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26717:16:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"typeName": {
												"id": 1866,
												"name": "bool",
												"nodeType": "ElementaryTypeName",
												"src": "26717:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1869,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "66616c7365",
										"id": 1868,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "26736:5:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "false"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "26717:24:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1871,
											"name": "i",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26751:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1870,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "26751:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1872,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "26751:8:2"
								},
								{
									"body": {
										"id": 1907,
										"nodeType": "Block",
										"src": "26813:257:2",
										"statements": [
											{
												"assignments": [
													1884
												],
												"declarations": [
													{
														"constant": false,
														"id": 1884,
														"name": "regionOwner",
														"nodeType": "VariableDeclaration",
														"scope": 1948,
														"src": "26827:18:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1883,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "26827:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1890,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1886,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1855,
																"src": "26857:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1887,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionOwners",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 228,
															"src": "26857:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1888,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1871,
															"src": "26876:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1885,
														"name": "getData8",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4158,
														"src": "26848:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1889,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "26848:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "26827:51:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 1893,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1891,
														"name": "regionOwner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1884,
														"src": "26896:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 1892,
														"name": "NOT_OWNED",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 123,
														"src": "26911:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "26896:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 1905,
													"nodeType": "Block",
													"src": "26991:69:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1903,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1899,
																		"name": "playerOwnsRegion",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1864,
																		"src": "27009:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																			"typeString": "bool[8] memory"
																		}
																	},
																	"id": 1901,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1900,
																		"name": "regionOwner",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1884,
																		"src": "27026:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "27009:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "74727565",
																	"id": 1902,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "27041:4:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "true"
																},
																"src": "27009:36:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1904,
															"nodeType": "ExpressionStatement",
															"src": "27009:36:2"
														}
													]
												},
												"id": 1906,
												"nodeType": "IfStatement",
												"src": "26892:168:2",
												"trueBody": {
													"id": 1898,
													"nodeType": "Block",
													"src": "26922:51:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1896,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1894,
																	"name": "hasNotOwned",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1867,
																	"src": "26940:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "74727565",
																	"id": 1895,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "26954:4:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "true"
																},
																"src": "26940:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1897,
															"nodeType": "ExpressionStatement",
															"src": "26940:18:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1879,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1877,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1871,
											"src": "26790:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1878,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "26794:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "26790:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1908,
									"initializationExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1875,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 1873,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "26783:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1874,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "26787:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "26783:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1876,
										"nodeType": "ExpressionStatement",
										"src": "26783:5:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1881,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "26808:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1880,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "26808:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1882,
										"nodeType": "ExpressionStatement",
										"src": "26808:3:2"
									},
									"nodeType": "ForStatement",
									"src": "26778:292:2"
								},
								{
									"assignments": [
										1910
									],
									"declarations": [
										{
											"constant": false,
											"id": 1910,
											"name": "turnTeamId",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "27080:17:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1909,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "27080:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1913,
									"initialValue": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 1911,
											"name": "game",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1855,
											"src": "27100:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData storage pointer"
											}
										},
										"id": 1912,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "turnTeamId",
										"nodeType": "MemberAccess",
										"referencedDeclaration": 214,
										"src": "27100:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "27080:35:2"
								},
								{
									"body": {
										"id": 1943,
										"nodeType": "Block",
										"src": "27164:173:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1933,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1925,
														"name": "turnTeamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1910,
														"src": "27178:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1932,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 1928,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1926,
																		"name": "turnTeamId",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1910,
																		"src": "27192:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "+",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 1927,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "27205:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"src": "27192:14:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 1929,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "27191:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "%",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1930,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1855,
																"src": "27210:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1931,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "playerCount",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 220,
															"src": "27210:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "27191:35:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "27178:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1934,
												"nodeType": "ExpressionStatement",
												"src": "27178:48:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1939,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1935,
														"name": "hasNotOwned",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1867,
														"src": "27244:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1936,
															"name": "playerOwnsRegion",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1864,
															"src": "27259:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																"typeString": "bool[8] memory"
															}
														},
														"id": 1938,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1937,
															"name": "turnTeamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1910,
															"src": "27276:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "27259:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "27244:43:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1942,
												"nodeType": "IfStatement",
												"src": "27240:87:2",
												"trueBody": {
													"id": 1941,
													"nodeType": "Block",
													"src": "27289:38:2",
													"statements": [
														{
															"id": 1940,
															"nodeType": "Break",
															"src": "27307:5:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1921,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1918,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1871,
											"src": "27137:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1919,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1855,
												"src": "27141:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1920,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "playerCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 220,
											"src": "27141:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "27137:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1944,
									"initializationExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1916,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 1914,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "27130:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1915,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "27134:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "27130:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1917,
										"nodeType": "ExpressionStatement",
										"src": "27130:5:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1923,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "27159:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1922,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "27159:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1924,
										"nodeType": "ExpressionStatement",
										"src": "27159:3:2"
									},
									"nodeType": "ForStatement",
									"src": "27125:212:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1945,
										"name": "turnTeamId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1910,
										"src": "27354:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 1853,
									"id": 1946,
									"nodeType": "Return",
									"src": "27347:17:2"
								}
							]
						},
						"documentation": "@notice Player who's turn is next. \n @param gameId Id of game\n @return Next player's turn",
						"id": 1948,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getNextTurnTeamId",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1850,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1849,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1948,
									"src": "26519:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1848,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "26519:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "26509:30:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1853,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1852,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1948,
									"src": "26588:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1851,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "26588:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "26587:8:2"
						},
						"scope": 4288,
						"src": "26483:888:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2099,
							"nodeType": "Block",
							"src": "28083:2297:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 1971,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1964,
													"name": "friendly",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1956,
													"src": "28101:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1970,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1965,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "28113:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 1966,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "28113:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1969,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1967,
															"name": "submitBlock",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1950,
															"src": "28128:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "+",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 1968,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "28142:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "28128:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "28113:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "28101:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "41747461636b73206d757374206265206174206c65617374203220626c6f636b73206f6c642e",
												"id": 1972,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "28145:40:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
													"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
												},
												"value": "Attacks must be at least 2 blocks old."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
													"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
												}
											],
											"id": 1963,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "28093:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 1973,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "28093:93:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1974,
									"nodeType": "ExpressionStatement",
									"src": "28093:93:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"id": 1975,
										"name": "friendly",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1956,
										"src": "28201:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 2097,
										"nodeType": "Block",
										"src": "28375:1999:2",
										"statements": [
											{
												"assignments": [
													1985
												],
												"declarations": [
													{
														"constant": false,
														"id": 1985,
														"name": "blockHash32",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "28719:18:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1984,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "28719:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1991,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1989,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1987,
																"name": "submitBlock",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1950,
																"src": "28756:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1988,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "28770:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "28756:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1986,
														"name": "readBlockHash32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1152,
														"src": "28740:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_view$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint32) view returns (uint32)"
														}
													},
													"id": 1990,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "28740:32:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "28719:53:2"
											},
											{
												"assignments": [
													1993
												],
												"declarations": [
													{
														"constant": false,
														"id": 1993,
														"name": "deadDefenders",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "28786:20:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1992,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "28786:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1995,
												"initialValue": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1994,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "28809:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "28786:24:2"
											},
											{
												"assignments": [
													1997
												],
												"declarations": [
													{
														"constant": false,
														"id": 1997,
														"name": "deadAttackers",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "28824:20:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1996,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "28824:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1999,
												"initialValue": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1998,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "28847:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "28824:24:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 2002,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 2000,
														"name": "blockHash32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1985,
														"src": "28955:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 2001,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "28970:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "28955:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 2059,
													"nodeType": "Block",
													"src": "29233:514:2",
													"statements": [
														{
															"assignments": [
																2018
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 2018,
																	"name": "randA",
																	"nodeType": "VariableDeclaration",
																	"scope": 2100,
																	"src": "29251:12:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 2017,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "29251:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 2024,
															"initialValue": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2022,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 2020,
																			"name": "blockHash32",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1985,
																			"src": "29273:11:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "%",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "323536",
																			"id": 2021,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "29287:3:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_256_by_1",
																				"typeString": "int_const 256"
																			},
																			"value": "256"
																		},
																		"src": "29273:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 2019,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "29266:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 2023,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "29266:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "29251:40:2"
														},
														{
															"assignments": [
																2026
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 2026,
																	"name": "randB",
																	"nodeType": "VariableDeclaration",
																	"scope": 2100,
																	"src": "29309:12:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 2025,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "29309:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 2035,
															"initialValue": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2033,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"components": [
																				{
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					"id": 2030,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"leftExpression": {
																						"argumentTypes": null,
																						"id": 2028,
																						"name": "blockHash32",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1985,
																						"src": "29332:11:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"nodeType": "BinaryOperation",
																					"operator": ">>",
																					"rightExpression": {
																						"argumentTypes": null,
																						"hexValue": "38",
																						"id": 2029,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "29347:1:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_8_by_1",
																							"typeString": "int_const 8"
																						},
																						"value": "8"
																					},
																					"src": "29332:16:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"id": 2031,
																			"isConstant": false,
																			"isInlineArray": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "TupleExpression",
																			"src": "29331:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "%",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "323536",
																			"id": 2032,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "29352:3:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_256_by_1",
																				"typeString": "int_const 256"
																			},
																			"value": "256"
																		},
																		"src": "29331:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 2027,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "29324:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 2034,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "29324:32:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "29309:47:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2043,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2036,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "29432:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2042,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 2038,
																				"name": "moveSoldierCount",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1952,
																				"src": "29456:16:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 2039,
																				"name": "randA",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 2018,
																				"src": "29474:5:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 2037,
																			"name": "mulSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4287,
																			"src": "29448:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 2040,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "29448:32:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "/",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "323536",
																		"id": 2041,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "29483:3:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_256_by_1",
																			"typeString": "int_const 256"
																		},
																		"value": "256"
																	},
																	"src": "29448:38:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29432:54:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2044,
															"nodeType": "ExpressionStatement",
															"src": "29432:54:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2057,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2045,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29606:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2056,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 2047,
																				"name": "defenderCount",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1954,
																				"src": "29630:13:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				"id": 2050,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"id": 2048,
																					"name": "DEFENDER_ADVANTAGE_NUM",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 141,
																					"src": "29645:22:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "*",
																				"rightExpression": {
																					"argumentTypes": null,
																					"id": 2049,
																					"name": "randB",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 2026,
																					"src": "29670:5:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"src": "29645:30:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 2046,
																			"name": "mulSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4287,
																			"src": "29622:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 2051,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "29622:54:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "/",
																	"rightExpression": {
																		"argumentTypes": null,
																		"components": [
																			{
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				"id": 2054,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"hexValue": "323536",
																					"id": 2052,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "29701:3:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_256_by_1",
																						"typeString": "int_const 256"
																					},
																					"value": "256"
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "*",
																				"rightExpression": {
																					"argumentTypes": null,
																					"id": 2053,
																					"name": "DEFENDER_ADVANTAGE_DENOM",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 144,
																					"src": "29707:24:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"src": "29701:30:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"id": 2055,
																		"isConstant": false,
																		"isInlineArray": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "TupleExpression",
																		"src": "29700:32:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29622:110:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29606:126:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2058,
															"nodeType": "ExpressionStatement",
															"src": "29606:126:2"
														}
													]
												},
												"id": 2060,
												"nodeType": "IfStatement",
												"src": "28951:796:2",
												"trueBody": {
													"id": 2016,
													"nodeType": "Block",
													"src": "28973:157:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 2005,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2003,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "28991:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 2004,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "29007:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																},
																"src": "28991:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2006,
															"nodeType": "ExpressionStatement",
															"src": "28991:17:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2014,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2007,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29026:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2013,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 2009,
																				"name": "defenderCount",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1954,
																				"src": "29050:13:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 2010,
																				"name": "DEFENDER_ADVANTAGE_NUM",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 141,
																				"src": "29065:22:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 2008,
																			"name": "mulSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4287,
																			"src": "29042:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 2011,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "29042:46:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "/",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2012,
																		"name": "DEFENDER_ADVANTAGE_DENOM",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 144,
																		"src": "29091:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29042:73:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29026:89:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2015,
															"nodeType": "ExpressionStatement",
															"src": "29026:89:2"
														}
													]
												}
											},
											{
												"assignments": [
													2062
												],
												"declarations": [
													{
														"constant": false,
														"id": 2062,
														"name": "remainingAttackers",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "29840:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 2061,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "29840:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 2073,
												"initialValue": {
													"argumentTypes": null,
													"condition": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2065,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2063,
																	"name": "moveSoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1952,
																	"src": "29869:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2064,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29888:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29869:32:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 2066,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "29868:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 2071,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "29959:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"id": 2072,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "Conditional",
													"src": "29868:92:2",
													"trueExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2069,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2067,
																	"name": "moveSoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1952,
																	"src": "29923:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2068,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29942:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29923:32:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2070,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "29922:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "29840:120:2"
											},
											{
												"assignments": [
													2075
												],
												"declarations": [
													{
														"constant": false,
														"id": 2075,
														"name": "remainingDefenders",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "30156:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 2074,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "30156:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 2092,
												"initialValue": {
													"argumentTypes": null,
													"condition": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2078,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2076,
																	"name": "defenderCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1954,
																	"src": "30185:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2077,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "30201:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "30185:29:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 2079,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30184:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"condition": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2086,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2084,
																		"name": "remainingAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2062,
																		"src": "30270:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": ">",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 2085,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "30291:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"src": "30270:22:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"falseExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 2088,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "30299:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"id": 2089,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "Conditional",
																"src": "30270:30:2",
																"trueExpression": {
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 2087,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "30295:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																},
																"typeDescriptions": {
																	"typeIdentifier": "t_uint8",
																	"typeString": "uint8"
																}
															}
														],
														"id": 2090,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30269:32:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"id": 2091,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "Conditional",
													"src": "30184:117:2",
													"trueExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2082,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2080,
																	"name": "defenderCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1954,
																	"src": "30236:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2081,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "30252:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "30236:29:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2083,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30235:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "30156:145:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"id": 2093,
															"name": "remainingAttackers",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2062,
															"src": "30324:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 2094,
															"name": "remainingDefenders",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2075,
															"src": "30344:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"id": 2095,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "30323:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
														"typeString": "tuple(uint32,uint32)"
													}
												},
												"functionReturnParameters": 1962,
												"id": 2096,
												"nodeType": "Return",
												"src": "30316:47:2"
											}
										]
									},
									"id": 2098,
									"nodeType": "IfStatement",
									"src": "28197:2177:2",
									"trueBody": {
										"id": 1983,
										"nodeType": "Block",
										"src": "28211:150:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 1977,
																	"name": "moveSoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1952,
																	"src": "28314:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1978,
																	"name": "defenderCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1954,
																	"src": "28332:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1976,
																"name": "addSafe",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4253,
																"src": "28306:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint32,uint32) pure returns (uint32)"
																}
															},
															"id": 1979,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "28306:40:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1980,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "28348:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"id": 1981,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "28305:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$_t_uint32_$_t_rational_0_by_1_$",
														"typeString": "tuple(uint32,int_const 0)"
													}
												},
												"functionReturnParameters": 1962,
												"id": 1982,
												"nodeType": "Return",
												"src": "28298:52:2"
											}
										]
									}
								}
							]
						},
						"documentation": "@notice Declare victory for a team.\n @param submitBlock Block number when action was submitted to queue\n @param moveSoldierCount Number of soldiers to move or attack\n @param defenderCount Number of soldiers defending destination region\n @param friendly Whether this is an attack, or friendly move\n @return remainingAttackers Number of attacking soldiers remaining \n @return remainingDefenders Number of defending soldiers remaining",
						"id": 2100,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getOutcomeAttackOrMove",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1957,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1950,
									"name": "submitBlock",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27900:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1949,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "27900:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1952,
									"name": "moveSoldierCount",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27929:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1951,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "27929:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1954,
									"name": "defenderCount",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27963:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1953,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "27963:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1956,
									"name": "friendly",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27994:13:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1955,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "27994:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "27890:123:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1962,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1959,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "28062:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1958,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "28062:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1961,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "28070:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1960,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "28070:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "28061:16:2"
						},
						"scope": 4288,
						"src": "27859:2521:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2163,
							"nodeType": "Block",
							"src": "30730:596:2",
							"statements": [
								{
									"assignments": [
										2110
									],
									"declarations": [
										{
											"constant": false,
											"id": 2110,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 2164,
											"src": "30740:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 2109,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "30740:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2114,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2111,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "30764:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 2113,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2112,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2102,
											"src": "30778:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "30764:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "30740:45:2"
								},
								{
									"assignments": [
										2116
									],
									"declarations": [
										{
											"constant": false,
											"id": 2116,
											"name": "rewardTotal",
											"nodeType": "VariableDeclaration",
											"scope": 2164,
											"src": "30862:18:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2115,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "30862:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2118,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 2117,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "30883:1:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "30862:22:2"
								},
								{
									"assignments": [
										2120
									],
									"declarations": [
										{
											"constant": false,
											"id": 2120,
											"name": "bonusScore",
											"nodeType": "VariableDeclaration",
											"scope": 2164,
											"src": "30973:17:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2119,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "30973:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2124,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 2123,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2121,
											"name": "REWARD_BONUS_MULTIPLIER_DENOM",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 147,
											"src": "30993:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "-",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 2122,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "31025:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "30993:33:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "30973:53:2"
								},
								{
									"body": {
										"id": 2153,
										"nodeType": "Block",
										"src": "31078:164:2",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 2141,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2136,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2110,
																	"src": "31105:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 2137,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "31105:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 2138,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2126,
																"src": "31124:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 2135,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "31096:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 2139,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "31096:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 2140,
														"name": "teamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2104,
														"src": "31130:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "31096:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 2152,
												"nodeType": "IfStatement",
												"src": "31092:140:2",
												"trueBody": {
													"id": 2151,
													"nodeType": "Block",
													"src": "31138:94:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 2146,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2142,
																	"name": "rewardTotal",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2116,
																	"src": "31156:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "+=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 2143,
																		"name": "regionRewards",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 183,
																		"src": "31171:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 2145,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 2144,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2126,
																		"src": "31185:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "31171:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "31156:31:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2147,
															"nodeType": "ExpressionStatement",
															"src": "31156:31:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2149,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "UnaryOperation",
																"operator": "++",
																"prefix": false,
																"src": "31205:12:2",
																"subExpression": {
																	"argumentTypes": null,
																	"id": 2148,
																	"name": "bonusScore",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2120,
																	"src": "31205:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2150,
															"nodeType": "ExpressionStatement",
															"src": "31205:12:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 2131,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2129,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2126,
											"src": "31055:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 2130,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "31059:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "31055:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 2154,
									"initializationExpression": {
										"assignments": [
											2126
										],
										"declarations": [
											{
												"constant": false,
												"id": 2126,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "31041:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2125,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31041:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2128,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2127,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "31052:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31041:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 2133,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "31073:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 2132,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2126,
												"src": "31073:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2134,
										"nodeType": "ExpressionStatement",
										"src": "31073:3:2"
									},
									"nodeType": "ForStatement",
									"src": "31036:206:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 2160,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 2157,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 2155,
																"name": "rewardTotal",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2116,
																"src": "31261:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "*",
															"rightExpression": {
																"argumentTypes": null,
																"id": 2156,
																"name": "bonusScore",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2120,
																"src": "31275:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "31261:24:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"id": 2158,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "31260:26:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "/",
												"rightExpression": {
													"argumentTypes": null,
													"id": 2159,
													"name": "REWARD_BONUS_MULTIPLIER_DENOM",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 147,
													"src": "31289:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "31260:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"id": 2161,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "31259:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 2108,
									"id": 2162,
									"nodeType": "Return",
									"src": "31252:67:2"
								}
							]
						},
						"documentation": "@notice Calculate a team's reward amount based on what regions they control.\n @param gameId Id of game\n @param teamId Team you'd like to calculate rewards for\n @return Reward amount for team",
						"id": 2164,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "calculateRegionRewards",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2105,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2102,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 2164,
									"src": "30638:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 2101,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "30638:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2104,
									"name": "teamId",
									"nodeType": "VariableDeclaration",
									"scope": 2164,
									"src": "30654:13:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 2103,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "30654:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "30637:31:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 2108,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2107,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2164,
									"src": "30717:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 2106,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "30717:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "30716:8:2"
						},
						"scope": 4288,
						"src": "30606:720:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2209,
							"nodeType": "Block",
							"src": "31494:612:2",
							"statements": [
								{
									"assignments": [
										2170
									],
									"declarations": [
										{
											"constant": false,
											"id": 2170,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31504:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 2169,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "31504:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2174,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2171,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "31528:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 2173,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2172,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2166,
											"src": "31542:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "31528:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31504:45:2"
								},
								{
									"assignments": [
										2176
									],
									"declarations": [
										{
											"constant": false,
											"id": 2176,
											"name": "teamId",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31618:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2175,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "31618:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2179,
									"initialValue": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 2177,
											"name": "game",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2170,
											"src": "31634:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData storage pointer"
											}
										},
										"id": 2178,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "turnTeamId",
										"nodeType": "MemberAccess",
										"referencedDeclaration": 214,
										"src": "31634:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31618:31:2"
								},
								{
									"assignments": [
										2181
									],
									"declarations": [
										{
											"constant": false,
											"id": 2181,
											"name": "rewardAmount",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31726:19:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2180,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "31726:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2186,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2183,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2166,
												"src": "31771:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"id": 2184,
												"name": "teamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2176,
												"src": "31779:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 2182,
											"name": "calculateRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2164,
											"src": "31748:22:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
												"typeString": "function (uint256,uint32) view returns (uint32)"
											}
										},
										"id": 2185,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "31748:38:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31726:60:2"
								},
								{
									"assignments": [
										2188
									],
									"declarations": [
										{
											"constant": false,
											"id": 2188,
											"name": "undeployedSoldierCount",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31852:29:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2187,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "31852:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2194,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2190,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2170,
													"src": "31894:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 2191,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "undeployedSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 226,
												"src": "31894:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"id": 2192,
												"name": "teamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2176,
												"src": "31919:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 2189,
											"name": "getData32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4095,
											"src": "31884:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
												"typeString": "function (uint256,uint32) pure returns (uint32)"
											}
										},
										"id": 2193,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "31884:42:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31852:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2207,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2195,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2170,
												"src": "31936:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 2197,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "undeployedSoldiers",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 226,
											"src": "31936:23:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2199,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2170,
														"src": "31985:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 2200,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "undeployedSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 226,
													"src": "31985:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 2201,
													"name": "teamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2176,
													"src": "32023:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2203,
															"name": "undeployedSoldierCount",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2188,
															"src": "32052:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 2204,
															"name": "rewardAmount",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2181,
															"src": "32076:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 2202,
														"name": "addSafe",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4253,
														"src": "32044:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint32,uint32) pure returns (uint32)"
														}
													},
													"id": 2205,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32044:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 2198,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "31962:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 2206,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "31962:137:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "31936:163:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 2208,
									"nodeType": "ExpressionStatement",
									"src": "31936:163:2"
								}
							]
						},
						"documentation": "@notice Reward team with soldiers based on what regions they control.\n @param gameId Id of game",
						"id": 2210,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "giveRegionRewards",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2167,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2166,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 2210,
									"src": "31470:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 2165,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "31470:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "31469:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 2168,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "31494:0:2"
						},
						"scope": 4288,
						"src": "31443:663:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 3840,
							"nodeType": "Block",
							"src": "32273:10521:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2225,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2213,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32283:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2219,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2215,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32306:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2216,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32306:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2214,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32299:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2217,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32299:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32283:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2220,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2218,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32323:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32283:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2222,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32335:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2223,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32335:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2221,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32328:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2224,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32328:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32283:72:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2226,
									"nodeType": "ExpressionStatement",
									"src": "32283:72:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2239,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2227,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32365:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2233,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2229,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32388:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2230,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32388:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2228,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32381:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2231,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32381:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32365:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2234,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2232,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32405:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32365:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2236,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32417:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2237,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32417:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2235,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32410:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2238,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32410:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32365:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2240,
									"nodeType": "ExpressionStatement",
									"src": "32365:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2241,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32440:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2247,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2243,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32463:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2244,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32463:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2242,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32456:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2245,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32456:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32440:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2248,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2246,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32480:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32440:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2249,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32485:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32440:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2251,
									"nodeType": "ExpressionStatement",
									"src": "32440:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2261,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2252,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32504:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2258,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2254,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32527:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2255,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32527:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2253,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32520:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2256,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32520:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32504:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2259,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2257,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32544:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32504:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2260,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32549:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32504:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2262,
									"nodeType": "ExpressionStatement",
									"src": "32504:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2272,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2263,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32568:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2269,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2265,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32591:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2266,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32591:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2264,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32584:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2267,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32584:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32568:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2270,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2268,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32608:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32568:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2271,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32613:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32568:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2273,
									"nodeType": "ExpressionStatement",
									"src": "32568:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2286,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2274,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32633:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2280,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2276,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32656:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2277,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32656:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2275,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32649:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2278,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32649:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32633:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2281,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2279,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32681:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32633:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2283,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32693:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2284,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32693:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2282,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32686:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2285,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32686:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32633:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2287,
									"nodeType": "ExpressionStatement",
									"src": "32633:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2300,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2288,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32723:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2294,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2290,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32746:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2291,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32746:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2289,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32739:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2292,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32739:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32723:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2295,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2293,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32771:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32723:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2297,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32783:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2298,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32783:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2296,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32776:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2299,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32776:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32723:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2301,
									"nodeType": "ExpressionStatement",
									"src": "32723:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2314,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2302,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32816:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2308,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2304,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32839:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2305,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32839:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2303,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32832:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2306,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32832:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32816:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2309,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2307,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32864:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32816:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2311,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32876:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2312,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32876:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2310,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32869:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2313,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32869:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32816:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2315,
									"nodeType": "ExpressionStatement",
									"src": "32816:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2325,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2316,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32909:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2322,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2318,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32932:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2319,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32932:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2317,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32925:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2320,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32925:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32909:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2323,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2321,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32957:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32909:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2324,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32962:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32909:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2326,
									"nodeType": "ExpressionStatement",
									"src": "32909:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2336,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2327,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32981:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2333,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2329,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33004:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2330,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33004:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2328,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32997:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2331,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32997:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32981:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2334,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2332,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33029:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32981:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2335,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33034:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32981:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2337,
									"nodeType": "ExpressionStatement",
									"src": "32981:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2350,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2338,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33054:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2344,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2340,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33077:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2341,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33077:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2339,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33070:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2342,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33070:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33054:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2345,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2343,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33102:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33054:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2347,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33114:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2348,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33114:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2346,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33107:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2349,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33107:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33054:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2351,
									"nodeType": "ExpressionStatement",
									"src": "33054:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2364,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2352,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33147:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2358,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2354,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33170:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2355,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33170:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2353,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33163:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2356,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33163:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33147:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2359,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2357,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33195:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33147:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2361,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33207:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2362,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "GREENLAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33207:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2360,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33200:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2363,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33200:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33147:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2365,
									"nodeType": "ExpressionStatement",
									"src": "33147:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2378,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2366,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33235:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2372,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2368,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33258:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2369,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33258:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2367,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33251:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2370,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33251:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33235:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2373,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2371,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33283:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33235:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2375,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33295:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2376,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33295:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2374,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33288:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2377,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33288:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33235:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2379,
									"nodeType": "ExpressionStatement",
									"src": "33235:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2389,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2380,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33325:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2386,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2382,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33348:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2383,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33348:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2381,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33341:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2384,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33341:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33325:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2387,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2385,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33373:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33325:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2388,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33378:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33325:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2390,
									"nodeType": "ExpressionStatement",
									"src": "33325:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2400,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2391,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33397:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2397,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2393,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33420:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2394,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33420:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2392,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33413:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2395,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33413:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33397:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2398,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2396,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33445:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33397:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2399,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33450:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33397:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2401,
									"nodeType": "ExpressionStatement",
									"src": "33397:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2414,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2402,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33470:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2408,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2404,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33493:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2405,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33493:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2403,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33486:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2406,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33486:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33470:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2409,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2407,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33515:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33470:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2411,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33527:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2412,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "HAWAII",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33527:14:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2410,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33520:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2413,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33520:22:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33470:72:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2415,
									"nodeType": "ExpressionStatement",
									"src": "33470:72:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2428,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2416,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33552:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2422,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2418,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33575:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2419,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33575:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2417,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33568:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2420,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33568:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33552:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2423,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2421,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33597:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33552:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2425,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33609:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2426,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33609:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2424,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33602:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2427,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33602:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33552:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2429,
									"nodeType": "ExpressionStatement",
									"src": "33552:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2442,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2430,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33642:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2436,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2432,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33665:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2433,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33665:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2431,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33658:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2434,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33658:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33642:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2437,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2435,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33687:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33642:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2439,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33699:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2440,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33699:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2438,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33692:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2441,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33692:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33642:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2443,
									"nodeType": "ExpressionStatement",
									"src": "33642:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2456,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2444,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33729:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2450,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2446,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33752:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2447,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33752:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2445,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33745:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2448,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33745:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33729:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2451,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2449,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33774:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33729:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2453,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33786:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2454,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NORTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33786:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2452,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33779:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2455,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33779:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33729:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2457,
									"nodeType": "ExpressionStatement",
									"src": "33729:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2467,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2458,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33827:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2464,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2460,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33850:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2461,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33850:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2459,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33843:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2462,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33843:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33827:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2465,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2463,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33872:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33827:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2466,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33877:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33827:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2468,
									"nodeType": "ExpressionStatement",
									"src": "33827:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2481,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2469,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33897:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2475,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2471,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33920:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2472,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33920:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2470,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33913:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2473,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33913:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33897:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2476,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2474,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33942:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33897:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2478,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33954:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2479,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33954:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2477,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33947:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2480,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33947:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33897:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2482,
									"nodeType": "ExpressionStatement",
									"src": "33897:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2495,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2483,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33984:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2489,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2485,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34007:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2486,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34007:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2484,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34000:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2487,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34000:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33984:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2490,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2488,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34029:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33984:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2492,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34041:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2493,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34041:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2491,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34034:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2494,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34034:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33984:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2496,
									"nodeType": "ExpressionStatement",
									"src": "33984:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2509,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2497,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34074:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2503,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2499,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34097:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2500,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34097:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2498,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34090:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2501,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34090:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34074:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2504,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2502,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34119:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34074:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2506,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34131:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2507,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NORTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34131:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2505,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34124:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2508,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34124:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34074:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2510,
									"nodeType": "ExpressionStatement",
									"src": "34074:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2520,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2511,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34172:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2517,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2513,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34195:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2514,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34195:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2512,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34188:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2515,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34188:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34172:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2518,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2516,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34217:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34172:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2519,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34222:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34172:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2521,
									"nodeType": "ExpressionStatement",
									"src": "34172:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2531,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2522,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34241:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2528,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2524,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34264:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2525,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34264:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2523,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34257:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2526,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34257:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34241:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2529,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2527,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34286:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34241:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2530,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34291:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34241:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2532,
									"nodeType": "ExpressionStatement",
									"src": "34241:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2545,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2533,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34311:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2539,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2535,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34334:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2536,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34334:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2534,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34327:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2537,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34327:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34311:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2540,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2538,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34354:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34311:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2542,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34366:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2543,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34366:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2541,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34359:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2544,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34359:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34311:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2546,
									"nodeType": "ExpressionStatement",
									"src": "34311:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2559,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2547,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34399:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2553,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2549,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34422:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2550,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34422:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2548,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34415:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2551,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34415:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34399:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2554,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2552,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34442:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34399:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2556,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34454:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2557,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34454:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2555,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34447:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2558,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34447:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34399:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2560,
									"nodeType": "ExpressionStatement",
									"src": "34399:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2570,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2561,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34487:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2567,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2563,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34510:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2564,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34510:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2562,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34503:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2565,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34503:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34487:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2568,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2566,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34530:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34487:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2569,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34535:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34487:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2571,
									"nodeType": "ExpressionStatement",
									"src": "34487:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2581,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2572,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34554:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2578,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2574,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34577:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2575,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34577:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2573,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34570:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2576,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34570:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34554:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2579,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2577,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34597:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34554:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2580,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34602:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34554:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2582,
									"nodeType": "ExpressionStatement",
									"src": "34554:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2592,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2583,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34621:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2589,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2585,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34644:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2586,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34644:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2584,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34637:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2587,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34637:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34621:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2590,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2588,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34664:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34621:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2591,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34669:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34621:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2593,
									"nodeType": "ExpressionStatement",
									"src": "34621:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2606,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2594,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34689:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2600,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2596,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34712:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2597,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34712:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2595,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34705:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2598,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34705:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34689:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2601,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2599,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34745:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34689:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2603,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34757:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2604,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34757:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2602,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34750:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2605,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34750:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34689:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2607,
									"nodeType": "ExpressionStatement",
									"src": "34689:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2620,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2608,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34787:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2614,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2610,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34810:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2611,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34810:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2609,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34803:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2612,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34803:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34787:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2615,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2613,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34843:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34787:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2617,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34855:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2618,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34855:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2616,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34848:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2619,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34848:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34787:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2621,
									"nodeType": "ExpressionStatement",
									"src": "34787:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2634,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2622,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34885:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2628,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2624,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34908:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2625,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34908:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2623,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34901:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2626,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34901:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34885:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2629,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2627,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34941:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34885:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2631,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34953:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2632,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34953:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2630,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34946:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2633,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34946:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34885:99:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2635,
									"nodeType": "ExpressionStatement",
									"src": "34885:99:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2645,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2636,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34994:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2642,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2638,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35017:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2639,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35017:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2637,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35010:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2640,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35010:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34994:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2643,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2641,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35050:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34994:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2644,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35055:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34994:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2646,
									"nodeType": "ExpressionStatement",
									"src": "34994:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2656,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2647,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35074:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2653,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2649,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35097:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2650,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35097:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2648,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35090:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2651,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35090:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35074:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2654,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2652,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35130:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35074:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2655,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35135:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35074:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2657,
									"nodeType": "ExpressionStatement",
									"src": "35074:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2670,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2658,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35155:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2664,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2660,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35178:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2661,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35178:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2659,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35171:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2662,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35171:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35155:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2665,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2663,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35211:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35155:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2667,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35223:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2668,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NORTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35223:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2666,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35216:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2669,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35216:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35155:99:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2671,
									"nodeType": "ExpressionStatement",
									"src": "35155:99:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2684,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2672,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35264:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2678,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2674,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35287:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2675,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35287:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2673,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35280:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2676,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35280:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35264:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2679,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2677,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35320:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35264:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2681,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35332:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2682,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35332:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2680,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35325:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2683,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35325:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35264:92:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2685,
									"nodeType": "ExpressionStatement",
									"src": "35264:92:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2695,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2686,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35366:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2692,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2688,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35389:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2689,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35389:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2687,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35382:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2690,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35382:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35366:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2693,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2691,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35422:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35366:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2694,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35427:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35366:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2696,
									"nodeType": "ExpressionStatement",
									"src": "35366:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2706,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2697,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35446:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2703,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2699,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35469:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2700,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35469:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2698,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35462:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2701,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35462:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35446:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2704,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2702,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35502:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35446:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2705,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35507:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35446:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2707,
									"nodeType": "ExpressionStatement",
									"src": "35446:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2717,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2708,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35526:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2714,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2710,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35549:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2711,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35549:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2709,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35542:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2712,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35542:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35526:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2715,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2713,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35582:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35526:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2716,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35587:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35526:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2718,
									"nodeType": "ExpressionStatement",
									"src": "35526:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2731,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2719,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35607:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2725,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2721,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35630:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2722,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35630:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2720,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35623:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2723,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35623:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35607:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2726,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2724,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35656:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35607:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2728,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35668:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2729,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35668:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2727,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35661:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2730,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35661:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35607:92:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2732,
									"nodeType": "ExpressionStatement",
									"src": "35607:92:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2745,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2733,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35709:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2739,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2735,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35732:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2736,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35732:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2734,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35725:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2737,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35725:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35709:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2740,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2738,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35758:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35709:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2742,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35770:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2743,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35770:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2741,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35763:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2744,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35763:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35709:85:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2746,
									"nodeType": "ExpressionStatement",
									"src": "35709:85:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2756,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2747,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35804:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2753,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2749,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35827:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2750,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35827:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2748,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35820:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2751,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35820:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35804:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2754,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2752,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35853:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35804:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2755,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35858:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35804:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2757,
									"nodeType": "ExpressionStatement",
									"src": "35804:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2767,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2758,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35877:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2764,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2760,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35900:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2761,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35900:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2759,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35893:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2762,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35893:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35877:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2765,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2763,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35926:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35877:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2766,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35931:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35877:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2768,
									"nodeType": "ExpressionStatement",
									"src": "35877:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2778,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2769,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35950:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2775,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2771,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35973:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2772,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35973:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2770,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35966:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2773,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35966:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35950:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2776,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2774,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35999:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35950:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2777,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36004:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35950:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2779,
									"nodeType": "ExpressionStatement",
									"src": "35950:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2792,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2780,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36024:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2786,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2782,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36047:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2783,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36047:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2781,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36040:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2784,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36040:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36024:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2787,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2785,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36073:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36024:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2789,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36085:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2790,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36085:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2788,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36078:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2791,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36078:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36024:85:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2793,
									"nodeType": "ExpressionStatement",
									"src": "36024:85:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2806,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2794,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36119:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2800,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2796,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36142:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2797,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36142:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2795,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36135:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2798,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36135:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36119:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2801,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2799,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36168:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36119:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2803,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36180:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2804,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NEW_ZEALAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36180:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2802,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36173:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2805,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36173:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36119:81:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2807,
									"nodeType": "ExpressionStatement",
									"src": "36119:81:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2817,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2808,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36210:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2814,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2810,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36233:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2811,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36233:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2809,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36226:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2812,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36226:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36210:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2815,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2813,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36259:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36210:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2816,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36264:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36210:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2818,
									"nodeType": "ExpressionStatement",
									"src": "36210:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2828,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2819,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36283:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2825,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2821,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36306:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2822,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36306:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2820,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36299:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2823,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36299:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36283:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2826,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2824,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36332:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36283:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2827,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36337:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36283:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2829,
									"nodeType": "ExpressionStatement",
									"src": "36283:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2839,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2830,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36356:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2836,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2832,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36379:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2833,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36379:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2831,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36372:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2834,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36372:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36356:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2837,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2835,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36405:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36356:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2838,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36410:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36356:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2840,
									"nodeType": "ExpressionStatement",
									"src": "36356:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2853,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2841,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36430:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2847,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2843,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36453:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2844,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36453:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2842,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36446:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2845,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36446:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36430:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2848,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2846,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36478:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36430:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2850,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36490:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2851,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "GREENLAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36490:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2849,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36483:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2852,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36483:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36430:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2854,
									"nodeType": "ExpressionStatement",
									"src": "36430:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2867,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2855,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36518:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2861,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2857,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36541:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2858,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36541:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2856,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36534:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2859,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36534:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36518:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2862,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2860,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36566:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36518:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2864,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36578:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2865,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36578:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2863,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36571:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2866,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36571:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36518:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2868,
									"nodeType": "ExpressionStatement",
									"src": "36518:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2881,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2869,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36611:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2875,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2871,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36634:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2872,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36634:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2870,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36627:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2873,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36627:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36611:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2876,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2874,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36659:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36611:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2878,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36671:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2879,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36671:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2877,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36664:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2880,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36664:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36611:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2882,
									"nodeType": "ExpressionStatement",
									"src": "36611:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2892,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2883,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36701:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2889,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2885,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36724:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2886,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36724:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2884,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36717:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2887,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36717:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36701:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2890,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2888,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36749:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36701:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2891,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36754:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36701:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2893,
									"nodeType": "ExpressionStatement",
									"src": "36701:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2903,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2894,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36773:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2900,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2896,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36796:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2897,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36796:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2895,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36789:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2898,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36789:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36773:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2901,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2899,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36821:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36773:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2902,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36826:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36773:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2904,
									"nodeType": "ExpressionStatement",
									"src": "36773:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2917,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2905,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36846:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2911,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2907,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36869:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2908,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36869:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2906,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36862:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2909,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36862:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36846:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2912,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2910,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36894:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36846:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2914,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36906:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2915,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36906:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2913,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36899:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2916,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36899:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36846:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2918,
									"nodeType": "ExpressionStatement",
									"src": "36846:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2931,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2919,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36939:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2925,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2921,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36962:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2922,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36962:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2920,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36955:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2923,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36955:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36939:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2926,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2924,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36987:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36939:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2928,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36999:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2929,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36999:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2927,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36992:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2930,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36992:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36939:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2932,
									"nodeType": "ExpressionStatement",
									"src": "36939:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2945,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2933,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37029:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2939,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2935,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37052:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2936,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37052:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2934,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37045:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2937,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37045:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37029:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2940,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2938,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37077:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37029:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2942,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37089:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2943,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37089:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2941,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37082:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2944,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37082:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37029:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2946,
									"nodeType": "ExpressionStatement",
									"src": "37029:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2959,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2947,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37119:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2953,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2949,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37142:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2950,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37142:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2948,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37135:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2951,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37135:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37119:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2954,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2952,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37167:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37119:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2956,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37179:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2957,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37179:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2955,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37172:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2958,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37172:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37119:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2960,
									"nodeType": "ExpressionStatement",
									"src": "37119:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2970,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2961,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37212:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2967,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2963,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37235:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2964,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37235:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2962,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37228:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2965,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37228:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37212:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2968,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2966,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37260:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37212:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2969,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "37265:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37212:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2971,
									"nodeType": "ExpressionStatement",
									"src": "37212:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2984,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2972,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37285:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2978,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2974,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37308:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2975,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37308:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2973,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37301:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2976,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37301:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37285:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2979,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2977,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37333:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37285:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2981,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37345:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2982,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37345:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2980,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37338:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2983,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37338:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37285:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2985,
									"nodeType": "ExpressionStatement",
									"src": "37285:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2998,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2986,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37378:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2992,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2988,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37401:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2989,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37401:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2987,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37394:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2990,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37394:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37378:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2993,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2991,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37426:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37378:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2995,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37438:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2996,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37438:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2994,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37431:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2997,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37431:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37378:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2999,
									"nodeType": "ExpressionStatement",
									"src": "37378:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3012,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3000,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37468:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3006,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3002,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37491:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3003,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37491:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3001,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37484:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3004,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37484:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37468:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3007,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3005,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37516:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37468:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3009,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37528:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3010,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37528:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3008,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37521:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3011,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37521:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37468:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3013,
									"nodeType": "ExpressionStatement",
									"src": "37468:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3026,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3014,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37552:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3020,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3016,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37575:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3017,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37575:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3015,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37568:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3018,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37568:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37552:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3021,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3019,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37600:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37552:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3023,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37612:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3024,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37612:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3022,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37605:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3025,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37605:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37552:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3027,
									"nodeType": "ExpressionStatement",
									"src": "37552:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3040,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3028,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37644:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3034,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3030,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37667:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3031,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37667:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3029,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37660:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3032,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37660:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37644:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3035,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3033,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37692:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37644:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3037,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37704:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3038,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37704:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3036,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37697:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3039,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37697:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37644:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3041,
									"nodeType": "ExpressionStatement",
									"src": "37644:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3054,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3042,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37738:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3048,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3044,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37761:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3045,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37761:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3043,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37754:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3046,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37754:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37738:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3049,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3047,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37786:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37738:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3051,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37798:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3052,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37798:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3050,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37791:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3053,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37791:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37738:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3055,
									"nodeType": "ExpressionStatement",
									"src": "37738:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3068,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3056,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37830:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3062,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3058,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37853:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3059,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37853:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3057,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37846:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3060,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37846:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37830:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3063,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3061,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37878:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37830:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3065,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37890:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3066,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37890:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3064,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37883:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3067,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37883:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37830:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3069,
									"nodeType": "ExpressionStatement",
									"src": "37830:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3082,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3070,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37923:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3076,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3072,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37946:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3073,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37946:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3071,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37939:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3074,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37939:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37923:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3077,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3075,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37971:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37923:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3079,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37983:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3080,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37983:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3078,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37976:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3081,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37976:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37923:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3083,
									"nodeType": "ExpressionStatement",
									"src": "37923:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3093,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3084,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38016:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3090,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3086,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38039:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3087,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38039:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3085,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38032:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3088,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38032:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38016:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3091,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3089,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38064:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38016:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3092,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "38069:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38016:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3094,
									"nodeType": "ExpressionStatement",
									"src": "38016:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3104,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3095,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38088:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3101,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3097,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38111:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3098,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38111:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3096,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38104:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3099,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38104:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38088:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3102,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3100,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38136:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38088:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3103,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "38141:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38088:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3105,
									"nodeType": "ExpressionStatement",
									"src": "38088:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3118,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3106,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38161:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3112,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3108,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38184:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3109,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38184:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3107,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38177:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3110,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38177:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38161:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3113,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3111,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38206:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38161:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3115,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38218:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3116,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38218:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3114,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38211:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3117,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38211:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38161:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3119,
									"nodeType": "ExpressionStatement",
									"src": "38161:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3132,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3120,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38251:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3126,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3122,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38274:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3123,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38274:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3121,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38267:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3124,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38267:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38251:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3127,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3125,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38296:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38251:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3129,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38308:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3130,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38308:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3128,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38301:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3131,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38301:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38251:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3133,
									"nodeType": "ExpressionStatement",
									"src": "38251:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3134,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38341:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3140,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3136,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38364:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3137,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38364:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3135,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38357:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3138,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38357:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38341:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3141,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3139,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38386:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38341:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3143,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38398:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3144,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38398:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3142,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38391:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3145,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38391:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38341:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3147,
									"nodeType": "ExpressionStatement",
									"src": "38341:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3160,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3148,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38428:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3154,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3150,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38451:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3151,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38451:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3149,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38444:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3152,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38444:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38428:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3155,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3153,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38473:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38428:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3157,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38485:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3158,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38485:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3156,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38478:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3159,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38478:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38428:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3161,
									"nodeType": "ExpressionStatement",
									"src": "38428:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3174,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3162,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38515:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3168,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3164,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38538:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3165,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38538:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3163,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38531:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3166,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38531:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38515:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3169,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3167,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38560:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38515:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3171,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38572:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3172,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTH_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38572:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3170,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38565:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3173,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38565:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38515:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3175,
									"nodeType": "ExpressionStatement",
									"src": "38515:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3188,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3176,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38604:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3182,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3178,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38627:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3179,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38627:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3177,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38620:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3180,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38620:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38604:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3183,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3181,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38649:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38604:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3185,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38661:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3186,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38661:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3184,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38654:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3187,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38654:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38604:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3189,
									"nodeType": "ExpressionStatement",
									"src": "38604:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3202,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3190,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38694:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3196,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3192,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38717:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3193,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38717:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3191,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38710:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3194,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38710:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38694:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3197,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3195,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38739:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38694:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3199,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38751:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3200,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38751:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3198,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38744:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3201,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38744:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38694:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3203,
									"nodeType": "ExpressionStatement",
									"src": "38694:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3216,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3204,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38784:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3210,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3206,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38807:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3207,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38807:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3205,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38800:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3208,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38800:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38784:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3211,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3209,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38829:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38784:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3213,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38841:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3214,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38841:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3212,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38834:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3215,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38834:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38784:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3217,
									"nodeType": "ExpressionStatement",
									"src": "38784:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3230,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3218,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38865:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3224,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3220,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38888:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3221,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38888:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3219,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38881:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3222,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38881:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38865:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3225,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3223,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38910:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38865:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3227,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38922:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3228,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38922:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3226,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38915:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3229,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38915:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38865:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3231,
									"nodeType": "ExpressionStatement",
									"src": "38865:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3244,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3232,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38952:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3238,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3234,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38975:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3235,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38975:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3233,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38968:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3236,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38968:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38952:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3239,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3237,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38997:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38952:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3241,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39009:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3242,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39009:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3240,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39002:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3243,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39002:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38952:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3245,
									"nodeType": "ExpressionStatement",
									"src": "38952:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3258,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3246,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39040:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3252,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3248,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39063:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3249,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39063:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3247,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39056:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3250,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39056:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39040:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3253,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3251,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39085:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39040:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3255,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39097:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3256,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39097:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3254,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39090:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3257,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39090:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39040:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3259,
									"nodeType": "ExpressionStatement",
									"src": "39040:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3272,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3260,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39127:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3266,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3262,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39150:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3263,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39150:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3261,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39143:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3264,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39143:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39127:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3267,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3265,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39172:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39127:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3269,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39184:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3270,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTH_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39184:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3268,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39177:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3271,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39177:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39127:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3273,
									"nodeType": "ExpressionStatement",
									"src": "39127:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3286,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3274,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39215:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3280,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3276,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39238:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3277,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39238:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3275,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39231:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3278,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39231:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39215:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3281,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3279,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39260:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39215:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3283,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39272:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3284,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39272:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3282,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39265:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3285,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39265:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39215:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3287,
									"nodeType": "ExpressionStatement",
									"src": "39215:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3300,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3288,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39302:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3294,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3290,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39325:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3291,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39325:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3289,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39318:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3292,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39318:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39302:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3295,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3293,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39347:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39302:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3297,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39359:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3298,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39359:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3296,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39352:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3299,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39352:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39302:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3301,
									"nodeType": "ExpressionStatement",
									"src": "39302:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3311,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3302,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39383:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3308,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3304,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39406:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3305,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39406:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3303,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39399:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3306,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39399:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39383:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3309,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3307,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39428:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39383:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3310,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39433:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39383:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3312,
									"nodeType": "ExpressionStatement",
									"src": "39383:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3325,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3313,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39453:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3319,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3315,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39476:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3316,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39476:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3314,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39469:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3317,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39469:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39453:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3320,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3318,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39499:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39453:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3322,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39511:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3323,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39511:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3321,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39504:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3324,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39504:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39453:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3326,
									"nodeType": "ExpressionStatement",
									"src": "39453:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3339,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3327,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39541:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3333,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3329,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39564:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3330,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39564:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3328,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39557:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3331,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39557:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39541:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3334,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3332,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39587:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39541:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3336,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39599:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3337,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39599:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3335,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39592:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3338,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39592:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39541:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3340,
									"nodeType": "ExpressionStatement",
									"src": "39541:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3350,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3341,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39629:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3347,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3343,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39652:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3344,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39652:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3342,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39645:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3345,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39645:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39629:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3348,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3346,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39675:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39629:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3349,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39680:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39629:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3351,
									"nodeType": "ExpressionStatement",
									"src": "39629:60:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3361,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3352,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39699:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3358,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3354,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39722:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3355,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39722:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3353,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39715:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3356,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39715:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39699:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3359,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3357,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39745:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39699:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3360,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39750:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39699:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3362,
									"nodeType": "ExpressionStatement",
									"src": "39699:60:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3372,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3363,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39769:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3369,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3365,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39792:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3366,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39792:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3364,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39785:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3367,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39785:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39769:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3370,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3368,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39815:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39769:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3371,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39820:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39769:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3373,
									"nodeType": "ExpressionStatement",
									"src": "39769:60:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3386,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3374,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39840:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3380,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3376,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39863:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3377,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39863:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3375,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39856:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3378,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39856:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39840:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3381,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3379,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39879:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39840:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3383,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39891:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3384,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39891:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3382,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39884:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3385,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39884:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39840:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3387,
									"nodeType": "ExpressionStatement",
									"src": "39840:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3400,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3388,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39921:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3394,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3390,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39944:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3391,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39944:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3389,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39937:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3392,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39937:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39921:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3395,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3393,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39960:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39921:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3397,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39972:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3398,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39972:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3396,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39965:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3399,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39965:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39921:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3401,
									"nodeType": "ExpressionStatement",
									"src": "39921:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3414,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3402,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40002:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3408,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3404,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40025:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3405,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40025:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3403,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40018:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3406,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40018:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40002:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3409,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3407,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40041:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40002:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3411,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40053:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3412,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40053:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3410,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40046:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3413,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40046:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40002:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3415,
									"nodeType": "ExpressionStatement",
									"src": "40002:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3428,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3416,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40086:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3422,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3418,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40109:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3419,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40109:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3417,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40102:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3420,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40102:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40086:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3423,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3421,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40125:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40086:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3425,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40137:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3426,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40137:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3424,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40130:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3427,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40130:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40086:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3429,
									"nodeType": "ExpressionStatement",
									"src": "40086:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3442,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3430,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40169:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3436,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3432,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40192:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3433,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40192:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3431,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40185:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3434,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40185:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40169:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3437,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3435,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40208:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40169:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3439,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40220:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3440,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40220:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3438,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40213:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3441,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40213:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40169:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3443,
									"nodeType": "ExpressionStatement",
									"src": "40169:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3456,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3444,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40254:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3450,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3446,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40277:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3447,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40277:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3445,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40270:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3448,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40270:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40254:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3451,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3449,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40301:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40254:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3453,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40313:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3454,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40313:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3452,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40306:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3455,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40306:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40254:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3457,
									"nodeType": "ExpressionStatement",
									"src": "40254:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3470,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3458,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40337:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3464,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3460,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40360:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3461,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40360:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3459,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40353:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3462,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40353:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40337:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3465,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3463,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40384:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40337:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3467,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40396:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3468,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40396:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3466,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40389:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3469,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40389:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40337:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3471,
									"nodeType": "ExpressionStatement",
									"src": "40337:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3484,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3472,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40429:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3478,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3474,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40452:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3475,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40452:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3473,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40445:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3476,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40445:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40429:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3479,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3477,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40476:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40429:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3481,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40488:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3482,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40488:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3480,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40481:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3483,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40481:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40429:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3485,
									"nodeType": "ExpressionStatement",
									"src": "40429:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3498,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3486,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40521:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3492,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3488,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40544:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3489,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40544:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3487,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40537:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3490,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40537:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40521:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3493,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3491,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40568:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40521:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3495,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40580:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3496,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40580:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3494,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40573:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3497,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40573:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40521:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3499,
									"nodeType": "ExpressionStatement",
									"src": "40521:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3509,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3500,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40613:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3506,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3502,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40636:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3503,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40636:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3501,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40629:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3504,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40629:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40613:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3507,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3505,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40660:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40613:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3508,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "40665:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40613:61:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3510,
									"nodeType": "ExpressionStatement",
									"src": "40613:61:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3523,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3511,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40685:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3517,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3513,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40708:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3514,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40708:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3512,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40701:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3515,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40701:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40685:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3518,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3516,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40733:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40685:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3520,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40745:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3521,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40745:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3519,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40738:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3522,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40738:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40685:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3524,
									"nodeType": "ExpressionStatement",
									"src": "40685:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3537,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3525,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40769:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3531,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3527,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40792:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3528,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40792:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3526,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40785:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3529,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40785:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40769:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3532,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3530,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40817:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40769:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3534,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40829:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3535,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40829:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3533,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40822:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3536,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40822:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40769:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3538,
									"nodeType": "ExpressionStatement",
									"src": "40769:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3551,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3539,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40861:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3545,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3541,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40884:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3542,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40884:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3540,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40877:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3543,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40877:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40861:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3546,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3544,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40909:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40861:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3548,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40921:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3549,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40921:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3547,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40914:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3550,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40914:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40861:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3552,
									"nodeType": "ExpressionStatement",
									"src": "40861:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3565,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3553,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40957:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3559,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3555,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40980:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3556,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40980:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3554,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40973:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3557,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40973:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40957:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3560,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3558,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41005:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40957:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3562,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41017:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3563,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41017:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3561,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41010:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3564,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41010:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40957:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3566,
									"nodeType": "ExpressionStatement",
									"src": "40957:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3579,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3567,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41053:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3573,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3569,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41076:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3570,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41076:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3568,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41069:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3571,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41069:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41053:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3574,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3572,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41101:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41053:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3576,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41113:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3577,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41113:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3575,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41106:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3578,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41106:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41053:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3580,
									"nodeType": "ExpressionStatement",
									"src": "41053:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3593,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3581,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41137:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3587,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3583,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41160:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3584,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41160:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3582,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41153:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3585,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41153:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41137:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3588,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3586,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41188:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41137:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3590,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41200:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3591,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41200:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3589,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41193:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3592,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41193:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41137:89:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3594,
									"nodeType": "ExpressionStatement",
									"src": "41137:89:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3607,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3595,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41236:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3601,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3597,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41259:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3598,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41259:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3596,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41252:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3599,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41252:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41236:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3602,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3600,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41287:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41236:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3604,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41299:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3605,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41299:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3603,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41292:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3606,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41292:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41236:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3608,
									"nodeType": "ExpressionStatement",
									"src": "41236:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3618,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3609,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41332:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3615,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3611,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41355:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3612,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41355:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3610,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41348:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3613,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41348:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41332:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3616,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3614,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41383:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41332:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3617,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41388:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41332:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3619,
									"nodeType": "ExpressionStatement",
									"src": "41332:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3629,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3620,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41407:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3626,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3622,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41430:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3623,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41430:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3621,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41423:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3624,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41423:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41407:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3627,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3625,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41458:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41407:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3628,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41463:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41407:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3630,
									"nodeType": "ExpressionStatement",
									"src": "41407:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3640,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3631,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41482:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3637,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3633,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41505:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3634,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41505:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3632,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41498:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3635,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41498:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41482:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3638,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3636,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41533:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41482:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3639,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41538:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41482:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3641,
									"nodeType": "ExpressionStatement",
									"src": "41482:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3654,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3642,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41558:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3648,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3644,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41581:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3645,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41581:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3643,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41574:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3646,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41574:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41558:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3649,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3647,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41609:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41558:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3651,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41621:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3652,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41621:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3650,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41614:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3653,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41614:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41558:89:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3655,
									"nodeType": "ExpressionStatement",
									"src": "41558:89:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3668,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3656,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41657:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3662,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3658,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41680:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3659,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41680:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3657,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41673:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3660,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41673:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41657:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3663,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3661,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41708:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41657:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3665,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41720:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3666,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41720:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3664,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41713:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3667,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41713:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41657:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3669,
									"nodeType": "ExpressionStatement",
									"src": "41657:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3682,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3670,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41753:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3676,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3672,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41776:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3673,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41776:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3671,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41769:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3674,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41769:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41753:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3677,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3675,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41804:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41753:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3679,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41816:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3680,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41816:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3678,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41809:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3681,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41809:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41753:76:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3683,
									"nodeType": "ExpressionStatement",
									"src": "41753:76:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3696,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3684,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41839:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3690,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3686,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41862:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3687,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41862:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3685,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41855:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3688,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41855:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41839:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3691,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3689,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41890:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41839:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3693,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41902:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3694,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NEW_ZEALAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41902:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3692,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41895:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3695,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41895:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41839:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3697,
									"nodeType": "ExpressionStatement",
									"src": "41839:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3707,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3698,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41932:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3704,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3700,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41955:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3701,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41955:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3699,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41948:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3702,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41948:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41932:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3705,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3703,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41983:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41932:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3706,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41988:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41932:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3708,
									"nodeType": "ExpressionStatement",
									"src": "41932:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3721,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3709,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42008:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3715,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3711,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42031:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3712,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42031:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3710,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42024:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3713,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42024:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42008:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3716,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3714,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42053:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42008:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3718,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42065:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3719,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42065:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3717,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42058:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3720,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42058:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42008:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3722,
									"nodeType": "ExpressionStatement",
									"src": "42008:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3735,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3723,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42101:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3729,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3725,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42124:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3726,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42124:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3724,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42117:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3727,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42117:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42101:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3730,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3728,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42146:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42101:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3732,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42158:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3733,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42158:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3731,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42151:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3734,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42151:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42101:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3736,
									"nodeType": "ExpressionStatement",
									"src": "42101:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3749,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3737,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42181:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3743,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3739,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42204:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3740,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42204:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3738,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42197:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3741,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42197:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42181:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3744,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3742,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42226:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42181:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3746,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42238:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3747,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42238:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3745,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42231:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3748,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42231:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42181:81:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3750,
									"nodeType": "ExpressionStatement",
									"src": "42181:81:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3760,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3751,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42272:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3757,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3753,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42295:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3754,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42295:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3752,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42288:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3755,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42288:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42272:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3758,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3756,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42317:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42272:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3759,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "42322:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42272:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3761,
									"nodeType": "ExpressionStatement",
									"src": "42272:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3771,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3762,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42341:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3768,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3764,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42364:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3765,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42364:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3763,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42357:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3766,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42357:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42341:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3769,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3767,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42386:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42341:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3770,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "42391:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42341:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3772,
									"nodeType": "ExpressionStatement",
									"src": "42341:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3785,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3773,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42411:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3779,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3775,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42434:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3776,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42434:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3774,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42427:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3777,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42427:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42411:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3780,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3778,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42449:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42411:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3782,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42461:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3783,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NEW_ZEALAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42461:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3781,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42454:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3784,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42454:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42411:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3786,
									"nodeType": "ExpressionStatement",
									"src": "42411:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3799,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3787,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42491:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3793,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3789,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42514:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3790,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42514:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3788,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42507:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3791,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42507:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42491:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3794,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3792,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42529:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42491:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3796,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42541:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3797,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42541:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3795,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42534:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3798,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42534:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42491:76:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3800,
									"nodeType": "ExpressionStatement",
									"src": "42491:76:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3813,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3801,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42577:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3807,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3803,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42600:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3804,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42600:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3802,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42593:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3805,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42593:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42577:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3808,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3806,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42615:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42577:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3810,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42627:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3811,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42627:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3809,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42620:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3812,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42620:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42577:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3814,
									"nodeType": "ExpressionStatement",
									"src": "42577:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3827,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3815,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42660:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3821,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3817,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42683:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3818,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42683:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3816,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42676:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3819,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42676:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42660:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3822,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3820,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42698:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42660:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3824,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42710:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3825,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "HAWAII",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42710:14:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3823,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42703:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3826,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42703:22:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42660:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3828,
									"nodeType": "ExpressionStatement",
									"src": "42660:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3838,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3829,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42735:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3835,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3831,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42758:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3832,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42758:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3830,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42751:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3833,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42751:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42735:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3836,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3834,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42773:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42735:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3837,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "42778:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42735:52:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3839,
									"nodeType": "ExpressionStatement",
									"src": "42735:52:2"
								}
							]
						},
						"documentation": "@notice Initialize neighbor relationships between all regions\n @dev This data shared by all game instances",
						"id": 3841,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "initRegionNeighbors",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2211,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "32262:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 2212,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "32273:0:2"
						},
						"scope": 4288,
						"src": "32234:10560:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 4069,
							"nodeType": "Block",
							"src": "42958:1456:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 3851,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3844,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "42968:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3849,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3846,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42989:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3847,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "HAWAII",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42989:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3845,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42982:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3848,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42982:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42968:37:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3850,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43008:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "42968:41:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3852,
									"nodeType": "ExpressionStatement",
									"src": "42968:41:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3860,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3853,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43019:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3858,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3855,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43040:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3856,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43040:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3854,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43033:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3857,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43033:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43019:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 3859,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43067:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_6_by_1",
												"typeString": "int_const 6"
											},
											"value": "6"
										},
										"src": "43019:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3861,
									"nodeType": "ExpressionStatement",
									"src": "43019:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3869,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3862,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43078:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3867,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3864,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43099:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3865,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43099:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3863,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43092:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3866,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43092:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43078:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "35",
											"id": 3868,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43126:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_5_by_1",
												"typeString": "int_const 5"
											},
											"value": "5"
										},
										"src": "43078:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3870,
									"nodeType": "ExpressionStatement",
									"src": "43078:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3878,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3871,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43137:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3876,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3873,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43158:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3874,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43158:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3872,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43151:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3875,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43151:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43137:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3131",
											"id": 3877,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43182:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_11_by_1",
												"typeString": "int_const 11"
											},
											"value": "11"
										},
										"src": "43137:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3879,
									"nodeType": "ExpressionStatement",
									"src": "43137:47:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3887,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3880,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43194:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3885,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3882,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43215:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3883,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43215:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3881,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43208:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3884,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43208:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43194:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 3886,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43239:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_8_by_1",
												"typeString": "int_const 8"
											},
											"value": "8"
										},
										"src": "43194:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3888,
									"nodeType": "ExpressionStatement",
									"src": "43194:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3896,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3889,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43250:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3894,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3891,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43271:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3892,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "GREENLAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43271:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3890,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43264:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3893,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43264:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43250:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3895,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43293:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43250:44:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3897,
									"nodeType": "ExpressionStatement",
									"src": "43250:44:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3905,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3898,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43304:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3903,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3900,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43325:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3901,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43325:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3899,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43318:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3902,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43318:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43304:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3904,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43360:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43304:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3906,
									"nodeType": "ExpressionStatement",
									"src": "43304:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3914,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3907,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43371:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3912,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3909,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43392:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3910,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43392:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3908,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43385:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3911,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43385:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43371:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 3913,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43427:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "43371:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3915,
									"nodeType": "ExpressionStatement",
									"src": "43371:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3923,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3916,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43438:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3921,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3918,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43459:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3919,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43459:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3917,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43452:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3920,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43452:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43438:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 3922,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43487:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "43438:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3924,
									"nodeType": "ExpressionStatement",
									"src": "43438:50:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3932,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3925,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43498:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3930,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3927,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43519:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3928,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43519:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3926,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43512:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3929,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43512:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43498:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 3931,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43547:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "43498:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3933,
									"nodeType": "ExpressionStatement",
									"src": "43498:50:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3941,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3934,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43558:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3939,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3936,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43579:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3937,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43579:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3935,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43572:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3938,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43572:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43558:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3130",
											"id": 3940,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43606:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_10_by_1",
												"typeString": "int_const 10"
											},
											"value": "10"
										},
										"src": "43558:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3942,
									"nodeType": "ExpressionStatement",
									"src": "43558:50:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3950,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3943,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43618:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3948,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3945,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43639:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3946,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43639:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3944,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43632:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3947,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43632:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43618:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 3949,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43666:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_6_by_1",
												"typeString": "int_const 6"
											},
											"value": "6"
										},
										"src": "43618:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3951,
									"nodeType": "ExpressionStatement",
									"src": "43618:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3959,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3952,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43677:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3957,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3954,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43698:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3955,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43698:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3953,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43691:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3956,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43691:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43677:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 3958,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43725:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "43677:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3960,
									"nodeType": "ExpressionStatement",
									"src": "43677:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3968,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3961,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43736:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3966,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3963,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43757:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3964,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43757:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3962,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43750:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3965,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43750:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43736:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3967,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43784:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43736:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3969,
									"nodeType": "ExpressionStatement",
									"src": "43736:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3977,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3970,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43795:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3975,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3972,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43816:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3973,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43816:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3971,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43809:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3974,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43809:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43795:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3976,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43840:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43795:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3978,
									"nodeType": "ExpressionStatement",
									"src": "43795:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3986,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3979,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43851:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3984,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3981,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43872:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3982,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43872:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3980,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43865:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3983,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43865:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43851:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 3985,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43896:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "43851:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3987,
									"nodeType": "ExpressionStatement",
									"src": "43851:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3995,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3988,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43907:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3993,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3990,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43928:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3991,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43928:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3989,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43921:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3992,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43921:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43907:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3994,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43952:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43907:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3996,
									"nodeType": "ExpressionStatement",
									"src": "43907:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4004,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3997,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43963:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4002,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3999,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43984:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4000,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTH_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43984:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3998,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43977:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4001,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43977:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43963:43:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "35",
											"id": 4003,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44009:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_5_by_1",
												"typeString": "int_const 5"
											},
											"value": "5"
										},
										"src": "43963:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4005,
									"nodeType": "ExpressionStatement",
									"src": "43963:47:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4013,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4006,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44020:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4011,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4008,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44041:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4009,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44041:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4007,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44034:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4010,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44034:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44020:36:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "37",
											"id": 4012,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44059:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_7_by_1",
												"typeString": "int_const 7"
											},
											"value": "7"
										},
										"src": "44020:40:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4014,
									"nodeType": "ExpressionStatement",
									"src": "44020:40:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4022,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4015,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44070:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4020,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4017,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44091:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4018,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44091:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4016,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44084:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4019,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44084:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44070:44:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3130",
											"id": 4021,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44117:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_10_by_1",
												"typeString": "int_const 10"
											},
											"value": "10"
										},
										"src": "44070:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4023,
									"nodeType": "ExpressionStatement",
									"src": "44070:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4031,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4024,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44129:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4029,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4026,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44150:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4027,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44150:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4025,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44143:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4028,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44143:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44129:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "35",
											"id": 4030,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44177:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_5_by_1",
												"typeString": "int_const 5"
											},
											"value": "5"
										},
										"src": "44129:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4032,
									"nodeType": "ExpressionStatement",
									"src": "44129:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4040,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4033,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44188:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4038,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4035,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44209:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4036,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44209:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4034,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44202:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4037,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44202:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44188:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 4039,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44239:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "44188:52:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4041,
									"nodeType": "ExpressionStatement",
									"src": "44188:52:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4049,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4042,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44250:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4047,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4044,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44271:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4045,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44271:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4043,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44264:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4046,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44264:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44250:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 4048,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44301:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_6_by_1",
												"typeString": "int_const 6"
											},
											"value": "6"
										},
										"src": "44250:52:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4050,
									"nodeType": "ExpressionStatement",
									"src": "44250:52:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4058,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4051,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44312:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4056,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4053,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44333:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4054,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44333:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4052,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44326:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4055,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44326:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44312:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 4057,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44357:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "44312:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4059,
									"nodeType": "ExpressionStatement",
									"src": "44312:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4067,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4060,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44368:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4065,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4062,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44389:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4063,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44389:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4061,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44382:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4064,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44382:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44368:35:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 4066,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44406:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "44368:39:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4068,
									"nodeType": "ExpressionStatement",
									"src": "44368:39:2"
								}
							]
						},
						"documentation": "@notice Initialize rewards given for controlling each region\n @dev This data shared by all game instances",
						"id": 4070,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "initRegionRewards",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 3842,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "42947:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 3843,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "42958:0:2"
						},
						"scope": 4288,
						"src": "42921:1493:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 4094,
							"nodeType": "Block",
							"src": "44738:107:2",
							"statements": [
								{
									"assignments": [
										4080
									],
									"declarations": [
										{
											"constant": false,
											"id": 4080,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4095,
											"src": "44748:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4079,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "44748:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4084,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4083,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4081,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4074,
											"src": "44764:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "3332",
											"id": 4082,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44772:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_32_by_1",
												"typeString": "int_const 32"
											},
											"value": "32"
										},
										"src": "44764:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "44748:26:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 4091,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 4088,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 4086,
																"name": "combinedData",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4072,
																"src": "44799:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">>",
															"rightExpression": {
																"argumentTypes": null,
																"id": 4087,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4080,
																"src": "44815:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "44799:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"id": 4089,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "44798:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&",
												"rightExpression": {
													"argumentTypes": null,
													"id": 4090,
													"name": "MASK_32_BITS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 153,
													"src": "44825:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "44798:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 4085,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "44791:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint32_$",
												"typeString": "type(uint32)"
											},
											"typeName": "uint32"
										},
										"id": 4092,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "44791:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4078,
									"id": 4093,
									"nodeType": "Return",
									"src": "44784:54:2"
								}
							]
						},
						"documentation": "@notice Reads data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to read\n @return Value at position index",
						"id": 4095,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getData32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4075,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4072,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4095,
									"src": "44672:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4071,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "44672:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4074,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4095,
									"src": "44694:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4073,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "44694:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "44671:36:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4078,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4077,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4095,
									"src": "44730:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4076,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "44730:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "44729:8:2"
						},
						"scope": 4288,
						"src": "44653:192:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4132,
							"nodeType": "Block",
							"src": "45268:168:2",
							"statements": [
								{
									"assignments": [
										4107
									],
									"declarations": [
										{
											"constant": false,
											"id": 4107,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4133,
											"src": "45278:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4106,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "45278:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4111,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4110,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4108,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4099,
											"src": "45294:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "3332",
											"id": 4109,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "45302:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_32_by_1",
												"typeString": "int_const 32"
											},
											"value": "32"
										},
										"src": "45294:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "45278:26:2"
								},
								{
									"assignments": [
										4113
									],
									"declarations": [
										{
											"constant": false,
											"id": 4113,
											"name": "zeromask",
											"nodeType": "VariableDeclaration",
											"scope": 4133,
											"src": "45314:16:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 4112,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "45314:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4119,
									"initialValue": {
										"argumentTypes": null,
										"id": 4118,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "UnaryOperation",
										"operator": "~",
										"prefix": true,
										"src": "45333:25:2",
										"subExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4116,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4114,
														"name": "MASK_32_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 153,
														"src": "45335:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4115,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4107,
														"src": "45351:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "45335:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4117,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "45334:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "45314:44:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 4130,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4122,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4120,
														"name": "combinedData",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4097,
														"src": "45376:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4121,
														"name": "zeromask",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4113,
														"src": "45391:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "45376:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4123,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "45375:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "|",
										"rightExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4128,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 4125,
																"name": "value",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4101,
																"src": "45412:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 4124,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "45404:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint256_$",
																"typeString": "type(uint256)"
															},
															"typeName": "uint256"
														},
														"id": 4126,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "45404:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4127,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4107,
														"src": "45422:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "45404:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4129,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "45403:26:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "45375:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 4105,
									"id": 4131,
									"nodeType": "Return",
									"src": "45368:61:2"
								}
							]
						},
						"documentation": "@notice Writes data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to write\n @param value Value to write at position index.  Value must fit in a uint32.\n @return Updated combined data",
						"id": 4133,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "setData32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4102,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4097,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45187:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4096,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "45187:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4099,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45209:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4098,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45209:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4101,
									"name": "value",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45223:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4100,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45223:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45186:50:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4105,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4104,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45259:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4103,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "45259:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45258:9:2"
						},
						"scope": 4288,
						"src": "45168:268:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4157,
							"nodeType": "Block",
							"src": "45759:105:2",
							"statements": [
								{
									"assignments": [
										4143
									],
									"declarations": [
										{
											"constant": false,
											"id": 4143,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4158,
											"src": "45769:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4142,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "45769:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4147,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4144,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4137,
											"src": "45785:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 4145,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "45793:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_8_by_1",
												"typeString": "int_const 8"
											},
											"value": "8"
										},
										"src": "45785:9:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "45769:25:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 4154,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 4151,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 4149,
																"name": "combinedData",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4135,
																"src": "45819:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">>",
															"rightExpression": {
																"argumentTypes": null,
																"id": 4150,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4143,
																"src": "45835:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "45819:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"id": 4152,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "45818:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&",
												"rightExpression": {
													"argumentTypes": null,
													"id": 4153,
													"name": "MASK_8_BITS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 156,
													"src": "45845:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "45818:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 4148,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "45811:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint32_$",
												"typeString": "type(uint32)"
											},
											"typeName": "uint32"
										},
										"id": 4155,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "45811:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4141,
									"id": 4156,
									"nodeType": "Return",
									"src": "45804:53:2"
								}
							]
						},
						"documentation": "@notice Reads data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to read\n @return Value at position index",
						"id": 4158,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getData8",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4138,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4135,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4158,
									"src": "45693:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4134,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "45693:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4137,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4158,
									"src": "45715:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4136,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45715:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45692:36:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4141,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4140,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4158,
									"src": "45751:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4139,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45751:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45750:8:2"
						},
						"scope": 4288,
						"src": "45675:189:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4202,
							"nodeType": "Block",
							"src": "46287:230:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 4172,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 4170,
													"name": "value",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4164,
													"src": "46305:5:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "<",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "323536",
													"id": 4171,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "46313:3:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_256_by_1",
														"typeString": "int_const 256"
													},
													"value": "256"
												},
												"src": "46305:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f6e6c792038206269747320616c6c6f77656420666f722076616c75652e",
												"id": 4173,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "46318:32:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
													"typeString": "literal_string \"Only 8 bits allowed for value.\""
												},
												"value": "Only 8 bits allowed for value."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
													"typeString": "literal_string \"Only 8 bits allowed for value.\""
												}
											],
											"id": 4169,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "46297:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 4174,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "46297:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 4175,
									"nodeType": "ExpressionStatement",
									"src": "46297:54:2"
								},
								{
									"assignments": [
										4177
									],
									"declarations": [
										{
											"constant": false,
											"id": 4177,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4203,
											"src": "46361:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4176,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "46361:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4181,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4180,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4178,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4162,
											"src": "46377:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 4179,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "46385:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_8_by_1",
												"typeString": "int_const 8"
											},
											"value": "8"
										},
										"src": "46377:9:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "46361:25:2"
								},
								{
									"assignments": [
										4183
									],
									"declarations": [
										{
											"constant": false,
											"id": 4183,
											"name": "zeromask",
											"nodeType": "VariableDeclaration",
											"scope": 4203,
											"src": "46396:16:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 4182,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "46396:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4189,
									"initialValue": {
										"argumentTypes": null,
										"id": 4188,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "UnaryOperation",
										"operator": "~",
										"prefix": true,
										"src": "46415:24:2",
										"subExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4186,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4184,
														"name": "MASK_8_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 156,
														"src": "46417:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4185,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4177,
														"src": "46432:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "46417:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4187,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "46416:23:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "46396:43:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 4200,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4192,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4190,
														"name": "combinedData",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4160,
														"src": "46457:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4191,
														"name": "zeromask",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4183,
														"src": "46472:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "46457:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4193,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "46456:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "|",
										"rightExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4198,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 4195,
																"name": "value",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4164,
																"src": "46493:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 4194,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "46485:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint256_$",
																"typeString": "type(uint256)"
															},
															"typeName": "uint256"
														},
														"id": 4196,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "46485:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4197,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4177,
														"src": "46503:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "46485:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4199,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "46484:26:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "46456:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 4168,
									"id": 4201,
									"nodeType": "Return",
									"src": "46449:61:2"
								}
							]
						},
						"documentation": "@notice Writes data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to write\n @param value Value to write at position index.  Value must be less than 256.\n @return Updated combined data",
						"id": 4203,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "setData8",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4165,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4160,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46206:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4159,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "46206:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4162,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46228:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4161,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46228:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4164,
									"name": "value",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46242:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4163,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46242:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46205:50:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4168,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4167,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46278:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4166,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "46278:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46277:9:2"
						},
						"scope": 4288,
						"src": "46188:329:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4227,
							"nodeType": "Block",
							"src": "46845:114:2",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4214,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4212,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4207,
											"src": "46859:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<=",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4213,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4205,
											"src": "46865:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "46859:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4224,
									"nodeType": "IfStatement",
									"src": "46855:79:2",
									"trueBody": {
										"id": 4223,
										"nodeType": "Block",
										"src": "46869:65:2",
										"statements": [
											{
												"assignments": [
													4216
												],
												"declarations": [
													{
														"constant": false,
														"id": 4216,
														"name": "c",
														"nodeType": "VariableDeclaration",
														"scope": 4228,
														"src": "46883:8:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 4215,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "46883:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 4220,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 4219,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4217,
														"name": "_a",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4205,
														"src": "46894:2:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "-",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4218,
														"name": "_b",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4207,
														"src": "46899:2:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "46894:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "46883:18:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 4221,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4216,
													"src": "46922:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"functionReturnParameters": 4211,
												"id": 4222,
												"nodeType": "Return",
												"src": "46915:8:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 4225,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "46951:1:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"functionReturnParameters": 4211,
									"id": 4226,
									"nodeType": "Return",
									"src": "46944:8:2"
								}
							]
						},
						"documentation": "@notice Safe subtraction that returns 0 on underflow.\n @dev We intentially don't assert so as to not block program execution.\n @param _a Value to subtract from\n @param _b Value to subtract\n @return Result of _a - _b",
						"id": 4228,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "subSafe",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4208,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4205,
									"name": "_a",
									"nodeType": "VariableDeclaration",
									"scope": 4228,
									"src": "46792:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4204,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46792:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4207,
									"name": "_b",
									"nodeType": "VariableDeclaration",
									"scope": 4228,
									"src": "46803:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4206,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46803:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46791:22:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4211,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4210,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4228,
									"src": "46837:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4209,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46837:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46836:8:2"
						},
						"scope": 4288,
						"src": "46775:184:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4252,
							"nodeType": "Block",
							"src": "47289:118:2",
							"statements": [
								{
									"assignments": [
										4238
									],
									"declarations": [
										{
											"constant": false,
											"id": 4238,
											"name": "c",
											"nodeType": "VariableDeclaration",
											"scope": 4253,
											"src": "47299:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4237,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "47299:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4242,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4241,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4239,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4230,
											"src": "47310:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "+",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4240,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4232,
											"src": "47315:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47310:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "47299:18:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4245,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4243,
											"name": "c",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4238,
											"src": "47331:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">=",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4244,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4230,
											"src": "47336:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47331:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4249,
									"nodeType": "IfStatement",
									"src": "47327:46:2",
									"trueBody": {
										"id": 4248,
										"nodeType": "Block",
										"src": "47340:33:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 4246,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4238,
													"src": "47361:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"functionReturnParameters": 4236,
												"id": 4247,
												"nodeType": "Return",
												"src": "47354:8:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4250,
										"name": "MAX_UINT32",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 159,
										"src": "47390:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4236,
									"id": 4251,
									"nodeType": "Return",
									"src": "47383:17:2"
								}
							]
						},
						"documentation": "@notice Safe addition that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to add\n @param _b Second value to add\n @return Result of _a + _b",
						"id": 4253,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "addSafe",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4233,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4230,
									"name": "_a",
									"nodeType": "VariableDeclaration",
									"scope": 4253,
									"src": "47236:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4229,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47236:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4232,
									"name": "_b",
									"nodeType": "VariableDeclaration",
									"scope": 4253,
									"src": "47247:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4231,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47247:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47235:22:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4236,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4235,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4253,
									"src": "47281:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4234,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47281:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47280:8:2"
						},
						"scope": 4288,
						"src": "47219:188:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4286,
							"nodeType": "Block",
							"src": "47753:179:2",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4264,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4262,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4255,
											"src": "47767:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 4263,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "47773:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "47767:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4268,
									"nodeType": "IfStatement",
									"src": "47763:46:2",
									"trueBody": {
										"id": 4267,
										"nodeType": "Block",
										"src": "47776:33:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 4265,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "47797:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"functionReturnParameters": 4261,
												"id": 4266,
												"nodeType": "Return",
												"src": "47790:8:2"
											}
										]
									}
								},
								{
									"assignments": [
										4270
									],
									"declarations": [
										{
											"constant": false,
											"id": 4270,
											"name": "c",
											"nodeType": "VariableDeclaration",
											"scope": 4287,
											"src": "47819:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4269,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "47819:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4274,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4273,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4271,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4255,
											"src": "47830:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4272,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4257,
											"src": "47835:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47830:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "47819:18:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4279,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4277,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4275,
												"name": "c",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4270,
												"src": "47851:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "/",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4276,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4255,
												"src": "47855:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47851:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4278,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4257,
											"src": "47861:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47851:12:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4283,
									"nodeType": "IfStatement",
									"src": "47847:51:2",
									"trueBody": {
										"id": 4282,
										"nodeType": "Block",
										"src": "47865:33:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 4280,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4270,
													"src": "47886:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"functionReturnParameters": 4261,
												"id": 4281,
												"nodeType": "Return",
												"src": "47879:8:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4284,
										"name": "MAX_UINT32",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 159,
										"src": "47915:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4261,
									"id": 4285,
									"nodeType": "Return",
									"src": "47908:17:2"
								}
							]
						},
						"documentation": "@notice Safe multiplication that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to multiply\n @param _b Second value to multiply\n @return Result of _a * _b",
						"id": 4287,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "mulSafe",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4258,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4255,
									"name": "_a",
									"nodeType": "VariableDeclaration",
									"scope": 4287,
									"src": "47700:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4254,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47700:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4257,
									"name": "_b",
									"nodeType": "VariableDeclaration",
									"scope": 4287,
									"src": "47711:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4256,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47711:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47699:22:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4261,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4260,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4287,
									"src": "47745:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4259,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47745:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47744:8:2"
						},
						"scope": 4288,
						"src": "47683:249:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					}
				],
				"scope": 4289,
				"src": "104:47830:2"
			}
		],
		"src": "0:47935:2"
	},
	"legacyAST": {
		"absolutePath": "/Users/justinhamilton/ethereum/worldgame/contracts/WorldGame.sol",
		"exportedSymbols": {
			"WorldGame": [
				4288
			]
		},
		"id": 4289,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 120,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".0"
				],
				"nodeType": "PragmaDirective",
				"src": "0:23:2"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": "@title World game. Battle to control territory and take over the world. ",
				"fullyImplemented": true,
				"id": 4288,
				"linearizedBaseContracts": [
					4288
				],
				"name": "WorldGame",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": true,
						"id": 123,
						"name": "NOT_OWNED",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "188:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 121,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "188:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "323535",
							"id": 122,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "216:3:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_255_by_1",
								"typeString": "int_const 255"
							},
							"value": "255"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 126,
						"name": "NO_REGION",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "267:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 124,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "267:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "323535",
							"id": 125,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "295:3:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_255_by_1",
								"typeString": "int_const 255"
							},
							"value": "255"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 129,
						"name": "REGION_COUNT",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "333:33:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 127,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "333:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3235",
							"id": 128,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "364:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_25_by_1",
								"typeString": "int_const 25"
							},
							"value": "25"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 132,
						"name": "MAX_NEIGHBORS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "423:33:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 130,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "423:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "35",
							"id": 131,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "455:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_5_by_1",
								"typeString": "int_const 5"
							},
							"value": "5"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 135,
						"name": "MAX_PLAYERS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "508:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 133,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "508:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "38",
							"id": 134,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "538:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_8_by_1",
								"typeString": "int_const 8"
							},
							"value": "8"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 138,
						"name": "MAX_ACTIONS_PER_TURN",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "602:40:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 136,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "602:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "38",
							"id": 137,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "641:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_8_by_1",
								"typeString": "int_const 8"
							},
							"value": "8"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 141,
						"name": "DEFENDER_ADVANTAGE_NUM",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "698:42:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 139,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "698:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "35",
							"id": 140,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "739:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_5_by_1",
								"typeString": "int_const 5"
							},
							"value": "5"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 144,
						"name": "DEFENDER_ADVANTAGE_DENOM",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "799:44:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 142,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "799:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "34",
							"id": 143,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "842:1:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_4_by_1",
								"typeString": "int_const 4"
							},
							"value": "4"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 147,
						"name": "REWARD_BONUS_MULTIPLIER_DENOM",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "897:50:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 145,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "897:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3230",
							"id": 146,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "945:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_20_by_1",
								"typeString": "int_const 20"
							},
							"value": "20"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 150,
						"name": "MAX_BLOCKS_THRESHOLD",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "999:41:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 148,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "999:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3230",
							"id": 149,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1038:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_20_by_1",
								"typeString": "int_const 20"
							},
							"value": "20"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 153,
						"name": "MASK_32_BITS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1095:42:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 151,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1095:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30786666666666666666",
							"id": 152,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1127:10:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_4294967295_by_1",
								"typeString": "int_const 4294967295"
							},
							"value": "0xffffffff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 156,
						"name": "MASK_8_BITS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1191:35:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 154,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1191:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30786666",
							"id": 155,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1222:4:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_255_by_1",
								"typeString": "int_const 255"
							},
							"value": "0xff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 159,
						"name": "MAX_UINT32",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1260:39:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint32",
							"typeString": "uint32"
						},
						"typeName": {
							"id": 157,
							"name": "uint32",
							"nodeType": "ElementaryTypeName",
							"src": "1260:6:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30786666666666666666",
							"id": 158,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1289:10:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_4294967295_by_1",
								"typeString": "int_const 4294967295"
							},
							"value": "0xffffffff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 162,
						"name": "ALL_REGIONS_NOT_OWNED",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1368:107:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 160,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1368:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "307866666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666",
							"id": 161,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1409:66:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_115792089237316195423570985008687907853269984665640564039457584007913129639935_by_1",
								"typeString": "int_const 1157...(70 digits omitted)...9935"
							},
							"value": "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
						},
						"visibility": "internal"
					},
					{
						"constant": true,
						"id": 165,
						"name": "BEGIN_SOLDIERS_COUNTS",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1578:107:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 163,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1578:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "307830303030303031343030303030303134303030303030313430303030303031343030303030303134303030303030313430303030303031343030303030303134",
							"id": 164,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1619:66:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_539198933468554830630303949770532107640973245947105932686537879715860_by_1",
								"typeString": "int_const 5391...(61 digits omitted)...5860"
							},
							"value": "0x0000001400000014000000140000001400000014000000140000001400000014"
						},
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 167,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1747:21:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 166,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "1747:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "private"
					},
					{
						"constant": false,
						"id": 169,
						"name": "stopped",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1820:20:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 168,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "1820:4:2",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "private"
					},
					{
						"constant": false,
						"id": 173,
						"name": "blockHash32Map",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "1891:48:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
							"typeString": "mapping(uint32 => uint32)"
						},
						"typeName": {
							"id": 172,
							"keyType": {
								"id": 170,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "1900:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"nodeType": "Mapping",
							"src": "1891:26:2",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
								"typeString": "mapping(uint32 => uint32)"
							},
							"valueType": {
								"id": 171,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "1910:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 179,
						"name": "regionNeighbors",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "2055:58:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
							"typeString": "uint32[5][25]"
						},
						"typeName": {
							"baseType": {
								"baseType": {
									"id": 174,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "2055:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"id": 176,
								"length": {
									"argumentTypes": null,
									"id": 175,
									"name": "MAX_NEIGHBORS",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 132,
									"src": "2062:13:2",
									"typeDescriptions": {
										"typeIdentifier": null,
										"typeString": null
									}
								},
								"nodeType": "ArrayTypeName",
								"src": "2055:21:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_uint32_$5_storage_ptr",
									"typeString": "uint32[5]"
								}
							},
							"id": 178,
							"length": {
								"argumentTypes": null,
								"id": 177,
								"name": "REGION_COUNT",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 129,
								"src": "2077:12:2",
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								}
							},
							"nodeType": "ArrayTypeName",
							"src": "2055:35:2",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage_ptr",
								"typeString": "uint32[5][25]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 183,
						"name": "regionRewards",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "2201:41:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_uint32_$25_storage",
							"typeString": "uint32[25]"
						},
						"typeName": {
							"baseType": {
								"id": 180,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "2201:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"id": 182,
							"length": {
								"argumentTypes": null,
								"id": 181,
								"name": "REGION_COUNT",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 129,
								"src": "2208:12:2",
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								}
							},
							"nodeType": "ArrayTypeName",
							"src": "2201:20:2",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
								"typeString": "uint32[25]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 186,
						"name": "gameDataArray",
						"nodeType": "VariableDeclaration",
						"scope": 4288,
						"src": "2332:31:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
							"typeString": "struct WorldGame.GameData[]"
						},
						"typeName": {
							"baseType": {
								"contractScope": null,
								"id": 184,
								"name": "GameData",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 245,
								"src": "2332:8:2",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
									"typeString": "struct WorldGame.GameData"
								}
							},
							"id": 185,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "2332:10:2",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage_ptr",
								"typeString": "struct WorldGame.GameData[]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"canonicalName": "WorldGame.Regions",
						"id": 212,
						"members": [
							{
								"id": 187,
								"name": "HAWAII",
								"nodeType": "EnumValue",
								"src": "2441:6:2"
							},
							{
								"id": 188,
								"name": "WESTERN_CANADA",
								"nodeType": "EnumValue",
								"src": "2457:14:2"
							},
							{
								"id": 189,
								"name": "EASTERN_CANADA",
								"nodeType": "EnumValue",
								"src": "2481:14:2"
							},
							{
								"id": 190,
								"name": "WESTERN_USA",
								"nodeType": "EnumValue",
								"src": "2505:11:2"
							},
							{
								"id": 191,
								"name": "EASTERN_USA",
								"nodeType": "EnumValue",
								"src": "2526:11:2"
							},
							{
								"id": 192,
								"name": "GREENLAND",
								"nodeType": "EnumValue",
								"src": "2547:9:2"
							},
							{
								"id": 193,
								"name": "NORTHERN_SOUTH_AMERICA",
								"nodeType": "EnumValue",
								"src": "2566:22:2"
							},
							{
								"id": 194,
								"name": "SOUTHERN_SOUTH_AMERICA",
								"nodeType": "EnumValue",
								"src": "2598:22:2"
							},
							{
								"id": 195,
								"name": "WEST_ANTARCTICA",
								"nodeType": "EnumValue",
								"src": "2630:15:2"
							},
							{
								"id": 196,
								"name": "EAST_ANTARCTICA",
								"nodeType": "EnumValue",
								"src": "2655:15:2"
							},
							{
								"id": 197,
								"name": "WESTERN_EUROPE",
								"nodeType": "EnumValue",
								"src": "2680:14:2"
							},
							{
								"id": 198,
								"name": "EASTERN_EUROPE",
								"nodeType": "EnumValue",
								"src": "2704:14:2"
							},
							{
								"id": 199,
								"name": "CENTRAL_RUSSIA",
								"nodeType": "EnumValue",
								"src": "2728:14:2"
							},
							{
								"id": 200,
								"name": "EASTERN_RUSSIA",
								"nodeType": "EnumValue",
								"src": "2752:14:2"
							},
							{
								"id": 201,
								"name": "WEST_AFRICA",
								"nodeType": "EnumValue",
								"src": "2776:11:2"
							},
							{
								"id": 202,
								"name": "MIDDLE_EAST",
								"nodeType": "EnumValue",
								"src": "2797:11:2"
							},
							{
								"id": 203,
								"name": "EAST_AFRICA",
								"nodeType": "EnumValue",
								"src": "2818:11:2"
							},
							{
								"id": 204,
								"name": "SOUTH_AFRICA",
								"nodeType": "EnumValue",
								"src": "2839:12:2"
							},
							{
								"id": 205,
								"name": "INDIA",
								"nodeType": "EnumValue",
								"src": "2861:5:2"
							},
							{
								"id": 206,
								"name": "EASTERN_CHINA",
								"nodeType": "EnumValue",
								"src": "2876:13:2"
							},
							{
								"id": 207,
								"name": "SOUTHEAST_ASIA",
								"nodeType": "EnumValue",
								"src": "2899:14:2"
							},
							{
								"id": 208,
								"name": "WESTERN_AUSTRALIA",
								"nodeType": "EnumValue",
								"src": "2923:17:2"
							},
							{
								"id": 209,
								"name": "EASTERN_AUSTRALIA",
								"nodeType": "EnumValue",
								"src": "2950:17:2"
							},
							{
								"id": 210,
								"name": "NEW_ZEALAND",
								"nodeType": "EnumValue",
								"src": "2977:11:2"
							},
							{
								"id": 211,
								"name": "FIJI",
								"nodeType": "EnumValue",
								"src": "2998:4:2"
							}
						],
						"name": "Regions",
						"nodeType": "EnumDefinition",
						"src": "2418:590:2"
					},
					{
						"canonicalName": "WorldGame.GameData",
						"id": 245,
						"members": [
							{
								"constant": false,
								"id": 214,
								"name": "turnTeamId",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3124:17:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 213,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3124:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 216,
								"name": "turnNum",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3201:14:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 215,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3201:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 218,
								"name": "maxBlocksPerTurn",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3276:23:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 217,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3276:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 220,
								"name": "playerCount",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3356:18:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 219,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3356:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 224,
								"name": "playerAddresses",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3423:36:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
									"typeString": "address[8]"
								},
								"typeName": {
									"baseType": {
										"id": 221,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3423:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 223,
									"length": {
										"argumentTypes": null,
										"id": 222,
										"name": "MAX_PLAYERS",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 135,
										"src": "3431:11:2",
										"typeDescriptions": {
											"typeIdentifier": null,
											"typeString": null
										}
									},
									"nodeType": "ArrayTypeName",
									"src": "3423:20:2",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
										"typeString": "address[8]"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 226,
								"name": "undeployedSoldiers",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3552:26:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 225,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "3552:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 228,
								"name": "regionOwners",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3638:20:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 227,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "3638:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 232,
								"name": "regionSoldiers",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3727:35:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
									"typeString": "uint32[25]"
								},
								"typeName": {
									"baseType": {
										"id": 229,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3727:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 231,
									"length": {
										"argumentTypes": null,
										"id": 230,
										"name": "REGION_COUNT",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 129,
										"src": "3734:12:2",
										"typeDescriptions": {
											"typeIdentifier": null,
											"typeString": null
										}
									},
									"nodeType": "ArrayTypeName",
									"src": "3727:20:2",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
										"typeString": "uint32[25]"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 234,
								"name": "actionCount",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3822:18:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								},
								"typeName": {
									"id": 233,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "3822:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 236,
								"name": "fromRegionList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "3923:22:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 235,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "3923:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 238,
								"name": "toRegionList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4027:20:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 237,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "4027:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 240,
								"name": "moveSoldierCountList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4121:28:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 239,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "4121:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 242,
								"name": "submitBlockList",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4235:23:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 241,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "4235:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 244,
								"name": "teamAvatars",
								"nodeType": "VariableDeclaration",
								"scope": 245,
								"src": "4313:18:2",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes8",
									"typeString": "bytes8"
								},
								"typeName": {
									"id": 243,
									"name": "bytes8",
									"nodeType": "ElementaryTypeName",
									"src": "4313:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "GameData",
						"nodeType": "StructDefinition",
						"scope": 4288,
						"src": "3053:1285:2",
						"visibility": "public"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 253,
						"name": "NewGame",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 252,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 247,
									"indexed": false,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 253,
									"src": "4418:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 246,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4418:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 249,
									"indexed": false,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 253,
									"src": "4434:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 248,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4434:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 251,
									"indexed": false,
									"name": "teamAvatars",
									"nodeType": "VariableDeclaration",
									"scope": 253,
									"src": "4450:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 250,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "4450:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4417:52:2"
						},
						"src": "4404:66:2"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 261,
						"name": "NextTurn",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 260,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 255,
									"indexed": false,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 261,
									"src": "4541:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 254,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4541:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 257,
									"indexed": false,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 261,
									"src": "4557:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 256,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4557:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 259,
									"indexed": false,
									"name": "nextTeamId",
									"nodeType": "VariableDeclaration",
									"scope": 261,
									"src": "4573:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 258,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4573:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4540:51:2"
						},
						"src": "4526:66:2"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 267,
						"name": "Winner",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 266,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 263,
									"indexed": false,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 267,
									"src": "4656:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 262,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4656:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 265,
									"indexed": false,
									"name": "winningTeamId",
									"nodeType": "VariableDeclaration",
									"scope": 267,
									"src": "4672:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 264,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4672:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4655:38:2"
						},
						"src": "4643:51:2"
					},
					{
						"body": {
							"id": 300,
							"nodeType": "Block",
							"src": "4837:377:2",
							"statements": [
								{
									"assignments": [
										274
									],
									"declarations": [
										{
											"constant": false,
											"id": 274,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 301,
											"src": "4847:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 273,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "4847:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 278,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 275,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "4871:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 277,
										"indexExpression": {
											"argumentTypes": null,
											"id": 276,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 269,
											"src": "4885:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "4871:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "4847:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 287,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 280,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4372,
														"src": "4973:3:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 281,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "4973:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 282,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 274,
															"src": "4987:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 283,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "playerAddresses",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 224,
														"src": "4987:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_address_$8_storage",
															"typeString": "address[8] storage ref"
														}
													},
													"id": 286,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 284,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 274,
															"src": "5008:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 285,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnTeamId",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 214,
														"src": "5008:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4987:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4973:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
												"id": 288,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "5039:24:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												},
												"value": "Sender not authorized."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												}
											],
											"id": 279,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "4952:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 289,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4952:121:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 290,
									"nodeType": "ExpressionStatement",
									"src": "4952:121:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 295,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 292,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 274,
														"src": "5149:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 293,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "5149:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 294,
													"name": "turnNum",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 271,
													"src": "5165:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "5149:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "57726f6e67207475726e206e756d6265722e",
												"id": 296,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "5174:20:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												},
												"value": "Wrong turn number."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												}
											],
											"id": 291,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "5141:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 297,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5141:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 298,
									"nodeType": "ExpressionStatement",
									"src": "5141:54:2"
								},
								{
									"id": 299,
									"nodeType": "PlaceholderStatement",
									"src": "5206:1:2"
								}
							]
						},
						"documentation": null,
						"id": 301,
						"name": "onlyIfPlayersTurn",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 272,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 269,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 301,
									"src": "4805:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 268,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4805:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 271,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 301,
									"src": "4821:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 270,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "4821:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4804:32:2"
						},
						"src": "4778:436:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 379,
							"nodeType": "Block",
							"src": "5324:623:2",
							"statements": [
								{
									"assignments": [
										306
									],
									"declarations": [
										{
											"constant": false,
											"id": 306,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 380,
											"src": "5334:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 305,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "5334:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 310,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 307,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "5358:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 309,
										"indexExpression": {
											"argumentTypes": null,
											"id": 308,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 303,
											"src": "5372:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "5358:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "5334:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 374,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 366,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 358,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 350,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 342,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 334,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"id": 326,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 318,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 312,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "5464:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 313,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "5464:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 314,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 306,
																						"src": "5478:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 315,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "5478:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 317,
																				"indexExpression": {
																					"argumentTypes": null,
																					"hexValue": "30",
																					"id": 316,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "5499:1:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_0_by_1",
																						"typeString": "int_const 0"
																					},
																					"value": "0"
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "5478:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "5464:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "||",
																		"rightExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 325,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 319,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "5518:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 320,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "5518:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 321,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 306,
																						"src": "5532:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 322,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "5532:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 324,
																				"indexExpression": {
																					"argumentTypes": null,
																					"hexValue": "31",
																					"id": 323,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "5553:1:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_1_by_1",
																						"typeString": "int_const 1"
																					},
																					"value": "1"
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "5532:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "5518:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"src": "5464:91:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "||",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		},
																		"id": 333,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 327,
																				"name": "msg",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4372,
																				"src": "5572:3:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_magic_message",
																					"typeString": "msg"
																				}
																			},
																			"id": 328,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "sender",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": null,
																			"src": "5572:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 329,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 306,
																					"src": "5586:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 330,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "playerAddresses",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 224,
																				"src": "5586:20:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_address_$8_storage",
																					"typeString": "address[8] storage ref"
																				}
																			},
																			"id": 332,
																			"indexExpression": {
																				"argumentTypes": null,
																				"hexValue": "32",
																				"id": 331,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "5607:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_2_by_1",
																					"typeString": "int_const 2"
																				},
																				"value": "2"
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "5586:23:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"src": "5572:37:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "5464:145:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"id": 341,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 335,
																			"name": "msg",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4372,
																			"src": "5626:3:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_message",
																				"typeString": "msg"
																			}
																		},
																		"id": 336,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "sender",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "5626:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 337,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 306,
																				"src": "5640:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 338,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "playerAddresses",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 224,
																			"src": "5640:20:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_address_$8_storage",
																				"typeString": "address[8] storage ref"
																			}
																		},
																		"id": 340,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "33",
																			"id": 339,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "5661:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_3_by_1",
																				"typeString": "int_const 3"
																			},
																			"value": "3"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "5640:23:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"src": "5626:37:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "5464:199:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																"id": 349,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 343,
																		"name": "msg",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4372,
																		"src": "5680:3:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_message",
																			"typeString": "msg"
																		}
																	},
																	"id": 344,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "sender",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "5680:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 345,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 306,
																			"src": "5694:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 346,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "playerAddresses",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 224,
																		"src": "5694:20:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_address_$8_storage",
																			"typeString": "address[8] storage ref"
																		}
																	},
																	"id": 348,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "34",
																		"id": 347,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "5715:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_4_by_1",
																			"typeString": "int_const 4"
																		},
																		"value": "4"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "5694:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"src": "5680:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "5464:253:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"id": 357,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 351,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4372,
																	"src": "5734:3:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 352,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "sender",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "5734:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 353,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 306,
																		"src": "5748:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 354,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "playerAddresses",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 224,
																	"src": "5748:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_address_$8_storage",
																		"typeString": "address[8] storage ref"
																	}
																},
																"id": 356,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "35",
																	"id": 355,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "5769:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_5_by_1",
																		"typeString": "int_const 5"
																	},
																	"value": "5"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "5748:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"src": "5734:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "5464:307:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														},
														"id": 365,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 359,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4372,
																"src": "5788:3:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 360,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "5788:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 361,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 306,
																	"src": "5802:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 362,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "playerAddresses",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 224,
																"src": "5802:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_address_$8_storage",
																	"typeString": "address[8] storage ref"
																}
															},
															"id": 364,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "36",
																"id": 363,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "5823:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_6_by_1",
																	"typeString": "int_const 6"
																},
																"value": "6"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "5802:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"src": "5788:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "5464:361:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 373,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 367,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4372,
															"src": "5842:3:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 368,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "5842:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 369,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 306,
																"src": "5856:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 370,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "playerAddresses",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 224,
															"src": "5856:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_address_$8_storage",
																"typeString": "address[8] storage ref"
															}
														},
														"id": 372,
														"indexExpression": {
															"argumentTypes": null,
															"hexValue": "37",
															"id": 371,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "5877:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_7_by_1",
																"typeString": "int_const 7"
															},
															"value": "7"
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "5856:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "5842:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "5464:415:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
												"id": 375,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "5894:24:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												},
												"value": "Sender not authorized."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												}
											],
											"id": 311,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "5443:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 376,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5443:485:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 377,
									"nodeType": "ExpressionStatement",
									"src": "5443:485:2"
								},
								{
									"id": 378,
									"nodeType": "PlaceholderStatement",
									"src": "5939:1:2"
								}
							]
						},
						"documentation": null,
						"id": 380,
						"name": "onlyPlayers",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 304,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 303,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 380,
									"src": "5308:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 302,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "5308:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5307:16:2"
						},
						"src": "5287:660:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 441,
							"nodeType": "Block",
							"src": "6098:610:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 393,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 389,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 387,
														"name": "regionFrom",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 382,
														"src": "6153:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 388,
														"name": "REGION_COUNT",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 129,
														"src": "6166:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "6153:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 392,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 390,
														"name": "regionTo",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 384,
														"src": "6182:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 391,
														"name": "REGION_COUNT",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 129,
														"src": "6193:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "6182:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "6153:52:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d7573742062652076616c696420726567696f6e73",
												"id": 394,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "6207:23:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
													"typeString": "literal_string \"Must be valid regions\""
												},
												"value": "Must be valid regions"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
													"typeString": "literal_string \"Must be valid regions\""
												}
											],
											"id": 386,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6145:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 395,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6145:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 396,
									"nodeType": "ExpressionStatement",
									"src": "6145:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 436,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 428,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 420,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 412,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 404,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 398,
																			"name": "regionNeighbors",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 179,
																			"src": "6330:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																				"typeString": "uint32[5] storage ref[25] storage ref"
																			}
																		},
																		"id": 400,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 399,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 382,
																			"src": "6346:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6330:27:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$5_storage",
																			"typeString": "uint32[5] storage ref"
																		}
																	},
																	"id": 402,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 401,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "6358:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6330:30:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 403,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 384,
																	"src": "6364:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "6330:42:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 411,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 405,
																			"name": "regionNeighbors",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 179,
																			"src": "6389:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																				"typeString": "uint32[5] storage ref[25] storage ref"
																			}
																		},
																		"id": 407,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 406,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 382,
																			"src": "6405:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6389:27:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$5_storage",
																			"typeString": "uint32[5] storage ref"
																		}
																	},
																	"id": 409,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 408,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "6417:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6389:30:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 410,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 384,
																	"src": "6423:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "6389:42:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "6330:101:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 419,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 413,
																		"name": "regionNeighbors",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 179,
																		"src": "6448:15:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																			"typeString": "uint32[5] storage ref[25] storage ref"
																		}
																	},
																	"id": 415,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 414,
																		"name": "regionFrom",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 382,
																		"src": "6464:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6448:27:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$5_storage",
																		"typeString": "uint32[5] storage ref"
																	}
																},
																"id": 417,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "32",
																	"id": 416,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "6476:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_2_by_1",
																		"typeString": "int_const 2"
																	},
																	"value": "2"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6448:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 418,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 384,
																"src": "6482:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "6448:42:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "6330:160:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 427,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 421,
																	"name": "regionNeighbors",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 179,
																	"src": "6507:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																		"typeString": "uint32[5] storage ref[25] storage ref"
																	}
																},
																"id": 423,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 422,
																	"name": "regionFrom",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 382,
																	"src": "6523:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6507:27:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$5_storage",
																	"typeString": "uint32[5] storage ref"
																}
															},
															"id": 425,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "33",
																"id": 424,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "6535:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_3_by_1",
																	"typeString": "int_const 3"
																},
																"value": "3"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "6507:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 426,
															"name": "regionTo",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 384,
															"src": "6541:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6507:42:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "6330:219:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 435,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 429,
																"name": "regionNeighbors",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 179,
																"src": "6566:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																	"typeString": "uint32[5] storage ref[25] storage ref"
																}
															},
															"id": 431,
															"indexExpression": {
																"argumentTypes": null,
																"id": 430,
																"name": "regionFrom",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 382,
																"src": "6582:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "6566:27:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$5_storage",
																"typeString": "uint32[5] storage ref"
															}
														},
														"id": 433,
														"indexExpression": {
															"argumentTypes": null,
															"hexValue": "34",
															"id": 432,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "6594:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_4_by_1",
																"typeString": "int_const 4"
															},
															"value": "4"
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6566:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 434,
														"name": "regionTo",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 384,
														"src": "6600:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "6566:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "6330:278:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "526567696f6e73206d757374206265206e65696768626f727320696e206f7264657220746f206d6f7665206265747765656e207468656d",
												"id": 437,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "6622:57:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
													"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
												},
												"value": "Regions must be neighbors in order to move between them"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
													"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
												}
											],
											"id": 397,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6309:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 438,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6309:380:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 439,
									"nodeType": "ExpressionStatement",
									"src": "6309:380:2"
								},
								{
									"id": 440,
									"nodeType": "PlaceholderStatement",
									"src": "6700:1:2"
								}
							]
						},
						"documentation": null,
						"id": 442,
						"name": "onlyNeighbors",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 385,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 382,
									"name": "regionFrom",
									"nodeType": "VariableDeclaration",
									"scope": 442,
									"src": "6062:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 381,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "6062:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 384,
									"name": "regionTo",
									"nodeType": "VariableDeclaration",
									"scope": 442,
									"src": "6081:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 383,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "6081:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6061:36:2"
						},
						"src": "6039:669:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 453,
							"nodeType": "Block",
							"src": "6793:95:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 448,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 445,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4372,
														"src": "6811:3:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 446,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "6811:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 447,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 167,
													"src": "6825:5:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "6811:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f6e6c79206f776e65722063616e2063616c6c20746869732066756e6374696f6e2e",
												"id": 449,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "6832:36:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
													"typeString": "literal_string \"Only owner can call this function.\""
												},
												"value": "Only owner can call this function."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
													"typeString": "literal_string \"Only owner can call this function.\""
												}
											],
											"id": 444,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6803:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 450,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6803:66:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 451,
									"nodeType": "ExpressionStatement",
									"src": "6803:66:2"
								},
								{
									"id": 452,
									"nodeType": "PlaceholderStatement",
									"src": "6880:1:2"
								}
							]
						},
						"documentation": null,
						"id": 454,
						"name": "isOwner",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 443,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "6790:2:2"
						},
						"src": "6774:114:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 464,
							"nodeType": "Block",
							"src": "6982:83:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 459,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 457,
													"name": "stopped",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 169,
													"src": "7000:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 458,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7011:5:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "7000:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53746f707065642064756520746f20656d657267656e63792e",
												"id": 460,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "7018:27:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
													"typeString": "literal_string \"Stopped due to emergency.\""
												},
												"value": "Stopped due to emergency."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
													"typeString": "literal_string \"Stopped due to emergency.\""
												}
											],
											"id": 456,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "6992:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 461,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6992:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 462,
									"nodeType": "ExpressionStatement",
									"src": "6992:54:2"
								},
								{
									"id": 463,
									"nodeType": "PlaceholderStatement",
									"src": "7057:1:2"
								}
							]
						},
						"documentation": null,
						"id": 465,
						"name": "stopInEmergency",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 455,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "6979:2:2"
						},
						"src": "6955:110:2",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 479,
							"nodeType": "Block",
							"src": "7153:95:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 471,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 468,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 167,
											"src": "7163:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 469,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4372,
												"src": "7171:3:2",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 470,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "7171:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "7163:18:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 472,
									"nodeType": "ExpressionStatement",
									"src": "7163:18:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 473,
											"name": "initRegionNeighbors",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 3841,
											"src": "7191:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
												"typeString": "function ()"
											}
										},
										"id": 474,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7191:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 475,
									"nodeType": "ExpressionStatement",
									"src": "7191:21:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 476,
											"name": "initRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4070,
											"src": "7222:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
												"typeString": "function ()"
											}
										},
										"id": 477,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7222:19:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 478,
									"nodeType": "ExpressionStatement",
									"src": "7222:19:2"
								}
							]
						},
						"documentation": null,
						"id": 480,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 466,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7143:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 467,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7153:0:2"
						},
						"scope": 4288,
						"src": "7132:116:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 487,
							"nodeType": "Block",
							"src": "7359:57:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "496e76616c69642063616c6c20746f2067616d6520636f6e74726163742e",
												"id": 484,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "7376:32:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
													"typeString": "literal_string \"Invalid call to game contract.\""
												},
												"value": "Invalid call to game contract."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
													"typeString": "literal_string \"Invalid call to game contract.\""
												}
											],
											"id": 483,
											"name": "revert",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4377,
												4378
											],
											"referencedDeclaration": 4378,
											"src": "7369:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (string memory) pure"
											}
										},
										"id": 485,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7369:40:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 486,
									"nodeType": "ExpressionStatement",
									"src": "7369:40:2"
								}
							]
						},
						"documentation": null,
						"id": 488,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 481,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7341:2:2"
						},
						"payable": true,
						"returnParameters": {
							"id": 482,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7359:0:2"
						},
						"scope": 4288,
						"src": "7333:83:2",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 499,
							"nodeType": "Block",
							"src": "7568:31:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 497,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 495,
											"name": "stopped",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 169,
											"src": "7578:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 496,
											"name": "stop",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 490,
											"src": "7588:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "7578:14:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 498,
									"nodeType": "ExpressionStatement",
									"src": "7578:14:2"
								}
							]
						},
						"documentation": null,
						"id": 500,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [],
								"id": 493,
								"modifierName": {
									"argumentTypes": null,
									"id": 492,
									"name": "isOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 454,
									"src": "7554:7:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "7554:9:2"
							}
						],
						"name": "stopNewGames",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 491,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 490,
									"name": "stop",
									"nodeType": "VariableDeclaration",
									"scope": 500,
									"src": "7519:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 489,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "7519:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7518:11:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 494,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "7568:0:2"
						},
						"scope": 4288,
						"src": "7497:102:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 649,
							"nodeType": "Block",
							"src": "8077:1839:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 520,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 518,
													"name": "maxBlocksPerTurn",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 504,
													"src": "8160:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 519,
													"name": "MAX_BLOCKS_THRESHOLD",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 150,
													"src": "8180:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "8160:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "5573657273206d75737420626520676976656e20656e6f7567682074696d6520746f20636f6d706c657465207468656972207475726e2e",
												"id": 521,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "8202:57:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
													"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
												},
												"value": "Users must be given enough time to complete their turn."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
													"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
												}
											],
											"id": 517,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "8152:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 522,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8152:108:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 523,
									"nodeType": "ExpressionStatement",
									"src": "8152:108:2"
								},
								{
									"assignments": [
										525
									],
									"declarations": [
										{
											"constant": false,
											"id": 525,
											"name": "gameId",
											"nodeType": "VariableDeclaration",
											"scope": 650,
											"src": "8426:14:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 524,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "8426:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 637,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 636,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 530,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "8527:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 529,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "8520:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 531,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "8520:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 533,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4362,
																		"src": "8584:5:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 534,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "number",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "8584:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																],
																"id": 532,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "8577:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 535,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "8577:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 536,
															"name": "maxBlocksPerTurn",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 504,
															"src": "8654:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 537,
															"name": "playerCount",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 502,
															"src": "8721:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 538,
															"name": "playerAddresses",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 508,
															"src": "8801:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																"typeString": "address[8] memory"
															}
														},
														{
															"argumentTypes": null,
															"id": 539,
															"name": "BEGIN_SOLDIERS_COUNTS",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 165,
															"src": "8876:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 540,
															"name": "ALL_REGIONS_NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 162,
															"src": "8951:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 542,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9066:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 541,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9059:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 543,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9059:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 545,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9077:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 544,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9070:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 546,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9070:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 548,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9088:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 547,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9081:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 549,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9081:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 551,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9099:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 550,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9092:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 552,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9092:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 554,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9110:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 553,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9103:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 555,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9103:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 557,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9121:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 556,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9114:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 558,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9114:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 560,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9149:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 559,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9142:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 561,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9142:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 563,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9160:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 562,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9153:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 564,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9153:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 566,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9171:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 565,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9164:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 567,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9164:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 569,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9182:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 568,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9175:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 570,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9175:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 572,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9193:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 571,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9186:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 573,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9186:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 575,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9204:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 574,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9197:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 576,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9197:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 578,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9232:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 577,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9225:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 579,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9225:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 581,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9243:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 580,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9236:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 582,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9236:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 584,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9254:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 583,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9247:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 585,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9247:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 587,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9265:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 586,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9258:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 588,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9258:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 590,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9276:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 589,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9269:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 591,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9269:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 593,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9287:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 592,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9280:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 594,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9280:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 596,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9315:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 595,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9308:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 597,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9308:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 599,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9326:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 598,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9319:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 600,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9319:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 602,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9337:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 601,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9330:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 603,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9330:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 605,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9348:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 604,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9341:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 606,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9341:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 608,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9359:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 607,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9352:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 609,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9352:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 611,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9370:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 610,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9363:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 612,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9363:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 614,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "9398:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			}
																		],
																		"id": 613,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "9391:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 615,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "9391:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 616,
															"isConstant": false,
															"isInlineArray": true,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "9041:373:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																"typeString": "uint32[25] memory"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 618,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9473:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 617,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9466:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 619,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9466:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 621,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9538:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 620,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9530:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 622,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9530:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 624,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9602:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 623,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9594:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 625,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9594:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 627,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9674:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 626,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9666:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 628,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9666:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 630,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "9741:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	}
																],
																"id": 629,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "9733:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 631,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "9733:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 632,
															"name": "teamAvatars",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 510,
															"src": "9794:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes8",
																"typeString": "bytes8"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																"typeString": "address[8] memory"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																"typeString": "uint32[25] memory"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_bytes8",
																"typeString": "bytes8"
															}
														],
														"id": 528,
														"name": "GameData",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 245,
														"src": "8462:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_struct$_GameData_$245_storage_ptr_$",
															"typeString": "type(struct WorldGame.GameData storage pointer)"
														}
													},
													"id": 633,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "structConstructorCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "8462:1353:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_memory",
														"typeString": "struct WorldGame.GameData memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_struct$_GameData_$245_memory",
														"typeString": "struct WorldGame.GameData memory"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 526,
													"name": "gameDataArray",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 186,
													"src": "8443:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
														"typeString": "struct WorldGame.GameData storage ref[] storage ref"
													}
												},
												"id": 527,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "push",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "8443:18:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_arraypush_nonpayable$_t_struct$_GameData_$245_storage_$returns$_t_uint256_$",
													"typeString": "function (struct WorldGame.GameData storage ref) returns (uint256)"
												}
											},
											"id": 634,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "8443:1373:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "-",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 635,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "9819:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "8443:1377:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "8426:1394:2"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 639,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 525,
												"src": "9844:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 641,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "9859:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 642,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "9859:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 640,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "9852:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 643,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "9852:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 644,
												"name": "teamAvatars",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 510,
												"src": "9874:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes8",
													"typeString": "bytes8"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												{
													"typeIdentifier": "t_bytes8",
													"typeString": "bytes8"
												}
											],
											"id": 638,
											"name": "NewGame",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 253,
											"src": "9836:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_bytes8_$returns$__$",
												"typeString": "function (uint256,uint32,bytes8)"
											}
										},
										"id": 645,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9836:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 646,
									"nodeType": "EmitStatement",
									"src": "9831:55:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 647,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 525,
										"src": "9903:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 516,
									"id": 648,
									"nodeType": "Return",
									"src": "9896:13:2"
								}
							]
						},
						"documentation": "@notice Create a new game instance\n @param playerCount number of players\n @param playerAddresses address of each player\n @param teamAvatars avatar to use for each player\n @return Id of the game instance",
						"id": 650,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [],
								"id": 513,
								"modifierName": {
									"argumentTypes": null,
									"id": 512,
									"name": "stopInEmergency",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 465,
									"src": "8028:15:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "8028:17:2"
							}
						],
						"name": "newGame",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 511,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 502,
									"name": "playerCount",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7870:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 501,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "7870:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 504,
									"name": "maxBlocksPerTurn",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7899:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 503,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "7899:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 508,
									"name": "playerAddresses",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7933:36:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
										"typeString": "address[8]"
									},
									"typeName": {
										"baseType": {
											"id": 505,
											"name": "address",
											"nodeType": "ElementaryTypeName",
											"src": "7933:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 507,
										"length": {
											"argumentTypes": null,
											"id": 506,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "7941:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "7933:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
											"typeString": "address[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 510,
									"name": "teamAvatars",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "7980:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 509,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "7980:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7860:144:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 516,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 515,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 650,
									"src": "8063:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 514,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "8063:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8062:9:2"
						},
						"scope": 4288,
						"src": "7844:2072:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 799,
							"nodeType": "Block",
							"src": "10563:1345:2",
							"statements": [
								{
									"assignments": [
										672
									],
									"declarations": [
										{
											"constant": false,
											"id": 672,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 800,
											"src": "10573:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 671,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "10573:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 676,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 673,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "10597:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 675,
										"indexExpression": {
											"argumentTypes": null,
											"id": 674,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 652,
											"src": "10611:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "10597:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10573:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 678,
											"name": "i",
											"nodeType": "VariableDeclaration",
											"scope": 800,
											"src": "10628:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 677,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "10628:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 679,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "10628:8:2"
								},
								{
									"body": {
										"id": 702,
										"nodeType": "Block",
										"src": "10733:231:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 698,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 692,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 658,
																"src": "10842:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "!=",
															"rightExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 694,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 672,
																			"src": "10864:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 695,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "toRegionList",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 238,
																		"src": "10864:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 696,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 678,
																		"src": "10883:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 693,
																	"name": "getData32",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4095,
																	"src": "10854:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 697,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "10854:31:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "10842:43:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														{
															"argumentTypes": null,
															"hexValue": "526567696f6e20616c7265616479206861732071756575656420616374696f6e2e",
															"id": 699,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "string",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "10904:35:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																"typeString": "literal_string \"Region already has queued action.\""
															},
															"value": "Region already has queued action."
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															{
																"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																"typeString": "literal_string \"Region already has queued action.\""
															}
														],
														"id": 691,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															4375,
															4376
														],
														"referencedDeclaration": 4376,
														"src": "10817:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
															"typeString": "function (bool,string memory) pure"
														}
													},
													"id": 700,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "10817:136:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 701,
												"nodeType": "ExpressionStatement",
												"src": "10817:136:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 687,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 684,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 678,
											"src": "10706:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 685,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "10710:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 686,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "10710:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "10706:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 703,
									"initializationExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 682,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 680,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "10699:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 681,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "10703:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "10699:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 683,
										"nodeType": "ExpressionStatement",
										"src": "10699:5:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 689,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "10728:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 688,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "10728:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 690,
										"nodeType": "ExpressionStatement",
										"src": "10728:3:2"
									},
									"nodeType": "ForStatement",
									"src": "10694:270:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 708,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 705,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "10981:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 706,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "actionCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 234,
													"src": "10981:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "<",
												"rightExpression": {
													"argumentTypes": null,
													"id": 707,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "11000:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "10981:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f6e6c79203820616374696f6e732061726520616c6c6f77656420706572207475726e",
												"id": 709,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11022:37:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
													"typeString": "literal_string \"Only 8 actions are allowed per turn\""
												},
												"value": "Only 8 actions are allowed per turn"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
													"typeString": "literal_string \"Only 8 actions are allowed per turn\""
												}
											],
											"id": 704,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "10973:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 710,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10973:87:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 711,
									"nodeType": "ExpressionStatement",
									"src": "10973:87:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 718,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 713,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11078:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 714,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "regionSoldiers",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 232,
														"src": "11078:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_uint32_$25_storage",
															"typeString": "uint32[25] storage ref"
														}
													},
													"id": 716,
													"indexExpression": {
														"argumentTypes": null,
														"id": 715,
														"name": "regionFrom",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 656,
														"src": "11098:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "11078:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"id": 717,
													"name": "moveSoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 660,
													"src": "11112:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "11078:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d75737420686176652073756666696369656e7420736f6c6469657273",
												"id": 719,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11130:31:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
													"typeString": "literal_string \"Must have sufficient soldiers\""
												},
												"value": "Must have sufficient soldiers"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
													"typeString": "literal_string \"Must have sufficient soldiers\""
												}
											],
											"id": 712,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "11070:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 720,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "11070:92:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 721,
									"nodeType": "ExpressionStatement",
									"src": "11070:92:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 730,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 723,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11180:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 724,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "11180:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 726,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "11208:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 727,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionOwners",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 228,
															"src": "11208:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 728,
															"name": "regionFrom",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 656,
															"src": "11227:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 725,
														"name": "getData8",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4158,
														"src": "11199:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 729,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "11199:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "11180:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d757374206f776e20726567696f6e206d6f76696e672066726f6d",
												"id": 731,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11240:29:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
													"typeString": "literal_string \"Must own region moving from\""
												},
												"value": "Must own region moving from"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
													"typeString": "literal_string \"Must own region moving from\""
												}
											],
											"id": 722,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "11172:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 732,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "11172:98:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 733,
									"nodeType": "ExpressionStatement",
									"src": "11172:98:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 737,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 734,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 678,
											"src": "11334:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 735,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11338:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 736,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "11338:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "11334:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 738,
									"nodeType": "ExpressionStatement",
									"src": "11334:20:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 745,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 739,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11407:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 742,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "regionSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 232,
												"src": "11407:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 743,
											"indexExpression": {
												"argumentTypes": null,
												"id": 741,
												"name": "regionFrom",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 656,
												"src": "11427:10:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "11407:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "-=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 744,
											"name": "moveSoldierCount",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 660,
											"src": "11442:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "11407:51:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 746,
									"nodeType": "ExpressionStatement",
									"src": "11407:51:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 756,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 747,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11516:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 749,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "fromRegionList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 236,
											"src": "11516:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 751,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11548:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 752,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "fromRegionList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 236,
													"src": "11548:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 753,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11569:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 754,
													"name": "regionFrom",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 656,
													"src": "11572:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 750,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11538:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 755,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11538:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11516:67:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 757,
									"nodeType": "ExpressionStatement",
									"src": "11516:67:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 767,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 758,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11593:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 760,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "toRegionList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 238,
											"src": "11593:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 762,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11623:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 763,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "toRegionList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 238,
													"src": "11623:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 764,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11642:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 765,
													"name": "regionTo",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 658,
													"src": "11645:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 761,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11613:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 766,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11613:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11593:61:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 768,
									"nodeType": "ExpressionStatement",
									"src": "11593:61:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 778,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 769,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11664:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 771,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "moveSoldierCountList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 240,
											"src": "11664:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 773,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11702:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 774,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "moveSoldierCountList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 240,
													"src": "11702:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 775,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11729:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 776,
													"name": "moveSoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 660,
													"src": "11732:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 772,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11692:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 777,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11692:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11664:85:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 779,
									"nodeType": "ExpressionStatement",
									"src": "11664:85:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 792,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 780,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11759:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 782,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "submitBlockList",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 242,
											"src": "11759:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 784,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11792:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 785,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "submitBlockList",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 242,
													"src": "11792:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 786,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "11814:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 788,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "11824:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 789,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "11824:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 787,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "11817:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 790,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "11817:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 783,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "11782:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 791,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11782:56:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11759:79:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 793,
									"nodeType": "ExpressionStatement",
									"src": "11759:79:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 797,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "UnaryOperation",
										"operator": "++",
										"prefix": false,
										"src": "11883:18:2",
										"subExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 794,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "11883:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 796,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "11883:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 798,
									"nodeType": "ExpressionStatement",
									"src": "11883:18:2"
								}
							]
						},
						"documentation": "@notice Move soldiers from one region to an adjacent region.  Attack if moving to enemy territory. \n @param gameId Id of game \n @param turnNum Turn action should occur during \n @param regionFrom Move soldiers from this region\n @param regionTo Move soldiers to this region\n @param moveSoldierCount Number of soldiers to move",
						"id": 800,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 663,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 652,
										"src": "10496:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									{
										"argumentTypes": null,
										"id": 664,
										"name": "turnNum",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 654,
										"src": "10504:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									}
								],
								"id": 665,
								"modifierName": {
									"argumentTypes": null,
									"id": 662,
									"name": "onlyIfPlayersTurn",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 301,
									"src": "10478:17:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
										"typeString": "modifier (uint256,uint32)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "10478:34:2"
							},
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 667,
										"name": "regionFrom",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 656,
										"src": "10536:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									{
										"argumentTypes": null,
										"id": 668,
										"name": "regionTo",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 658,
										"src": "10548:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									}
								],
								"id": 669,
								"modifierName": {
									"argumentTypes": null,
									"id": 666,
									"name": "onlyNeighbors",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 442,
									"src": "10522:13:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint32_$_t_uint32_$",
										"typeString": "modifier (uint32,uint32)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "10522:35:2"
							}
						],
						"name": "attackOrMove",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 661,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 652,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10320:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 651,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "10320:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 654,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10345:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 653,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10345:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 656,
									"name": "regionFrom",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10370:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 655,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10370:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 658,
									"name": "regionTo",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10398:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 657,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10398:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 660,
									"name": "moveSoldierCount",
									"nodeType": "VariableDeclaration",
									"scope": 800,
									"src": "10424:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 659,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "10424:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10310:143:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 670,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10563:0:2"
						},
						"scope": 4288,
						"src": "10289:1619:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 951,
							"nodeType": "Block",
							"src": "12478:1644:2",
							"statements": [
								{
									"assignments": [
										816
									],
									"declarations": [
										{
											"constant": false,
											"id": 816,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 952,
											"src": "12488:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 815,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "12488:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 820,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 817,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "12512:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 819,
										"indexExpression": {
											"argumentTypes": null,
											"id": 818,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 802,
											"src": "12526:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "12512:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "12488:45:2"
								},
								{
									"assignments": [
										822
									],
									"declarations": [
										{
											"constant": false,
											"id": 822,
											"name": "undeployedSoldierCount",
											"nodeType": "VariableDeclaration",
											"scope": 952,
											"src": "12543:29:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 821,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "12543:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 829,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 824,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "12585:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 825,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "undeployedSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 226,
												"src": "12585:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 826,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "12610:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 827,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "12610:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 823,
											"name": "getData32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4095,
											"src": "12575:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
												"typeString": "function (uint256,uint32) pure returns (uint32)"
											}
										},
										"id": 828,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "12575:51:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "12543:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 833,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 831,
													"name": "undeployedSoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 822,
													"src": "12645:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 832,
													"name": "deploySoldierCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 808,
													"src": "12671:18:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "12645:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4d75737420686176652073756666696369656e7420736f6c64696572732e",
												"id": 834,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "12691:32:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
													"typeString": "literal_string \"Must have sufficient soldiers.\""
												},
												"value": "Must have sufficient soldiers."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
													"typeString": "literal_string \"Must have sufficient soldiers.\""
												}
											],
											"id": 830,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "12637:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 835,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "12637:87:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 836,
									"nodeType": "ExpressionStatement",
									"src": "12637:87:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 862,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 854,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 844,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 840,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 838,
																		"name": "regionDeploy",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 806,
																		"src": "12756:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 839,
																		"name": "NO_REGION",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 126,
																		"src": "12772:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "12756:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "&&",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 843,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 841,
																		"name": "deploySoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 808,
																		"src": "12785:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 842,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "12807:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"src": "12785:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "12756:52:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 845,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "12755:54:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 853,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 847,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "12835:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 848,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "12835:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 849,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "12854:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 846,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "12826:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 850,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "12826:41:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 851,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "12871:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 852,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "12871:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "12826:60:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "12755:131:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 861,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 856,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "12912:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 857,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "12912:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 858,
																"name": "regionDeploy",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 806,
																"src": "12931:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 855,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "12903:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 859,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "12903:41:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 860,
														"name": "NOT_OWNED",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 123,
														"src": "12948:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "12903:54:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "12755:202:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "596f752063616e206f6e6c79206465706c6f7920736f6c646965727320746f206120726567696f6e20796f75206f776e2c206f72207468617420697320756e6f636375706965642e",
												"id": 863,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "12971:74:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
													"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
												},
												"value": "You can only deploy soldiers to a region you own, or that is unoccupied."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
													"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
												}
											],
											"id": 837,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "12734:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 864,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "12734:321:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 865,
									"nodeType": "ExpressionStatement",
									"src": "12734:321:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 869,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 866,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 816,
												"src": "13152:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 867,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "13152:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 868,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "13171:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "13152:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 875,
									"nodeType": "IfStatement",
									"src": "13148:80:2",
									"trueBody": {
										"id": 874,
										"nodeType": "Block",
										"src": "13174:54:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 871,
															"name": "gameId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 802,
															"src": "13210:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 870,
														"name": "executePendingActions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1847,
														"src": "13188:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 872,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "13188:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 873,
												"nodeType": "ExpressionStatement",
												"src": "13188:29:2"
											}
										]
									}
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 878,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 876,
											"name": "regionDeploy",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 806,
											"src": "13297:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"id": 877,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "13313:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "13297:25:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 921,
									"nodeType": "IfStatement",
									"src": "13293:500:2",
									"trueBody": {
										"id": 920,
										"nodeType": "Block",
										"src": "13324:469:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 889,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 879,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 816,
															"src": "13338:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 881,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "regionOwners",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 228,
														"src": "13338:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 883,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13367:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 884,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "13367:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 885,
																"name": "regionDeploy",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 806,
																"src": "13386:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 886,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13400:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 887,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "13400:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 882,
															"name": "setData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4203,
															"src": "13358:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
															}
														},
														"id": 888,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13358:58:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "13338:78:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 890,
												"nodeType": "ExpressionStatement",
												"src": "13338:78:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 904,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 891,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 816,
															"src": "13430:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 893,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "undeployedSoldiers",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 226,
														"src": "13430:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 895,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13483:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 896,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "undeployedSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 226,
																"src": "13483:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 897,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13525:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 898,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "13525:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"id": 900,
																		"name": "undeployedSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 822,
																		"src": "13567:22:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 901,
																		"name": "deploySoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 808,
																		"src": "13591:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 899,
																	"name": "subSafe",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4228,
																	"src": "13559:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint32,uint32) pure returns (uint32)"
																	}
																},
																"id": 902,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "13559:51:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 894,
															"name": "setData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4133,
															"src": "13456:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
															}
														},
														"id": 903,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13456:168:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "13430:194:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 905,
												"nodeType": "ExpressionStatement",
												"src": "13430:194:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 918,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 906,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "13638:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 909,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionSoldiers",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 232,
															"src": "13638:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_storage",
																"typeString": "uint32[25] storage ref"
															}
														},
														"id": 910,
														"indexExpression": {
															"argumentTypes": null,
															"id": 908,
															"name": "regionDeploy",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 806,
															"src": "13658:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "13638:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 912,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13699:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 913,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 232,
																	"src": "13699:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$25_storage",
																		"typeString": "uint32[25] storage ref"
																	}
																},
																"id": 915,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 914,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "13719:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "13699:33:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 916,
																"name": "deploySoldierCount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 808,
																"src": "13750:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 911,
															"name": "addSafe",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4253,
															"src": "13674:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32,uint32) pure returns (uint32)"
															}
														},
														"id": 917,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13674:108:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "13638:144:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 919,
												"nodeType": "ExpressionStatement",
												"src": "13638:144:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 928,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 922,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 816,
												"src": "13845:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 924,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "13845:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 926,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "13881:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 925,
												"name": "getNextTurnTeamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1948,
												"src": "13863:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
													"typeString": "function (uint256) view returns (uint32)"
												}
											},
											"id": 927,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "13863:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "13845:43:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 929,
									"nodeType": "ExpressionStatement",
									"src": "13845:43:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 937,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 930,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 816,
												"src": "13898:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 932,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnNum",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 216,
											"src": "13898:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 934,
														"name": "block",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4362,
														"src": "13920:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_block",
															"typeString": "block"
														}
													},
													"id": 935,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "number",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "13920:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 933,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "13913:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 936,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "13913:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "13898:35:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 938,
									"nodeType": "ExpressionStatement",
									"src": "13898:35:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 940,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 802,
												"src": "14045:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 939,
											"name": "giveRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2210,
											"src": "14027:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 941,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14027:25:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 942,
									"nodeType": "ExpressionStatement",
									"src": "14027:25:2"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 944,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 802,
												"src": "14077:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 945,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "14085:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 946,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "14085:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 947,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "14099:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 948,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "14099:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 943,
											"name": "NextTurn",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 261,
											"src": "14068:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
												"typeString": "function (uint256,uint32,uint32)"
											}
										},
										"id": 949,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14068:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 950,
									"nodeType": "EmitStatement",
									"src": "14063:52:2"
								}
							]
						},
						"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game \n @param turnNum Turn deploySoldiersAndEndTurn should occur during \n @param regionDeploy Region where you'd like to deploy soldiers to\n @param deploySoldierCount Number of soldiers you'd like to deploy at end of your turn",
						"id": 952,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 811,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 802,
										"src": "12456:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									{
										"argumentTypes": null,
										"id": 812,
										"name": "turnNum",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 804,
										"src": "12464:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									}
								],
								"id": 813,
								"modifierName": {
									"argumentTypes": null,
									"id": 810,
									"name": "onlyIfPlayersTurn",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 301,
									"src": "12438:17:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
										"typeString": "modifier (uint256,uint32)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "12438:34:2"
							}
						],
						"name": "deploySoldiersAndEndTurn",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 809,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 802,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12302:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 801,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "12302:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 804,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12327:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 803,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "12327:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 806,
									"name": "regionDeploy",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12352:19:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 805,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "12352:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 808,
									"name": "deploySoldierCount",
									"nodeType": "VariableDeclaration",
									"scope": 952,
									"src": "12382:25:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 807,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "12382:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "12292:121:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 814,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "12478:0:2"
						},
						"scope": 4288,
						"src": "12259:1863:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1028,
							"nodeType": "Block",
							"src": "14421:740:2",
							"statements": [
								{
									"assignments": [
										963
									],
									"declarations": [
										{
											"constant": false,
											"id": 963,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1029,
											"src": "14431:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 962,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "14431:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 967,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 964,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "14455:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 966,
										"indexExpression": {
											"argumentTypes": null,
											"id": 965,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 954,
											"src": "14469:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "14455:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "14431:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 972,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 969,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 963,
														"src": "14494:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 970,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "14494:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 971,
													"name": "turnNum",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 956,
													"src": "14510:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "14494:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "57726f6e67207475726e206e756d6265722e",
												"id": 973,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "14519:20:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												},
												"value": "Wrong turn number."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
													"typeString": "literal_string \"Wrong turn number.\""
												}
											],
											"id": 968,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "14486:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 974,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14486:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 975,
									"nodeType": "ExpressionStatement",
									"src": "14486:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 985,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 977,
														"name": "block",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4362,
														"src": "14558:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_block",
															"typeString": "block"
														}
													},
													"id": 978,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "number",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "14558:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 980,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 963,
																"src": "14581:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 981,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnNum",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 216,
															"src": "14581:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 982,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 963,
																"src": "14595:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 983,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "maxBlocksPerTurn",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 218,
															"src": "14595:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 979,
														"name": "addSafe",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4253,
														"src": "14573:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint32,uint32) pure returns (uint32)"
														}
													},
													"id": 984,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "14573:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "14558:59:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "506c61796572207374696c6c206861732074696d6520746f2066696e697368207475726e2e",
												"id": 986,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "14619:39:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
													"typeString": "literal_string \"Player still has time to finish turn.\""
												},
												"value": "Player still has time to finish turn."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
													"typeString": "literal_string \"Player still has time to finish turn.\""
												}
											],
											"id": 976,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "14550:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 987,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "14550:109:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 988,
									"nodeType": "ExpressionStatement",
									"src": "14550:109:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 992,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 989,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 963,
												"src": "14756:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 990,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "14756:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 991,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "14775:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "14756:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 998,
									"nodeType": "IfStatement",
									"src": "14752:80:2",
									"trueBody": {
										"id": 997,
										"nodeType": "Block",
										"src": "14778:54:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 994,
															"name": "gameId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 954,
															"src": "14814:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 993,
														"name": "executePendingActions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1847,
														"src": "14792:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 995,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "14792:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 996,
												"nodeType": "ExpressionStatement",
												"src": "14792:29:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1005,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 999,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 963,
												"src": "14884:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1001,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "14884:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1003,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 954,
													"src": "14920:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1002,
												"name": "getNextTurnTeamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1948,
												"src": "14902:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
													"typeString": "function (uint256) view returns (uint32)"
												}
											},
											"id": 1004,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14902:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "14884:43:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 1006,
									"nodeType": "ExpressionStatement",
									"src": "14884:43:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1014,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1007,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 963,
												"src": "14937:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1009,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "turnNum",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 216,
											"src": "14937:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1011,
														"name": "block",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4362,
														"src": "14959:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_block",
															"typeString": "block"
														}
													},
													"id": 1012,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "number",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "14959:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1010,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "14952:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 1013,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14952:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "14937:35:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 1015,
									"nodeType": "ExpressionStatement",
									"src": "14937:35:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1017,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 954,
												"src": "15084:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 1016,
											"name": "giveRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2210,
											"src": "15066:17:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1018,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "15066:25:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1019,
									"nodeType": "ExpressionStatement",
									"src": "15066:25:2"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1021,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 954,
												"src": "15116:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1022,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "15124:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1023,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "15124:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1024,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "15138:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1025,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "15138:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 1020,
											"name": "NextTurn",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 261,
											"src": "15107:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
												"typeString": "function (uint256,uint32,uint32)"
											}
										},
										"id": 1026,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "15107:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1027,
									"nodeType": "EmitStatement",
									"src": "15102:52:2"
								}
							]
						},
						"documentation": "@notice Force turn to end for player who's taking too long.\n @param gameId Id of game \n @param turnNum Turn forceEndOfTurn should occur during ",
						"id": 1029,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 959,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 954,
										"src": "14409:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									}
								],
								"id": 960,
								"modifierName": {
									"argumentTypes": null,
									"id": 958,
									"name": "onlyPlayers",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 380,
									"src": "14397:11:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$",
										"typeString": "modifier (uint256)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "14397:19:2"
							}
						],
						"name": "forceEndOfTurn",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 957,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 954,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1029,
									"src": "14327:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 953,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "14327:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 956,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 1029,
									"src": "14352:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 955,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "14352:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "14317:55:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 961,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "14421:0:2"
						},
						"scope": 4288,
						"src": "14294:867:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1087,
							"nodeType": "Block",
							"src": "15406:402:2",
							"statements": [
								{
									"assignments": [
										1040
									],
									"declarations": [
										{
											"constant": false,
											"id": 1040,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1088,
											"src": "15416:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1039,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "15416:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1044,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1041,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "15440:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1043,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1042,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1031,
											"src": "15454:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "15440:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "15416:45:2"
								},
								{
									"assignments": [
										1046
									],
									"declarations": [
										{
											"constant": false,
											"id": 1046,
											"name": "isWinner",
											"nodeType": "VariableDeclaration",
											"scope": 1088,
											"src": "15480:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"typeName": {
												"id": 1045,
												"name": "bool",
												"nodeType": "ElementaryTypeName",
												"src": "15480:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1048,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1047,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "15496:4:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "15480:20:2"
								},
								{
									"body": {
										"id": 1072,
										"nodeType": "Block",
										"src": "15552:119:2",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 1065,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1060,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1040,
																	"src": "15579:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1061,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "15579:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1062,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1050,
																"src": "15598:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1059,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "15570:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1063,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "15570:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "!=",
													"rightExpression": {
														"argumentTypes": null,
														"id": 1064,
														"name": "teamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1033,
														"src": "15604:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "15570:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1071,
												"nodeType": "IfStatement",
												"src": "15566:95:2",
												"trueBody": {
													"id": 1070,
													"nodeType": "Block",
													"src": "15612:49:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1068,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1066,
																	"name": "isWinner",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1046,
																	"src": "15630:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "66616c7365",
																	"id": 1067,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "15641:5:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "false"
																},
																"src": "15630:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1069,
															"nodeType": "ExpressionStatement",
															"src": "15630:16:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1055,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1053,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1050,
											"src": "15529:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1054,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "15533:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "15529:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1073,
									"initializationExpression": {
										"assignments": [
											1050
										],
										"declarations": [
											{
												"constant": false,
												"id": 1050,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1088,
												"src": "15515:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1049,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "15515:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1052,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1051,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "15526:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "15515:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1057,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "15547:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1056,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1050,
												"src": "15547:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1058,
										"nodeType": "ExpressionStatement",
										"src": "15547:3:2"
									},
									"nodeType": "ForStatement",
									"src": "15510:161:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1075,
												"name": "isWinner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1046,
												"src": "15689:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "576520646f6e2774206861766520612077696e6e65722e",
												"id": 1076,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "15699:25:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
													"typeString": "literal_string \"We don't have a winner.\""
												},
												"value": "We don't have a winner."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
													"typeString": "literal_string \"We don't have a winner.\""
												}
											],
											"id": 1074,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "15681:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 1077,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "15681:44:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1078,
									"nodeType": "ExpressionStatement",
									"src": "15681:44:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"id": 1079,
										"name": "isWinner",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1046,
										"src": "15740:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1086,
									"nodeType": "IfStatement",
									"src": "15736:66:2",
									"trueBody": {
										"id": 1085,
										"nodeType": "Block",
										"src": "15750:52:2",
										"statements": [
											{
												"eventCall": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 1081,
															"name": "gameId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1031,
															"src": "15776:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1082,
															"name": "teamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1033,
															"src": "15784:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1080,
														"name": "Winner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 267,
														"src": "15769:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$returns$__$",
															"typeString": "function (uint256,uint32)"
														}
													},
													"id": 1083,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "15769:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 1084,
												"nodeType": "EmitStatement",
												"src": "15764:27:2"
											}
										]
									}
								}
							]
						},
						"documentation": "@notice Declare victory for a team.\n @param gameId Id of game\n @param teamId Team you'd like to declare as winner",
						"id": 1088,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [
									{
										"argumentTypes": null,
										"id": 1036,
										"name": "gameId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1031,
										"src": "15394:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									}
								],
								"id": 1037,
								"modifierName": {
									"argumentTypes": null,
									"id": 1035,
									"name": "onlyPlayers",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 380,
									"src": "15382:11:2",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$_t_uint256_$",
										"typeString": "modifier (uint256)"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "15382:19:2"
							}
						],
						"name": "declareWinner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1034,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1031,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1088,
									"src": "15326:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1030,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "15326:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1033,
									"name": "teamId",
									"nodeType": "VariableDeclaration",
									"scope": 1088,
									"src": "15342:13:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1032,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "15342:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "15325:31:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1038,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "15406:0:2"
						},
						"scope": 4288,
						"src": "15303:505:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1122,
							"nodeType": "Block",
							"src": "16071:261:2",
							"statements": [
								{
									"assignments": [
										1096
									],
									"declarations": [
										{
											"constant": false,
											"id": 1096,
											"name": "cachedBlockHash",
											"nodeType": "VariableDeclaration",
											"scope": 1123,
											"src": "16081:22:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1095,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "16081:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1100,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1097,
											"name": "blockHash32Map",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 173,
											"src": "16106:14:2",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
												"typeString": "mapping(uint32 => uint32)"
											}
										},
										"id": 1099,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1098,
											"name": "blockNum",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1090,
											"src": "16121:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "16106:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "16081:49:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1103,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1101,
											"name": "cachedBlockHash",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1096,
											"src": "16145:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1102,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "16164:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "16145:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1119,
									"nodeType": "IfStatement",
									"src": "16141:152:2",
									"trueBody": {
										"id": 1118,
										"nodeType": "Block",
										"src": "16167:126:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1110,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1104,
														"name": "cachedBlockHash",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1096,
														"src": "16181:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"id": 1107,
																		"name": "blockNum",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1090,
																		"src": "16216:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1106,
																	"name": "blockhash",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4363,
																	"src": "16206:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
																		"typeString": "function (uint256) view returns (bytes32)"
																	}
																},
																"id": 1108,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "16206:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															],
															"id": 1105,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "16199:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 1109,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "16199:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "16181:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1111,
												"nodeType": "ExpressionStatement",
												"src": "16181:45:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1116,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1112,
															"name": "blockHash32Map",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 173,
															"src": "16240:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																"typeString": "mapping(uint32 => uint32)"
															}
														},
														"id": 1114,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1113,
															"name": "blockNum",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1090,
															"src": "16255:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "16240:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 1115,
														"name": "cachedBlockHash",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1096,
														"src": "16267:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "16240:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1117,
												"nodeType": "ExpressionStatement",
												"src": "16240:42:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1120,
										"name": "cachedBlockHash",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1096,
										"src": "16310:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 1094,
									"id": 1121,
									"nodeType": "Return",
									"src": "16303:22:2"
								}
							]
						},
						"documentation": "@notice Caches the hash for a specific block in a map.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
						"id": 1123,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "cacheBlockHash32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1091,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1090,
									"name": "blockNum",
									"nodeType": "VariableDeclaration",
									"scope": 1123,
									"src": "16031:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1089,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16031:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16030:17:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1094,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1093,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1123,
									"src": "16063:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1092,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16063:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16062:8:2"
						},
						"scope": 4288,
						"src": "16005:327:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1151,
							"nodeType": "Block",
							"src": "16583:189:2",
							"statements": [
								{
									"assignments": [
										1131
									],
									"declarations": [
										{
											"constant": false,
											"id": 1131,
											"name": "blockHash32",
											"nodeType": "VariableDeclaration",
											"scope": 1152,
											"src": "16593:18:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1130,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "16593:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1137,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1134,
														"name": "blockNum",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1125,
														"src": "16631:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 1133,
													"name": "blockhash",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4363,
													"src": "16621:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
														"typeString": "function (uint256) view returns (bytes32)"
													}
												},
												"id": 1135,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "16621:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 1132,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "16614:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint32_$",
												"typeString": "type(uint32)"
											},
											"typeName": "uint32"
										},
										"id": 1136,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "16614:27:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "16593:48:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1140,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1138,
											"name": "blockHash32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1131,
											"src": "16656:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1139,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "16671:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "16656:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1148,
									"nodeType": "IfStatement",
									"src": "16652:85:2",
									"trueBody": {
										"id": 1147,
										"nodeType": "Block",
										"src": "16674:63:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1145,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1141,
														"name": "blockHash32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1131,
														"src": "16688:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1142,
															"name": "blockHash32Map",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 173,
															"src": "16702:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																"typeString": "mapping(uint32 => uint32)"
															}
														},
														"id": 1144,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1143,
															"name": "blockNum",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1125,
															"src": "16717:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "16702:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "16688:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1146,
												"nodeType": "ExpressionStatement",
												"src": "16688:38:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1149,
										"name": "blockHash32",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1131,
										"src": "16754:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 1129,
									"id": 1150,
									"nodeType": "Return",
									"src": "16747:18:2"
								}
							]
						},
						"documentation": "@notice Get hash for a specific block.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
						"id": 1152,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "readBlockHash32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1126,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1125,
									"name": "blockNum",
									"nodeType": "VariableDeclaration",
									"scope": 1152,
									"src": "16538:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1124,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16538:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16537:17:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1129,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1128,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1152,
									"src": "16575:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1127,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "16575:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16574:8:2"
						},
						"scope": 4288,
						"src": "16513:259:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1160,
							"nodeType": "Block",
							"src": "16902:44:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 1157,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "16919:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1158,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "length",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "16919:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1156,
									"id": 1159,
									"nodeType": "Return",
									"src": "16912:27:2"
								}
							]
						},
						"documentation": "@notice Returns total number of games that have been created.",
						"id": 1161,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "numberOfGames",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1153,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "16870:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1156,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1155,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1161,
									"src": "16893:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1154,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "16893:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "16892:9:2"
						},
						"scope": 4288,
						"src": "16848:98:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1286,
							"nodeType": "Block",
							"src": "17332:1119:2",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1178,
											"name": "gameIdList",
											"nodeType": "VariableDeclaration",
											"scope": 1287,
											"src": "17342:29:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
												"typeString": "uint256[10]"
											},
											"typeName": {
												"baseType": {
													"id": 1176,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "17342:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 1177,
												"length": {
													"argumentTypes": null,
													"hexValue": "3130",
													"id": 1175,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "17350:2:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "10"
												},
												"nodeType": "ArrayTypeName",
												"src": "17342:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
													"typeString": "uint256[10]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1179,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "17342:29:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1181,
											"name": "gameIdCount",
											"nodeType": "VariableDeclaration",
											"scope": 1287,
											"src": "17381:18:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1180,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "17381:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1182,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "17381:18:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1184,
											"name": "gameId",
											"nodeType": "VariableDeclaration",
											"scope": 1287,
											"src": "17409:14:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1183,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "17409:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1185,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "17409:14:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1189,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1186,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "17437:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1187,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "17437:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1188,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "17460:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "17437:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1280,
									"nodeType": "IfStatement",
									"src": "17433:961:2",
									"trueBody": {
										"id": 1279,
										"nodeType": "Block",
										"src": "17463:931:2",
										"statements": [
											{
												"assignments": [
													1191
												],
												"declarations": [
													{
														"constant": false,
														"id": 1191,
														"name": "startPosition",
														"nodeType": "VariableDeclaration",
														"scope": 1287,
														"src": "17553:21:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"typeName": {
															"id": 1190,
															"name": "uint256",
															"nodeType": "ElementaryTypeName",
															"src": "17553:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1196,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1195,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1192,
															"name": "gameDataArray",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 186,
															"src": "17577:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																"typeString": "struct WorldGame.GameData storage ref[] storage ref"
															}
														},
														"id": 1193,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "length",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "17577:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "-",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 1194,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "17600:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "17577:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "17553:48:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1203,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1199,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1197,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1163,
															"src": "17619:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1198,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17628:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "17619:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1202,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1200,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1163,
															"src": "17633:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1201,
															"name": "startPosition",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1191,
															"src": "17642:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "17633:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "17619:36:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1209,
												"nodeType": "IfStatement",
												"src": "17615:97:2",
												"trueBody": {
													"id": 1208,
													"nodeType": "Block",
													"src": "17657:55:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1206,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1204,
																	"name": "startPosition",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1191,
																	"src": "17675:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1205,
																	"name": "offset",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1163,
																	"src": "17691:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "17675:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 1207,
															"nodeType": "ExpressionStatement",
															"src": "17675:22:2"
														}
													]
												}
											},
											{
												"body": {
													"id": 1277,
													"nodeType": "Block",
													"src": "17867:517:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1226,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1222,
																	"name": "gameId",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1184,
																	"src": "17885:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 1225,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1223,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1211,
																		"src": "17894:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 1224,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "17898:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"src": "17894:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "17885:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 1227,
															"nodeType": "ExpressionStatement",
															"src": "17885:14:2"
														},
														{
															"assignments": [
																1229
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 1229,
																	"name": "game",
																	"nodeType": "VariableDeclaration",
																	"scope": 1287,
																	"src": "17918:21:2",
																	"stateVariable": false,
																	"storageLocation": "storage",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData"
																	},
																	"typeName": {
																		"contractScope": null,
																		"id": 1228,
																		"name": "GameData",
																		"nodeType": "UserDefinedTypeName",
																		"referencedDeclaration": 245,
																		"src": "17918:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 1233,
															"initialValue": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 1230,
																	"name": "gameDataArray",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 186,
																	"src": "17942:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																		"typeString": "struct WorldGame.GameData storage ref[] storage ref"
																	}
																},
																"id": 1232,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 1231,
																	"name": "gameId",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1184,
																	"src": "17956:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "17942:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage",
																	"typeString": "struct WorldGame.GameData storage ref"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "17918:45:2"
														},
														{
															"body": {
																"id": 1264,
																"nodeType": "Block",
																"src": "18027:234:2",
																"statements": [
																	{
																		"condition": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 1251,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1245,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1229,
																						"src": "18053:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 1246,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "18053:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 1248,
																				"indexExpression": {
																					"argumentTypes": null,
																					"id": 1247,
																					"name": "j",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1235,
																					"src": "18074:1:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "18053:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1249,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "18080:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 1250,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "18080:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "18053:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"falseBody": null,
																		"id": 1263,
																		"nodeType": "IfStatement",
																		"src": "18049:194:2",
																		"trueBody": {
																			"id": 1262,
																			"nodeType": "Block",
																			"src": "18092:151:2",
																			"statements": [
																				{
																					"expression": {
																						"argumentTypes": null,
																						"id": 1256,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"leftHandSide": {
																							"argumentTypes": null,
																							"baseExpression": {
																								"argumentTypes": null,
																								"id": 1252,
																								"name": "gameIdList",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1178,
																								"src": "18118:10:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
																									"typeString": "uint256[10] memory"
																								}
																							},
																							"id": 1254,
																							"indexExpression": {
																								"argumentTypes": null,
																								"id": 1253,
																								"name": "gameIdCount",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1181,
																								"src": "18129:11:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint32",
																									"typeString": "uint32"
																								}
																							},
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": true,
																							"nodeType": "IndexAccess",
																							"src": "18118:23:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"nodeType": "Assignment",
																						"operator": "=",
																						"rightHandSide": {
																							"argumentTypes": null,
																							"id": 1255,
																							"name": "gameId",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1184,
																							"src": "18144:6:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"src": "18118:32:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint256",
																							"typeString": "uint256"
																						}
																					},
																					"id": 1257,
																					"nodeType": "ExpressionStatement",
																					"src": "18118:32:2"
																				},
																				{
																					"expression": {
																						"argumentTypes": null,
																						"id": 1259,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"nodeType": "UnaryOperation",
																						"operator": "++",
																						"prefix": false,
																						"src": "18176:13:2",
																						"subExpression": {
																							"argumentTypes": null,
																							"id": 1258,
																							"name": "gameIdCount",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1181,
																							"src": "18176:11:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint32",
																								"typeString": "uint32"
																							}
																						},
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"id": 1260,
																					"nodeType": "ExpressionStatement",
																					"src": "18176:13:2"
																				},
																				{
																					"id": 1261,
																					"nodeType": "Break",
																					"src": "18215:5:2"
																				}
																			]
																		}
																	}
																]
															},
															"condition": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 1241,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 1238,
																	"name": "j",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1235,
																	"src": "18000:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "<",
																"rightExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1239,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1229,
																		"src": "18004:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1240,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "playerCount",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 220,
																	"src": "18004:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "18000:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1265,
															"initializationExpression": {
																"assignments": [
																	1235
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 1235,
																		"name": "j",
																		"nodeType": "VariableDeclaration",
																		"scope": 1287,
																		"src": "17986:8:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 1234,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "17986:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 1237,
																"initialValue": {
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 1236,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "17997:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "17986:12:2"
															},
															"loopExpression": {
																"expression": {
																	"argumentTypes": null,
																	"id": 1243,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "UnaryOperation",
																	"operator": "++",
																	"prefix": false,
																	"src": "18022:3:2",
																	"subExpression": {
																		"argumentTypes": null,
																		"id": 1242,
																		"name": "j",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1235,
																		"src": "18022:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1244,
																"nodeType": "ExpressionStatement",
																"src": "18022:3:2"
															},
															"nodeType": "ForStatement",
															"src": "17981:280:2"
														},
														{
															"condition": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 1273,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 1268,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1266,
																		"name": "gameIdCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1181,
																		"src": "18283:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "3130",
																		"id": 1267,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "18298:2:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_10_by_1",
																			"typeString": "int_const 10"
																		},
																		"value": "10"
																	},
																	"src": "18283:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 1272,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [],
																		"expression": {
																			"argumentTypes": [],
																			"id": 1269,
																			"name": "gasleft",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4365,
																			"src": "18304:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_gasleft_view$__$returns$_t_uint256_$",
																				"typeString": "function () view returns (uint256)"
																			}
																		},
																		"id": 1270,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "18304:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "<",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "313030303030",
																		"id": 1271,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "18316:6:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_100000_by_1",
																			"typeString": "int_const 100000"
																		},
																		"value": "100000"
																	},
																	"src": "18304:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "18283:39:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"falseBody": null,
															"id": 1276,
															"nodeType": "IfStatement",
															"src": "18279:91:2",
															"trueBody": {
																"id": 1275,
																"nodeType": "Block",
																"src": "18324:46:2",
																"statements": [
																	{
																		"id": 1274,
																		"nodeType": "Break",
																		"src": "18346:5:2"
																	}
																]
															}
														}
													]
												},
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1218,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1216,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1211,
														"src": "17855:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1217,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "17859:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "17855:5:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 1278,
												"initializationExpression": {
													"assignments": [
														1211
													],
													"declarations": [
														{
															"constant": false,
															"id": 1211,
															"name": "i",
															"nodeType": "VariableDeclaration",
															"scope": 1287,
															"src": "17824:9:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"typeName": {
																"id": 1210,
																"name": "uint256",
																"nodeType": "ElementaryTypeName",
																"src": "17824:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1215,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1214,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1212,
															"name": "startPosition",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1191,
															"src": "17836:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "+",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 1213,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17852:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "17836:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "17824:29:2"
												},
												"loopExpression": {
													"expression": {
														"argumentTypes": null,
														"id": 1220,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "UnaryOperation",
														"operator": "--",
														"prefix": false,
														"src": "17862:3:2",
														"subExpression": {
															"argumentTypes": null,
															"id": 1219,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1211,
															"src": "17862:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 1221,
													"nodeType": "ExpressionStatement",
													"src": "17862:3:2"
												},
												"nodeType": "ForStatement",
												"src": "17819:565:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"id": 1281,
												"name": "gameIdList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1178,
												"src": "18412:10:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
													"typeString": "uint256[10] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1282,
												"name": "gameIdCount",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1181,
												"src": "18424:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 1283,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1184,
												"src": "18437:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"id": 1284,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "18411:33:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_array$_t_uint256_$10_memory_ptr_$_t_uint32_$_t_uint256_$",
											"typeString": "tuple(uint256[10] memory,uint32,uint256)"
										}
									},
									"functionReturnParameters": 1173,
									"id": 1285,
									"nodeType": "Return",
									"src": "18404:40:2"
								}
							]
						},
						"documentation": "@notice Returns recent game ids where msg.sender is a player.\n @param offset Position in game data array to start search from\n @return List of game ids\n @return Number of game ids\n @return Position in loop when ended",
						"id": 1287,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "listGamesForAddress",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1164,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1163,
									"name": "offset",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17234:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1162,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "17234:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "17233:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1173,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1168,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17297:11:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
										"typeString": "uint256[10]"
									},
									"typeName": {
										"baseType": {
											"id": 1165,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "17297:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 1167,
										"length": {
											"argumentTypes": null,
											"hexValue": "3130",
											"id": 1166,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "17305:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											},
											"value": "10"
										},
										"nodeType": "ArrayTypeName",
										"src": "17297:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
											"typeString": "uint256[10]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1170,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17310:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1169,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "17310:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1172,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1287,
									"src": "17318:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1171,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "17318:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "17296:30:2"
						},
						"scope": 4288,
						"src": "17205:1246:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1339,
							"nodeType": "Block",
							"src": "18840:302:2",
							"statements": [
								{
									"assignments": [
										1301
									],
									"declarations": [
										{
											"constant": false,
											"id": 1301,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1340,
											"src": "18850:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1300,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "18850:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1305,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1302,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "18874:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1304,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1303,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1289,
											"src": "18888:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "18874:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "18850:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1310,
											"name": "regionOwnersList",
											"nodeType": "VariableDeclaration",
											"scope": 1340,
											"src": "18906:44:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
												"typeString": "uint32[25]"
											},
											"typeName": {
												"baseType": {
													"id": 1308,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "18906:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1309,
												"length": {
													"argumentTypes": null,
													"id": 1307,
													"name": "REGION_COUNT",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 129,
													"src": "18913:12:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "18906:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
													"typeString": "uint32[25]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1311,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "18906:44:2"
								},
								{
									"body": {
										"id": 1332,
										"nodeType": "Block",
										"src": "19002:77:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1330,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1322,
															"name": "regionOwnersList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1310,
															"src": "19016:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																"typeString": "uint32[25] memory"
															}
														},
														"id": 1324,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1323,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1313,
															"src": "19033:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "19016:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1326,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1301,
																	"src": "19047:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1327,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "19047:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1328,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1313,
																"src": "19066:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1325,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "19038:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1329,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "19038:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "19016:52:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1331,
												"nodeType": "ExpressionStatement",
												"src": "19016:52:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1318,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1316,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1313,
											"src": "18979:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1317,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "18983:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "18979:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1333,
									"initializationExpression": {
										"assignments": [
											1313
										],
										"declarations": [
											{
												"constant": false,
												"id": 1313,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1340,
												"src": "18965:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1312,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "18965:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1315,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1314,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "18976:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "18965:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1320,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "18997:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1319,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1313,
												"src": "18997:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1321,
										"nodeType": "ExpressionStatement",
										"src": "18997:3:2"
									},
									"nodeType": "ForStatement",
									"src": "18960:119:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"id": 1334,
												"name": "regionOwnersList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1310,
												"src": "19097:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
													"typeString": "uint32[25] memory"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1335,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1301,
													"src": "19115:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1336,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "regionSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 232,
												"src": "19115:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											}
										],
										"id": 1337,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "19096:39:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_array$_t_uint32_$25_memory_ptr_$_t_array$_t_uint32_$25_storage_$",
											"typeString": "tuple(uint32[25] memory,uint32[25] storage ref)"
										}
									},
									"functionReturnParameters": 1299,
									"id": 1338,
									"nodeType": "Return",
									"src": "19089:46:2"
								}
							]
						},
						"documentation": "@notice Returns the number of soldiers deployed to each region and region owners.\n @param gameId Id of game \n @return List of which player owns each region\n @return List of number of soldiers deployed to each region",
						"id": 1340,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "soldiersByRegion",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1290,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1289,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1340,
									"src": "18728:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1288,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "18728:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "18727:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1299,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1294,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1340,
									"src": "18791:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
										"typeString": "uint32[25]"
									},
									"typeName": {
										"baseType": {
											"id": 1291,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "18791:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1293,
										"length": {
											"argumentTypes": null,
											"id": 1292,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "18798:12:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "18791:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
											"typeString": "uint32[25]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1298,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1340,
									"src": "18813:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
										"typeString": "uint32[25]"
									},
									"typeName": {
										"baseType": {
											"id": 1295,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "18813:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1297,
										"length": {
											"argumentTypes": null,
											"id": 1296,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "18820:12:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "18813:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
											"typeString": "uint32[25]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "18790:44:2"
						},
						"scope": 4288,
						"src": "18702:440:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1379,
							"nodeType": "Block",
							"src": "19575:277:2",
							"statements": [
								{
									"assignments": [
										1360
									],
									"declarations": [
										{
											"constant": false,
											"id": 1360,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1380,
											"src": "19585:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1359,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "19585:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1364,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1361,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "19609:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1363,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1362,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1342,
											"src": "19623:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "19609:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "19585:45:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1365,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19661:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1366,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "19661:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1367,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19691:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1368,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "19691:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1369,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19718:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1370,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "maxBlocksPerTurn",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 218,
												"src": "19718:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1371,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19754:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1372,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "playerCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 220,
												"src": "19754:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1373,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19785:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1374,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "playerAddresses",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 224,
												"src": "19785:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_address_$8_storage",
													"typeString": "address[8] storage ref"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1375,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1360,
													"src": "19819:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1376,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "teamAvatars",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 244,
												"src": "19819:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes8",
													"typeString": "bytes8"
												}
											}
										],
										"id": 1377,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "19647:198:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_uint32_$_t_uint32_$_t_array$_t_address_$8_storage_$_t_bytes8_$",
											"typeString": "tuple(uint32,uint32,uint32,uint32,address[8] storage ref,bytes8)"
										}
									},
									"functionReturnParameters": 1358,
									"id": 1378,
									"nodeType": "Return",
									"src": "19640:205:2"
								}
							]
						},
						"documentation": "@notice Returns information about current turn and players.\n @param gameId Id of game \n @return Id of current player\n @return Turn number\n @return Max blocks per turn\n @return Number of players\n @return Player addresses",
						"id": 1380,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "turnAndPlayerInfo",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1343,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1342,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19445:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1341,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "19445:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "19444:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1358,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1345,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19508:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1344,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19508:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1347,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19516:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1346,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19516:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1349,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19524:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1348,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19524:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1351,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19532:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1350,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "19532:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1355,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19540:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
										"typeString": "address[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1352,
											"name": "address",
											"nodeType": "ElementaryTypeName",
											"src": "19540:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 1354,
										"length": {
											"argumentTypes": null,
											"id": 1353,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "19548:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "19540:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
											"typeString": "address[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1357,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1380,
									"src": "19562:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 1356,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "19562:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "19507:62:2"
						},
						"scope": 4288,
						"src": "19418:434:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1446,
							"nodeType": "Block",
							"src": "20213:445:2",
							"statements": [
								{
									"assignments": [
										1394
									],
									"declarations": [
										{
											"constant": false,
											"id": 1394,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1447,
											"src": "20223:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1393,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "20223:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1398,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1395,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "20247:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1397,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1396,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1382,
											"src": "20261:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "20247:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "20223:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1403,
											"name": "undeployedSoldiersList",
											"nodeType": "VariableDeclaration",
											"scope": 1447,
											"src": "20279:49:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1401,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "20279:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1402,
												"length": {
													"argumentTypes": null,
													"id": 1400,
													"name": "MAX_PLAYERS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 135,
													"src": "20286:11:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "20279:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1404,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "20279:49:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1409,
											"name": "regionRewardList",
											"nodeType": "VariableDeclaration",
											"scope": 1447,
											"src": "20338:43:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1407,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "20338:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1408,
												"length": {
													"argumentTypes": null,
													"id": 1406,
													"name": "MAX_PLAYERS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 135,
													"src": "20345:11:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "20338:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1410,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "20338:43:2"
								},
								{
									"body": {
										"id": 1440,
										"nodeType": "Block",
										"src": "20432:160:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1429,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1421,
															"name": "undeployedSoldiersList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1403,
															"src": "20446:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1423,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1422,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1412,
															"src": "20469:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "20446:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1425,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1394,
																	"src": "20484:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1426,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "undeployedSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 226,
																"src": "20484:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1427,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20509:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1424,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "20474:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1428,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "20474:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "20446:65:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1430,
												"nodeType": "ExpressionStatement",
												"src": "20446:65:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1438,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1431,
															"name": "regionRewardList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1409,
															"src": "20525:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1433,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1432,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1412,
															"src": "20542:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "20525:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 1435,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1382,
																"src": "20570:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1436,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20578:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1434,
															"name": "calculateRegionRewards",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2164,
															"src": "20547:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) view returns (uint32)"
															}
														},
														"id": 1437,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "20547:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "20525:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1439,
												"nodeType": "ExpressionStatement",
												"src": "20525:55:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1417,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1415,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1412,
											"src": "20410:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1416,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "20414:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "20410:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1441,
									"initializationExpression": {
										"assignments": [
											1412
										],
										"declarations": [
											{
												"constant": false,
												"id": 1412,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20396:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1411,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "20396:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1414,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1413,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "20407:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "20396:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1419,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "20427:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1418,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1412,
												"src": "20427:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1420,
										"nodeType": "ExpressionStatement",
										"src": "20427:3:2"
									},
									"nodeType": "ForStatement",
									"src": "20391:201:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"id": 1442,
												"name": "undeployedSoldiersList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1403,
												"src": "20610:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1443,
												"name": "regionRewardList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1409,
												"src": "20634:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											}
										],
										"id": 1444,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "20609:42:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
											"typeString": "tuple(uint32[8] memory,uint32[8] memory)"
										}
									},
									"functionReturnParameters": 1392,
									"id": 1445,
									"nodeType": "Return",
									"src": "20602:49:2"
								}
							]
						},
						"documentation": "@notice Returns the number of undeployed soldiers for each player.\n @param gameId Id of game \n @return Number of undeployed soldiers for each player\n @return Reward points for each player",
						"id": 1447,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "undeployedSoldiers",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1383,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1382,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1447,
									"src": "20103:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1381,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "20103:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "20102:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1392,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1387,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1447,
									"src": "20166:19:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1384,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "20166:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1386,
										"length": {
											"argumentTypes": null,
											"id": 1385,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "20173:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "20166:19:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1391,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1447,
									"src": "20187:19:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1388,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "20187:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1390,
										"length": {
											"argumentTypes": null,
											"id": 1389,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "20194:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "20187:19:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "20165:42:2"
						},
						"scope": 4288,
						"src": "20075:583:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1560,
							"nodeType": "Block",
							"src": "21323:836:2",
							"statements": [
								{
									"assignments": [
										1471
									],
									"declarations": [
										{
											"constant": false,
											"id": 1471,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21333:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1470,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "21333:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1475,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1472,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "21357:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1474,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1473,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1449,
											"src": "21371:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "21357:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "21333:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1480,
											"name": "fromRegionList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21389:50:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1478,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21389:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1479,
												"length": {
													"argumentTypes": null,
													"id": 1477,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21396:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21389:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1481,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21389:50:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1486,
											"name": "toRegionList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21449:48:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1484,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21449:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1485,
												"length": {
													"argumentTypes": null,
													"id": 1483,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21456:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21449:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1487,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21449:48:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1492,
											"name": "moveSoldierCountList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21507:56:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1490,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21507:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1491,
												"length": {
													"argumentTypes": null,
													"id": 1489,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21514:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21507:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1493,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21507:56:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1498,
											"name": "submitBlockList",
											"nodeType": "VariableDeclaration",
											"scope": 1561,
											"src": "21573:51:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1496,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21573:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1497,
												"length": {
													"argumentTypes": null,
													"id": 1495,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "21580:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "21573:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1499,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "21573:51:2"
								},
								{
									"body": {
										"id": 1550,
										"nodeType": "Block",
										"src": "21685:289:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1518,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1510,
															"name": "fromRegionList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1480,
															"src": "21699:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1512,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1511,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21714:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21699:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1514,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21729:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1515,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "fromRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 236,
																"src": "21729:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1516,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21750:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1513,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21719:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1517,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21719:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21699:53:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1519,
												"nodeType": "ExpressionStatement",
												"src": "21699:53:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1528,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1520,
															"name": "toRegionList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1486,
															"src": "21766:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1522,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1521,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21779:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21766:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1524,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21794:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1525,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "toRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 238,
																"src": "21794:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1526,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21813:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1523,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21784:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1527,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21784:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21766:49:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1529,
												"nodeType": "ExpressionStatement",
												"src": "21766:49:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1538,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1530,
															"name": "moveSoldierCountList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1492,
															"src": "21829:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1532,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1531,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21850:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21829:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1534,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21865:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1535,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "moveSoldierCountList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 240,
																"src": "21865:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1536,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21892:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1533,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21855:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1537,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21855:39:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21829:65:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1539,
												"nodeType": "ExpressionStatement",
												"src": "21829:65:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1548,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1540,
															"name": "submitBlockList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1498,
															"src": "21908:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1542,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1541,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1501,
															"src": "21924:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "21908:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1544,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1471,
																	"src": "21939:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1545,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "submitBlockList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 242,
																"src": "21939:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1546,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21961:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1543,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "21929:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1547,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "21929:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "21908:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1549,
												"nodeType": "ExpressionStatement",
												"src": "21908:55:2"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1506,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1504,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1501,
											"src": "21654:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1505,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21658:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "21654:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1551,
									"initializationExpression": {
										"assignments": [
											1501
										],
										"declarations": [
											{
												"constant": false,
												"id": 1501,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21640:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1500,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "21640:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1503,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1502,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "21651:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "21640:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1508,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "21680:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1507,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1501,
												"src": "21680:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1509,
										"nodeType": "ExpressionStatement",
										"src": "21680:3:2"
									},
									"nodeType": "ForStatement",
									"src": "21635:339:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1552,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1471,
													"src": "22005:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1553,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "22005:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 1554,
												"name": "fromRegionList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1480,
												"src": "22036:14:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1555,
												"name": "toRegionList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1486,
												"src": "22065:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1556,
												"name": "moveSoldierCountList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1492,
												"src": "22092:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1557,
												"name": "submitBlockList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1498,
												"src": "22127:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											}
										],
										"id": 1558,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "21991:161:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
											"typeString": "tuple(uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
										}
									},
									"functionReturnParameters": 1469,
									"id": 1559,
									"nodeType": "Return",
									"src": "21984:168:2"
								}
							]
						},
						"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Number of pending actions\n @return List of regions moving soldiers from\n @return List of regions moving soldiers to\n @return List with number of soldiers to move\n @return List with block number when action was queued",
						"id": 1561,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pendingActions",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1450,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1449,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21063:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1448,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "21063:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "21062:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1469,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1452,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21139:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1451,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "21139:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1456,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21159:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1453,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21159:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1455,
										"length": {
											"argumentTypes": null,
											"id": 1454,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21166:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21159:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1460,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21202:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1457,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21202:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1459,
										"length": {
											"argumentTypes": null,
											"id": 1458,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21209:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21202:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1464,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21245:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1461,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21245:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1463,
										"length": {
											"argumentTypes": null,
											"id": 1462,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21252:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21245:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1468,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1561,
									"src": "21288:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1465,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21288:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1467,
										"length": {
											"argumentTypes": null,
											"id": 1466,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "21295:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "21288:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "21125:197:2"
						},
						"scope": 4288,
						"src": "21039:1120:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1710,
							"nodeType": "Block",
							"src": "22781:1507:2",
							"statements": [
								{
									"assignments": [
										1583
									],
									"declarations": [
										{
											"constant": false,
											"id": 1583,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22791:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1582,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "22791:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1587,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1584,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "22815:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1586,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1585,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1563,
											"src": "22829:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "22815:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "22791:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1592,
											"name": "submitBlockList",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22847:51:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1590,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "22847:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1591,
												"length": {
													"argumentTypes": null,
													"id": 1589,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "22854:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "22847:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1593,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "22847:51:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1598,
											"name": "remainingAttackerList",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22908:57:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1596,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "22908:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1597,
												"length": {
													"argumentTypes": null,
													"id": 1595,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "22915:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "22908:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1599,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "22908:57:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1604,
											"name": "remainingDefenderList",
											"nodeType": "VariableDeclaration",
											"scope": 1711,
											"src": "22975:57:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
												"typeString": "uint32[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1602,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "22975:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1603,
												"length": {
													"argumentTypes": null,
													"id": 1601,
													"name": "MAX_ACTIONS_PER_TURN",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 138,
													"src": "22982:20:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "22975:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
													"typeString": "uint32[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1605,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "22975:57:2"
								},
								{
									"body": {
										"id": 1697,
										"nodeType": "Block",
										"src": "23093:995:2",
										"statements": [
											{
												"assignments": [
													1617
												],
												"declarations": [
													{
														"constant": false,
														"id": 1617,
														"name": "toRegion",
														"nodeType": "VariableDeclaration",
														"scope": 1711,
														"src": "23107:15:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1616,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "23107:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1623,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1619,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1583,
																"src": "23135:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1620,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "toRegionList",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 238,
															"src": "23135:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1621,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1607,
															"src": "23154:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1618,
														"name": "getData32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4095,
														"src": "23125:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1622,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "23125:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "23107:49:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 1632,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1624,
															"name": "submitBlockList",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1592,
															"src": "23170:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																"typeString": "uint32[8] memory"
															}
														},
														"id": 1626,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1625,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1607,
															"src": "23186:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "23170:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1628,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1583,
																	"src": "23201:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1629,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "submitBlockList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 242,
																"src": "23201:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1630,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1607,
																"src": "23223:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1627,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "23191:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1631,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "23191:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "23170:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1633,
												"nodeType": "ExpressionStatement",
												"src": "23170:55:2"
											},
											{
												"assignments": [
													1635
												],
												"declarations": [
													{
														"constant": false,
														"id": 1635,
														"name": "friendly",
														"nodeType": "VariableDeclaration",
														"scope": 1711,
														"src": "23240:13:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"typeName": {
															"id": 1634,
															"name": "bool",
															"nodeType": "ElementaryTypeName",
															"src": "23240:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1652,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1651,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1643,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1637,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1583,
																		"src": "23265:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1638,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "23265:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1639,
																	"name": "toRegion",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1617,
																	"src": "23284:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1636,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "23256:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1640,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "23256:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1641,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1583,
																"src": "23297:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1642,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "23297:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23256:56:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1650,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1645,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1583,
																		"src": "23342:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1646,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "23342:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1647,
																	"name": "toRegion",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1617,
																	"src": "23361:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1644,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "23333:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1648,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "23333:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1649,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "23374:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23333:50:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "23256:127:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "23240:143:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1662,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1653,
														"name": "friendly",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1635,
														"src": "23402:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1661,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1654,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "23414:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 1655,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "23414:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1660,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 1656,
																	"name": "submitBlockList",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1592,
																	"src": "23429:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																		"typeString": "uint32[8] memory"
																	}
																},
																"id": 1658,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 1657,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1607,
																	"src": "23445:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "23429:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1659,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "23450:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "23429:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23414:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "23402:49:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1696,
												"nodeType": "IfStatement",
												"src": "23398:680:2",
												"trueBody": {
													"id": 1695,
													"nodeType": "Block",
													"src": "23453:625:2",
													"statements": [
														{
															"assignments": [
																1664,
																1666
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 1664,
																	"name": "remainingAttackers",
																	"nodeType": "VariableDeclaration",
																	"scope": 1711,
																	"src": "23472:25:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 1663,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "23472:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																},
																{
																	"constant": false,
																	"id": 1666,
																	"name": "remainingDefenders",
																	"nodeType": "VariableDeclaration",
																	"scope": 1711,
																	"src": "23499:25:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 1665,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "23499:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 1682,
															"initialValue": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1668,
																			"name": "submitBlockList",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1592,
																			"src": "23617:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																				"typeString": "uint32[8] memory"
																			}
																		},
																		"id": 1670,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1669,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1607,
																			"src": "23633:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "23617:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1672,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1583,
																					"src": "23718:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1673,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "moveSoldierCountList",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 240,
																				"src": "23718:25:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 1674,
																				"name": "i",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1607,
																				"src": "23745:1:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 1671,
																			"name": "getData32",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4095,
																			"src": "23708:9:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint256,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 1675,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "23708:39:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1676,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1583,
																				"src": "23818:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1677,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "23818:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1679,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1678,
																			"name": "toRegion",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1617,
																			"src": "23838:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "23818:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1680,
																		"name": "friendly",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1635,
																		"src": "23910:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	],
																	"id": 1667,
																	"name": "getOutcomeAttackOrMove",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2100,
																	"src": "23528:22:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
																		"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
																	}
																},
																"id": 1681,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "23528:408:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
																	"typeString": "tuple(uint32,uint32)"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "23471:465:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1687,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1683,
																		"name": "remainingAttackerList",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1598,
																		"src": "23955:21:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																			"typeString": "uint32[8] memory"
																		}
																	},
																	"id": 1685,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1684,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1607,
																		"src": "23977:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "23955:24:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1686,
																	"name": "remainingAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1664,
																	"src": "23982:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "23955:45:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1688,
															"nodeType": "ExpressionStatement",
															"src": "23955:45:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1693,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1689,
																		"name": "remainingDefenderList",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1604,
																		"src": "24018:21:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																			"typeString": "uint32[8] memory"
																		}
																	},
																	"id": 1691,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1690,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1607,
																		"src": "24040:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "24018:24:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1692,
																	"name": "remainingDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1666,
																	"src": "24045:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "24018:45:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1694,
															"nodeType": "ExpressionStatement",
															"src": "24018:45:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1612,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1610,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1607,
											"src": "23062:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1611,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "23066:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "23062:24:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1698,
									"initializationExpression": {
										"assignments": [
											1607
										],
										"declarations": [
											{
												"constant": false,
												"id": 1607,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "23048:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1606,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "23048:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1609,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1608,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "23059:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "23048:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1614,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "23088:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1613,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1607,
												"src": "23088:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1615,
										"nodeType": "ExpressionStatement",
										"src": "23088:3:2"
									},
									"nodeType": "ForStatement",
									"src": "23043:1045:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1700,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "24126:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 1701,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "24126:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 1699,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "24119:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 1702,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "24119:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1703,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1583,
													"src": "24154:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1704,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "24154:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											{
												"argumentTypes": null,
												"id": 1705,
												"name": "submitBlockList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1592,
												"src": "24185:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1706,
												"name": "remainingAttackerList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1598,
												"src": "24215:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											},
											{
												"argumentTypes": null,
												"id": 1707,
												"name": "remainingDefenderList",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1604,
												"src": "24250:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8] memory"
												}
											}
										],
										"id": 1708,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "24105:176:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
											"typeString": "tuple(uint32,uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
										}
									},
									"functionReturnParameters": 1581,
									"id": 1709,
									"nodeType": "Return",
									"src": "24098:183:2"
								}
							]
						},
						"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Current block numbber\n @return Number of pending actions\n @return List with block number when action was queued\n @return Number of remaining attackers\n @return Number of remaining defenders",
						"id": 1711,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pendingActionOutcomes",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1564,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1563,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22544:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1562,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "22544:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "22543:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1581,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1566,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22620:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1565,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "22620:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1568,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22640:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1567,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "22640:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1572,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22660:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1569,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22660:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1571,
										"length": {
											"argumentTypes": null,
											"id": 1570,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "22667:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "22660:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1576,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22703:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1573,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22703:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1575,
										"length": {
											"argumentTypes": null,
											"id": 1574,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "22710:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "22703:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1580,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1711,
									"src": "22746:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
										"typeString": "uint32[8]"
									},
									"typeName": {
										"baseType": {
											"id": 1577,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22746:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1579,
										"length": {
											"argumentTypes": null,
											"id": 1578,
											"name": "MAX_ACTIONS_PER_TURN",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 138,
											"src": "22753:20:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "22746:28:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
											"typeString": "uint32[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "22606:174:2"
						},
						"scope": 4288,
						"src": "22513:1775:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1846,
							"nodeType": "Block",
							"src": "24480:1885:2",
							"statements": [
								{
									"assignments": [
										1717
									],
									"declarations": [
										{
											"constant": false,
											"id": 1717,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1847,
											"src": "24490:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1716,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "24490:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1721,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1718,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "24514:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1720,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1719,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1713,
											"src": "24528:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "24514:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "24490:45:2"
								},
								{
									"body": {
										"id": 1838,
										"nodeType": "Block",
										"src": "24666:1623:2",
										"statements": [
											{
												"assignments": [
													1734
												],
												"declarations": [
													{
														"constant": false,
														"id": 1734,
														"name": "regionFrom",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "24680:17:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1733,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "24680:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1740,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1736,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1717,
																"src": "24710:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1737,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "fromRegionList",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 236,
															"src": "24710:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1738,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1723,
															"src": "24731:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1735,
														"name": "getData32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4095,
														"src": "24700:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1739,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "24700:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "24680:53:2"
											},
											{
												"assignments": [
													1742
												],
												"declarations": [
													{
														"constant": false,
														"id": 1742,
														"name": "regionTo",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "24747:15:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1741,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "24747:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1748,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1744,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1717,
																"src": "24775:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1745,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "toRegionList",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 238,
															"src": "24775:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1746,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1723,
															"src": "24794:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1743,
														"name": "getData32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4095,
														"src": "24765:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1747,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "24765:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "24747:49:2"
											},
											{
												"assignments": [
													1750
												],
												"declarations": [
													{
														"constant": false,
														"id": 1750,
														"name": "friendly",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "24810:13:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"typeName": {
															"id": 1749,
															"name": "bool",
															"nodeType": "ElementaryTypeName",
															"src": "24810:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1767,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1766,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1758,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1752,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "24835:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1753,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "24835:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1754,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1742,
																	"src": "24854:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1751,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "24826:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1755,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "24826:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1756,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1717,
																"src": "24867:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1757,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "24867:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "24826:56:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1765,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1760,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "24911:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1761,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "24911:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1762,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1742,
																	"src": "24930:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1759,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "24902:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1763,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "24902:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1764,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "24943:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "24902:50:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "24826:126:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "24810:142:2"
											},
											{
												"assignments": [
													1769,
													1771
												],
												"declarations": [
													{
														"constant": false,
														"id": 1769,
														"name": "remainingAttackers",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "25167:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1768,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "25167:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													},
													{
														"constant": false,
														"id": 1771,
														"name": "remainingDefenders",
														"nodeType": "VariableDeclaration",
														"scope": 1847,
														"src": "25194:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1770,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "25194:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1789,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1774,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25314:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1775,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "submitBlockList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 242,
																	"src": "25314:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1776,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1723,
																	"src": "25336:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1773,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "25304:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1777,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "25304:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1779,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25413:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1780,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "moveSoldierCountList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 240,
																	"src": "25413:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1781,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1723,
																	"src": "25440:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1778,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "25403:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1782,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "25403:39:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1783,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "25505:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1784,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 232,
																"src": "25505:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_storage",
																	"typeString": "uint32[25] storage ref"
																}
															},
															"id": 1786,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1785,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1742,
																"src": "25525:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "25505:29:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 1787,
															"name": "friendly",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1750,
															"src": "25589:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 1772,
														"name": "getOutcomeAttackOrMove",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2100,
														"src": "25223:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
															"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
														}
													},
													"id": 1788,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "25223:388:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
														"typeString": "tuple(uint32,uint32)"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "25166:445:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 1792,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1790,
														"name": "remainingDefenders",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1771,
														"src": "25630:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1791,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "25652:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "25630:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 1836,
													"nodeType": "Block",
													"src": "25949:330:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1826,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1814,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "26043:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1817,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "26043:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 1818,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1816,
																		"name": "regionFrom",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1734,
																		"src": "26063:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "26043:31:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1820,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1717,
																					"src": "26106:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1821,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "regionSoldiers",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 232,
																				"src": "26106:19:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_uint32_$25_storage",
																					"typeString": "uint32[25] storage ref"
																				}
																			},
																			"id": 1823,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 1822,
																				"name": "regionFrom",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1734,
																				"src": "26126:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "26106:31:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 1824,
																			"name": "remainingAttackers",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1769,
																			"src": "26160:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 1819,
																		"name": "addSafe",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4253,
																		"src": "26077:7:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																			"typeString": "function (uint32,uint32) pure returns (uint32)"
																		}
																	},
																	"id": 1825,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "26077:119:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "26043:153:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1827,
															"nodeType": "ExpressionStatement",
															"src": "26043:153:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1834,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1828,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "26214:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1831,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "26214:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 1832,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1830,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "26234:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "26214:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1833,
																	"name": "remainingDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1771,
																	"src": "26246:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "26214:50:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1835,
															"nodeType": "ExpressionStatement",
															"src": "26214:50:2"
														}
													]
												},
												"id": 1837,
												"nodeType": "IfStatement",
												"src": "25626:653:2",
												"trueBody": {
													"id": 1813,
													"nodeType": "Block",
													"src": "25655:276:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1799,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1793,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25774:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1796,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "25774:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 1797,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1795,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "25794:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "25774:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"id": 1798,
																	"name": "remainingAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1769,
																	"src": "25806:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "25774:50:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 1800,
															"nodeType": "ExpressionStatement",
															"src": "25774:50:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 1811,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1801,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25842:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1803,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "25842:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1805,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "25871:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1806,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionOwners",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 228,
																			"src": "25871:17:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 1807,
																			"name": "regionTo",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1742,
																			"src": "25890:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1808,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "25900:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1809,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "turnTeamId",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 214,
																			"src": "25900:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 1804,
																		"name": "setData8",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4203,
																		"src": "25862:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																			"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																		}
																	},
																	"id": 1810,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "25862:54:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "25842:74:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 1812,
															"nodeType": "ExpressionStatement",
															"src": "25842:74:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1729,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1726,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1723,
											"src": "24639:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1727,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1717,
												"src": "24643:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1728,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "24643:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "24639:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1839,
									"initializationExpression": {
										"assignments": [
											1723
										],
										"declarations": [
											{
												"constant": false,
												"id": 1723,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1847,
												"src": "24625:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1722,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "24625:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1725,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1724,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "24636:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "24625:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1731,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "24661:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1730,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1723,
												"src": "24661:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1732,
										"nodeType": "ExpressionStatement",
										"src": "24661:3:2"
									},
									"nodeType": "ForStatement",
									"src": "24620:1669:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1844,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1840,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1717,
												"src": "26338:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1842,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "actionCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 234,
											"src": "26338:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1843,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "26357:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "26338:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 1845,
									"nodeType": "ExpressionStatement",
									"src": "26338:20:2"
								}
							]
						},
						"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game ",
						"id": 1847,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "executePendingActions",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1714,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1713,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1847,
									"src": "24437:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1712,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "24437:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "24427:30:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1715,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "24480:0:2"
						},
						"scope": 4288,
						"src": "24397:1968:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 1947,
							"nodeType": "Block",
							"src": "26601:770:2",
							"statements": [
								{
									"assignments": [
										1855
									],
									"declarations": [
										{
											"constant": false,
											"id": 1855,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26611:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 1854,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "26611:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1859,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1856,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "26635:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 1858,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1857,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1849,
											"src": "26649:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "26635:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "26611:45:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1864,
											"name": "playerOwnsRegion",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26666:41:2",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
												"typeString": "bool[8]"
											},
											"typeName": {
												"baseType": {
													"id": 1862,
													"name": "bool",
													"nodeType": "ElementaryTypeName",
													"src": "26666:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 1863,
												"length": {
													"argumentTypes": null,
													"id": 1861,
													"name": "MAX_PLAYERS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 135,
													"src": "26671:11:2",
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													}
												},
												"nodeType": "ArrayTypeName",
												"src": "26666:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bool_$8_storage_ptr",
													"typeString": "bool[8]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1865,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "26666:41:2"
								},
								{
									"assignments": [
										1867
									],
									"declarations": [
										{
											"constant": false,
											"id": 1867,
											"name": "hasNotOwned",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26717:16:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"typeName": {
												"id": 1866,
												"name": "bool",
												"nodeType": "ElementaryTypeName",
												"src": "26717:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1869,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "66616c7365",
										"id": 1868,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "26736:5:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "false"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "26717:24:2"
								},
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 1871,
											"name": "i",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "26751:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1870,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "26751:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1872,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "26751:8:2"
								},
								{
									"body": {
										"id": 1907,
										"nodeType": "Block",
										"src": "26813:257:2",
										"statements": [
											{
												"assignments": [
													1884
												],
												"declarations": [
													{
														"constant": false,
														"id": 1884,
														"name": "regionOwner",
														"nodeType": "VariableDeclaration",
														"scope": 1948,
														"src": "26827:18:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1883,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "26827:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1890,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1886,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1855,
																"src": "26857:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1887,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionOwners",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 228,
															"src": "26857:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														{
															"argumentTypes": null,
															"id": 1888,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1871,
															"src": "26876:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1885,
														"name": "getData8",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4158,
														"src": "26848:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint256,uint32) pure returns (uint32)"
														}
													},
													"id": 1889,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "26848:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "26827:51:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 1893,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1891,
														"name": "regionOwner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1884,
														"src": "26896:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 1892,
														"name": "NOT_OWNED",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 123,
														"src": "26911:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "26896:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 1905,
													"nodeType": "Block",
													"src": "26991:69:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1903,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1899,
																		"name": "playerOwnsRegion",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1864,
																		"src": "27009:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																			"typeString": "bool[8] memory"
																		}
																	},
																	"id": 1901,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1900,
																		"name": "regionOwner",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1884,
																		"src": "27026:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"nodeType": "IndexAccess",
																	"src": "27009:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "74727565",
																	"id": 1902,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "27041:4:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "true"
																},
																"src": "27009:36:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1904,
															"nodeType": "ExpressionStatement",
															"src": "27009:36:2"
														}
													]
												},
												"id": 1906,
												"nodeType": "IfStatement",
												"src": "26892:168:2",
												"trueBody": {
													"id": 1898,
													"nodeType": "Block",
													"src": "26922:51:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 1896,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 1894,
																	"name": "hasNotOwned",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1867,
																	"src": "26940:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "74727565",
																	"id": 1895,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "26954:4:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "true"
																},
																"src": "26940:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 1897,
															"nodeType": "ExpressionStatement",
															"src": "26940:18:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1879,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1877,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1871,
											"src": "26790:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 1878,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "26794:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "26790:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1908,
									"initializationExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1875,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 1873,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "26783:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1874,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "26787:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "26783:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1876,
										"nodeType": "ExpressionStatement",
										"src": "26783:5:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1881,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "26808:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1880,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "26808:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1882,
										"nodeType": "ExpressionStatement",
										"src": "26808:3:2"
									},
									"nodeType": "ForStatement",
									"src": "26778:292:2"
								},
								{
									"assignments": [
										1910
									],
									"declarations": [
										{
											"constant": false,
											"id": 1910,
											"name": "turnTeamId",
											"nodeType": "VariableDeclaration",
											"scope": 1948,
											"src": "27080:17:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 1909,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "27080:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1913,
									"initialValue": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 1911,
											"name": "game",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1855,
											"src": "27100:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData storage pointer"
											}
										},
										"id": 1912,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "turnTeamId",
										"nodeType": "MemberAccess",
										"referencedDeclaration": 214,
										"src": "27100:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "27080:35:2"
								},
								{
									"body": {
										"id": 1943,
										"nodeType": "Block",
										"src": "27164:173:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1933,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1925,
														"name": "turnTeamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1910,
														"src": "27178:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1932,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 1928,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1926,
																		"name": "turnTeamId",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1910,
																		"src": "27192:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "+",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 1927,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "27205:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"src": "27192:14:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 1929,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "27191:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "%",
														"rightExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1930,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1855,
																"src": "27210:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 1931,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "playerCount",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 220,
															"src": "27210:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "27191:35:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "27178:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"id": 1934,
												"nodeType": "ExpressionStatement",
												"src": "27178:48:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1939,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1935,
														"name": "hasNotOwned",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1867,
														"src": "27244:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1936,
															"name": "playerOwnsRegion",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1864,
															"src": "27259:16:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																"typeString": "bool[8] memory"
															}
														},
														"id": 1938,
														"indexExpression": {
															"argumentTypes": null,
															"id": 1937,
															"name": "turnTeamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1910,
															"src": "27276:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "27259:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "27244:43:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 1942,
												"nodeType": "IfStatement",
												"src": "27240:87:2",
												"trueBody": {
													"id": 1941,
													"nodeType": "Block",
													"src": "27289:38:2",
													"statements": [
														{
															"id": 1940,
															"nodeType": "Break",
															"src": "27307:5:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 1921,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1918,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1871,
											"src": "27137:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1919,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1855,
												"src": "27141:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1920,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "playerCount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 220,
											"src": "27141:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "27137:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1944,
									"initializationExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1916,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 1914,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "27130:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1915,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "27134:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "27130:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1917,
										"nodeType": "ExpressionStatement",
										"src": "27130:5:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 1923,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "27159:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 1922,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "27159:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1924,
										"nodeType": "ExpressionStatement",
										"src": "27159:3:2"
									},
									"nodeType": "ForStatement",
									"src": "27125:212:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1945,
										"name": "turnTeamId",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1910,
										"src": "27354:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 1853,
									"id": 1946,
									"nodeType": "Return",
									"src": "27347:17:2"
								}
							]
						},
						"documentation": "@notice Player who's turn is next. \n @param gameId Id of game\n @return Next player's turn",
						"id": 1948,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getNextTurnTeamId",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1850,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1849,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 1948,
									"src": "26519:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1848,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "26519:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "26509:30:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1853,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1852,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1948,
									"src": "26588:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1851,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "26588:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "26587:8:2"
						},
						"scope": 4288,
						"src": "26483:888:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2099,
							"nodeType": "Block",
							"src": "28083:2297:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 1971,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1964,
													"name": "friendly",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1956,
													"src": "28101:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1970,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1965,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "28113:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 1966,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "28113:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1969,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1967,
															"name": "submitBlock",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1950,
															"src": "28128:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "+",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 1968,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "28142:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "28128:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "28113:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "28101:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "41747461636b73206d757374206265206174206c65617374203220626c6f636b73206f6c642e",
												"id": 1972,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "28145:40:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
													"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
												},
												"value": "Attacks must be at least 2 blocks old."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
													"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
												}
											],
											"id": 1963,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "28093:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 1973,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "28093:93:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1974,
									"nodeType": "ExpressionStatement",
									"src": "28093:93:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"id": 1975,
										"name": "friendly",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1956,
										"src": "28201:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 2097,
										"nodeType": "Block",
										"src": "28375:1999:2",
										"statements": [
											{
												"assignments": [
													1985
												],
												"declarations": [
													{
														"constant": false,
														"id": 1985,
														"name": "blockHash32",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "28719:18:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1984,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "28719:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1991,
												"initialValue": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1989,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1987,
																"name": "submitBlock",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1950,
																"src": "28756:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1988,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "28770:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "28756:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1986,
														"name": "readBlockHash32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1152,
														"src": "28740:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_view$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint32) view returns (uint32)"
														}
													},
													"id": 1990,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "28740:32:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "28719:53:2"
											},
											{
												"assignments": [
													1993
												],
												"declarations": [
													{
														"constant": false,
														"id": 1993,
														"name": "deadDefenders",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "28786:20:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1992,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "28786:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1995,
												"initialValue": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1994,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "28809:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "28786:24:2"
											},
											{
												"assignments": [
													1997
												],
												"declarations": [
													{
														"constant": false,
														"id": 1997,
														"name": "deadAttackers",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "28824:20:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 1996,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "28824:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 1999,
												"initialValue": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1998,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "28847:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "28824:24:2"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 2002,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 2000,
														"name": "blockHash32",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1985,
														"src": "28955:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 2001,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "28970:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "28955:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 2059,
													"nodeType": "Block",
													"src": "29233:514:2",
													"statements": [
														{
															"assignments": [
																2018
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 2018,
																	"name": "randA",
																	"nodeType": "VariableDeclaration",
																	"scope": 2100,
																	"src": "29251:12:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 2017,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "29251:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 2024,
															"initialValue": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2022,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 2020,
																			"name": "blockHash32",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1985,
																			"src": "29273:11:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "%",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "323536",
																			"id": 2021,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "29287:3:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_256_by_1",
																				"typeString": "int_const 256"
																			},
																			"value": "256"
																		},
																		"src": "29273:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 2019,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "29266:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 2023,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "29266:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "29251:40:2"
														},
														{
															"assignments": [
																2026
															],
															"declarations": [
																{
																	"constant": false,
																	"id": 2026,
																	"name": "randB",
																	"nodeType": "VariableDeclaration",
																	"scope": 2100,
																	"src": "29309:12:2",
																	"stateVariable": false,
																	"storageLocation": "default",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"typeName": {
																		"id": 2025,
																		"name": "uint32",
																		"nodeType": "ElementaryTypeName",
																		"src": "29309:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"value": null,
																	"visibility": "internal"
																}
															],
															"id": 2035,
															"initialValue": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2033,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"components": [
																				{
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					"id": 2030,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"leftExpression": {
																						"argumentTypes": null,
																						"id": 2028,
																						"name": "blockHash32",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1985,
																						"src": "29332:11:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"nodeType": "BinaryOperation",
																					"operator": ">>",
																					"rightExpression": {
																						"argumentTypes": null,
																						"hexValue": "38",
																						"id": 2029,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "29347:1:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_8_by_1",
																							"typeString": "int_const 8"
																						},
																						"value": "8"
																					},
																					"src": "29332:16:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"id": 2031,
																			"isConstant": false,
																			"isInlineArray": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "TupleExpression",
																			"src": "29331:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "%",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "323536",
																			"id": 2032,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "29352:3:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_256_by_1",
																				"typeString": "int_const 256"
																			},
																			"value": "256"
																		},
																		"src": "29331:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 2027,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "29324:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 2034,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "29324:32:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "VariableDeclarationStatement",
															"src": "29309:47:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2043,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2036,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "29432:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2042,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 2038,
																				"name": "moveSoldierCount",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1952,
																				"src": "29456:16:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 2039,
																				"name": "randA",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 2018,
																				"src": "29474:5:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 2037,
																			"name": "mulSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4287,
																			"src": "29448:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 2040,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "29448:32:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "/",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "323536",
																		"id": 2041,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "29483:3:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_256_by_1",
																			"typeString": "int_const 256"
																		},
																		"value": "256"
																	},
																	"src": "29448:38:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29432:54:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2044,
															"nodeType": "ExpressionStatement",
															"src": "29432:54:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2057,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2045,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29606:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2056,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 2047,
																				"name": "defenderCount",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1954,
																				"src": "29630:13:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				"id": 2050,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"id": 2048,
																					"name": "DEFENDER_ADVANTAGE_NUM",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 141,
																					"src": "29645:22:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "*",
																				"rightExpression": {
																					"argumentTypes": null,
																					"id": 2049,
																					"name": "randB",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 2026,
																					"src": "29670:5:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"src": "29645:30:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 2046,
																			"name": "mulSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4287,
																			"src": "29622:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 2051,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "29622:54:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "/",
																	"rightExpression": {
																		"argumentTypes": null,
																		"components": [
																			{
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				"id": 2054,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"hexValue": "323536",
																					"id": 2052,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "29701:3:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_256_by_1",
																						"typeString": "int_const 256"
																					},
																					"value": "256"
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "*",
																				"rightExpression": {
																					"argumentTypes": null,
																					"id": 2053,
																					"name": "DEFENDER_ADVANTAGE_DENOM",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 144,
																					"src": "29707:24:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"src": "29701:30:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"id": 2055,
																		"isConstant": false,
																		"isInlineArray": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "TupleExpression",
																		"src": "29700:32:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29622:110:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29606:126:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2058,
															"nodeType": "ExpressionStatement",
															"src": "29606:126:2"
														}
													]
												},
												"id": 2060,
												"nodeType": "IfStatement",
												"src": "28951:796:2",
												"trueBody": {
													"id": 2016,
													"nodeType": "Block",
													"src": "28973:157:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 2005,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2003,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "28991:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 2004,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "29007:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																},
																"src": "28991:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2006,
															"nodeType": "ExpressionStatement",
															"src": "28991:17:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2014,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2007,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29026:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2013,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"id": 2009,
																				"name": "defenderCount",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1954,
																				"src": "29050:13:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 2010,
																				"name": "DEFENDER_ADVANTAGE_NUM",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 141,
																				"src": "29065:22:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 2008,
																			"name": "mulSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4287,
																			"src": "29042:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 2011,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "29042:46:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "/",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2012,
																		"name": "DEFENDER_ADVANTAGE_DENOM",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 144,
																		"src": "29091:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29042:73:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29026:89:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2015,
															"nodeType": "ExpressionStatement",
															"src": "29026:89:2"
														}
													]
												}
											},
											{
												"assignments": [
													2062
												],
												"declarations": [
													{
														"constant": false,
														"id": 2062,
														"name": "remainingAttackers",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "29840:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 2061,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "29840:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 2073,
												"initialValue": {
													"argumentTypes": null,
													"condition": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2065,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2063,
																	"name": "moveSoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1952,
																	"src": "29869:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2064,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29888:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29869:32:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 2066,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "29868:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 2071,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "29959:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"id": 2072,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "Conditional",
													"src": "29868:92:2",
													"trueExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2069,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2067,
																	"name": "moveSoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1952,
																	"src": "29923:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2068,
																	"name": "deadAttackers",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1997,
																	"src": "29942:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "29923:32:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2070,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "29922:34:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "29840:120:2"
											},
											{
												"assignments": [
													2075
												],
												"declarations": [
													{
														"constant": false,
														"id": 2075,
														"name": "remainingDefenders",
														"nodeType": "VariableDeclaration",
														"scope": 2100,
														"src": "30156:25:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 2074,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "30156:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 2092,
												"initialValue": {
													"argumentTypes": null,
													"condition": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2078,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2076,
																	"name": "defenderCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1954,
																	"src": "30185:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2077,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "30201:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "30185:29:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 2079,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30184:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"condition": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2086,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2084,
																		"name": "remainingAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2062,
																		"src": "30270:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": ">",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 2085,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "30291:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"src": "30270:22:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"falseExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 2088,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "30299:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"id": 2089,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "Conditional",
																"src": "30270:30:2",
																"trueExpression": {
																	"argumentTypes": null,
																	"hexValue": "30",
																	"id": 2087,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "30295:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_0_by_1",
																		"typeString": "int_const 0"
																	},
																	"value": "0"
																},
																"typeDescriptions": {
																	"typeIdentifier": "t_uint8",
																	"typeString": "uint8"
																}
															}
														],
														"id": 2090,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30269:32:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint8",
															"typeString": "uint8"
														}
													},
													"id": 2091,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "Conditional",
													"src": "30184:117:2",
													"trueExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2082,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2080,
																	"name": "defenderCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1954,
																	"src": "30236:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "-",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2081,
																	"name": "deadDefenders",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1993,
																	"src": "30252:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "30236:29:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2083,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30235:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "30156:145:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"id": 2093,
															"name": "remainingAttackers",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2062,
															"src": "30324:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 2094,
															"name": "remainingDefenders",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2075,
															"src": "30344:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"id": 2095,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "30323:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
														"typeString": "tuple(uint32,uint32)"
													}
												},
												"functionReturnParameters": 1962,
												"id": 2096,
												"nodeType": "Return",
												"src": "30316:47:2"
											}
										]
									},
									"id": 2098,
									"nodeType": "IfStatement",
									"src": "28197:2177:2",
									"trueBody": {
										"id": 1983,
										"nodeType": "Block",
										"src": "28211:150:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 1977,
																	"name": "moveSoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1952,
																	"src": "28314:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1978,
																	"name": "defenderCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1954,
																	"src": "28332:13:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1976,
																"name": "addSafe",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4253,
																"src": "28306:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint32,uint32) pure returns (uint32)"
																}
															},
															"id": 1979,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "28306:40:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1980,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "28348:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"id": 1981,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "28305:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$_t_uint32_$_t_rational_0_by_1_$",
														"typeString": "tuple(uint32,int_const 0)"
													}
												},
												"functionReturnParameters": 1962,
												"id": 1982,
												"nodeType": "Return",
												"src": "28298:52:2"
											}
										]
									}
								}
							]
						},
						"documentation": "@notice Declare victory for a team.\n @param submitBlock Block number when action was submitted to queue\n @param moveSoldierCount Number of soldiers to move or attack\n @param defenderCount Number of soldiers defending destination region\n @param friendly Whether this is an attack, or friendly move\n @return remainingAttackers Number of attacking soldiers remaining \n @return remainingDefenders Number of defending soldiers remaining",
						"id": 2100,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getOutcomeAttackOrMove",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1957,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1950,
									"name": "submitBlock",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27900:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1949,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "27900:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1952,
									"name": "moveSoldierCount",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27929:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1951,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "27929:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1954,
									"name": "defenderCount",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27963:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1953,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "27963:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1956,
									"name": "friendly",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "27994:13:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1955,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "27994:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "27890:123:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 1962,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1959,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "28062:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1958,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "28062:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1961,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2100,
									"src": "28070:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 1960,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "28070:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "28061:16:2"
						},
						"scope": 4288,
						"src": "27859:2521:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2163,
							"nodeType": "Block",
							"src": "30730:596:2",
							"statements": [
								{
									"assignments": [
										2110
									],
									"declarations": [
										{
											"constant": false,
											"id": 2110,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 2164,
											"src": "30740:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 2109,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "30740:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2114,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2111,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "30764:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 2113,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2112,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2102,
											"src": "30778:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "30764:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "30740:45:2"
								},
								{
									"assignments": [
										2116
									],
									"declarations": [
										{
											"constant": false,
											"id": 2116,
											"name": "rewardTotal",
											"nodeType": "VariableDeclaration",
											"scope": 2164,
											"src": "30862:18:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2115,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "30862:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2118,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 2117,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "30883:1:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "30862:22:2"
								},
								{
									"assignments": [
										2120
									],
									"declarations": [
										{
											"constant": false,
											"id": 2120,
											"name": "bonusScore",
											"nodeType": "VariableDeclaration",
											"scope": 2164,
											"src": "30973:17:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2119,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "30973:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2124,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 2123,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2121,
											"name": "REWARD_BONUS_MULTIPLIER_DENOM",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 147,
											"src": "30993:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "-",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 2122,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "31025:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "30993:33:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "30973:53:2"
								},
								{
									"body": {
										"id": 2153,
										"nodeType": "Block",
										"src": "31078:164:2",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 2141,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2136,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2110,
																	"src": "31105:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 2137,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "31105:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 2138,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2126,
																"src": "31124:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 2135,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "31096:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 2139,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "31096:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 2140,
														"name": "teamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2104,
														"src": "31130:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "31096:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 2152,
												"nodeType": "IfStatement",
												"src": "31092:140:2",
												"trueBody": {
													"id": 2151,
													"nodeType": "Block",
													"src": "31138:94:2",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 2146,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 2142,
																	"name": "rewardTotal",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2116,
																	"src": "31156:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "Assignment",
																"operator": "+=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 2143,
																		"name": "regionRewards",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 183,
																		"src": "31171:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 2145,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 2144,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2126,
																		"src": "31185:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "31171:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "31156:31:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2147,
															"nodeType": "ExpressionStatement",
															"src": "31156:31:2"
														},
														{
															"expression": {
																"argumentTypes": null,
																"id": 2149,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "UnaryOperation",
																"operator": "++",
																"prefix": false,
																"src": "31205:12:2",
																"subExpression": {
																	"argumentTypes": null,
																	"id": 2148,
																	"name": "bonusScore",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2120,
																	"src": "31205:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"id": 2150,
															"nodeType": "ExpressionStatement",
															"src": "31205:12:2"
														}
													]
												}
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 2131,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2129,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2126,
											"src": "31055:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"id": 2130,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "31059:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "31055:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 2154,
									"initializationExpression": {
										"assignments": [
											2126
										],
										"declarations": [
											{
												"constant": false,
												"id": 2126,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "31041:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2125,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31041:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2128,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2127,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "31052:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31041:12:2"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 2133,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "31073:3:2",
											"subExpression": {
												"argumentTypes": null,
												"id": 2132,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2126,
												"src": "31073:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2134,
										"nodeType": "ExpressionStatement",
										"src": "31073:3:2"
									},
									"nodeType": "ForStatement",
									"src": "31036:206:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 2160,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 2157,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 2155,
																"name": "rewardTotal",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2116,
																"src": "31261:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "*",
															"rightExpression": {
																"argumentTypes": null,
																"id": 2156,
																"name": "bonusScore",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2120,
																"src": "31275:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "31261:24:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"id": 2158,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "31260:26:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "/",
												"rightExpression": {
													"argumentTypes": null,
													"id": 2159,
													"name": "REWARD_BONUS_MULTIPLIER_DENOM",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 147,
													"src": "31289:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "31260:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"id": 2161,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "31259:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 2108,
									"id": 2162,
									"nodeType": "Return",
									"src": "31252:67:2"
								}
							]
						},
						"documentation": "@notice Calculate a team's reward amount based on what regions they control.\n @param gameId Id of game\n @param teamId Team you'd like to calculate rewards for\n @return Reward amount for team",
						"id": 2164,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "calculateRegionRewards",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2105,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2102,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 2164,
									"src": "30638:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 2101,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "30638:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2104,
									"name": "teamId",
									"nodeType": "VariableDeclaration",
									"scope": 2164,
									"src": "30654:13:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 2103,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "30654:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "30637:31:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 2108,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2107,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2164,
									"src": "30717:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 2106,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "30717:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "30716:8:2"
						},
						"scope": 4288,
						"src": "30606:720:2",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2209,
							"nodeType": "Block",
							"src": "31494:612:2",
							"statements": [
								{
									"assignments": [
										2170
									],
									"declarations": [
										{
											"constant": false,
											"id": 2170,
											"name": "game",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31504:21:2",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData"
											},
											"typeName": {
												"contractScope": null,
												"id": 2169,
												"name": "GameData",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 245,
												"src": "31504:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2174,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2171,
											"name": "gameDataArray",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 186,
											"src": "31528:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
												"typeString": "struct WorldGame.GameData storage ref[] storage ref"
											}
										},
										"id": 2173,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2172,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2166,
											"src": "31542:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "31528:21:2",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_GameData_$245_storage",
											"typeString": "struct WorldGame.GameData storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31504:45:2"
								},
								{
									"assignments": [
										2176
									],
									"declarations": [
										{
											"constant": false,
											"id": 2176,
											"name": "teamId",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31618:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2175,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "31618:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2179,
									"initialValue": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 2177,
											"name": "game",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2170,
											"src": "31634:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
												"typeString": "struct WorldGame.GameData storage pointer"
											}
										},
										"id": 2178,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "turnTeamId",
										"nodeType": "MemberAccess",
										"referencedDeclaration": 214,
										"src": "31634:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31618:31:2"
								},
								{
									"assignments": [
										2181
									],
									"declarations": [
										{
											"constant": false,
											"id": 2181,
											"name": "rewardAmount",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31726:19:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2180,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "31726:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2186,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2183,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2166,
												"src": "31771:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"id": 2184,
												"name": "teamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2176,
												"src": "31779:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 2182,
											"name": "calculateRegionRewards",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2164,
											"src": "31748:22:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
												"typeString": "function (uint256,uint32) view returns (uint32)"
											}
										},
										"id": 2185,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "31748:38:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31726:60:2"
								},
								{
									"assignments": [
										2188
									],
									"declarations": [
										{
											"constant": false,
											"id": 2188,
											"name": "undeployedSoldierCount",
											"nodeType": "VariableDeclaration",
											"scope": 2210,
											"src": "31852:29:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 2187,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "31852:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2194,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2190,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2170,
													"src": "31894:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 2191,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "undeployedSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 226,
												"src": "31894:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"id": 2192,
												"name": "teamId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2176,
												"src": "31919:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											],
											"id": 2189,
											"name": "getData32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4095,
											"src": "31884:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
												"typeString": "function (uint256,uint32) pure returns (uint32)"
											}
										},
										"id": 2193,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "31884:42:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "31852:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2207,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2195,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2170,
												"src": "31936:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 2197,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "undeployedSoldiers",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 226,
											"src": "31936:23:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2199,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2170,
														"src": "31985:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 2200,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "undeployedSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 226,
													"src": "31985:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 2201,
													"name": "teamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2176,
													"src": "32023:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2203,
															"name": "undeployedSoldierCount",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2188,
															"src": "32052:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														{
															"argumentTypes": null,
															"id": 2204,
															"name": "rewardAmount",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2181,
															"src": "32076:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 2202,
														"name": "addSafe",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4253,
														"src": "32044:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
															"typeString": "function (uint32,uint32) pure returns (uint32)"
														}
													},
													"id": 2205,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32044:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 2198,
												"name": "setData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4133,
												"src": "31962:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
													"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
												}
											},
											"id": 2206,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "31962:137:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "31936:163:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 2208,
									"nodeType": "ExpressionStatement",
									"src": "31936:163:2"
								}
							]
						},
						"documentation": "@notice Reward team with soldiers based on what regions they control.\n @param gameId Id of game",
						"id": 2210,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "giveRegionRewards",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2167,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2166,
									"name": "gameId",
									"nodeType": "VariableDeclaration",
									"scope": 2210,
									"src": "31470:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 2165,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "31470:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "31469:16:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 2168,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "31494:0:2"
						},
						"scope": 4288,
						"src": "31443:663:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 3840,
							"nodeType": "Block",
							"src": "32273:10521:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2225,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2213,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32283:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2219,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2215,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32306:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2216,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32306:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2214,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32299:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2217,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32299:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32283:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2220,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2218,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32323:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32283:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2222,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32335:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2223,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32335:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2221,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32328:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2224,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32328:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32283:72:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2226,
									"nodeType": "ExpressionStatement",
									"src": "32283:72:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2239,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2227,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32365:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2233,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2229,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32388:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2230,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32388:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2228,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32381:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2231,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32381:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32365:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2234,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2232,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32405:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32365:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2236,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32417:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2237,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32417:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2235,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32410:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2238,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32410:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32365:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2240,
									"nodeType": "ExpressionStatement",
									"src": "32365:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2241,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32440:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2247,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2243,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32463:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2244,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32463:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2242,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32456:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2245,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32456:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32440:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2248,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2246,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32480:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32440:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2249,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32485:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32440:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2251,
									"nodeType": "ExpressionStatement",
									"src": "32440:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2261,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2252,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32504:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2258,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2254,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32527:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2255,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32527:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2253,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32520:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2256,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32520:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32504:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2259,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2257,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32544:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32504:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2260,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32549:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32504:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2262,
									"nodeType": "ExpressionStatement",
									"src": "32504:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2272,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2263,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32568:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2269,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2265,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32591:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2266,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32591:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2264,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32584:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2267,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32584:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32568:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2270,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2268,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32608:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32568:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2271,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32613:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32568:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2273,
									"nodeType": "ExpressionStatement",
									"src": "32568:54:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2286,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2274,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32633:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2280,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2276,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32656:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2277,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32656:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2275,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32649:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2278,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32649:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32633:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2281,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2279,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32681:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32633:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2283,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32693:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2284,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32693:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2282,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32686:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2285,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32686:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32633:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2287,
									"nodeType": "ExpressionStatement",
									"src": "32633:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2300,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2288,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32723:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2294,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2290,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32746:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2291,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32746:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2289,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32739:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2292,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32739:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32723:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2295,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2293,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32771:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32723:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2297,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32783:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2298,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32783:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2296,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32776:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2299,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32776:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32723:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2301,
									"nodeType": "ExpressionStatement",
									"src": "32723:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2314,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2302,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32816:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2308,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2304,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32839:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2305,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32839:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2303,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32832:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2306,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32832:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32816:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2309,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2307,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32864:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32816:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2311,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "32876:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2312,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "32876:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2310,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "32869:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2313,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "32869:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32816:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2315,
									"nodeType": "ExpressionStatement",
									"src": "32816:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2325,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2316,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32909:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2322,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2318,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "32932:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2319,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "32932:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2317,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32925:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2320,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32925:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32909:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2323,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2321,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "32957:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32909:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2324,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "32962:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32909:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2326,
									"nodeType": "ExpressionStatement",
									"src": "32909:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2336,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2327,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "32981:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2333,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2329,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33004:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2330,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33004:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2328,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "32997:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2331,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "32997:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "32981:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2334,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2332,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33029:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "32981:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2335,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33034:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "32981:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2337,
									"nodeType": "ExpressionStatement",
									"src": "32981:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2350,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2338,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33054:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2344,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2340,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33077:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2341,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33077:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2339,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33070:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2342,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33070:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33054:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2345,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2343,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33102:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33054:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2347,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33114:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2348,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33114:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2346,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33107:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2349,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33107:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33054:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2351,
									"nodeType": "ExpressionStatement",
									"src": "33054:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2364,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2352,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33147:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2358,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2354,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33170:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2355,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33170:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2353,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33163:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2356,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33163:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33147:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2359,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2357,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33195:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33147:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2361,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33207:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2362,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "GREENLAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33207:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2360,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33200:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2363,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33200:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33147:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2365,
									"nodeType": "ExpressionStatement",
									"src": "33147:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2378,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2366,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33235:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2372,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2368,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33258:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2369,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33258:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2367,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33251:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2370,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33251:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33235:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2373,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2371,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33283:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33235:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2375,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33295:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2376,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33295:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2374,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33288:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2377,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33288:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33235:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2379,
									"nodeType": "ExpressionStatement",
									"src": "33235:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2389,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2380,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33325:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2386,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2382,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33348:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2383,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33348:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2381,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33341:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2384,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33341:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33325:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2387,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2385,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33373:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33325:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2388,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33378:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33325:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2390,
									"nodeType": "ExpressionStatement",
									"src": "33325:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2400,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2391,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33397:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2397,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2393,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33420:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2394,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33420:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2392,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33413:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2395,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33413:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33397:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2398,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2396,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33445:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33397:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2399,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33450:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33397:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2401,
									"nodeType": "ExpressionStatement",
									"src": "33397:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2414,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2402,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33470:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2408,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2404,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33493:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2405,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33493:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2403,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33486:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2406,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33486:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33470:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2409,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2407,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33515:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33470:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2411,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33527:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2412,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "HAWAII",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33527:14:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2410,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33520:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2413,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33520:22:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33470:72:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2415,
									"nodeType": "ExpressionStatement",
									"src": "33470:72:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2428,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2416,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33552:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2422,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2418,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33575:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2419,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33575:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2417,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33568:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2420,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33568:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33552:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2423,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2421,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33597:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33552:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2425,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33609:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2426,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33609:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2424,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33602:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2427,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33602:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33552:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2429,
									"nodeType": "ExpressionStatement",
									"src": "33552:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2442,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2430,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33642:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2436,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2432,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33665:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2433,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33665:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2431,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33658:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2434,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33658:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33642:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2437,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2435,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33687:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33642:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2439,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33699:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2440,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33699:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2438,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33692:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2441,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33692:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33642:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2443,
									"nodeType": "ExpressionStatement",
									"src": "33642:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2456,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2444,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33729:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2450,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2446,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33752:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2447,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33752:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2445,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33745:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2448,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33745:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33729:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2451,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2449,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33774:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33729:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2453,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33786:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2454,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NORTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33786:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2452,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33779:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2455,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33779:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33729:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2457,
									"nodeType": "ExpressionStatement",
									"src": "33729:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2467,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2458,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33827:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2464,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2460,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33850:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2461,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33850:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2459,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33843:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2462,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33843:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33827:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2465,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2463,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33872:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33827:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2466,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "33877:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33827:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2468,
									"nodeType": "ExpressionStatement",
									"src": "33827:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2481,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2469,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33897:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2475,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2471,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "33920:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2472,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "33920:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2470,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "33913:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2473,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "33913:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33897:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2476,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2474,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "33942:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33897:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2478,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "33954:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2479,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "33954:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2477,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "33947:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2480,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "33947:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33897:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2482,
									"nodeType": "ExpressionStatement",
									"src": "33897:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2495,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2483,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "33984:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2489,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2485,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34007:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2486,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34007:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2484,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34000:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2487,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34000:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "33984:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2490,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2488,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34029:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "33984:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2492,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34041:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2493,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34041:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2491,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34034:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2494,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34034:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "33984:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2496,
									"nodeType": "ExpressionStatement",
									"src": "33984:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2509,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2497,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34074:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2503,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2499,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34097:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2500,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34097:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2498,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34090:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2501,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34090:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34074:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2504,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2502,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34119:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34074:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2506,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34131:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2507,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NORTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34131:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2505,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34124:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2508,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34124:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34074:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2510,
									"nodeType": "ExpressionStatement",
									"src": "34074:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2520,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2511,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34172:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2517,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2513,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34195:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2514,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34195:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2512,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34188:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2515,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34188:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34172:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2518,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2516,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34217:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34172:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2519,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34222:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34172:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2521,
									"nodeType": "ExpressionStatement",
									"src": "34172:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2531,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2522,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34241:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2528,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2524,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34264:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2525,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34264:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2523,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34257:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2526,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34257:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34241:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2529,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2527,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34286:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34241:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2530,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34291:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34241:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2532,
									"nodeType": "ExpressionStatement",
									"src": "34241:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2545,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2533,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34311:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2539,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2535,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34334:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2536,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34334:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2534,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34327:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2537,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34327:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34311:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2540,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2538,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34354:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34311:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2542,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34366:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2543,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34366:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2541,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34359:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2544,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34359:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34311:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2546,
									"nodeType": "ExpressionStatement",
									"src": "34311:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2559,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2547,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34399:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2553,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2549,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34422:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2550,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34422:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2548,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34415:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2551,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34415:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34399:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2554,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2552,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34442:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34399:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2556,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34454:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2557,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34454:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2555,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34447:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2558,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34447:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34399:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2560,
									"nodeType": "ExpressionStatement",
									"src": "34399:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2570,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2561,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34487:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2567,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2563,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34510:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2564,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34510:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2562,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34503:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2565,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34503:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34487:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2568,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2566,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34530:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34487:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2569,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34535:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34487:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2571,
									"nodeType": "ExpressionStatement",
									"src": "34487:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2581,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2572,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34554:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2578,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2574,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34577:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2575,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34577:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2573,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34570:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2576,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34570:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34554:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2579,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2577,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34597:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34554:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2580,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34602:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34554:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2582,
									"nodeType": "ExpressionStatement",
									"src": "34554:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2592,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2583,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34621:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2589,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2585,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34644:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2586,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34644:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2584,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34637:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2587,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34637:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34621:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2590,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2588,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34664:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34621:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2591,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "34669:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34621:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2593,
									"nodeType": "ExpressionStatement",
									"src": "34621:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2606,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2594,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34689:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2600,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2596,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34712:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2597,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34712:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2595,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34705:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2598,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34705:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34689:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2601,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2599,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34745:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34689:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2603,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34757:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2604,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34757:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2602,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34750:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2605,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34750:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34689:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2607,
									"nodeType": "ExpressionStatement",
									"src": "34689:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2620,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2608,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34787:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2614,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2610,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34810:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2611,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34810:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2609,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34803:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2612,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34803:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34787:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2615,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2613,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34843:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34787:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2617,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34855:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2618,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_USA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34855:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2616,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34848:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2619,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34848:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34787:88:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2621,
									"nodeType": "ExpressionStatement",
									"src": "34787:88:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2634,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2622,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34885:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2628,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2624,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "34908:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2625,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "34908:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2623,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "34901:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2626,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "34901:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34885:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2629,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2627,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "34941:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34885:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2631,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "34953:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2632,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "34953:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2630,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "34946:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2633,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "34946:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34885:99:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2635,
									"nodeType": "ExpressionStatement",
									"src": "34885:99:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2645,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2636,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "34994:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2642,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2638,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35017:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2639,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35017:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2637,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35010:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2640,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35010:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "34994:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2643,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2641,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35050:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "34994:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2644,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35055:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "34994:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2646,
									"nodeType": "ExpressionStatement",
									"src": "34994:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2656,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2647,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35074:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2653,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2649,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35097:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2650,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35097:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2648,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35090:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2651,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35090:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35074:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2654,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2652,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35130:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35074:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2655,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35135:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35074:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2657,
									"nodeType": "ExpressionStatement",
									"src": "35074:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2670,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2658,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35155:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2664,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2660,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35178:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2661,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35178:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2659,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35171:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2662,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35171:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35155:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2665,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2663,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35211:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35155:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2667,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35223:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2668,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NORTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35223:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2666,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35216:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2669,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35216:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35155:99:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2671,
									"nodeType": "ExpressionStatement",
									"src": "35155:99:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2684,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2672,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35264:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2678,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2674,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35287:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2675,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35287:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2673,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35280:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2676,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35280:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35264:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2679,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2677,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35320:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35264:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2681,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35332:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2682,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35332:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2680,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35325:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2683,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35325:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35264:92:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2685,
									"nodeType": "ExpressionStatement",
									"src": "35264:92:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2695,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2686,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35366:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2692,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2688,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35389:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2689,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35389:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2687,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35382:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2690,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35382:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35366:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2693,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2691,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35422:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35366:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2694,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35427:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35366:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2696,
									"nodeType": "ExpressionStatement",
									"src": "35366:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2706,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2697,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35446:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2703,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2699,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35469:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2700,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35469:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2698,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35462:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2701,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35462:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35446:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2704,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2702,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35502:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35446:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2705,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35507:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35446:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2707,
									"nodeType": "ExpressionStatement",
									"src": "35446:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2717,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2708,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35526:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2714,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2710,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35549:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2711,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35549:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2709,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35542:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2712,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35542:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35526:55:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2715,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2713,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35582:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35526:58:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2716,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35587:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35526:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2718,
									"nodeType": "ExpressionStatement",
									"src": "35526:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2731,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2719,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35607:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2725,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2721,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35630:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2722,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35630:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2720,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35623:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2723,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35623:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35607:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2726,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2724,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35656:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35607:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2728,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35668:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2729,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHERN_SOUTH_AMERICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35668:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2727,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35661:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2730,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35661:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35607:92:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2732,
									"nodeType": "ExpressionStatement",
									"src": "35607:92:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2745,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2733,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35709:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2739,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2735,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35732:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2736,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35732:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2734,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35725:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2737,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35725:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35709:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2740,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2738,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35758:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35709:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2742,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "35770:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2743,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "35770:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2741,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "35763:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2744,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "35763:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35709:85:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2746,
									"nodeType": "ExpressionStatement",
									"src": "35709:85:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2756,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2747,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35804:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2753,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2749,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35827:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2750,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35827:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2748,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35820:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2751,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35820:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35804:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2754,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2752,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35853:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35804:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2755,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35858:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35804:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2757,
									"nodeType": "ExpressionStatement",
									"src": "35804:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2767,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2758,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35877:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2764,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2760,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35900:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2761,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35900:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2759,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35893:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2762,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35893:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35877:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2765,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2763,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35926:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35877:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2766,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "35931:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35877:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2768,
									"nodeType": "ExpressionStatement",
									"src": "35877:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2778,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2769,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "35950:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2775,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2771,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "35973:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2772,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "35973:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2770,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "35966:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2773,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "35966:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "35950:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2776,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2774,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "35999:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "35950:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2777,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36004:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "35950:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2779,
									"nodeType": "ExpressionStatement",
									"src": "35950:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2792,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2780,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36024:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2786,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2782,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36047:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2783,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36047:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2781,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36040:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2784,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36040:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36024:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2787,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2785,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36073:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36024:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2789,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36085:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2790,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36085:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2788,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36078:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2791,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36078:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36024:85:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2793,
									"nodeType": "ExpressionStatement",
									"src": "36024:85:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2806,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2794,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36119:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2800,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2796,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36142:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2797,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36142:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2795,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36135:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2798,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36135:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36119:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2801,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2799,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36168:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36119:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2803,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36180:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2804,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NEW_ZEALAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36180:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2802,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36173:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2805,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36173:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36119:81:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2807,
									"nodeType": "ExpressionStatement",
									"src": "36119:81:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2817,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2808,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36210:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2814,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2810,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36233:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2811,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36233:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2809,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36226:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2812,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36226:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36210:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2815,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2813,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36259:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36210:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2816,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36264:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36210:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2818,
									"nodeType": "ExpressionStatement",
									"src": "36210:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2828,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2819,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36283:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2825,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2821,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36306:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2822,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36306:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2820,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36299:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2823,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36299:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36283:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2826,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2824,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36332:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36283:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2827,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36337:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36283:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2829,
									"nodeType": "ExpressionStatement",
									"src": "36283:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2839,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2830,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36356:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2836,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2832,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36379:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2833,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36379:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2831,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36372:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2834,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36372:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36356:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2837,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2835,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36405:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36356:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2838,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36410:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36356:63:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2840,
									"nodeType": "ExpressionStatement",
									"src": "36356:63:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2853,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2841,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36430:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2847,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2843,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36453:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2844,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36453:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2842,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36446:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2845,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36446:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36430:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2848,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2846,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36478:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36430:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2850,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36490:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2851,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "GREENLAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36490:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2849,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36483:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2852,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36483:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36430:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2854,
									"nodeType": "ExpressionStatement",
									"src": "36430:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2867,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2855,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36518:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2861,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2857,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36541:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2858,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36541:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2856,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36534:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2859,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36534:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36518:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2862,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2860,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36566:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36518:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2864,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36578:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2865,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36578:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2863,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36571:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2866,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36571:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36518:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2868,
									"nodeType": "ExpressionStatement",
									"src": "36518:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2881,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2869,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36611:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2875,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2871,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36634:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2872,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36634:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2870,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36627:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2873,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36627:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36611:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2876,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2874,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36659:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36611:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2878,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36671:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2879,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36671:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2877,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36664:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2880,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36664:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36611:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2882,
									"nodeType": "ExpressionStatement",
									"src": "36611:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2892,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2883,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36701:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2889,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2885,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36724:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2886,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36724:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2884,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36717:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2887,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36717:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36701:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2890,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2888,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36749:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36701:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2891,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36754:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36701:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2893,
									"nodeType": "ExpressionStatement",
									"src": "36701:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2903,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2894,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36773:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2900,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2896,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36796:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2897,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36796:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2895,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36789:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2898,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36789:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36773:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2901,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2899,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36821:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36773:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2902,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "36826:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36773:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2904,
									"nodeType": "ExpressionStatement",
									"src": "36773:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2917,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2905,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36846:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2911,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2907,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36869:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2908,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36869:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2906,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36862:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2909,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36862:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36846:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2912,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2910,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36894:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36846:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2914,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36906:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2915,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36906:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2913,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36899:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2916,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36899:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36846:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2918,
									"nodeType": "ExpressionStatement",
									"src": "36846:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2931,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2919,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "36939:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2925,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2921,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "36962:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2922,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "36962:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2920,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "36955:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2923,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "36955:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "36939:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2926,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2924,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "36987:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "36939:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2928,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "36999:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2929,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "36999:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2927,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "36992:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2930,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "36992:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "36939:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2932,
									"nodeType": "ExpressionStatement",
									"src": "36939:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2945,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2933,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37029:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2939,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2935,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37052:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2936,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37052:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2934,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37045:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2937,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37045:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37029:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2940,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2938,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37077:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37029:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2942,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37089:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2943,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37089:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2941,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37082:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2944,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37082:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37029:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2946,
									"nodeType": "ExpressionStatement",
									"src": "37029:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2959,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2947,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37119:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2953,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2949,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37142:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2950,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37142:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2948,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37135:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2951,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37135:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37119:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2954,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2952,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37167:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37119:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2956,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37179:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2957,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37179:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2955,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37172:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2958,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37172:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37119:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2960,
									"nodeType": "ExpressionStatement",
									"src": "37119:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2970,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2961,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37212:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2967,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2963,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37235:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2964,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37235:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2962,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37228:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2965,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37228:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37212:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2968,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2966,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37260:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37212:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2969,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "37265:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37212:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2971,
									"nodeType": "ExpressionStatement",
									"src": "37212:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2984,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2972,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37285:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2978,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2974,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37308:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2975,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37308:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2973,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37301:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2976,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37301:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37285:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2979,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2977,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37333:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37285:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2981,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37345:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2982,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37345:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2980,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37338:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2983,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37338:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37285:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2985,
									"nodeType": "ExpressionStatement",
									"src": "37285:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2998,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 2986,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37378:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 2992,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2988,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37401:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 2989,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37401:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 2987,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37394:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 2990,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37394:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37378:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 2993,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2991,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37426:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37378:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2995,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37438:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 2996,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37438:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 2994,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37431:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 2997,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37431:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37378:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 2999,
									"nodeType": "ExpressionStatement",
									"src": "37378:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3012,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3000,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37468:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3006,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3002,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37491:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3003,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37491:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3001,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37484:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3004,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37484:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37468:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3007,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3005,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37516:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37468:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3009,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37528:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3010,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37528:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3008,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37521:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3011,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37521:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37468:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3013,
									"nodeType": "ExpressionStatement",
									"src": "37468:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3026,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3014,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37552:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3020,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3016,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37575:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3017,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37575:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3015,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37568:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3018,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37568:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37552:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3021,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3019,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37600:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37552:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3023,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37612:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3024,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37612:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3022,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37605:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3025,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37605:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37552:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3027,
									"nodeType": "ExpressionStatement",
									"src": "37552:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3040,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3028,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37644:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3034,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3030,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37667:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3031,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37667:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3029,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37660:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3032,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37660:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37644:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3035,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3033,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37692:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37644:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3037,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37704:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3038,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37704:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3036,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37697:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3039,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37697:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37644:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3041,
									"nodeType": "ExpressionStatement",
									"src": "37644:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3054,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3042,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37738:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3048,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3044,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37761:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3045,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37761:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3043,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37754:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3046,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37754:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37738:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3049,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3047,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37786:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37738:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3051,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37798:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3052,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37798:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3050,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37791:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3053,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37791:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37738:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3055,
									"nodeType": "ExpressionStatement",
									"src": "37738:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3068,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3056,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37830:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3062,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3058,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37853:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3059,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37853:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3057,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37846:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3060,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37846:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37830:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3063,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3061,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37878:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37830:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3065,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37890:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3066,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37890:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3064,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37883:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3067,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37883:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37830:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3069,
									"nodeType": "ExpressionStatement",
									"src": "37830:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3082,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3070,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "37923:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3076,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3072,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "37946:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3073,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "37946:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3071,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "37939:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3074,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "37939:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "37923:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3077,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3075,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "37971:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "37923:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3079,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "37983:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3080,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_CANADA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "37983:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3078,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "37976:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3081,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "37976:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "37923:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3083,
									"nodeType": "ExpressionStatement",
									"src": "37923:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3093,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3084,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38016:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3090,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3086,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38039:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3087,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38039:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3085,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38032:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3088,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38032:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38016:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3091,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3089,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38064:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38016:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3092,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "38069:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38016:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3094,
									"nodeType": "ExpressionStatement",
									"src": "38016:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3104,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3095,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38088:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3101,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3097,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38111:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3098,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38111:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3096,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38104:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3099,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38104:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38088:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3102,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3100,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38136:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38088:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3103,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "38141:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38088:62:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3105,
									"nodeType": "ExpressionStatement",
									"src": "38088:62:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3118,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3106,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38161:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3112,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3108,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38184:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3109,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38184:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3107,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38177:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3110,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38177:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38161:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3113,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3111,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38206:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38161:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3115,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38218:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3116,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38218:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3114,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38211:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3117,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38211:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38161:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3119,
									"nodeType": "ExpressionStatement",
									"src": "38161:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3132,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3120,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38251:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3126,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3122,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38274:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3123,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38274:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3121,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38267:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3124,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38267:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38251:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3127,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3125,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38296:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38251:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3129,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38308:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3130,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38308:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3128,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38301:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3131,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38301:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38251:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3133,
									"nodeType": "ExpressionStatement",
									"src": "38251:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3134,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38341:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3140,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3136,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38364:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3137,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38364:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3135,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38357:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3138,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38357:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38341:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3141,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3139,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38386:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38341:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3143,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38398:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3144,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38398:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3142,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38391:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3145,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38391:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38341:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3147,
									"nodeType": "ExpressionStatement",
									"src": "38341:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3160,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3148,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38428:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3154,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3150,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38451:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3151,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38451:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3149,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38444:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3152,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38444:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38428:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3155,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3153,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38473:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38428:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3157,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38485:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3158,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38485:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3156,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38478:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3159,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38478:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38428:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3161,
									"nodeType": "ExpressionStatement",
									"src": "38428:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3174,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3162,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38515:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3168,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3164,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38538:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3165,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38538:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3163,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38531:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3166,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38531:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38515:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3169,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3167,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38560:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38515:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3171,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38572:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3172,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTH_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38572:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3170,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38565:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3173,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38565:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38515:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3175,
									"nodeType": "ExpressionStatement",
									"src": "38515:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3188,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3176,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38604:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3182,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3178,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38627:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3179,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38627:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3177,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38620:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3180,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38620:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38604:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3183,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3181,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38649:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38604:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3185,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38661:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3186,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_EUROPE",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38661:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3184,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38654:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3187,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38654:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38604:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3189,
									"nodeType": "ExpressionStatement",
									"src": "38604:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3202,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3190,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38694:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3196,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3192,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38717:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3193,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38717:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3191,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38710:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3194,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38710:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38694:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3197,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3195,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38739:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38694:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3199,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38751:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3200,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38751:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3198,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38744:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3201,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38744:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38694:80:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3203,
									"nodeType": "ExpressionStatement",
									"src": "38694:80:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3216,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3204,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38784:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3210,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3206,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38807:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3207,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38807:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3205,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38800:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3208,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38800:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38784:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3211,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3209,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38829:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38784:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3213,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38841:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3214,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38841:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3212,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38834:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3215,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38834:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38784:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3217,
									"nodeType": "ExpressionStatement",
									"src": "38784:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3230,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3218,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38865:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3224,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3220,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38888:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3221,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38888:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3219,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38881:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3222,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38881:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38865:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3225,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3223,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38910:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38865:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3227,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "38922:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3228,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "38922:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3226,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "38915:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3229,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "38915:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38865:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3231,
									"nodeType": "ExpressionStatement",
									"src": "38865:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3244,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3232,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "38952:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3238,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3234,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "38975:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3235,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "38975:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3233,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "38968:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3236,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "38968:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "38952:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3239,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3237,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "38997:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "38952:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3241,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39009:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3242,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39009:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3240,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39002:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3243,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39002:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "38952:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3245,
									"nodeType": "ExpressionStatement",
									"src": "38952:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3258,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3246,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39040:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3252,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3248,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39063:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3249,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39063:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3247,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39056:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3250,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39056:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39040:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3253,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3251,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39085:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39040:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3255,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39097:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3256,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39097:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3254,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39090:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3257,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39090:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39040:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3259,
									"nodeType": "ExpressionStatement",
									"src": "39040:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3272,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3260,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39127:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3266,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3262,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39150:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3263,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39150:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3261,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39143:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3264,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39143:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39127:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3267,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3265,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39172:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39127:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3269,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39184:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3270,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTH_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39184:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3268,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39177:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3271,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39177:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39127:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3273,
									"nodeType": "ExpressionStatement",
									"src": "39127:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3286,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3274,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39215:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3280,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3276,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39238:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3277,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39238:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3275,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39231:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3278,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39231:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39215:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3281,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3279,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39260:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39215:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3283,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39272:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3284,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39272:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3282,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39265:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3285,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39265:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39215:77:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3287,
									"nodeType": "ExpressionStatement",
									"src": "39215:77:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3300,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3288,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39302:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3294,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3290,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39325:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3291,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39325:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3289,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39318:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3292,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39318:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39302:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3295,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3293,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39347:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39302:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3297,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39359:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3298,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39359:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3296,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39352:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3299,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39352:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39302:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3301,
									"nodeType": "ExpressionStatement",
									"src": "39302:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3311,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3302,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39383:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3308,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3304,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39406:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3305,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39406:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3303,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39399:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3306,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39399:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39383:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3309,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3307,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39428:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39383:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3310,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39433:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39383:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3312,
									"nodeType": "ExpressionStatement",
									"src": "39383:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3325,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3313,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39453:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3319,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3315,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39476:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3316,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39476:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3314,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39469:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3317,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39469:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39453:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3320,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3318,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39499:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39453:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3322,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39511:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3323,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WEST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39511:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3321,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39504:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3324,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39504:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39453:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3326,
									"nodeType": "ExpressionStatement",
									"src": "39453:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3339,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3327,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39541:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3333,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3329,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39564:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3330,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39564:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3328,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39557:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3331,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39557:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39541:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3334,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3332,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39587:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39541:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3336,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39599:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3337,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39599:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3335,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39592:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3338,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39592:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39541:78:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3340,
									"nodeType": "ExpressionStatement",
									"src": "39541:78:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3350,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3341,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39629:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3347,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3343,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39652:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3344,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39652:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3342,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39645:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3345,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39645:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39629:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3348,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3346,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39675:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39629:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3349,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39680:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39629:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3351,
									"nodeType": "ExpressionStatement",
									"src": "39629:60:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3361,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3352,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39699:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3358,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3354,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39722:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3355,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39722:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3353,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39715:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3356,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39715:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39699:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3359,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3357,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39745:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39699:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3360,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39750:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39699:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3362,
									"nodeType": "ExpressionStatement",
									"src": "39699:60:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3372,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3363,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39769:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3369,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3365,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39792:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3366,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39792:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3364,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39785:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3367,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39785:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39769:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3370,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3368,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39815:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39769:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3371,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "39820:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39769:60:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3373,
									"nodeType": "ExpressionStatement",
									"src": "39769:60:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3386,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3374,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39840:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3380,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3376,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39863:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3377,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39863:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3375,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39856:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3378,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39856:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39840:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3381,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3379,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39879:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39840:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3383,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39891:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3384,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_AFRICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39891:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3382,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39884:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3385,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39884:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39840:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3387,
									"nodeType": "ExpressionStatement",
									"src": "39840:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3400,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3388,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "39921:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3394,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3390,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "39944:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3391,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "39944:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3389,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "39937:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3392,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "39937:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "39921:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3395,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3393,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "39960:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "39921:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3397,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "39972:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3398,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "MIDDLE_EAST",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "39972:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3396,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "39965:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3399,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "39965:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "39921:71:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3401,
									"nodeType": "ExpressionStatement",
									"src": "39921:71:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3414,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3402,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40002:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3408,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3404,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40025:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3405,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40025:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3403,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40018:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3406,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40018:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40002:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3409,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3407,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40041:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40002:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3411,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40053:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3412,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40053:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3410,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40046:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3413,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40046:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40002:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3415,
									"nodeType": "ExpressionStatement",
									"src": "40002:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3428,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3416,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40086:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3422,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3418,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40109:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3419,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40109:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3417,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40102:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3420,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40102:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40086:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3423,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3421,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40125:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40086:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3425,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40137:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3426,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40137:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3424,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40130:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3427,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40130:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40086:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3429,
									"nodeType": "ExpressionStatement",
									"src": "40086:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3442,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3430,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40169:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3436,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3432,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40192:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3433,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40192:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3431,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40185:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3434,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40185:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40169:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3437,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3435,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40208:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40169:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3439,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40220:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3440,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40220:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3438,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40213:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3441,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40213:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40169:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3443,
									"nodeType": "ExpressionStatement",
									"src": "40169:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3456,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3444,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40254:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3450,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3446,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40277:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3447,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40277:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3445,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40270:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3448,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40270:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40254:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3451,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3449,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40301:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40254:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3453,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40313:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3454,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40313:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3452,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40306:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3455,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40306:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40254:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3457,
									"nodeType": "ExpressionStatement",
									"src": "40254:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3470,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3458,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40337:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3464,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3460,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40360:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3461,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40360:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3459,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40353:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3462,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40353:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40337:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3465,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3463,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40384:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40337:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3467,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40396:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3468,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "CENTRAL_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40396:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3466,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40389:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3469,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40389:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40337:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3471,
									"nodeType": "ExpressionStatement",
									"src": "40337:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3484,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3472,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40429:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3478,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3474,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40452:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3475,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40452:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3473,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40445:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3476,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40445:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40429:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3479,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3477,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40476:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40429:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3481,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40488:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3482,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_RUSSIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40488:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3480,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40481:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3483,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40481:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40429:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3485,
									"nodeType": "ExpressionStatement",
									"src": "40429:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3498,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3486,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40521:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3492,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3488,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40544:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3489,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40544:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3487,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40537:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3490,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40537:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40521:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3493,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3491,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40568:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40521:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3495,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40580:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3496,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40580:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3494,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40573:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3497,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40573:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40521:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3499,
									"nodeType": "ExpressionStatement",
									"src": "40521:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3509,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3500,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40613:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3506,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3502,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40636:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3503,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40636:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3501,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40629:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3504,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40629:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40613:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3507,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3505,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40660:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40613:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3508,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "40665:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40613:61:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3510,
									"nodeType": "ExpressionStatement",
									"src": "40613:61:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3523,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3511,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40685:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3517,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3513,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40708:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3514,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40708:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3512,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40701:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3515,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40701:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40685:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3518,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3516,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40733:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40685:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3520,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40745:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3521,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "INDIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40745:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3519,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40738:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3522,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40738:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40685:74:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3524,
									"nodeType": "ExpressionStatement",
									"src": "40685:74:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3537,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3525,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40769:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3531,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3527,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40792:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3528,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40792:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3526,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40785:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3529,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40785:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40769:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3532,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3530,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40817:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40769:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3534,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40829:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3535,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_CHINA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40829:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3533,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40822:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3536,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40822:29:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40769:82:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3538,
									"nodeType": "ExpressionStatement",
									"src": "40769:82:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3551,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3539,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40861:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3545,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3541,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40884:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3542,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40884:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3540,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40877:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3543,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40877:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40861:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3546,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3544,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "40909:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40861:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3548,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "40921:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3549,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "40921:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3547,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "40914:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3550,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "40914:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40861:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3552,
									"nodeType": "ExpressionStatement",
									"src": "40861:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3565,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3553,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "40957:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3559,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3555,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "40980:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3556,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "40980:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3554,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "40973:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3557,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "40973:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "40957:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3560,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3558,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41005:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "40957:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3562,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41017:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3563,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41017:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3561,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41010:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3564,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41010:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "40957:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3566,
									"nodeType": "ExpressionStatement",
									"src": "40957:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3579,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3567,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41053:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3573,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3569,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41076:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3570,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41076:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3568,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41069:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3571,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41069:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41053:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3574,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3572,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41101:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41053:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3576,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41113:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3577,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41113:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3575,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41106:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3578,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41106:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41053:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3580,
									"nodeType": "ExpressionStatement",
									"src": "41053:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3593,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3581,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41137:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3587,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3583,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41160:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3584,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41160:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3582,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41153:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3585,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41153:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41137:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3588,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3586,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41188:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41137:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3590,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41200:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3591,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41200:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3589,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41193:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3592,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41193:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41137:89:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3594,
									"nodeType": "ExpressionStatement",
									"src": "41137:89:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3607,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3595,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41236:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3601,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3597,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41259:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3598,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41259:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3596,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41252:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3599,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41252:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41236:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3602,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3600,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41287:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41236:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3604,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41299:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3605,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41299:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3603,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41292:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3606,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41292:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41236:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3608,
									"nodeType": "ExpressionStatement",
									"src": "41236:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3618,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3609,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41332:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3615,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3611,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41355:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3612,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41355:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3610,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41348:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3613,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41348:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41332:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3616,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3614,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41383:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41332:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3617,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41388:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41332:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3619,
									"nodeType": "ExpressionStatement",
									"src": "41332:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3629,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3620,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41407:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3626,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3622,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41430:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3623,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41430:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3621,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41423:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3624,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41423:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41407:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3627,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3625,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41458:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41407:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3628,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41463:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41407:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3630,
									"nodeType": "ExpressionStatement",
									"src": "41407:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3640,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3631,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41482:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3637,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3633,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41505:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3634,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41505:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3632,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41498:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3635,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41498:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41482:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3638,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3636,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41533:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41482:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3639,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41538:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41482:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3641,
									"nodeType": "ExpressionStatement",
									"src": "41482:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3654,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3642,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41558:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3648,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3644,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41581:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3645,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41581:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3643,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41574:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3646,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41574:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41558:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3649,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3647,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41609:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41558:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3651,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41621:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3652,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "WESTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41621:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3650,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41614:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3653,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41614:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41558:89:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3655,
									"nodeType": "ExpressionStatement",
									"src": "41558:89:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3668,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3656,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41657:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3662,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3658,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41680:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3659,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41680:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3657,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41673:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3660,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41673:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41657:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3663,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3661,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41708:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41657:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3665,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41720:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3666,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41720:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3664,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41713:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3667,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41713:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41657:86:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3669,
									"nodeType": "ExpressionStatement",
									"src": "41657:86:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3682,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3670,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41753:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3676,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3672,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41776:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3673,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41776:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3671,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41769:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3674,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41769:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41753:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3677,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3675,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41804:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41753:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3679,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41816:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3680,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41816:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3678,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41809:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3681,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41809:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41753:76:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3683,
									"nodeType": "ExpressionStatement",
									"src": "41753:76:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3696,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3684,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41839:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3690,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3686,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41862:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3687,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41862:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3685,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41855:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3688,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41855:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41839:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3691,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3689,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41890:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41839:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3693,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "41902:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3694,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NEW_ZEALAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "41902:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3692,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "41895:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3695,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "41895:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41839:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3697,
									"nodeType": "ExpressionStatement",
									"src": "41839:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3707,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3698,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "41932:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3704,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3700,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "41955:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3701,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "41955:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3699,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "41948:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3702,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "41948:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "41932:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3705,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3703,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "41983:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "41932:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3706,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "41988:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "41932:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3708,
									"nodeType": "ExpressionStatement",
									"src": "41932:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3721,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3709,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42008:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3715,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3711,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42031:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3712,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42031:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3710,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42024:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3713,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42024:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42008:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3716,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3714,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42053:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42008:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3718,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42065:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3719,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42065:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3717,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42058:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3720,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42058:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42008:83:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3722,
									"nodeType": "ExpressionStatement",
									"src": "42008:83:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3735,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3723,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42101:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3729,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3725,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42124:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3726,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42124:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3724,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42117:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3727,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42117:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42101:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3730,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3728,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42146:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42101:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3732,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42158:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3733,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "FIJI",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42158:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3731,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42151:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3734,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42151:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42101:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3736,
									"nodeType": "ExpressionStatement",
									"src": "42101:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3749,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3737,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42181:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3743,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3739,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42204:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3740,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42204:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3738,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42197:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3741,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42197:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42181:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3744,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3742,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42226:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42181:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3746,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42238:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3747,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EAST_ANTARCTICA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42238:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3745,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42231:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3748,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42231:31:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42181:81:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3750,
									"nodeType": "ExpressionStatement",
									"src": "42181:81:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3760,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3751,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42272:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3757,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3753,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42295:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3754,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42295:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3752,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42288:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3755,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42288:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42272:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3758,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3756,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42317:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42272:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3759,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "42322:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42272:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3761,
									"nodeType": "ExpressionStatement",
									"src": "42272:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3771,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3762,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42341:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3768,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3764,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42364:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3765,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42364:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3763,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42357:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3766,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42357:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42341:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3769,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3767,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42386:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42341:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3770,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "42391:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42341:59:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3772,
									"nodeType": "ExpressionStatement",
									"src": "42341:59:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3785,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3773,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42411:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3779,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3775,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42434:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3776,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42434:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3774,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42427:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3777,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42427:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42411:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3780,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 3778,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42449:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42411:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3782,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42461:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3783,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "NEW_ZEALAND",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42461:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3781,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42454:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3784,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42454:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42411:70:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3786,
									"nodeType": "ExpressionStatement",
									"src": "42411:70:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3799,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3787,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42491:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3793,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3789,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42514:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3790,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42514:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3788,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42507:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3791,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42507:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42491:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3794,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 3792,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42529:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42491:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3796,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42541:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3797,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "EASTERN_AUSTRALIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42541:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3795,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42534:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3798,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42534:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42491:76:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3800,
									"nodeType": "ExpressionStatement",
									"src": "42491:76:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3813,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3801,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42577:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3807,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3803,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42600:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3804,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42600:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3802,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42593:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3805,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42593:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42577:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3808,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3806,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42615:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42577:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3810,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42627:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3811,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "SOUTHEAST_ASIA",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42627:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3809,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42620:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3812,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42620:30:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42577:73:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3814,
									"nodeType": "ExpressionStatement",
									"src": "42577:73:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3827,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3815,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42660:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3821,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3817,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42683:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3818,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42683:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3816,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42676:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3819,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42676:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42660:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3822,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3820,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42698:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42660:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 3824,
														"name": "Regions",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 212,
														"src": "42710:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
															"typeString": "type(enum WorldGame.Regions)"
														}
													},
													"id": 3825,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"memberName": "HAWAII",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "42710:14:2",
													"typeDescriptions": {
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_enum$_Regions_$212",
														"typeString": "enum WorldGame.Regions"
													}
												],
												"id": 3823,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "42703:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 3826,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "42703:22:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42660:65:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3828,
									"nodeType": "ExpressionStatement",
									"src": "42660:65:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3838,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3829,
													"name": "regionNeighbors",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 179,
													"src": "42735:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
														"typeString": "uint32[5] storage ref[25] storage ref"
													}
												},
												"id": 3835,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3831,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42758:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3832,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42758:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3830,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42751:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3833,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42751:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "42735:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$5_storage",
													"typeString": "uint32[5] storage ref"
												}
											},
											"id": 3836,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3834,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "42773:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42735:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 3837,
											"name": "NO_REGION",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 126,
											"src": "42778:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "42735:52:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3839,
									"nodeType": "ExpressionStatement",
									"src": "42735:52:2"
								}
							]
						},
						"documentation": "@notice Initialize neighbor relationships between all regions\n @dev This data shared by all game instances",
						"id": 3841,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "initRegionNeighbors",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2211,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "32262:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 2212,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "32273:0:2"
						},
						"scope": 4288,
						"src": "32234:10560:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 4069,
							"nodeType": "Block",
							"src": "42958:1456:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 3851,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3844,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "42968:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3849,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3846,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42989:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3847,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "HAWAII",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42989:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3845,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42982:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3848,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42982:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "42968:37:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3850,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43008:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "42968:41:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3852,
									"nodeType": "ExpressionStatement",
									"src": "42968:41:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3860,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3853,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43019:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3858,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3855,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43040:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3856,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43040:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3854,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43033:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3857,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43033:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43019:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 3859,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43067:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_6_by_1",
												"typeString": "int_const 6"
											},
											"value": "6"
										},
										"src": "43019:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3861,
									"nodeType": "ExpressionStatement",
									"src": "43019:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3869,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3862,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43078:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3867,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3864,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43099:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3865,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43099:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3863,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43092:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3866,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43092:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43078:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "35",
											"id": 3868,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43126:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_5_by_1",
												"typeString": "int_const 5"
											},
											"value": "5"
										},
										"src": "43078:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3870,
									"nodeType": "ExpressionStatement",
									"src": "43078:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3878,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3871,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43137:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3876,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3873,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43158:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3874,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43158:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3872,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43151:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3875,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43151:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43137:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3131",
											"id": 3877,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43182:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_11_by_1",
												"typeString": "int_const 11"
											},
											"value": "11"
										},
										"src": "43137:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3879,
									"nodeType": "ExpressionStatement",
									"src": "43137:47:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3887,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3880,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43194:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3885,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3882,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43215:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3883,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43215:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3881,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43208:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3884,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43208:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43194:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 3886,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43239:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_8_by_1",
												"typeString": "int_const 8"
											},
											"value": "8"
										},
										"src": "43194:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3888,
									"nodeType": "ExpressionStatement",
									"src": "43194:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3896,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3889,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43250:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3894,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3891,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43271:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3892,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "GREENLAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43271:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3890,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43264:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3893,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43264:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43250:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3895,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43293:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43250:44:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3897,
									"nodeType": "ExpressionStatement",
									"src": "43250:44:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3905,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3898,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43304:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3903,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3900,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43325:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3901,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43325:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3899,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43318:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3902,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43318:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43304:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3904,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43360:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43304:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3906,
									"nodeType": "ExpressionStatement",
									"src": "43304:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3914,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3907,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43371:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3912,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3909,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43392:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3910,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43392:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3908,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43385:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3911,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43385:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43371:53:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 3913,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43427:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "43371:57:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3915,
									"nodeType": "ExpressionStatement",
									"src": "43371:57:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3923,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3916,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43438:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3921,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3918,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43459:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3919,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43459:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3917,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43452:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3920,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43452:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43438:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 3922,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43487:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "43438:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3924,
									"nodeType": "ExpressionStatement",
									"src": "43438:50:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3932,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3925,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43498:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3930,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3927,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43519:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3928,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43519:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3926,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43512:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3929,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43512:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43498:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 3931,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43547:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "43498:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3933,
									"nodeType": "ExpressionStatement",
									"src": "43498:50:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3941,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3934,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43558:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3939,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3936,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43579:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3937,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43579:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3935,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43572:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3938,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43572:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43558:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3130",
											"id": 3940,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43606:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_10_by_1",
												"typeString": "int_const 10"
											},
											"value": "10"
										},
										"src": "43558:50:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3942,
									"nodeType": "ExpressionStatement",
									"src": "43558:50:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3950,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3943,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43618:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3948,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3945,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43639:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3946,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43639:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3944,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43632:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3947,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43632:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43618:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 3949,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43666:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_6_by_1",
												"typeString": "int_const 6"
											},
											"value": "6"
										},
										"src": "43618:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3951,
									"nodeType": "ExpressionStatement",
									"src": "43618:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3959,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3952,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43677:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3957,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3954,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43698:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3955,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43698:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3953,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43691:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3956,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43691:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43677:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 3958,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43725:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "43677:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3960,
									"nodeType": "ExpressionStatement",
									"src": "43677:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3968,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3961,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43736:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3966,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3963,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43757:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3964,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43757:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3962,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43750:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3965,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43750:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43736:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3967,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43784:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43736:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3969,
									"nodeType": "ExpressionStatement",
									"src": "43736:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3977,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3970,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43795:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3975,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3972,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43816:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3973,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43816:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3971,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43809:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3974,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43809:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43795:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3976,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43840:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43795:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3978,
									"nodeType": "ExpressionStatement",
									"src": "43795:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3986,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3979,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43851:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3984,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3981,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43872:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3982,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43872:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3980,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43865:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3983,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43865:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43851:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 3985,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43896:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "43851:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3987,
									"nodeType": "ExpressionStatement",
									"src": "43851:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 3995,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3988,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43907:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 3993,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3990,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43928:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3991,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43928:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3989,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43921:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3992,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43921:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43907:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "33",
											"id": 3994,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "43952:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_3_by_1",
												"typeString": "int_const 3"
											},
											"value": "3"
										},
										"src": "43907:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 3996,
									"nodeType": "ExpressionStatement",
									"src": "43907:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4004,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 3997,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "43963:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4002,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3999,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "43984:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4000,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTH_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "43984:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3998,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "43977:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4001,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "43977:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "43963:43:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "35",
											"id": 4003,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44009:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_5_by_1",
												"typeString": "int_const 5"
											},
											"value": "5"
										},
										"src": "43963:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4005,
									"nodeType": "ExpressionStatement",
									"src": "43963:47:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4013,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4006,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44020:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4011,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4008,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44041:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4009,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44041:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4007,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44034:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4010,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44034:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44020:36:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "37",
											"id": 4012,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44059:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_7_by_1",
												"typeString": "int_const 7"
											},
											"value": "7"
										},
										"src": "44020:40:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4014,
									"nodeType": "ExpressionStatement",
									"src": "44020:40:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4022,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4015,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44070:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4020,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4017,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44091:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4018,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44091:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4016,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44084:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4019,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44084:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44070:44:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3130",
											"id": 4021,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44117:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_10_by_1",
												"typeString": "int_const 10"
											},
											"value": "10"
										},
										"src": "44070:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4023,
									"nodeType": "ExpressionStatement",
									"src": "44070:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4031,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4024,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44129:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4029,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4026,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44150:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4027,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44150:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4025,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44143:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4028,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44143:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44129:45:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "35",
											"id": 4030,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44177:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_5_by_1",
												"typeString": "int_const 5"
											},
											"value": "5"
										},
										"src": "44129:49:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4032,
									"nodeType": "ExpressionStatement",
									"src": "44129:49:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4040,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4033,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44188:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4038,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4035,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44209:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4036,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44209:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4034,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44202:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4037,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44202:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44188:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 4039,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44239:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "44188:52:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4041,
									"nodeType": "ExpressionStatement",
									"src": "44188:52:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4049,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4042,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44250:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4047,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4044,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44271:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4045,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44271:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4043,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44264:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4046,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44264:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44250:48:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 4048,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44301:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_6_by_1",
												"typeString": "int_const 6"
											},
											"value": "6"
										},
										"src": "44250:52:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4050,
									"nodeType": "ExpressionStatement",
									"src": "44250:52:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4058,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4051,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44312:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4056,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4053,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44333:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4054,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44333:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4052,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44326:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4055,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44326:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44312:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "34",
											"id": 4057,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44357:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_4_by_1",
												"typeString": "int_const 4"
											},
											"value": "4"
										},
										"src": "44312:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4059,
									"nodeType": "ExpressionStatement",
									"src": "44312:46:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4067,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 4060,
												"name": "regionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 183,
												"src": "44368:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_storage",
													"typeString": "uint32[25] storage ref"
												}
											},
											"id": 4065,
											"indexExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 4062,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "44389:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 4063,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "44389:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 4061,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "44382:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 4064,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "44382:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "44368:35:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "32",
											"id": 4066,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44406:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_2_by_1",
												"typeString": "int_const 2"
											},
											"value": "2"
										},
										"src": "44368:39:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 4068,
									"nodeType": "ExpressionStatement",
									"src": "44368:39:2"
								}
							]
						},
						"documentation": "@notice Initialize rewards given for controlling each region\n @dev This data shared by all game instances",
						"id": 4070,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "initRegionRewards",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 3842,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "42947:2:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 3843,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "42958:0:2"
						},
						"scope": 4288,
						"src": "42921:1493:2",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 4094,
							"nodeType": "Block",
							"src": "44738:107:2",
							"statements": [
								{
									"assignments": [
										4080
									],
									"declarations": [
										{
											"constant": false,
											"id": 4080,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4095,
											"src": "44748:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4079,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "44748:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4084,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4083,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4081,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4074,
											"src": "44764:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "3332",
											"id": 4082,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "44772:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_32_by_1",
												"typeString": "int_const 32"
											},
											"value": "32"
										},
										"src": "44764:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "44748:26:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 4091,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 4088,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 4086,
																"name": "combinedData",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4072,
																"src": "44799:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">>",
															"rightExpression": {
																"argumentTypes": null,
																"id": 4087,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4080,
																"src": "44815:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "44799:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"id": 4089,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "44798:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&",
												"rightExpression": {
													"argumentTypes": null,
													"id": 4090,
													"name": "MASK_32_BITS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 153,
													"src": "44825:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "44798:39:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 4085,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "44791:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint32_$",
												"typeString": "type(uint32)"
											},
											"typeName": "uint32"
										},
										"id": 4092,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "44791:47:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4078,
									"id": 4093,
									"nodeType": "Return",
									"src": "44784:54:2"
								}
							]
						},
						"documentation": "@notice Reads data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to read\n @return Value at position index",
						"id": 4095,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getData32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4075,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4072,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4095,
									"src": "44672:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4071,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "44672:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4074,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4095,
									"src": "44694:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4073,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "44694:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "44671:36:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4078,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4077,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4095,
									"src": "44730:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4076,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "44730:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "44729:8:2"
						},
						"scope": 4288,
						"src": "44653:192:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4132,
							"nodeType": "Block",
							"src": "45268:168:2",
							"statements": [
								{
									"assignments": [
										4107
									],
									"declarations": [
										{
											"constant": false,
											"id": 4107,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4133,
											"src": "45278:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4106,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "45278:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4111,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4110,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4108,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4099,
											"src": "45294:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "3332",
											"id": 4109,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "45302:2:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_32_by_1",
												"typeString": "int_const 32"
											},
											"value": "32"
										},
										"src": "45294:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "45278:26:2"
								},
								{
									"assignments": [
										4113
									],
									"declarations": [
										{
											"constant": false,
											"id": 4113,
											"name": "zeromask",
											"nodeType": "VariableDeclaration",
											"scope": 4133,
											"src": "45314:16:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 4112,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "45314:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4119,
									"initialValue": {
										"argumentTypes": null,
										"id": 4118,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "UnaryOperation",
										"operator": "~",
										"prefix": true,
										"src": "45333:25:2",
										"subExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4116,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4114,
														"name": "MASK_32_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 153,
														"src": "45335:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4115,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4107,
														"src": "45351:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "45335:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4117,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "45334:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "45314:44:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 4130,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4122,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4120,
														"name": "combinedData",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4097,
														"src": "45376:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4121,
														"name": "zeromask",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4113,
														"src": "45391:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "45376:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4123,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "45375:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "|",
										"rightExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4128,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 4125,
																"name": "value",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4101,
																"src": "45412:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 4124,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "45404:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint256_$",
																"typeString": "type(uint256)"
															},
															"typeName": "uint256"
														},
														"id": 4126,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "45404:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4127,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4107,
														"src": "45422:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "45404:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4129,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "45403:26:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "45375:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 4105,
									"id": 4131,
									"nodeType": "Return",
									"src": "45368:61:2"
								}
							]
						},
						"documentation": "@notice Writes data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to write\n @param value Value to write at position index.  Value must fit in a uint32.\n @return Updated combined data",
						"id": 4133,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "setData32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4102,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4097,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45187:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4096,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "45187:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4099,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45209:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4098,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45209:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4101,
									"name": "value",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45223:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4100,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45223:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45186:50:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4105,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4104,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4133,
									"src": "45259:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4103,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "45259:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45258:9:2"
						},
						"scope": 4288,
						"src": "45168:268:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4157,
							"nodeType": "Block",
							"src": "45759:105:2",
							"statements": [
								{
									"assignments": [
										4143
									],
									"declarations": [
										{
											"constant": false,
											"id": 4143,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4158,
											"src": "45769:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4142,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "45769:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4147,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4144,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4137,
											"src": "45785:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 4145,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "45793:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_8_by_1",
												"typeString": "int_const 8"
											},
											"value": "8"
										},
										"src": "45785:9:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "45769:25:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 4154,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 4151,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 4149,
																"name": "combinedData",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4135,
																"src": "45819:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">>",
															"rightExpression": {
																"argumentTypes": null,
																"id": 4150,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4143,
																"src": "45835:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "45819:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"id": 4152,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "45818:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&",
												"rightExpression": {
													"argumentTypes": null,
													"id": 4153,
													"name": "MASK_8_BITS",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 156,
													"src": "45845:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "45818:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 4148,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "45811:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint32_$",
												"typeString": "type(uint32)"
											},
											"typeName": "uint32"
										},
										"id": 4155,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "45811:46:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4141,
									"id": 4156,
									"nodeType": "Return",
									"src": "45804:53:2"
								}
							]
						},
						"documentation": "@notice Reads data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to read\n @return Value at position index",
						"id": 4158,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getData8",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4138,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4135,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4158,
									"src": "45693:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4134,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "45693:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4137,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4158,
									"src": "45715:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4136,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45715:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45692:36:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4141,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4140,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4158,
									"src": "45751:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4139,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "45751:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "45750:8:2"
						},
						"scope": 4288,
						"src": "45675:189:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4202,
							"nodeType": "Block",
							"src": "46287:230:2",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 4172,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 4170,
													"name": "value",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4164,
													"src": "46305:5:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "<",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "323536",
													"id": 4171,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "46313:3:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_256_by_1",
														"typeString": "int_const 256"
													},
													"value": "256"
												},
												"src": "46305:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f6e6c792038206269747320616c6c6f77656420666f722076616c75652e",
												"id": 4173,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "46318:32:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
													"typeString": "literal_string \"Only 8 bits allowed for value.\""
												},
												"value": "Only 8 bits allowed for value."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
													"typeString": "literal_string \"Only 8 bits allowed for value.\""
												}
											],
											"id": 4169,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												4375,
												4376
											],
											"referencedDeclaration": 4376,
											"src": "46297:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 4174,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "46297:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 4175,
									"nodeType": "ExpressionStatement",
									"src": "46297:54:2"
								},
								{
									"assignments": [
										4177
									],
									"declarations": [
										{
											"constant": false,
											"id": 4177,
											"name": "offset",
											"nodeType": "VariableDeclaration",
											"scope": 4203,
											"src": "46361:13:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4176,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "46361:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4181,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4180,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4178,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4162,
											"src": "46377:5:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "38",
											"id": 4179,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "46385:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_8_by_1",
												"typeString": "int_const 8"
											},
											"value": "8"
										},
										"src": "46377:9:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "46361:25:2"
								},
								{
									"assignments": [
										4183
									],
									"declarations": [
										{
											"constant": false,
											"id": 4183,
											"name": "zeromask",
											"nodeType": "VariableDeclaration",
											"scope": 4203,
											"src": "46396:16:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 4182,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "46396:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4189,
									"initialValue": {
										"argumentTypes": null,
										"id": 4188,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "UnaryOperation",
										"operator": "~",
										"prefix": true,
										"src": "46415:24:2",
										"subExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4186,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4184,
														"name": "MASK_8_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 156,
														"src": "46417:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4185,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4177,
														"src": "46432:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "46417:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4187,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "46416:23:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "46396:43:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 4200,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4192,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4190,
														"name": "combinedData",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4160,
														"src": "46457:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4191,
														"name": "zeromask",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4183,
														"src": "46472:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "46457:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4193,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "46456:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "|",
										"rightExpression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4198,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 4195,
																"name": "value",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4164,
																"src": "46493:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 4194,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "46485:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint256_$",
																"typeString": "type(uint256)"
															},
															"typeName": "uint256"
														},
														"id": 4196,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "46485:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4197,
														"name": "offset",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4177,
														"src": "46503:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "46485:24:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 4199,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "46484:26:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "46456:54:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 4168,
									"id": 4201,
									"nodeType": "Return",
									"src": "46449:61:2"
								}
							]
						},
						"documentation": "@notice Writes data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to write\n @param value Value to write at position index.  Value must be less than 256.\n @return Updated combined data",
						"id": 4203,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "setData8",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4165,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4160,
									"name": "combinedData",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46206:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4159,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "46206:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4162,
									"name": "index",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46228:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4161,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46228:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4164,
									"name": "value",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46242:12:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4163,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46242:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46205:50:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4168,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4167,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4203,
									"src": "46278:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 4166,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "46278:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46277:9:2"
						},
						"scope": 4288,
						"src": "46188:329:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4227,
							"nodeType": "Block",
							"src": "46845:114:2",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4214,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4212,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4207,
											"src": "46859:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<=",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4213,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4205,
											"src": "46865:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "46859:8:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4224,
									"nodeType": "IfStatement",
									"src": "46855:79:2",
									"trueBody": {
										"id": 4223,
										"nodeType": "Block",
										"src": "46869:65:2",
										"statements": [
											{
												"assignments": [
													4216
												],
												"declarations": [
													{
														"constant": false,
														"id": 4216,
														"name": "c",
														"nodeType": "VariableDeclaration",
														"scope": 4228,
														"src": "46883:8:2",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"typeName": {
															"id": 4215,
															"name": "uint32",
															"nodeType": "ElementaryTypeName",
															"src": "46883:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 4220,
												"initialValue": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 4219,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4217,
														"name": "_a",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4205,
														"src": "46894:2:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "-",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4218,
														"name": "_b",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4207,
														"src": "46899:2:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "46894:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "46883:18:2"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 4221,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4216,
													"src": "46922:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"functionReturnParameters": 4211,
												"id": 4222,
												"nodeType": "Return",
												"src": "46915:8:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "30",
										"id": 4225,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "number",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "46951:1:2",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_rational_0_by_1",
											"typeString": "int_const 0"
										},
										"value": "0"
									},
									"functionReturnParameters": 4211,
									"id": 4226,
									"nodeType": "Return",
									"src": "46944:8:2"
								}
							]
						},
						"documentation": "@notice Safe subtraction that returns 0 on underflow.\n @dev We intentially don't assert so as to not block program execution.\n @param _a Value to subtract from\n @param _b Value to subtract\n @return Result of _a - _b",
						"id": 4228,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "subSafe",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4208,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4205,
									"name": "_a",
									"nodeType": "VariableDeclaration",
									"scope": 4228,
									"src": "46792:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4204,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46792:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4207,
									"name": "_b",
									"nodeType": "VariableDeclaration",
									"scope": 4228,
									"src": "46803:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4206,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46803:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46791:22:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4211,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4210,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4228,
									"src": "46837:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4209,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "46837:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "46836:8:2"
						},
						"scope": 4288,
						"src": "46775:184:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4252,
							"nodeType": "Block",
							"src": "47289:118:2",
							"statements": [
								{
									"assignments": [
										4238
									],
									"declarations": [
										{
											"constant": false,
											"id": 4238,
											"name": "c",
											"nodeType": "VariableDeclaration",
											"scope": 4253,
											"src": "47299:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4237,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "47299:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4242,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4241,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4239,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4230,
											"src": "47310:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "+",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4240,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4232,
											"src": "47315:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47310:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "47299:18:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4245,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4243,
											"name": "c",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4238,
											"src": "47331:1:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">=",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4244,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4230,
											"src": "47336:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47331:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4249,
									"nodeType": "IfStatement",
									"src": "47327:46:2",
									"trueBody": {
										"id": 4248,
										"nodeType": "Block",
										"src": "47340:33:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 4246,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4238,
													"src": "47361:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"functionReturnParameters": 4236,
												"id": 4247,
												"nodeType": "Return",
												"src": "47354:8:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4250,
										"name": "MAX_UINT32",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 159,
										"src": "47390:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4236,
									"id": 4251,
									"nodeType": "Return",
									"src": "47383:17:2"
								}
							]
						},
						"documentation": "@notice Safe addition that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to add\n @param _b Second value to add\n @return Result of _a + _b",
						"id": 4253,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "addSafe",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4233,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4230,
									"name": "_a",
									"nodeType": "VariableDeclaration",
									"scope": 4253,
									"src": "47236:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4229,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47236:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4232,
									"name": "_b",
									"nodeType": "VariableDeclaration",
									"scope": 4253,
									"src": "47247:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4231,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47247:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47235:22:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4236,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4235,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4253,
									"src": "47281:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4234,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47281:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47280:8:2"
						},
						"scope": 4288,
						"src": "47219:188:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 4286,
							"nodeType": "Block",
							"src": "47753:179:2",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4264,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4262,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4255,
											"src": "47767:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 4263,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "47773:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "47767:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4268,
									"nodeType": "IfStatement",
									"src": "47763:46:2",
									"trueBody": {
										"id": 4267,
										"nodeType": "Block",
										"src": "47776:33:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 4265,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "47797:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"functionReturnParameters": 4261,
												"id": 4266,
												"nodeType": "Return",
												"src": "47790:8:2"
											}
										]
									}
								},
								{
									"assignments": [
										4270
									],
									"declarations": [
										{
											"constant": false,
											"id": 4270,
											"name": "c",
											"nodeType": "VariableDeclaration",
											"scope": 4287,
											"src": "47819:8:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"typeName": {
												"id": 4269,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "47819:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 4274,
									"initialValue": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4273,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 4271,
											"name": "_a",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4255,
											"src": "47830:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "*",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4272,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4257,
											"src": "47835:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47830:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "47819:18:2"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"id": 4279,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4277,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4275,
												"name": "c",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4270,
												"src": "47851:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "/",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4276,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4255,
												"src": "47855:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47851:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"id": 4278,
											"name": "_b",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 4257,
											"src": "47861:2:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"src": "47851:12:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 4283,
									"nodeType": "IfStatement",
									"src": "47847:51:2",
									"trueBody": {
										"id": 4282,
										"nodeType": "Block",
										"src": "47865:33:2",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 4280,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4270,
													"src": "47886:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"functionReturnParameters": 4261,
												"id": 4281,
												"nodeType": "Return",
												"src": "47879:8:2"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 4284,
										"name": "MAX_UINT32",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 159,
										"src": "47915:10:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"functionReturnParameters": 4261,
									"id": 4285,
									"nodeType": "Return",
									"src": "47908:17:2"
								}
							]
						},
						"documentation": "@notice Safe multiplication that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to multiply\n @param _b Second value to multiply\n @return Result of _a * _b",
						"id": 4287,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "mulSafe",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 4258,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4255,
									"name": "_a",
									"nodeType": "VariableDeclaration",
									"scope": 4287,
									"src": "47700:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4254,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47700:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 4257,
									"name": "_b",
									"nodeType": "VariableDeclaration",
									"scope": 4287,
									"src": "47711:9:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4256,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47711:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47699:22:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 4261,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 4260,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 4287,
									"src": "47745:6:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 4259,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "47745:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "47744:8:2"
						},
						"scope": 4288,
						"src": "47683:249:2",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					}
				],
				"scope": 4289,
				"src": "104:47830:2"
			}
		],
		"src": "0:47935:2"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {
		"3": {
			"events": {},
			"links": {},
			"address": "0x259139349dA1D9Cfd088c3b57Ef9B9f3576cfB8D",
			"transactionHash": "0x9916ba6679e4959d4b29b1ca7716b605d45163218b7b248df4dec3dc4b288785"
		},
		"4": {
			"events": {},
			"links": {},
			"address": "0x5137Bc501546968791522D17787e459076d0f036",
			"transactionHash": "0x611e085b0cf42cea521308dc7a2b1cd23760b43e1a858c5da0e0c7d2b7616abd"
		},
		"42": {
			"events": {},
			"links": {},
			"address": "0xc5ad4439464A10A001Ba98a8b60C360Be0b441AA",
			"transactionHash": "0x8f486ccddd7dad6972ddad2a1078a022a9d595fa20520cc1ddd7e9b1c24d24ed"
		},
		"1534033426853": {
			"events": {},
			"links": {},
			"address": "0x22e3c3ba6a631a1dd17645a0ba6c41c7a33738cb",
			"transactionHash": "0x145b7585dbbb81d700de1fbf2e72ba9b45fc696b21062d6deef0e04889b3d749"
		},
		"1534476764846": {
			"events": {},
			"links": {},
			"address": "0x2522eae578d5b36aac150d71f847d704f4b33339",
			"transactionHash": "0x509f826a34f0be603ac9b19ba6404517eba23a54d726fbac8a57ab6bc66d0791"
		},
		"1534727609521": {
			"events": {},
			"links": {},
			"address": "0x66033ff9d49a47c965f0cdd991c7cfdc322e9426",
			"transactionHash": "0x78ed6993df4df7a1f315a8099fc5a22038c3b2f249a2d1d2e67130a71e95ee15"
		},
		"1534891437232": {
			"events": {},
			"links": {},
			"address": "0xe61c6aabb196A4FE6Aef017A65885F17237F2554",
			"transactionHash": "0x0495f3d3bfe687cc823022be6ad8720a02fb2e6668ce631bb8cd5a301976f6a7"
		},
		"1535413900904": {
			"events": {},
			"links": {},
			"address": "0x9DC25910461D1fBFbD3CE86bb1fa08E0422680CC",
			"transactionHash": "0x7ca6aa6dae2b969c4038a42f2e1bec250832e8af7924709b9558bff057b6724c"
		},
		"1535436387932": {
			"events": {},
			"links": {},
			"address": "0x761020Aed073d61b854Dd94f391210d4B494ae24",
			"transactionHash": "0x7ca6aa6dae2b969c4038a42f2e1bec250832e8af7924709b9558bff057b6724c"
		},
		"1535437564033": {
			"events": {},
			"links": {},
			"address": "0x6E82EC8319078852cf4851bF40EA9Ba3D60E9E26",
			"transactionHash": "0x4b96b3a551e497b5f665143eba7b763b9499530b3fa345cf31ba773e99e4c8ee"
		},
		"1535517793544": {
			"events": {},
			"links": {},
			"address": "0x5b1869D9A4C187F2EAa108f3062412ecf0526b24",
			"transactionHash": "0xc05d757fd3e66e734552d804fea1c00066a9339eecc7a79e75f0a67f3ac1e321"
		},
		"1535601734805": {
			"events": {},
			"links": {},
			"address": "0x5b1869D9A4C187F2EAa108f3062412ecf0526b24",
			"transactionHash": "0xc05d757fd3e66e734552d804fea1c00066a9339eecc7a79e75f0a67f3ac1e321"
		}
	},
	"schemaVersion": "3.0.0-beta.0",
	"updatedAt": "2018-08-30T04:02:29.217Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/WorldGame.json
// module id = 553
// module chunks = 0